const LISTINGS235_VOCABULARY = {"alphabet":[{"value":"A","label":"A","glyph":"A"},{"value":"B","label":"B","glyph":"B"},{"value":"C","label":"C","glyph":"C"},{"value":"D","label":"D","glyph":"D"},{"value":"E","label":"E","glyph":"E"},{"value":"F","label":"F","glyph":"F"},{"value":"G","label":"G","glyph":"G"},{"value":"H","label":"H","glyph":"H"},{"value":"I","label":"I","glyph":"I"},{"value":"J","label":"J","glyph":"J"},{"value":"K","label":"K","glyph":"K"},{"value":"L","label":"L","glyph":"L"},{"value":"M","label":"M","glyph":"M"},{"value":"N","label":"N","glyph":"N"},{"value":"O","label":"O","glyph":"O"},{"value":"P","label":"P","glyph":"P"},{"value":"Q","label":"Q","glyph":"Q"},{"value":"R","label":"R","glyph":"R"},{"value":"S","label":"S","glyph":"S"},{"value":"T","label":"T","glyph":"T"},{"value":"U","label":"U","glyph":"U"},{"value":"V","label":"V","glyph":"V"},{"value":"W","label":"W","glyph":"W"},{"value":"X","label":"X","glyph":"X"},{"value":"Y","label":"Y","glyph":"Y"},{"value":"Z","label":"Z","glyph":"Z"}],"numbers":[{"value":"0","label":"0","glyph":"0"},{"value":"1","label":"1","glyph":"1"},{"value":"2","label":"2","glyph":"2"},{"value":"3","label":"3","glyph":"3"},{"value":"4","label":"4","glyph":"4"},{"value":"5","label":"5","glyph":"5"},{"value":"6","label":"6","glyph":"6"},{"value":"7","label":"7","glyph":"7"},{"value":"8","label":"8","glyph":"8"},{"value":"9","label":"9","glyph":"9"}],"symbols":[{"value":"HEART (❤️)","label":"Heart","category":"Meaning","glyph":"♥"},{"value":"CROSS (†)","label":"Cross","category":"Meaning","glyph":"†"},{"value":"CLOVER (🍀)","label":"Clover","category":"Nature","glyph":"♣"},{"value":"PAW","label":"Paw","category":"Pets & nature","glyph":"🐾"},{"value":"INFINITY (♾️)","label":"Infinity","category":"Meaning","glyph":"∞"},{"value":"BASEBALL (⚾)","label":"Baseball","category":"Sports & music","glyph":"⚾"},{"value":"BOLT (⚡)","label":"Bolt","category":"Meaning","glyph":"⚡"},{"value":"BUTTERFLY (🦋)","label":"Butterfly","category":"Pets & nature","glyph":"🦋"},{"value":"HASHTAG (#)","label":"Hashtag","category":"Symbols","glyph":"#"},{"value":"HORSE SHOE","label":"Horse shoe","category":"Symbols","glyph":"∪"},{"value":"KITTY CAT","label":"Kitty cat","category":"Pets & nature","glyph":"🐱"},{"value":"MOON","label":"Moon","category":"Pets & nature","glyph":"☾"},{"value":"SNOWFLAKE","label":"Snowflake","category":"Pets & nature","glyph":"❄"},{"value":"SNOWMAN","label":"Snowman","category":"Pets & nature","glyph":"☃"},{"value":"SUN","label":"Sun","category":"Pets & nature","glyph":"☀"},{"value":"TENNIS RACKET","label":"Tennis racket","category":"Sports & music","glyph":"🎾"},{"value":"TREBLE CLEF","label":"Treble clef","category":"Sports & music","glyph":"𝄞"},{"value":"AMPERSAND (&)","label":"Ampersand","category":"Symbols","glyph":"&"},{"value":"TRIANGLE (△)","label":"Triangle","category":"Symbols","glyph":"△"},{"value":"PAW LISTING","label":"Paw","category":"Pets & nature","glyph":"🐾"}],"birthstones":[{"value":"JANUARY","label":"January","detail":"Garnet","glyph":"●","color":"#7A2E3A"},{"value":"FEBRUARY","label":"February","detail":"Amethyst","glyph":"●","color":"#6E5A9E"},{"value":"MARCH","label":"March","detail":"Aquamarine","glyph":"●","color":"#6FA3B4"},{"value":"APRIL","label":"April","detail":"White topaz","glyph":"●","color":"#B9BEC4"},{"value":"MAY","label":"May","detail":"Emerald","glyph":"●","color":"#2E6B4F"},{"value":"JUNE","label":"June","detail":"Alexandrite","glyph":"●","color":"#7E8FB0"},{"value":"JULY","label":"July","detail":"Ruby","glyph":"●","color":"#8E2436"},{"value":"AUGUST","label":"August","detail":"Peridot","glyph":"●","color":"#7D8F3E"},{"value":"SEPTEMBER","label":"September","detail":"Sapphire","glyph":"●","color":"#2C4A7E"},{"value":"OCTOBER","label":"October","detail":"Pink tourmaline","glyph":"●","color":"#C88699"},{"value":"NOVEMBER","label":"November","detail":"Citrine","glyph":"●","color":"#C08A2E"},{"value":"DECEMBER","label":"December","detail":"Blue topaz","glyph":"●","color":"#3E8F8A"}],"birthflowers":[{"value":"JANUARY","label":"January","detail":"Carnation","glyph":"✿"},{"value":"FEBRUARY","label":"February","detail":"Violet","glyph":"✿"},{"value":"MARCH","label":"March","detail":"Daffodil","glyph":"✿"},{"value":"APRIL","label":"April","detail":"Daisy","glyph":"✿"},{"value":"MAY","label":"May","detail":"Hawthorne","glyph":"✿"},{"value":"JUNE","label":"June","detail":"Rose","glyph":"✿"},{"value":"JULY","label":"July","detail":"Lotus","glyph":"✿"},{"value":"AUGUST","label":"August","detail":"Poppy","glyph":"✿"},{"value":"SEPTEMBER","label":"September","detail":"Aster","glyph":"✿"},{"value":"OCTOBER","label":"October","detail":"Marigold","glyph":"✿"},{"value":"NOVEMBER","label":"November","detail":"Chrysanthemum","glyph":"✿"},{"value":"DECEMBER","label":"December","detail":"Holly","glyph":"✿"}],"birthflowersAnklet":[{"value":"JANUARY","label":"January","detail":"Carnation","glyph":"✿"},{"value":"FEBRUARY","label":"February","detail":"Iris","glyph":"✿"},{"value":"MARCH","label":"March","detail":"Daffodil","glyph":"✿"},{"value":"APRIL","label":"April","detail":"Daisy","glyph":"✿"},{"value":"MAY","label":"May","detail":"Lily of the valley","glyph":"✿"},{"value":"JUNE","label":"June","detail":"Rose","glyph":"✿"},{"value":"JULY","label":"July","detail":"Water lily","glyph":"✿"},{"value":"AUGUST","label":"August","detail":"Poppy","glyph":"✿"},{"value":"SEPTEMBER","label":"September","detail":"Morning glory","glyph":"✿"},{"value":"OCTOBER","label":"October","detail":"Marigold","glyph":"✿"},{"value":"NOVEMBER","label":"November","detail":"Chrysanthemum","glyph":"✿"},{"value":"DECEMBER","label":"December","detail":"Narcissus","glyph":"✿"}],"fonts":[{"value":"Font 1","label":"Alex Brush"},{"value":"Font 2","label":"Brush Script MT"},{"value":"Font 3","label":"Commercial Script BT"},{"value":"Font 4","label":"Elaine Hanks Bold"},{"value":"Font 5","label":"FabfeltScript Bold"},{"value":"Font 6","label":"Harlow Solid Italic"},{"value":"Font 7","label":"Sofia"},{"value":"Font 8","label":"Old English Text MT"},{"value":"Font 9","label":"Harmonie Script"},{"value":"Font 10","label":"Love Jewlits"}],"charms":[{"value":"Charm 1 — Heart","label":"Heart","detail":"Love & Luck","category":"Love & Luck","glyph":"1"},{"value":"Charm 2 — Double Outline Star","label":"Double Outline Star","detail":"Stars & Sky","category":"Stars & Sky","glyph":"2"},{"value":"Charm 3 — Star","label":"Star","detail":"Stars & Sky","category":"Stars & Sky","glyph":"3"},{"value":"Charm 4 — Geometric Star","label":"Geometric Star","detail":"Stars & Sky","category":"Stars & Sky","glyph":"4"},{"value":"Charm 5 — Classic Paw","label":"Classic Paw","detail":"Animals","category":"Animals","glyph":"5"},{"value":"Charm 6 — Playful Paw","label":"Playful Paw","detail":"Animals","category":"Animals","glyph":"6"},{"value":"Charm 7 — Moon","label":"Moon","detail":"Stars & Sky","category":"Stars & Sky","glyph":"7"},{"value":"Charm 8 — Cross","label":"Cross","detail":"Love & Luck","category":"Love & Luck","glyph":"8"},{"value":"Charm 9 — Bold Bolt","label":"Bold Bolt","detail":"Style","category":"Style","glyph":"9"},{"value":"Charm 10 — Slim Bolt","label":"Slim Bolt","detail":"Style","category":"Style","glyph":"10"},{"value":"Charm 11 — Infinity","label":"Infinity","detail":"Love & Luck","category":"Love & Luck","glyph":"11"},{"value":"Charm 12 — Flower Bouquet","label":"Flower Bouquet","detail":"Nature","category":"Nature","glyph":"12"},{"value":"Charm 13 — Floral Stem","label":"Floral Stem","detail":"Nature","category":"Nature","glyph":"13"},{"value":"Charm 14 — Clover","label":"Clover","detail":"Love & Luck","category":"Love & Luck","glyph":"14"},{"value":"Charm 15 — Butterfly","label":"Butterfly","detail":"Animals","category":"Animals","glyph":"15"},{"value":"Charm 16 — Sun","label":"Sun","detail":"Stars & Sky","category":"Stars & Sky","glyph":"16"},{"value":"Charm 17 — Snowflake","label":"Snowflake","detail":"Stars & Sky","category":"Stars & Sky","glyph":"17"},{"value":"Charm 18 — Guitar","label":"Guitar","detail":"Music & Fun","category":"Music & Fun","glyph":"18"},{"value":"Charm 19 — Music Note","label":"Music Note","detail":"Music & Fun","category":"Music & Fun","glyph":"19"},{"value":"Charm 20 — Cat","label":"Cat","detail":"Animals","category":"Animals","glyph":"20"},{"value":"Charm 21 — Outline Cat","label":"Outline Cat","detail":"Animals","category":"Animals","glyph":"21"},{"value":"Charm 22 — Dog","label":"Dog","detail":"Animals","category":"Animals","glyph":"22"},{"value":"Charm 23 — Bow","label":"Bow","detail":"Style","category":"Style","glyph":"23"},{"value":"Charm 24 — Ribbon","label":"Ribbon","detail":"Style","category":"Style","glyph":"24"},{"value":"Charm 25 — Cherry","label":"Cherry","detail":"Sweet Treats","category":"Sweet Treats","glyph":"25"},{"value":"Charm 26 — Strawberry","label":"Strawberry","detail":"Sweet Treats","category":"Sweet Treats","glyph":"26"},{"value":"Charm 27 — Mushroom","label":"Mushroom","detail":"Sweet Treats","category":"Sweet Treats","glyph":"27"},{"value":"Charm 28 — Fish","label":"Fish","detail":"Animals","category":"Animals","glyph":"28"},{"value":"Charm 29 — Balloon Dog","label":"Balloon Dog","detail":"Animals","category":"Animals","glyph":"29"},{"value":"Charm 30 — Dolphin","label":"Dolphin","detail":"Animals","category":"Animals","glyph":"30"},{"value":"Charm 31 — Envelope","label":"Envelope","detail":"Keepsakes","category":"Keepsakes","glyph":"31"},{"value":"Charm 32 — Lock","label":"Lock","detail":"Keepsakes","category":"Keepsakes","glyph":"32"},{"value":"Charm 33 — Key","label":"Key","detail":"Keepsakes","category":"Keepsakes","glyph":"33"},{"value":"Charm 34 — Teddy Bear","label":"Teddy Bear","detail":"Keepsakes","category":"Keepsakes","glyph":"34"},{"value":"Charm 35 — Smiley Face","label":"Smiley Face","detail":"Music & Fun","category":"Music & Fun","glyph":"35"},{"value":"Charm 36 — Matchbox","label":"Matchbox","detail":"Keepsakes","category":"Keepsakes","glyph":"36"},{"value":"Charm 37 — Coffee Cup","label":"Coffee Cup","detail":"Sweet Treats","category":"Sweet Treats","glyph":"37"},{"value":"Charm 38 — Book","label":"Book","detail":"Keepsakes","category":"Keepsakes","glyph":"38"},{"value":"Charm 39 — Tarot Card","label":"Tarot Card","detail":"Keepsakes","category":"Keepsakes","glyph":"39"},{"value":"Charm 40 — iPhone","label":"iPhone","detail":"Keepsakes","category":"Keepsakes","glyph":"40"},{"value":"Charm 41 — Campfire","label":"Campfire","detail":"Travel","category":"Travel","glyph":"41"},{"value":"Charm 42 — Headphones","label":"Headphones","detail":"Music & Fun","category":"Music & Fun","glyph":"42"},{"value":"Charm 43 — Cowboy Boot","label":"Cowboy Boot","detail":"Western","category":"Western","glyph":"43"},{"value":"Charm 44 — Western Boot","label":"Western Boot","detail":"Western","category":"Western","glyph":"44"},{"value":"Charm 45 — Camera","label":"Camera","detail":"Travel","category":"Travel","glyph":"45"},{"value":"Charm 46 — Compass","label":"Compass","detail":"Travel","category":"Travel","glyph":"46"},{"value":"Charm 47 — Disco Ball","label":"Disco Ball","detail":"Music & Fun","category":"Music & Fun","glyph":"47"},{"value":"Charm 48 — Airplane","label":"Airplane","detail":"Travel","category":"Travel","glyph":"48"},{"value":"Charm 49 — Hot Air Balloon","label":"Hot Air Balloon","detail":"Travel","category":"Travel","glyph":"49"},{"value":"Charm 50 — Seashell","label":"Seashell","detail":"Travel","category":"Travel","glyph":"50"},{"value":"Charm 51 — Anchor","label":"Anchor","detail":"Travel","category":"Travel","glyph":"51"},{"value":"Charm 52 — Snake","label":"Snake","detail":"Animals","category":"Animals","glyph":"52"},{"value":"Charm 53 — Cactus","label":"Cactus","detail":"Nature","category":"Nature","glyph":"53"},{"value":"Charm 54 — Sunglasses","label":"Sunglasses","detail":"Style","category":"Style","glyph":"54"},{"value":"Charm 55 — Cowboy Hat","label":"Cowboy Hat","detail":"Western","category":"Western","glyph":"55"},{"value":"Charm 56 — Horseshoe","label":"Horseshoe","detail":"Love & Luck","category":"Love & Luck","glyph":"56"},{"value":"Charm 57 — Rodeo Rider","label":"Rodeo Rider","detail":"Western","category":"Western","glyph":"57"},{"value":"Charm 58 — Roller Skate","label":"Roller Skate","detail":"Sports","category":"Sports","glyph":"58"},{"value":"Charm 59 — Stethoscope","label":"Stethoscope","detail":"Keepsakes","category":"Keepsakes","glyph":"59"},{"value":"Charm 60 — Pickleball Paddle","label":"Pickleball Paddle","detail":"Sports","category":"Sports","glyph":"60"},{"value":"Charm 61 — Checkered Paddle","label":"Checkered Paddle","detail":"Sports","category":"Sports","glyph":"61"},{"value":"Charm 62 — Tennis Racket","label":"Tennis Racket","detail":"Sports","category":"Sports","glyph":"62"},{"value":"Charm 63 — Baseball Ball","label":"Baseball Ball","detail":"Sports","category":"Sports","glyph":"63"},{"value":"Charm 64 — Mountain","label":"Mountain","detail":"Nature","category":"Nature","glyph":"64"},{"value":"Charm 65 — Theater Masks","label":"Theater Masks","detail":"Keepsakes","category":"Keepsakes","glyph":"65"},{"value":"Charm 66 — Croissant","label":"Croissant","detail":"Sweet Treats","category":"Sweet Treats","glyph":"66"},{"value":"Charm 67 — Longhorn Skull","label":"Longhorn Skull","detail":"Western","category":"Western","glyph":"67"},{"value":"Charm 68 — Cow Head","label":"Cow Head","detail":"Western","category":"Western","glyph":"68"},{"value":"Charm 69 — Rope","label":"Rope","detail":"Western","category":"Western","glyph":"69"},{"value":"Charm 70 — Sheriff","label":"Sheriff","detail":"Western","category":"Western","glyph":"70"},{"value":"Charm 71 — Gun","label":"Gun","detail":"Western","category":"Western","glyph":"71"},{"value":"Charm 72 — Wave","label":"Wave","detail":"Nature","category":"Nature","glyph":"72"},{"value":"Charm 73 — Saloon","label":"Saloon","detail":"Western","category":"Western","glyph":"73"},{"value":"Charm 74 — Rainbow","label":"Rainbow","detail":"Stars & Sky","category":"Stars & Sky","glyph":"74"},{"value":"Charm 75 — Palm Tree","label":"Palm Tree","detail":"Nature","category":"Nature","glyph":"75"},{"value":"Charm 76 — Washington","label":"Washington","detail":"Places","category":"Places","glyph":"76"},{"value":"Charm 77 — New York","label":"New York","detail":"Places","category":"Places","glyph":"77"},{"value":"Charm 78 — New York","label":"New York","detail":"Places","category":"Places","glyph":"78"},{"value":"Charm 79 — Texas Map","label":"Texas Map","detail":"Places","category":"Places","glyph":"79"},{"value":"Charm 80 — Texas Heart","label":"Texas Heart","detail":"Places","category":"Places","glyph":"80"},{"value":"Charm 81 — Illinois","label":"Illinois","detail":"Places","category":"Places","glyph":"81"},{"value":"Charm 82 — Florida","label":"Florida","detail":"Places","category":"Places","glyph":"82"}],"serif_letters":[{"value":"Serif A","label":"A","detail":"Serif letter","glyph":"A"},{"value":"Serif B","label":"B","detail":"Serif letter","glyph":"B"},{"value":"Serif C","label":"C","detail":"Serif letter","glyph":"C"},{"value":"Serif D","label":"D","detail":"Serif letter","glyph":"D"},{"value":"Serif E","label":"E","detail":"Serif letter","glyph":"E"},{"value":"Serif F","label":"F","detail":"Serif letter","glyph":"F"},{"value":"Serif G","label":"G","detail":"Serif letter","glyph":"G"},{"value":"Serif H","label":"H","detail":"Serif letter","glyph":"H"},{"value":"Serif I","label":"I","detail":"Serif letter","glyph":"I"},{"value":"Serif J","label":"J","detail":"Serif letter","glyph":"J"},{"value":"Serif K","label":"K","detail":"Serif letter","glyph":"K"},{"value":"Serif L","label":"L","detail":"Serif letter","glyph":"L"},{"value":"Serif M","label":"M","detail":"Serif letter","glyph":"M"},{"value":"Serif N","label":"N","detail":"Serif letter","glyph":"N"},{"value":"Serif O","label":"O","detail":"Serif letter","glyph":"O"},{"value":"Serif P","label":"P","detail":"Serif letter","glyph":"P"},{"value":"Serif Q","label":"Q","detail":"Serif letter","glyph":"Q"},{"value":"Serif R","label":"R","detail":"Serif letter","glyph":"R"},{"value":"Serif S","label":"S","detail":"Serif letter","glyph":"S"},{"value":"Serif T","label":"T","detail":"Serif letter","glyph":"T"},{"value":"Serif U","label":"U","detail":"Serif letter","glyph":"U"},{"value":"Serif V","label":"V","detail":"Serif letter","glyph":"V"},{"value":"Serif W","label":"W","detail":"Serif letter","glyph":"W"},{"value":"Serif X","label":"X","detail":"Serif letter","glyph":"X"},{"value":"Serif Y","label":"Y","detail":"Serif letter","glyph":"Y"},{"value":"Serif Z","label":"Z","detail":"Serif letter","glyph":"Z"}],"lowercase_letters":[{"value":"Lowercase A","label":"a","detail":"Lowercase letter","glyph":"a"},{"value":"Lowercase B","label":"b","detail":"Lowercase letter","glyph":"b"},{"value":"Lowercase C","label":"c","detail":"Lowercase letter","glyph":"c"},{"value":"Lowercase D","label":"d","detail":"Lowercase letter","glyph":"d"},{"value":"Lowercase E","label":"e","detail":"Lowercase letter","glyph":"e"},{"value":"Lowercase F","label":"f","detail":"Lowercase letter","glyph":"f"},{"value":"Lowercase G","label":"g","detail":"Lowercase letter","glyph":"g"},{"value":"Lowercase H","label":"h","detail":"Lowercase letter","glyph":"h"},{"value":"Lowercase I","label":"i","detail":"Lowercase letter","glyph":"i"},{"value":"Lowercase J","label":"j","detail":"Lowercase letter","glyph":"j"},{"value":"Lowercase K","label":"k","detail":"Lowercase letter","glyph":"k"},{"value":"Lowercase L","label":"l","detail":"Lowercase letter","glyph":"l"},{"value":"Lowercase M","label":"m","detail":"Lowercase letter","glyph":"m"},{"value":"Lowercase N","label":"n","detail":"Lowercase letter","glyph":"n"},{"value":"Lowercase O","label":"o","detail":"Lowercase letter","glyph":"o"},{"value":"Lowercase P","label":"p","detail":"Lowercase letter","glyph":"p"},{"value":"Lowercase Q","label":"q","detail":"Lowercase letter","glyph":"q"},{"value":"Lowercase R","label":"r","detail":"Lowercase letter","glyph":"r"},{"value":"Lowercase S","label":"s","detail":"Lowercase letter","glyph":"s"},{"value":"Lowercase T","label":"t","detail":"Lowercase letter","glyph":"t"},{"value":"Lowercase U","label":"u","detail":"Lowercase letter","glyph":"u"},{"value":"Lowercase V","label":"v","detail":"Lowercase letter","glyph":"v"},{"value":"Lowercase W","label":"w","detail":"Lowercase letter","glyph":"w"},{"value":"Lowercase X","label":"x","detail":"Lowercase letter","glyph":"x"},{"value":"Lowercase Y","label":"y","detail":"Lowercase letter","glyph":"y"},{"value":"Lowercase Z","label":"z","detail":"Lowercase letter","glyph":"z"}],"monograms":[{"value":"KEY","label":"KEY","detail":"Monogram","glyph":"KEY"},{"value":"LES","label":"LES","detail":"Monogram","glyph":"LES"},{"value":"EAR","label":"EAR","detail":"Monogram","glyph":"EAR"},{"value":"RED","label":"RED","detail":"Monogram","glyph":"RED"},{"value":"KID","label":"KID","detail":"Monogram","glyph":"KID"},{"value":"NOW","label":"NOW","detail":"Monogram","glyph":"NOW"},{"value":"END","label":"END","detail":"Monogram","glyph":"END"},{"value":"MEN","label":"MEN","detail":"Monogram","glyph":"MEN"},{"value":"PAY","label":"PAY","detail":"Monogram","glyph":"PAY"},{"value":"SHE","label":"SHE","detail":"Monogram","glyph":"SHE"},{"value":"MAN","label":"MAN","detail":"Monogram","glyph":"MAN"},{"value":"WAY","label":"WAY","detail":"Monogram","glyph":"WAY"},{"value":"FOR","label":"FOR","detail":"Monogram","glyph":"FOR"},{"value":"RUN","label":"RUN","detail":"Monogram","glyph":"RUN"},{"value":"USE","label":"USE","detail":"Monogram","glyph":"USE"},{"value":"JOB","label":"JOB","detail":"Monogram","glyph":"JOB"},{"value":"TRY","label":"TRY","detail":"Monogram","glyph":"TRY"},{"value":"ART","label":"ART","detail":"Monogram","glyph":"ART"},{"value":"HAS","label":"HAS","detail":"Monogram","glyph":"HAS"},{"value":"GOD","label":"GOD","detail":"Monogram","glyph":"GOD"},{"value":"FAR","label":"FAR","detail":"Monogram","glyph":"FAR"},{"value":"DOG","label":"DOG","detail":"Monogram","glyph":"DOG"},{"value":"CAT","label":"CAT","detail":"Monogram","glyph":"CAT"},{"value":"THE","label":"THE","detail":"Monogram","glyph":"THE"}],"large_initial_letters":[{"value":"A","label":"A","detail":"Large initial"},{"value":"B","label":"B","detail":"Large initial"},{"value":"C","label":"C","detail":"Large initial"},{"value":"D","label":"D","detail":"Large initial"},{"value":"E","label":"E","detail":"Large initial"},{"value":"F","label":"F","detail":"Large initial"},{"value":"G","label":"G","detail":"Large initial"},{"value":"H","label":"H","detail":"Large initial"},{"value":"I","label":"I","detail":"Large initial"},{"value":"J","label":"J","detail":"Large initial"},{"value":"K","label":"K","detail":"Large initial"},{"value":"L","label":"L","detail":"Large initial"},{"value":"M","label":"M","detail":"Large initial"},{"value":"N","label":"N","detail":"Large initial"},{"value":"O","label":"O","detail":"Large initial"},{"value":"P","label":"P","detail":"Large initial"},{"value":"Q","label":"Q","detail":"Large initial"},{"value":"R","label":"R","detail":"Large initial"},{"value":"S","label":"S","detail":"Large initial"},{"value":"T","label":"T","detail":"Large initial"},{"value":"U","label":"U","detail":"Large initial"},{"value":"V","label":"V","detail":"Large initial"},{"value":"W","label":"W","detail":"Large initial"},{"value":"X","label":"X","detail":"Large initial"},{"value":"Y","label":"Y","detail":"Large initial"},{"value":"Z","label":"Z","detail":"Large initial"}],"large_initial_symbols":[{"value":"PUZZLE","label":"Puzzle","detail":"Large symbol"},{"value":"CROSS","label":"Cross","detail":"Large symbol"},{"value":"PAW","label":"Paw","detail":"Large symbol"},{"value":"STAR","label":"Star","detail":"Large symbol"},{"value":"CLOVER","label":"Clover","detail":"Large symbol"},{"value":"HEART","label":"Heart","detail":"Large symbol"},{"value":"TRIANGLE","label":"Triangle","detail":"Large symbol"}],"cursive_letters":[{"value":"Cursive A","label":"A","detail":"Cursive letter","glyph":"A"},{"value":"Cursive B","label":"B","detail":"Cursive letter","glyph":"B"},{"value":"Cursive C","label":"C","detail":"Cursive letter","glyph":"C"},{"value":"Cursive D","label":"D","detail":"Cursive letter","glyph":"D"},{"value":"Cursive E","label":"E","detail":"Cursive letter","glyph":"E"},{"value":"Cursive F","label":"F","detail":"Cursive letter","glyph":"F"},{"value":"Cursive G","label":"G","detail":"Cursive letter","glyph":"G"},{"value":"Cursive H","label":"H","detail":"Cursive letter","glyph":"H"},{"value":"Cursive I","label":"I","detail":"Cursive letter","glyph":"I"},{"value":"Cursive J","label":"J","detail":"Cursive letter","glyph":"J"},{"value":"Cursive K","label":"K","detail":"Cursive letter","glyph":"K"},{"value":"Cursive L","label":"L","detail":"Cursive letter","glyph":"L"},{"value":"Cursive M","label":"M","detail":"Cursive letter","glyph":"M"},{"value":"Cursive N","label":"N","detail":"Cursive letter","glyph":"N"},{"value":"Cursive O","label":"O","detail":"Cursive letter","glyph":"O"},{"value":"Cursive P","label":"P","detail":"Cursive letter","glyph":"P"},{"value":"Cursive Q","label":"Q","detail":"Cursive letter","glyph":"Q"},{"value":"Cursive R","label":"R","detail":"Cursive letter","glyph":"R"},{"value":"Cursive S","label":"S","detail":"Cursive letter","glyph":"S"},{"value":"Cursive T","label":"T","detail":"Cursive letter","glyph":"T"},{"value":"Cursive U","label":"U","detail":"Cursive letter","glyph":"U"},{"value":"Cursive V","label":"V","detail":"Cursive letter","glyph":"V"},{"value":"Cursive W","label":"W","detail":"Cursive letter","glyph":"W"},{"value":"Cursive X","label":"X","detail":"Cursive letter","glyph":"X"},{"value":"Cursive Y","label":"Y","detail":"Cursive letter","glyph":"Y"},{"value":"Cursive Z","label":"Z","detail":"Cursive letter","glyph":"Z"}],"zodiac_signs":[{"value":"AQUARIUS","label":"Aquarius","detail":"Jan 20 – Feb 18"},{"value":"PISCES","label":"Pisces","detail":"Feb 19 – Mar 20"},{"value":"ARIES","label":"Aries","detail":"Mar 21 – Apr 19"},{"value":"TAURUS","label":"Taurus","detail":"Apr 20 – May 20"},{"value":"GEMINI","label":"Gemini","detail":"May 21 – Jun 21"},{"value":"CANCER","label":"Cancer","detail":"Jun 22 – Jul 22"},{"value":"LEO","label":"Leo","detail":"Jul 23 – Aug 22"},{"value":"VIRGO","label":"Virgo","detail":"Aug 23 – Sep 22"},{"value":"LIBRA","label":"Libra","detail":"Sep 23 – Oct 23"},{"value":"SCORPIO","label":"Scorpio","detail":"Oct 24 – Nov 21"},{"value":"SAGITTARIUS","label":"Sagittarius","detail":"Nov 22 – Dec 21"},{"value":"CAPRICORN","label":"Capricorn","detail":"Dec 22 – Jan 19"}],"enamel_hearts":[{"value":"Red","label":"Red","color":"#C8102E"},{"value":"Blue","label":"Blue","color":"#1F4FA8"},{"value":"White","label":"White","color":"#F4F4F2"},{"value":"Pink","label":"Pink","color":"#E8A0B4"},{"value":"Yellow","label":"Yellow","color":"#F2C63D"}],"numbersCharm":[{"value":"Number 0","label":"0","detail":"Number charm","glyph":"0"},{"value":"Number 1","label":"1","detail":"Number charm","glyph":"1"},{"value":"Number 2","label":"2","detail":"Number charm","glyph":"2"},{"value":"Number 3","label":"3","detail":"Number charm","glyph":"3"},{"value":"Number 4","label":"4","detail":"Number charm","glyph":"4"},{"value":"Number 5","label":"5","detail":"Number charm","glyph":"5"},{"value":"Number 6","label":"6","detail":"Number charm","glyph":"6"},{"value":"Number 7","label":"7","detail":"Number charm","glyph":"7"},{"value":"Number 8","label":"8","detail":"Number charm","glyph":"8"},{"value":"Number 9","label":"9","detail":"Number charm","glyph":"9"}]}
if (!window.SilveristicV22) {
window.SilveristicV22 = true

const sjUi = (() => {
  try {
    return Object.freeze(JSON.parse(document.getElementById('SilveristicUiCopy')?.textContent || '{}'))
  } catch {
    return Object.freeze({})
  }
})()

const sjUiText = (key, replacements = {}) => {
  let output = String(sjUi[key] || '')
  Object.entries(replacements).forEach(([token, value]) => {
    output = output.split(token).join(String(value))
  })
  return output
}

const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
const dialogReturnFocus = new WeakMap()
const money = (value, currency = document.documentElement.dataset.currency || 'USD') => {
const amount = Number(value || 0) / 100
try {
  return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(amount)
} catch {
  return `$${amount.toFixed(2)}`
}
}

// showModal() makes the rest of the page inert but does not stop it scrolling,
// so hold the scroll position while any modal is open.
const syncModalScrollLock = () => {
const open = document.querySelector('dialog[open]')
document.documentElement.classList.toggle('sj-modal-open', Boolean(open))
}

const closeDialog = (dialog) => {
if (dialog?.open) dialog.close()
}

/*
  A trigger that says aria-haspopup="dialog" and carries aria-expanded is promising a screen reader
  that the attribute tracks the dialog. The stacking-ring fan-out set it to false on close and
  never to true on open, so the control announced itself as collapsed while its picker filled the
  screen — and the picker opens by itself once the ring count is chosen, so a keyboard user met an
  open modal from a button that claimed to be shut.

  Setting it here rather than at each call site means every expander-style trigger in the theme
  stays honest, including ones added later. Only triggers that already declare aria-expanded are
  touched; a plain button is left exactly as it was.
*/
const syncExpanded = (trigger, open) => {
  if (trigger instanceof HTMLElement && trigger.hasAttribute('aria-expanded')) {
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false')
  }
}

const openDialog = (dialog, trigger) => {
if (!dialog) return
if (trigger instanceof HTMLElement) dialogReturnFocus.set(dialog, trigger)
syncExpanded(trigger, true)
dialog.showModal()
syncModalScrollLock()
requestAnimationFrame(() => dialog.querySelector('[data-dialog-close], h2, input, button')?.focus())
}

document.addEventListener('close', (event) => {
const dialog = event.target
if (!(dialog instanceof HTMLDialogElement)) return
syncModalScrollLock()
syncExpanded(dialogReturnFocus.get(dialog), false)
dialogReturnFocus.get(dialog)?.focus()
dialogReturnFocus.delete(dialog)
}, true)

document.addEventListener('click', (event) => {
const opener = event.target.closest('[data-dialog-open]')
if (opener) {
  event.preventDefault()
  openDialog(document.getElementById(opener.dataset.dialogOpen), opener)
  return
}

const closer = event.target.closest('[data-dialog-close]')
if (closer) {
  event.preventDefault()
  closeDialog(closer.closest('dialog'))
  return
}

if (event.target instanceof HTMLDialogElement) {
  const rect = event.target.getBoundingClientRect()
  const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom
  if (outside) event.target.close()
}
})

document.addEventListener('keydown', (event) => {
const dialog = event.target.closest?.('dialog[open]')
if (!dialog || event.key !== 'Tab') return
const controls = [...dialog.querySelectorAll(focusableSelector)].filter((element) => element.offsetParent !== null)
if (!controls.length) return
const first = controls[0]
const last = controls[controls.length - 1]
if (event.shiftKey && document.activeElement === first) {
  event.preventDefault()
  last.focus()
} else if (!event.shiftKey && document.activeElement === last) {
  event.preventDefault()
  first.focus()
}
})

document.querySelectorAll('.sj-mobile-menu').forEach((menu) => {
const items = [...menu.querySelectorAll('.sj-details')]
items.forEach((details, index) => {
  const summary = details.querySelector('summary')
  const body = details.querySelector('.sj-details__body')
  if (!summary || !body) return
  body.id ||= `${menu.id || 'SilveristicMobileMenu'}Panel-${index + 1}`
  summary.setAttribute('aria-controls', body.id)
  summary.setAttribute('aria-expanded', String(details.open))
  summary.addEventListener('click', () => {
    if (!details.open) {
      items.forEach((other) => {
        if (other !== details) other.open = false
      })
    }
  })
  details.addEventListener('toggle', () => {
    items.forEach((item) => item.querySelector('summary')?.setAttribute('aria-expanded', String(item.open)))
  })
})
})

const megaOpenTimers = new WeakMap()
const megaCloseTimers = new WeakMap()

const setMegaState = (trigger, open) => {
if (!trigger) return
const panel = document.getElementById(trigger.getAttribute('aria-controls'))
trigger.setAttribute('aria-expanded', open ? 'true' : 'false')
if (open) panel?.removeAttribute('hidden')
else panel?.setAttribute('hidden', '')
}

const closeMegaMenus = (except = null) => {
document.querySelectorAll('[data-mega-trigger][aria-expanded="true"]').forEach((button) => {
  if (button !== except) setMegaState(button, false)
})
}

const clearMegaTimer = (map, group) => {
const timer = map.get(group)
if (timer) window.clearTimeout(timer)
map.delete(group)
}

document.addEventListener('click', (event) => {
const trigger = event.target.closest('[data-mega-trigger]')
if (!trigger) return
event.preventDefault()
const wasOpen = trigger.getAttribute('aria-expanded') === 'true'
closeMegaMenus(trigger)
setMegaState(trigger, !wasOpen)
})

document.addEventListener('mouseover', (event) => {
if (!window.matchMedia?.('(pointer: fine)').matches) return
const group = event.target.closest?.('.sj-mega')
if (!group || group.contains(event.relatedTarget)) return
clearMegaTimer(megaCloseTimers, group)
clearMegaTimer(megaOpenTimers, group)
const trigger = group.querySelector('[data-mega-trigger]')
megaOpenTimers.set(group, window.setTimeout(() => {
  closeMegaMenus(trigger)
  setMegaState(trigger, true)
}, 90))
})

document.addEventListener('mouseout', (event) => {
if (!window.matchMedia?.('(pointer: fine)').matches) return
const group = event.target.closest?.('.sj-mega')
if (!group || group.contains(event.relatedTarget)) return
clearMegaTimer(megaOpenTimers, group)
clearMegaTimer(megaCloseTimers, group)
const trigger = group.querySelector('[data-mega-trigger]')
megaCloseTimers.set(group, window.setTimeout(() => setMegaState(trigger, false), 260))
})

document.addEventListener('focusin', (event) => {
if (event.target.closest?.('.sj-mega')) return
closeMegaMenus()
})

document.addEventListener('keydown', (event) => {
if (event.key !== 'Escape') return
const open = [...document.querySelectorAll('[data-mega-trigger][aria-expanded="true"]')]
if (!open.length) return
const trigger = event.target.closest?.('[data-mega-trigger]')
const panel = event.target.closest?.('[data-mega-panel]')
// Escape closes any open panel, wherever focus is; focus only returns to the
// trigger when focus was inside that disclosure group.
const owner = trigger
  || (panel && document.querySelector(`[aria-controls="${panel.id}"]`))
  || null
open.forEach((button) => setMegaState(button, false))
if (owner) owner.focus()
})

document.addEventListener('click', (event) => {
if (event.target.closest('[data-mega-trigger], [data-mega-panel]')) return
closeMegaMenus()
})

document.addEventListener('click', (event) => {
const alt = event.target.closest('[data-card-alt-toggle]')
if (alt) {
  const card = alt.closest('[data-product-card]')
  const active = card?.dataset.cardAlt === 'true'
  if (card) card.dataset.cardAlt = active ? 'false' : 'true'
  alt.setAttribute('aria-pressed', active ? 'false' : 'true')
  alt.textContent = active ? 'View worn' : 'View front'
}
})

const comparedProducts = new Map()
const renderCompareTray = () => {
const tray = document.querySelector('[data-compare-tray]')
document.querySelectorAll('[data-card-compare]').forEach((button) => {
  const active = comparedProducts.has(button.dataset.productHandle)
  button.setAttribute('aria-pressed', active ? 'true' : 'false')
  button.textContent = active ? '✓ Comparing' : '+ Compare'
})
if (!tray) return
const count = comparedProducts.size
tray.hidden = count === 0
const countNode = tray.querySelector('[data-compare-count]')
const namesNode = tray.querySelector('[data-compare-names]')
if (countNode) countNode.textContent = `${count} ${count === 1 ? 'piece' : 'pieces'} selected`
if (namesNode) namesNode.textContent = [...comparedProducts.values()].join(' · ')
}

document.addEventListener('click', (event) => {
const compare = event.target.closest('[data-card-compare]')
if (compare) {
  const handle = compare.dataset.productHandle
  if (comparedProducts.has(handle)) comparedProducts.delete(handle)
  else if (comparedProducts.size < 3) comparedProducts.set(handle, compare.dataset.productTitle || handle)
  else {
    const tray = document.querySelector('[data-compare-tray]')
    tray?.animate?.([{ transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'none' }], { duration: 180 })
  }
  renderCompareTray()
  return
}
if (event.target.closest('[data-compare-clear]')) {
  comparedProducts.clear()
  renderCompareTray()
}
})

const personalizationBaseChoiceMissing = (wrapper) => {
const controls = [...wrapper.querySelectorAll('input, select, textarea')].filter((control) => !control.disabled)
const required = wrapper.dataset.required === 'true' || wrapper.dataset.intentionalChoice === 'true'
if (!required || !controls.length) return false
if (controls.some((control) => control.matches('[type="radio"], [type="checkbox"]'))) {
  return !controls.some((control) => control.checked)
}
return !String(controls[0].value || '').trim()
}

const nativeOptionChoiceMissing = (fieldset) => {
const selected = fieldset.querySelector('input:checked, select')
return !String(selected?.value || '').trim()
  || (fieldset.hasAttribute('data-required-touch') && fieldset.dataset.touched !== 'true')
}

const baseChoiceLabel = (element) => String(
element.dataset.optionLabel
|| element.dataset.fieldTitle
|| element.querySelector('.sj-legend, legend, .sj-label')?.textContent
|| 'options'
).split('·')[0].trim()

/* These two helpers used to re-derive meaning from the merchant-typed option name
 with their own regexes, and they disagreed with the Liquid resolver. The count
 pattern included `amount`, so the gift card's $50.00–$200.00 denomination axis was
 still stamped data-option-display="count" by JavaScript even after Liquid had
 correctly called it gift_card_denomination. The role is now resolved once, in
 snippets/sj-option-role.liquid, published as data-option-role, and simply read
 here. Nothing in this file interprets an option name any more. */
const ROLE_ORDER_RANK = {
metal_finish: 10, stone_color: 10, material: 10,
ring_size: 20, chain_length: 20, pendant_size: 20, dimension: 20,
style_variant: 30, font_choice: 30, zodiac_choice: 30, birthstone_choice: 30,
count: 40, gift_card_denomination: 40, cart_quantity: 40,
default_title: 90
}
const COUNT_ROLES = new Set(['count'])

/* Base fields that the personalizer moves or rebuilds keep data-option-index but not
 always data-option-role, so fall back to the source fieldset carrying the same
 native label. Without this they collapse to the unknown-rank bucket and the metal
 axis sorts to the end. */
const nativeOptionRole = (fieldset) => {
const own = String(fieldset?.dataset?.optionRole || '').trim()
if (own) return own
const label = String(fieldset?.dataset?.nativeOptionLabel || '').trim()
if (!label) return ''
const root = fieldset.closest('form') || document
for (const candidate of root.querySelectorAll('[data-option-role]')) {
  if (String(candidate.dataset.nativeOptionLabel || '').trim() === label) {
    return String(candidate.dataset.optionRole || '').trim()
  }
}
return ''
}
const nativeOptionOrderRank = (fieldset) => ROLE_ORDER_RANK[nativeOptionRole(fieldset)] ?? 50
const nativeOptionIsCount = (fieldset) => COUNT_ROLES.has(nativeOptionRole(fieldset))
const basePersonalizationFields = (form) => [...form.querySelectorAll(
'[data-personalization-field][data-personalization-stage="base"]:not([hidden])'
)]

const standardizeNativeOptionOrder = (form) => {
const primary = form.querySelector('.sj-product-form__decisions:not([data-personalization-base-fields])')
if (primary) {
  basePersonalizationFields(form)
    .filter((field) => field.dataset.optionRole)
    .forEach((field) => primary.append(field))
  const baseWrap = form.querySelector('[data-personalization-base-wrap]')
  const baseContainer = form.querySelector('[data-personalization-base-fields]')
  if (baseContainer && !baseContainer.children.length) baseWrap?.setAttribute('hidden', '')
}

form.querySelectorAll('.sj-product-form__decisions').forEach((container) => {
  const groups = [...container.children].filter((child) => child.matches(
    '[data-option-index], [data-personalization-field][data-personalization-stage="base"][data-option-role]'
  ))
  groups.forEach((group) => {
    if (nativeOptionIsCount(group)) group.dataset.optionDisplay = 'count'
  })
  if (groups.length < 2) return
  const sourceOrder = new Map(groups.map((group, index) => [group, index]))
  groups
    .sort((left, right) => (
      nativeOptionOrderRank(left) - nativeOptionOrderRank(right)
      || (Number.isFinite(Number(left.dataset.optionIndex)) ? Number(left.dataset.optionIndex) : 999)
        - (Number.isFinite(Number(right.dataset.optionIndex)) ? Number(right.dataset.optionIndex) : 999)
      || sourceOrder.get(left) - sourceOrder.get(right)
    ))
    .forEach((group) => container.append(group))
})
}

const unresolvedBaseChoices = (form) => {
const unresolved = []
basePersonalizationFields(form).forEach((wrapper) => {
  if (personalizationBaseChoiceMissing(wrapper)) unresolved.push({ element: wrapper, label: baseChoiceLabel(wrapper) })
})
form.querySelectorAll('[data-option-index]').forEach((fieldset) => {
  if (nativeOptionChoiceMissing(fieldset)) unresolved.push({ element: fieldset, label: baseChoiceLabel(fieldset) })
})
/* A fan-out product is not ready when its variant resolves — it is ready when the shopper has said
   how many pieces and chosen that many. Reported here so the CTA, the availability line and the
   focus-the-unanswered-question behaviour all get it for free. */
const fanOut = form._sjFanOut
if (fanOut && !fanOut.complete()) unresolved.push({
  element: fanOut.element,
  label: fanOut.missingLabel(),
  activate: () => fanOut.activate()
})
return unresolved
}

const applyChoiceTemplate = (template, token, value, fallback) => {
const source = String(template || fallback || '')
return source.includes(token) ? source.replace(token, value) : source
}

const unresolvedChoicePrompt = (form, choices = unresolvedBaseChoices(form)) => {
if (!choices.length) return ''
const labels = choices.map(({ label }) => label.toLocaleLowerCase()).join(' + ')
const source = form.querySelector('[data-personalize-start], [data-product-submit], [data-product-availability]')
return applyChoiceTemplate(source?.dataset.chooseTemplate, '__AXES__', labels, source?.dataset.choose)
}

const focusUnresolvedChoice = (form) => {
const choices = unresolvedBaseChoices(form)
const first = choices[0]
if (!first) return false
const target = first.element.matches('fieldset')
  ? first.element
  : first.element.querySelector('fieldset') || first.element
if (!target.hasAttribute('tabindex')) target.tabIndex = -1
first.element.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
target.focus({ preventScroll: true })
const live = form.querySelector('[data-product-availability]')
if (live) live.textContent = `${unresolvedChoicePrompt(form, choices)}.`
return true
}

/* ── Controller next-action helpers ───────────────────────────────────────────
 Every configurator controller answers the same two questions from its OWN state
 and validation results. Nothing here reads a button's text: an earlier attempt
 scraped [data-config-primary].textContent and served a one-tick-stale label, which
 is the same defect the shared resolver exists to remove. */
const stageAdvanceAction = ({ stages, stage, nextButton, goNext }) => {
const upcoming = stages[stage + 1]
if (upcoming === undefined) return null
const label = upcoming === 'Review' ? 'Review design' : `Continue to ${upcoming.toLocaleLowerCase()}`
return {
  kind: 'advance_stage', label, accessibleLabel: label,
  meta: { fromStage: stages[stage], toStage: upcoming, stageIndex: stage },
  target: nextButton || null,
  activate: () => { if (nextButton && !nextButton.hidden) nextButton.click(); else goNext?.() }
}
}

const errorAction = (error, kind, resolveTarget) => {
if (!error) return null
const label = `Choose ${String(error.label || '').toLocaleLowerCase()}`.replace(/^choose (enter|upload)/i, '$1')
return {
  kind, label: error.ctaLabel || label, accessibleLabel: error.message || error.ctaLabel || label,
  meta: { errorKey: error.key, field: error.label },
  target: null,
  activate: () => {
    const node = resolveTarget?.(error)
    if (!node) return
    node.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
    node.focus?.({ preventScroll: true })
  }
}
}

/*
  Scoped to the FORM, not to the fields container.

  A configurator moves the fields it owns out of [data-personalization-fields] and takes its
  siblings with it — the hexagon pendant's birthstone ends up outside that container even though
  nothing claimed it. Searching only the container found no missing answer, so the CTA resolver fell
  through to "ready" and the button read "Add to cart — $66.00" on a form that then refused to
  submit. Telling a shopper the piece is ready and then blocking them is the failure this fixes.

  Widening is safe: the controls a configurator owns are disabled by it, and disabled controls are
  filtered out below, so an owned field can never be reported twice.
*/
const firstMissingPersonalizationField = (form) => [...form.querySelectorAll(
'[data-personalization-field]:not([hidden])'
)].find((wrapper) => {
if (wrapper.classList.contains('sj-personalization-instruction')) return false
const controls = [...wrapper.querySelectorAll('input, select, textarea')].filter((control) => !control.disabled)
const required = wrapper.dataset.required === 'true' || controls.some((control) => control.required)
if (!required || !controls.length) return false
if (controls.some((control) => control.matches('[type="radio"], [type="checkbox"]'))) {
  return !controls.some((control) => control.checked)
}
const file = controls.find((control) => control.type === 'file')
if (file) return !file.files?.length
return !String(controls[0].value || '').trim()
})

const missingRequiredPersonalization = (form) => Boolean(firstMissingPersonalizationField(form))

/* Structured sources stay in the form so their exact line-item property still serialises,
 but their customer-facing control is a button/modal. Route focus and CTA activation to
 that visible owner instead of focusing a one-pixel carrier. */
const visiblePersonalizationTarget = (control, wrapper = control?.closest?.('[data-personalization-field]')) => {
if (!control) return wrapper || null
if (control.dataset.mediaChoiceSource !== undefined) {
  /*
    The trigger is usually beside its own select. It is not when the chooser has been placed inside
    the design — the hexagon's stone sits in the middle of the four initials — so it is looked up by
    the dialog this control drives, which is derived from this control's own id and therefore cannot
    match another field's trigger. Falling through to the select made the CTA's "Choose birthstone"
    a dead end: it focused something invisible and nothing opened.
  */
  return wrapper?.querySelector('[data-media-choice-open]')
    || (control.id && control.closest('form')?.querySelector(`[data-media-choice-open][aria-controls="${control.id}-MediaPicker"]`))
    || control
}
if (control.dataset.singleInitialValue !== undefined) return wrapper?.querySelector('[data-single-initial-open]') || control
if (control.dataset.fontChoiceSource !== undefined) return control.closest('form')?.querySelector('[data-font-picker-open]') || control
if (control.dataset.fontNameSource !== undefined && wrapper?.dataset.fontSelected !== 'true') {
  return control.closest('form')?.querySelector('[data-font-picker-open]') || control
}
if (control.dataset.fontNameSource !== undefined) return wrapper?.querySelector('[data-font-name-input]') || control
/*
  A field that owns a modal opener but whose control carries none of the source markers above —
  the products with ONE combined "Font and name" field, where the trigger sits in the wrapper and
  the control is the plain text input. Without this the CTA fell through to focusing the input, so
  "Choose font" was a dead end: the shopper was told what was missing and clicking it did nothing.
  Checked last so nothing that already resolves a specific target changes.
*/
const wrapperOpener = wrapper?.querySelector('[data-font-picker-open], [data-media-choice-open], [data-single-initial-open]')
if (wrapperOpener) return wrapperOpener
/*
  A visual chooser that has been moved out of its field — the hexagon's stone lives in the middle of
  the design, not beside its own label — is still THIS field's control. It is found by the dialog it
  drives, which is derived from this control's id, so no other field's trigger can be picked up by
  mistake. Without this the CTA's "Choose birthstone" focused a hidden select and nothing opened.
*/
if (control?.id) {
  const moved = control.closest('form')?.querySelector(`[data-media-choice-open][aria-controls="${control.id}-MediaPicker"]`)
  if (moved) return moved
}
return control
}

const genericFieldRequirement = (form) => {
const wrapper = firstMissingPersonalizationField(form)
if (!wrapper) return null
const d = form.querySelector('[data-product-submit]')?.dataset || {}
const field = String(wrapper.dataset.fieldTitle || '').trim() || 'your details'
const control = wrapper.querySelector('input:not([disabled]), select, textarea')
const visibleTarget = visiblePersonalizationTarget(control, wrapper)
const modalChoice = control?.dataset.mediaChoiceSource !== undefined
  || control?.dataset.singleInitialValue !== undefined
  || control?.dataset.fontChoiceSource !== undefined
  || (control?.dataset.fontNameSource !== undefined && wrapper.dataset.fontSelected !== 'true')
  /* Same combined-field case as visiblePersonalizationTarget: the opener lives on the wrapper, so
     the CTA must ACTIVATE it rather than focus the text input behind it. */
  || Boolean(wrapper?.querySelector('[data-font-picker-open], [data-media-choice-open], [data-single-initial-open]'))
  /* A chooser relocated into the design still has to be OPENED by the CTA, not focused. */
  || Boolean(visibleTarget?.matches?.('[data-media-choice-open], [data-single-initial-open], [data-font-picker-open]'))
const verb = control?.type === 'file' ? 'Upload' : modalChoice || control?.tagName === 'SELECT' || control?.type === 'radio' ? 'Choose' : 'Enter'
const label = `${verb} ${field.toLocaleLowerCase()}`
const kind = control?.dataset.mediaChoiceSource !== undefined
  ? 'media_choice'
  : control?.dataset.singleInitialValue !== undefined
    ? 'single_initial'
    : modalChoice
      ? 'font_choice'
      : 'personalization_field'
return {
  kind, label, accessibleLabel: label, meta: { field },
  target: visibleTarget || wrapper,
  activate: () => {
    wrapper.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
    if (modalChoice && visibleTarget?.click) visibleTarget.click()
    else (visibleTarget || wrapper).focus?.({ preventScroll: true })
  }
}
}

/* ── Shared PDP next-action resolver ────────────────────────────────────────
 One hierarchy, one action object, both CTAs. State comes from controller
 getNextAction() and from unresolvedBaseChoices — never from any button's text.
 Controllers no longer author the primary CTA label; they only report what they
 still need, which is what removes the desktop/sticky staleness entirely. */
const ctaTemplate = (source, token, value, fallback) => {
const raw = String(source || '')
return raw ? raw.split(token).join(value) : String(fallback || '')
}

const nextRequiredAction = (form) => {
const submit = form?.querySelector('[data-product-submit]')
const d = submit?.dataset || {}

/* 1 — true commerce blockers. The only states allowed to disable. */
if (form?.dataset.ctaBusy === 'true') {
  return { kind: 'busy', label: d.busy || 'Working…', accessibleLabel: d.busy || 'Working…',
    blocking: true, disabled: true, ready: false, activate: () => {} }
}
/* Safety-critical: a priced personalization choice the theme cannot model. The
   undercharge guard disables submission; the CTA must say so honestly and must not
   be re-enabled by the renderer. Two catalogue products fail closed here and their
   price is never guessed. */
/* A DECLARED structured profile that is inactive, wrong-version, empty or price-unsafe.
   The merchant's configuration is broken, so the shopper is told plainly and submission
   stays disabled — the theme never guesses a contract and never falls back to free text. */
if (form?.dataset.profileBlocked === 'true') {
  const label = d.profileBlocked || 'Personalization unavailable — configuration incomplete'
  return { kind: 'profile_blocked', label, accessibleLabel: d.profileBlockedA11y || label,
    blocking: true, disabled: true, ready: false,
    target: form.querySelector('[data-personalization-status]'),
    activate: () => form.querySelector('[data-personalization-status]')
      ?.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }) }
}
if (form?.dataset.unmodeledPrice === 'true') {
  const label = d.unmodeledPrice || 'Unavailable to order online'
  return { kind: 'unmodeled_price', label, accessibleLabel: d.unmodeledPriceA11y || label,
    blocking: true, disabled: true, ready: false,
    target: form.querySelector('[data-personalization-status]'),
    activate: () => form.querySelector('[data-personalization-status]')
      ?.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }) }
}
const variantInput = form?.querySelector('input[name="id"]')
if (form?.dataset.variantUnavailable === 'true' || (variantInput && !variantInput.value)) {
  return { kind: 'unavailable', label: d.unavailable || 'Unavailable', accessibleLabel: d.unavailable || 'Unavailable',
    blocking: true, disabled: true, ready: false, activate: () => {} }
}

/* 2 — first missing required native axis, in resolved role order. */
const unresolved = form ? unresolvedBaseChoices(form) : []
if (unresolved.length) {
  const axis = unresolved[0]
  const label = ctaTemplate(d.chooseTemplate, '__AXES__', axis.label.toLocaleLowerCase(), d.choose)
  return { kind: 'native_option', label, accessibleLabel: label, blocking: false, disabled: false, ready: false,
    meta: { axis: axis.label }, target: axis.element,
    activate: () => {
      if (typeof axis.activate === 'function') {
        axis.activate()
        return
      }
      const node = axis.element
      const focusable = node.hasAttribute('tabindex') || node.matches('input, select, textarea, button')
        ? node
        : node.querySelector('input:not([disabled]), select, textarea, button:not([disabled])') || node
      node.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
      focusable.focus?.({ preventScroll: true })
    } }
}

/* 3 — personalization not started. */
const start = form?.querySelector('[data-personalize-start]:not([hidden])')
if (start) {
  const label = (start.textContent || '').trim() || d.startPersonalization || 'Start personalization'
  return { kind: 'personalization_start', label, accessibleLabel: label, blocking: false, disabled: false,
    ready: false, target: start, activate: () => start.click() }
}

/* 4/5 — the controller's own outstanding requirement, derived from its state. */
const controllers = form?._sjControllers || (form?._sjPositionConfigurator ? [form._sjPositionConfigurator] : [])
for (const controller of controllers) {
  const fromController = controller?.getNextAction?.()
  if (fromController) return { blocking: false, disabled: false, ready: false, ...fromController }
}

/* 4 (generic path) — first missing required personalization field. */
const genericField = genericFieldRequirement(form)
if (genericField) return { blocking: false, disabled: false, ready: false, ...genericField }

/* 6 — ready. */
const price = form?.closest('.sj-product__buybox')?.querySelector('[data-product-price]')?.textContent.trim() || ''
const label = ctaTemplate(d.availableTemplate, '__PRICE__', price, d.available)
return { kind: 'ready', label, accessibleLabel: label, blocking: false, disabled: false, ready: true,
  target: submit, activate: () => submit?.form?.requestSubmit?.(submit) }
}

const renderPrimaryCta = (form) => {
if (!form) return null
const action = nextRequiredAction(form)
const bar = document.querySelector('[data-pdp-sticky]')
const sticky = bar?.querySelector('[data-sticky-cta]')
const submit = form.querySelector('[data-product-submit]')
const configPrimary = form.querySelector('[data-config-primary]:not([hidden])')
/* [data-config-next] is authored by the staged controller. Mirror the shared state
   onto it so both surfaces agree semantically, but never rewrite its stage label. */
const stageOwned = configPrimary?.matches('[data-config-next]')
if (stageOwned) {
  configPrimary.dataset.ctaKind = action.kind
  configPrimary.dataset.ctaReady = action.ready ? 'true' : 'false'
  configPrimary.setAttribute('aria-label', action.accessibleLabel)
}

for (const button of [submit, stageOwned ? null : configPrimary, sticky].filter(Boolean)) {
  const slot = button.querySelector('[data-submit-label]') || button
  /* The sticky bar may use its own concise template for the SAME action; state,
     accessible intent and target are always identical. */
  let text = action.label
  if (button === sticky && action.kind === 'native_option' && button.dataset.chooseTemplate) {
    text = ctaTemplate(button.dataset.chooseTemplate, '__AXIS__',
      String(action.meta?.axis || '').toLocaleLowerCase(), button.dataset.choose)
  }
  if (slot.textContent !== text) slot.textContent = text
  button.setAttribute('aria-label', action.accessibleLabel)
  button.dataset.ctaKind = action.kind
  button.dataset.ctaReady = action.ready ? 'true' : 'false'
  if (action.disabled) button.setAttribute('disabled', '')
  else if (!button.dataset.blockedByGuard) button.removeAttribute('disabled')
  if (action.disabled) button.setAttribute('aria-disabled', 'true')
  else button.removeAttribute('aria-disabled')
}
form._sjCtaAction = action
const live = form.querySelector('[data-cta-live]')
if (live && live.textContent !== action.accessibleLabel) live.textContent = action.accessibleLabel
return action
}

const activatePrimaryCta = (form, event) => {
const action = form?._sjCtaAction || nextRequiredAction(form)
if (!action || action.ready) return false
const OWNED_BY_RESOLVER = [
  'native_option', 'token_position', 'advance_stage', 'personalization_start',
  'media_choice', 'single_initial', 'font_choice'
]
if (!OWNED_BY_RESOLVER.includes(action.kind)) return false
if (event?.target?.closest?.('[data-config-next]')) return false
if (action.target && event?.target?.closest?.('button') === action.target) return false
event?.preventDefault?.()
event?.stopPropagation?.()
const controller = form?._sjPositionConfigurator
if (controller?.activateNextAction && ['token_position', 'token_validation', 'stage_field', 'advance_stage'].includes(action.kind)) {
  controller.activateNextAction(action)
} else {
  action.activate?.()
}
return true
}

document.addEventListener('click', (event) => {
const button = event.target.closest('[data-product-submit], [data-config-primary], [data-sticky-cta]')
if (!button) return
const form = button.closest('[data-sj-product-form]') || document.querySelector('[data-sj-product-form]')
if (!form) return
if (activatePrimaryCta(form, event)) return
if (button.matches('[data-sticky-cta]')) {
  event.preventDefault()
  form.querySelector('[data-product-submit]')?.click()
}
}, true)

const scheduleCtaSync = () => {
const form = document.querySelector('[data-sj-product-form]')
if (form) renderPrimaryCta(form)
}
addEventListener('pageshow', scheduleCtaSync)
addEventListener('popstate', scheduleCtaSync)
document.addEventListener('silveristic:configurator-change', scheduleCtaSync)

const advanceToPersonalization = (form) => {
if (form.dataset.baseOnly === 'true') return false
const personalizer = form.querySelector('[data-sj-personalizer]')
if (!personalizer) return false
const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'

if (form.dataset.inlinePersonalization === 'true') {
  personalizer.scrollIntoView({ block: 'start', behavior })
  return true
}
if (form._sjPositionConfigurator?.start) {
  form._sjPositionConfigurator.start()
  syncPdpSticky()
  return true
}
const start = form.querySelector('[data-personalize-start]:not([hidden])')
if (!start) return false
start.click()
return true
}

const updateProductForm = (form, changedInput) => {
const variantsNode = form.querySelector('[data-sj-variants]')
if (!variantsNode) return
let variants = []
try {
  variants = JSON.parse(variantsNode.textContent)
} catch {
  return
}

const optionGroups = [...form.querySelectorAll('[data-option-index]')]
const selections = optionGroups
  .reduce((result, fieldset) => {
    const selected = fieldset.querySelector('input:checked, select')
    result[Number(fieldset.dataset.optionIndex)] = selected?.value || ''
    return result
  }, [])
const nativeSelectionIncomplete = optionGroups.some(
  (fieldset) => !fieldset.querySelector('input:checked, select')?.value
)

const idInput = form.querySelector('input[name="id"]')
const variant = optionGroups.length
  ? variants.find((item) => item.options.every((option, index) => option === selections[index]))
  : variants.find((item) => String(item.id) === String(idInput?.value)) || variants[0]
const buybox = form.closest('.sj-product__buybox')
const price = buybox?.querySelector('[data-product-price]')
const compare = buybox?.querySelector('[data-compare-price]')
const pricePrefix = buybox?.querySelector('[data-product-price-prefix]')
const add = form.querySelector('[data-product-submit]')
const availability = form.querySelector('[data-product-availability]')

if (variant && idInput) idInput.value = variant.id
/* A fan-out set costs what its pieces cost. Every piece is the same price on this product, so the
   set price is the variant price times how many were asked for — and because each piece really is
   its own line item, the number the shopper reads here is the number the cart charges. */
const fanOutCount = form._sjFanOut?.count
const setMultiplier = fanOutCount && fanOutCount > 0 ? fanOutCount : 1
if (price && variant) price.textContent = money(variant.price * setMultiplier)
if (pricePrefix) pricePrefix.hidden = Boolean(variant && !nativeSelectionIncomplete)
if (compare && variant) {
  compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : ''
  compare.hidden = !(variant.compare_at_price > variant.price)
}
if (compare && nativeSelectionIncomplete) compare.hidden = true
if (changedInput?.closest('[data-required-touch]')) {
  changedInput.closest('[data-required-touch]').dataset.touched = 'true'
}

const baseChoicesWereComplete = form.dataset.baseChoicesComplete === 'true'
const unresolvedChoices = unresolvedBaseChoices(form)
const requiredPersonalizationMissing = missingRequiredPersonalization(form)
const choiceMissing = unresolvedChoices.length > 0
const choiceLabel = unresolvedChoicePrompt(form, unresolvedChoices)
const unavailable = Boolean(!nativeSelectionIncomplete && (!variant || !variant.available))
const baseChoicesComplete = !choiceMissing && !unavailable
form.dataset.baseChoicesComplete = baseChoicesComplete ? 'true' : 'false'
// mirror onto the section root: the price hint renders before the form opens, so a
// sibling selector cannot reach the form's own attribute
const productRoot = form.closest('[data-product-root]')
if (productRoot) productRoot.dataset.baseChoicesComplete = baseChoicesComplete ? 'true' : 'false'
if (availability) {
  availability.textContent = choiceMissing
    ? choiceLabel
    : variant?.available
      ? availability.dataset.available
      : availability.dataset.unavailable
}
if (add) {
  add.disabled = Boolean(
    unavailable
    || form.dataset.profileBlocked === 'true'
    || form.dataset.unmodeledPrice === 'true'
  )
  if (form.dataset.unmodeledPrice === 'true') add.dataset.blockedByGuard = 'unmodeled-price'
  else delete add.dataset.blockedByGuard
  if (add.disabled) add.setAttribute('aria-disabled', 'true')
  else add.removeAttribute('aria-disabled')
  add.toggleAttribute('data-choice-missing', choiceMissing)
  const availableLabel = variant
    ? applyChoiceTemplate(add.dataset.availableTemplate, '__PRICE__', money(variant.price * setMultiplier), add.dataset.available)
    : add.dataset.available
  add.querySelector('[data-submit-label]').textContent = choiceMissing
    ? choiceLabel
    : unavailable
      ? add.dataset.unavailable
      : requiredPersonalizationMissing
        ? add.dataset.personalization || add.dataset.choose
        : availableLabel
  const shouldShowSubmit = form.dataset.baseOnly === 'true'
    || !form.querySelector('[data-personalize-start]')
    || form.dataset.personalizationStarted === 'true'
  add.toggleAttribute('hidden', !shouldShowSubmit)
}

const start = form.querySelector('[data-personalize-start]')
if (start) {
  start.disabled = unavailable
  start.setAttribute('aria-disabled', unavailable ? 'true' : 'false')
  start.toggleAttribute('data-choice-missing', choiceMissing)
  const label = start.querySelector('[data-personalize-label]')
  if (label) label.textContent = choiceMissing ? choiceLabel : unavailable ? start.dataset.unavailable || availability?.dataset.unavailable : start.dataset.ready
}
const personalizer = form.querySelector('[data-sj-personalizer]')
if (
  form.dataset.baseOnly !== 'true'
  && form.dataset.inlinePersonalization !== 'true'
  && personalizer
  && (choiceMissing || unavailable)
) {
  personalizer.open = false
  personalizer.setAttribute('hidden', '')
  delete form.dataset.personalizationStarted
  add?.setAttribute('hidden', '')
  start?.removeAttribute('hidden')
}

if (variant?.featured_media?.id) {
  const thumb = document.querySelector(`[data-gallery-thumb="${variant.featured_media.id}"]`)
  thumb?.click()
}

if (variant) {
  const url = new URL(window.location.href)
  url.searchParams.set('variant', variant.id)
  history.replaceState({}, '', url)
}
form._sjPositionConfigurator?.afterProductUpdate()

const changedUpperChoice = changedInput?.closest(
  '[data-option-index], [data-personalization-field][data-personalization-stage="base"]'
)
if (
  changedUpperChoice
  && !baseChoicesWereComplete
  && baseChoicesComplete
  && form.dataset.personalizationAutoAdvanced !== 'true'
  && form.dataset.baseOnly !== 'true'
  && form.querySelector('[data-sj-personalizer]')
) {
  form.dataset.personalizationAutoAdvanced = 'true'
  requestAnimationFrame(() => advanceToPersonalization(form))
}
}

const createElement = (tag, className = '', textContent = '') => {
const element = document.createElement(tag)
if (className) element.className = className
if (textContent) element.textContent = textContent
return element
}

const formSelections = (form) => [...form.querySelectorAll('[data-option-index]')]
.reduce((result, fieldset) => {
  const selected = fieldset.querySelector('input:checked, select')
  result[Number(fieldset.dataset.optionIndex)] = selected?.value || ''
  return result
}, [])

/*
  The same selections keyed by the merchant's option NAME rather than its rendered position.

  Position is not a stable key. sj-product-commerce sorts the option fieldsets by role before
  rendering, so "Heart Type" can be third in the product data and second on the page, and a
  condition written against index 2 then watches Length instead. Name is what the merchant
  actually controls and what the document names, so it is the authoritative key; the index path
  below survives only for contracts already shipped against it.
*/
const formSelectionsByName = (form) => [...form.querySelectorAll('[data-option-index]')]
.reduce((result, fieldset) => {
  const label = fieldset.dataset.nativeOptionLabel
    || fieldset.querySelector('legend')?.childNodes[0]?.textContent?.trim()
    || ''
  const selected = fieldset.querySelector('input:checked, select')
  if (label) result[label.trim().toLocaleLowerCase()] = selected?.value || ''
  return result
}, {})

/*
  What the personalization fields themselves currently answer, keyed by title.

  Native options answer the question "which variant"; these answer "what shall we make". A field
  can now depend on ANOTHER field's answer — the paw pendant offers a switch between a word and a
  single character, and the box that follows has a different limit for each — which no variant axis
  expresses, because the choice changes nothing about the piece being sold.
*/
const formPersonalizationValues = (form) => [...form.querySelectorAll('[data-personalization-field]')]
.reduce((result, wrapper) => {
  const title = String(wrapper.dataset.fieldTitle || '').trim().toLocaleLowerCase()
  if (!title) return result
  const checked = wrapper.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked')
  const control = checked || wrapper.querySelector('select, input:not([type="radio"]):not([type="checkbox"]), textarea')
  result[title] = control ? String(control.value ?? '') : ''
  return result
}, {})

const parsePersonalizationSchema = (node) => {
if (!node) return null
try {
  let schema = JSON.parse(node.textContent)
  if (typeof schema === 'string') schema = JSON.parse(schema)
  return schema
} catch {
  return null
}
}

/*
Photographs of the actual pieces, keyed by the EXACT saved value that reaches the cart.

Emitted once per page by snippets/sj-token-media.liquid, which is generated from
custom-data/token-media.mjs — so the mapping lives in one place and this side carries no
normalization of its own. "HEART (❤️)" and "HEART" and "Jan - Garnet" and "JANUARY" are
separate keys pointing at the same asset precisely so that this stays a plain lookup.

A miss returns null and the caller keeps the glyph it renders today. Three real choices have
no photograph (BASEBALL, AMPERSAND, TRIANGLE); showing them a different charm would be a
false claim about what the customer is buying.
*/
const tokenMediaMap = (() => {
const node = document.querySelector('[data-sj-token-media]')
if (!node) return {}
try {
  const parsed = JSON.parse(node.textContent)
  return parsed && typeof parsed === 'object' ? parsed : {}
} catch {
  return {}
}
})()
const tokenPhotograph = (type, value) => {
if (!type || value == null || value === '') return null
return tokenMediaMap[`${type}|${value}`] || null
}

const alphabet = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ']
const numbers = [...'0123456789']
const structuredSymbols = [
{ value: 'HEART (❤️)', label: 'Heart', glyph: '♥', category: 'Meaning' },
{ value: 'CROSS (†)', label: 'Cross', glyph: '†', category: 'Meaning' },
{ value: 'CLOVER (🍀)', label: 'Clover', glyph: '♣', category: 'Nature' },
{ value: 'PAW', label: 'Paw', glyph: '🐾', category: 'Pets & nature' },
{ value: 'INFINITY (♾️)', label: 'Infinity', glyph: '∞', category: 'Meaning' },
{ value: 'BASEBALL (⚾)', label: 'Baseball', glyph: '⚾', category: 'Sports & music' },
{ value: 'BOLT (⚡)', label: 'Bolt', glyph: '⚡', category: 'Meaning' },
{ value: 'BUTTERFLY (🦋)', label: 'Butterfly', glyph: '🦋', category: 'Pets & nature' },
{ value: 'HASHTAG (#)', label: 'Hashtag', glyph: '#', category: 'Symbols' },
{ value: 'HORSE SHOE', label: 'Horse shoe', glyph: '∪', category: 'Symbols' },
{ value: 'KITTY CAT', label: 'Kitty cat', glyph: '🐱', category: 'Pets & nature' },
{ value: 'MOON', label: 'Moon', glyph: '☾', category: 'Pets & nature' },
{ value: 'SNOWFLAKE', label: 'Snowflake', glyph: '❄', category: 'Pets & nature' },
{ value: 'SNOWMAN', label: 'Snowman', glyph: '☃', category: 'Pets & nature' },
{ value: 'SUN', label: 'Sun', glyph: '☀', category: 'Pets & nature' },
{ value: 'TENNIS RACKET', label: 'Tennis racket', glyph: '🎾', category: 'Sports & music' },
{ value: 'TREBLE CLEF', label: 'Treble clef', glyph: '𝄞', category: 'Sports & music' }
]
const mixedSymbols = [
{ value: 'HEART', label: 'Heart', glyph: '♥', category: 'Meaning' },
{ value: 'CROSS', label: 'Cross', glyph: '†', category: 'Meaning' },
{ value: 'AMPERSAND', label: 'Ampersand', glyph: '&', category: 'Symbols' },
{ value: 'CLOVER', label: 'Clover', glyph: '♣', category: 'Nature' },
{ value: 'TRIANGLE', label: 'Triangle', glyph: '△', category: 'Symbols' }
]
const birthstones = [
{ value: 'JANUARY', label: 'January', detail: 'Garnet', glyph: '●', color: '#7A2E3A' },
{ value: 'FEBRUARY', label: 'February', detail: 'Amethyst', glyph: '●', color: '#6E5A9E' },
{ value: 'MARCH', label: 'March', detail: 'Aquamarine', glyph: '●', color: '#6FA3B4' },
{ value: 'APRIL', label: 'April', detail: 'White topaz', glyph: '●', color: '#B9BEC4' },
{ value: 'MAY', label: 'May', detail: 'Emerald', glyph: '●', color: '#2E6B4F' },
{ value: 'JUNE', label: 'June', detail: 'Alexandrite', glyph: '●', color: '#7E8FB0' },
{ value: 'JULY', label: 'July', detail: 'Ruby', glyph: '●', color: '#8E2436' },
{ value: 'AUGUST', label: 'August', detail: 'Peridot', glyph: '●', color: '#7D8F3E' },
{ value: 'SEPTEMBER', label: 'September', detail: 'Sapphire', glyph: '●', color: '#2C4A7E' },
{ value: 'OCTOBER', label: 'October', detail: 'Pink tourmaline', glyph: '●', color: '#C88699' },
{ value: 'NOVEMBER', label: 'November', detail: 'Citrine', glyph: '●', color: '#C08A2E' },
{ value: 'DECEMBER', label: 'December', detail: 'Blue topaz', glyph: '●', color: '#3E8F8A' }
]
// Merchant-owned structured profiles carry media-backed vocabularies in full. The remaining
// compatibility table is intentionally limited to flows that need no external media; a missing
// charm/birthflower profile fails closed in Liquid instead of reaching a code-owned chart.
/* Token type -> vocabulary key, so a merchant profile that names token types can be mapped
 onto the same vocabulary shape the configurator already consumes. */
const CONTRACT_VOCABULARY_KEY = {
letter: 'alphabet', number: 'numbers', charm: 'charms', serif_letter: 'serif_letters',
cursive_letter: 'cursive_letters', symbol: 'symbols', birthflower: 'birthflowers',
birthstone: 'birthstones', font: 'fonts', zodiac: 'zodiac_signs', heart: 'enamel_hearts',
lowercase_letter: 'lowercase_letters', monogram: 'monograms',
large_initial_letter: 'large_initial_letters', large_initial_symbol: 'large_initial_symbols'
}

const contractRoutingByFlow = {
letter_symbol_sequence: {
  token_types: ['letter', 'symbol', 'number'],
  vocabulary: { alphabet, symbols: structuredSymbols, numbers }
},
mixed_token_sequence: {
  token_types: ['letter', 'symbol', 'birthstone', 'number'],
  vocabulary: { alphabet, symbols: mixedSymbols, birthstones, numbers }
},
birthstone_sequence: {
  token_types: ['birthstone'],
  vocabulary: { birthstones }
},
single_initial: {
  token_types: ['letter'],
  vocabulary: { alphabet }
}
}

// Mirrors vocabularyFor in the configurator: every declared token type must resolve to choices.
const contractVocabularyKeys = {
letter: 'alphabet',
number: 'numbers',
charm: 'charms',
serif_letter: 'serif_letters',
cursive_letter: 'cursive_letters',
symbol: 'symbols',
birthflower: 'birthflowers',
birthstone: 'birthstones',
font: 'fonts',
zodiac: 'zodiac_signs',
heart: 'enamel_hearts',
lowercase_letter: 'lowercase_letters',
monogram: 'monograms',
large_initial_letter: 'large_initial_letters',
large_initial_symbol: 'large_initial_symbols'
}

const contractHasVocabulary = (contract) => {
const needsVocabulary = ['single_initial', 'choice_select', 'letter_symbol_sequence',
  'mixed_token_sequence', 'birthstone_sequence', 'birthflower_sequence',
  'mixed_birthflower_sequence', 'charm_sequence'].includes(contract?.flow_type)
  || (contract?.token_types || []).length > 0
if (!needsVocabulary) return Boolean(contract)
const types = Array.isArray(contract?.token_types) ? contract.token_types : []
if (!types.length) return false
return types.every((type) => {
  const key = contractVocabularyKeys[type]
  const choices = key ? contract.vocabulary?.[key] : null
  return Array.isArray(choices) && choices.length > 0
})
}

const hydrateContractRouting = (contract) => {
if (!contract) return contract
/*
  listings235 contracts arrive from snippets/sj-listings235-contract.liquid carrying only their
  SHAPE — the vocabulary is stripped at generation time and rebuilt here from the one shared table
  in silveristic-global-js-0-data.liquid. Inlining ~19 symbols and 12 stones into each of 135
  products would have multiplied the Liquid file several times past Shopify's 256 KB cap, and made
  a single vocabulary edit a 135-place change.

  Checked BEFORE the structured-profile branch below, which assumes a contract that already
  carries its own vocabulary. Fails closed: a token type with no table entry returns null rather
  than a picker with an empty list.
*/
if (contract.hydrate === 'listings235-v1') {
  const types = Array.isArray(contract.token_types) ? contract.token_types : []
  const vocabulary = {}
  for (const type of types) {
    /*
      A contract may READ a different table for a type it offers — the disk anklet's birth flowers
      are its own twelve, not the shared twelve — but it must STORE them under the canonical key,
      because that is what every consumer downstream looks the vocabulary up by. Storing under the
      variant name instead left the picker finding nothing and the whole contract declined.
    */
    const key = CONTRACT_VOCABULARY_KEY[type]
    const sourceKey = contract.vocabulary_variant?.[type] || key
    const choices = sourceKey && typeof LISTINGS235_VOCABULARY !== 'undefined'
      ? LISTINGS235_VOCABULARY[sourceKey]
      : null
    if (!Array.isArray(choices) || !choices.length) return null
    vocabulary[key] = choices
  }
  /*
    The paw-titled family carries a different paw charm from the generic pawprint the shared symbol
    set offers (owner, 2026-08-07). Both live in the one shared table so each ships its photograph
    once, and exactly one of them survives per product: a contract that asks for the listing paw
    drops the generic one, and every other product drops the listing paw.

    Filtering here rather than shipping a second symbol table is what keeps the other paw products
    untouched — they never name PAW LISTING, so they never see it.
  */
  if (Array.isArray(vocabulary.symbols)) {
    const dropped = contract.paw_listing ? 'PAW' : 'PAW LISTING'
    vocabulary.symbols = vocabulary.symbols
      .filter((choice) => String(choice?.value ?? choice).toUpperCase() !== dropped)
  }
  return { ...contract, vocabulary, source: 'listings235' }
}
/* A merchant-configured profile SUPPLIES its own vocabulary, picker, serializer and count
   binding. It must not be re-hydrated from contractRoutingByFlow, because that table is
   keyed by the shipped handle registry and would overwrite the merchant's own choice sets
   with the built-in ones. It is the highest-precedence source; the table below it is a
   read-only compatibility tier. */
if (contract.source === 'structured-profile') {
  /* Every key the picker reads is carried through: detail is the second caption line, color
     is the birthstone swatch, and image_url/x/y crop one charm out of the reviewed sheet.
     Dropping them here rendered charms as blank tiles and birthstones without their colour. */
  const vocabulary = contract.vocabulary && Object.keys(contract.vocabulary).length
    ? Object.fromEntries(Object.entries(contract.vocabulary).map(([tokenType, choices]) => [
        CONTRACT_VOCABULARY_KEY[tokenType] ?? tokenType,
        choices.map((c) => ({
          value: c.value, label: c.label, detail: c.detail, category: c.category, glyph: c.glyph,
          color: c.color, image_url: c.image_url, image_x: c.image_x, image_y: c.image_y
        }))
      ]))
    : null
  const needsVocabulary = ['single_initial', 'choice_select', 'letter_symbol_sequence',
    'mixed_token_sequence', 'birthstone_sequence', 'birthflower_sequence',
    'mixed_birthflower_sequence', 'charm_sequence'].includes(contract.flow_type)
    || (contract.token_types || []).length > 0
  if (needsVocabulary && !vocabulary) return null
  return { ...contract, vocabulary: vocabulary || {}, token_types: contract.token_types ?? Object.keys(contract.vocabulary || {}) }
}
if (contract.hydrate !== 'vocabulary-by-flow-v1') return contract
const routing = contractRoutingByFlow[contract.flow_type]
if (!routing) return null
return { ...contract, ...routing }
}

// A routing-only node that cannot be hydrated collapses to null. Media-backed flows are
// emitted only from a complete structured profile and fail closed in Liquid; this remaining
// hydration tier exists solely for the reviewed non-media compatibility contracts.
const shippedContract = (form) => {
const contract = hydrateContractRouting(
  parsePersonalizationSchema(form.querySelector('[data-personalization-contract-schema]'))
)
return contractHasVocabulary(contract) ? contract : null
}

const personalizationContract = (form) => shippedContract(form)

const guideCharts = []

const publishGuideCharts = (form) => {
const target = productScope().querySelector('[data-personalization-guide-media]')
const list = target?.querySelector('[data-personalization-guide-media-list]')
const charts = guideCharts.splice(0, guideCharts.length)
if (!target || !list) return
const seen = new Set()
for (const chart of charts) {
  if (!chart.src || seen.has(chart.src)) continue
  seen.add(chart.src)
  const figure = createElement('figure', 'sj-commerce-guide-media__item')
  const image = document.createElement('img')
  image.src = chart.src
  image.alt = String(form?.querySelector('[data-sj-personalizer]')?.dataset.productTitle || '')
    ? `Reference chart for ${form.querySelector('[data-sj-personalizer]').dataset.productTitle}`
    : 'Personalization reference chart'
  image.width = 900
  image.height = 900
  image.loading = 'lazy'
  figure.append(image)
  list.append(figure)
}
if (list.children.length) target.removeAttribute('hidden')
}

const propertyName = (field, index) => {
const label = String(field.title || field.label || `Personalization ${index + 1}`).trim()
return label || `Personalization ${index + 1}`
}

const verbosePropertyLabel = (label) => {
const normalized = String(label || '').replace(/\s+/g, ' ').trim()
return normalized.length > 48 || /^(?:add|enter|list|please|provide|specify|type|upload|write)\b/i.test(normalized)
}

const fulfillmentPropertyLabel = (label, type = '') => {
const normalized = String(label || '').replace(/\s+/g, ' ').trim()
if (String(type).toLowerCase() === 'file') return 'Source image'
if (/birth\s*flower/i.test(normalized)) return 'Birthflowers'
if (/birth\s*stone|month\s+or\s+stone/i.test(normalized)) return 'Birthstones'
if (/charm/i.test(normalized)) return 'Charms'
if (/engrav|paw\s*print|name,?\s+date,?\s+or\s+word/i.test(normalized)) return 'Engraving'
if (/^(?:preferred\s+name|name)|preferred\s+name/i.test(normalized)) return 'Preferred name'
if (/initial|enter\s+the\s+letter/i.test(normalized) && verbosePropertyLabel(normalized)) return 'Initial'
if (verbosePropertyLabel(normalized)) return 'Personalization'
return normalized || 'Personalization'
}

const safeInstructionImage = (html) => {
const match = String(html || '').match(/src=["'](https:\/\/cdn\.shopify\.com\/[^"']+)["']/i)
return match?.[1] || ''
}

/*
  Normalizes a native option VALUE to the role the listings document talks about. Shared by the
  token configurator and by plain field conditions, so "Blank Heart", "Plain Stars" and
  "15mm - No Engraving" all read as `blank` in both places and a merchant renaming a value cannot
  silently switch a product's personalization off.
*/
const modeRoleOf = (value) => {
  const text = String(value || '').toLocaleLowerCase()
  /* 'Double Side' — no trailing d — is how the curb-chain pendant names it, and requiring
     'sided' classified it as 'other', so a both-sides rule could never fire for it. */
  if (/both\s*side|double[-\s]?side/.test(text)) return 'both_sides'
  if (/one[-\s]*side|single[-\s]*side|one[-\s]?sided/.test(text)) return 'one_side'
  if (/front\s*(and|&)\s*back/.test(text)) return 'front_and_back'
  if (/fro?nt\s*side\s*only|front\s*only/.test(text)) return 'front_only'
  if (/no\s*engrav|blank|plain/.test(text)) return 'blank'
  if (/engrav/.test(text)) return 'engraved'
  if (/^\s*single\s*$/.test(text)) return 'single'
  if (/\d+\s*pieces?/.test(text)) return 'multi'
  return 'other'
}

const conditionMatches = (field, selections, byName = null, fieldValues = null) => {
/* A condition on a sibling FIELD is checked first: it names a personalization answer, never a
   variant option, so no amount of option matching below could resolve it. */
const fieldTitle = field.conditional_field_title
if (fieldTitle && fieldValues) {
  const answered = String(fieldValues[String(fieldTitle).trim().toLocaleLowerCase()] ?? '')
  const wanted = Array.isArray(field.conditional_values) && field.conditional_values.length
    ? field.conditional_values
    : [field.conditional_value]
  return wanted.some((value) => String(value ?? '') === answered)
}
/* Name first. A contract that names its option never depends on render order. */
const optionName = field.conditional_option_name ?? field.condition?.option_name
if (optionName && byName) {
  const selected = String(byName[String(optionName).trim().toLocaleLowerCase()] ?? '')
  if (Array.isArray(field.conditional_roles) && field.conditional_roles.length) {
    return field.conditional_roles.includes(modeRoleOf(selected))
  }
  if (Array.isArray(field.conditional_values) && field.conditional_values.length) {
    return field.conditional_values.some((value) => String(value) === selected)
  }
  const expected = field.conditional_value ?? field.condition?.value
  return selected === String(expected || '')
}
const source = field.conditional_option ?? field.condition?.option
if (source === undefined || source === null || String(source) === '') return true
const index = Number(source)
if (!Number.isFinite(index)) return true
const selected = String(selections[index] || '')
/* Role matching, added for the listings235 conditional rows. A field can apply to SEVERAL values
   of one option — the compass is engraved at both 15mm and 20mm — which single-value matching
   could not express without duplicating the field. */
if (Array.isArray(field.conditional_roles) && field.conditional_roles.length) {
  return field.conditional_roles.includes(modeRoleOf(selected))
}
if (Array.isArray(field.conditional_values) && field.conditional_values.length) {
  return field.conditional_values.some((value) => String(value) === selected)
}
const expected = field.conditional_value ?? field.condition?.value
return selected === String(expected || '')
}

const choicePrice = (choice) => {
const amount = Number(choice?.price || 0)
return Number.isFinite(amount) ? amount : 0
}

const SINGLE_VALUE_MAXLENGTH = 60

const usesCompactEngravingControl = (type, displayTitle, productHandle, field = {}) => {
if (type !== 'textarea') return false
if (/double-sided/i.test(productHandle)) return false
if (displayTitle === 'Engraving') return true
const declared = Number(field.maxlength)
return Number.isFinite(declared) && declared > 0 && declared <= SINGLE_VALUE_MAXLENGTH
}

const claimStructuredControls = (wrappers, owner, controller = null) => {
const claimed = [...wrappers].filter((wrapper) => wrapper?.dataset?.structuredControl)
claimed.forEach((wrapper) => {
  wrapper.dataset.structuredControlClaimedBy = owner
  /*
    A claimed control is off-screen: the picker answers for it. Leaving `required` on it let the
    browser refuse to submit a form the customer had completed — no message, no visible field to
    fix, the button simply did nothing. Whatever the picker claims, the picker is now responsible
    for; requiredness travels with it.
  */
  wrapper.querySelectorAll('[required]').forEach((control) => { control.required = false })
})
if (controller) controller.dataset.claimsStructuredControl = `${owner}:${claimed.length}`
return claimed.length
}
const unclaimedStructuredControls = (form) => [...form.querySelectorAll('[data-structured-control]')]
.filter((wrapper) => !wrapper.dataset.structuredControlClaimedBy
  && !wrapper.querySelector('[data-token-picker-open], [data-single-initial-open]'))

const metalFinishDisplayLabel = (value, materialLabel = '') => {
const raw = String(value || '').trim()
const key = raw.toLocaleLowerCase()
const isSolid14K = String(materialLabel || '').trim().toLocaleLowerCase() === '14k solid gold'
if (key === 'rose gold') return 'Rose'
if (key === 'yellow gold') return isSolid14K ? 'Yellow' : 'Gold'
if (key === 'white gold') return isSolid14K ? 'White' : 'Silver'
if (isSolid14K && key === 'gold') return 'Yellow'
if (isSolid14K && key === 'silver') return 'White'
return raw
}

const buildField = (field, index, productHandle = '', materialLabel = '') => {
const type = String(field.type || 'text').toLowerCase()
const title = propertyName(field, index)
let displayTitle = /^How to Personalize Your Order$/i.test(title)
  ? 'Letter & icon guide'
  : /preferred letter\(s\)|preferred letter|preferred icon/i.test(title)
    ? 'Letters or icons, in order'
    : title
if (/^color$/i.test(displayTitle)) displayTitle = 'Metal color'
if (/upload the image/i.test(displayTitle)) displayTitle = 'Source image'
if (/pay now and send image later/i.test(displayTitle)) displayTitle = 'Send image later'
if (/name\(s\).*paw|paw.*name/i.test(displayTitle)) displayTitle = 'Name(s), in paw order'
else if (/name, date, or word.*engrav|what.*engrav|for engraving/i.test(displayTitle)) displayTitle = 'Engraving'
if (verbosePropertyLabel(displayTitle)) displayTitle = fulfillmentPropertyLabel(displayTitle, type)
const compactEngraving = usesCompactEngravingControl(type, displayTitle, productHandle, field)
const values = Array.isArray(field.values) ? field.values : []
const required = field.required === true || field.required === 'on'
const intentionalChoice = /(?:^|\b)(?:ring\s*size|number|quantity|count)(?:\b|$)/i.test(title)
const wrapper = createElement('div', 'sj-personalization-field')
if (compactEngraving) wrapper.classList.add('sj-personalization-field--compact')
/* A contract may ask for a half-width input so two short answers share a row — two names on a
   couple's necklace, rather than one box the customer types both into. It is a shared modifier,
   not a per-product rule: any contract can ask for it, and the stylesheet stacks them again on a
   narrow phone. */
if (field.input_width === 'half') wrapper.classList.add('sj-personalization-field--half')
/* A field that belongs to the font step waits for the font, exactly as the name beside it does.
   Without this the couple's SECOND name rendered immediately and sat alone in the right-hand
   column while the left one did not exist yet — one half of a pair, before the question that
   introduces it had been asked. */
if (field.reveal_with_font) wrapper.dataset.revealWithFont = ''
wrapper.dataset.personalizationField = ''
wrapper.dataset.fieldIndex = String(index)
wrapper.dataset.conditionalOption = String(field.conditional_option ?? field.condition?.option ?? '')
wrapper.dataset.conditionalOptionName = String(field.conditional_option_name ?? field.condition?.option_name ?? '')
wrapper.dataset.conditionalFieldTitle = String(field.conditional_field_title ?? '')
wrapper.dataset.conditionalRoles = JSON.stringify(field.conditional_roles ?? [])
wrapper.dataset.conditionalValues = JSON.stringify(field.conditional_values ?? [])
wrapper.dataset.conditionalValue = String(field.conditional_value ?? field.condition?.value ?? '')
wrapper.dataset.required = required ? 'true' : 'false'
wrapper.dataset.intentionalChoice = intentionalChoice ? 'true' : 'false'
wrapper.dataset.fieldTitle = displayTitle
/* Fields that belong together name the same group; see groupPersonalizationFields. */
if (field.group) wrapper.dataset.fieldGroup = String(field.group)
/* displayTitle is what the shopper and the packing slip read, and the shortener above
   deliberately collapses a whole family of verbose titles onto one word. Behaviour must not
   key off it. It already did once: a field titled "Preferred Font and Name - Please use
   uppercase..." shortens to "Personalization", which stopped matching the /preferred.*name/
   probe in initializeFontNamePicker, and six name necklaces silently lost their font picker
   while three sibling products on the same flow kept theirs. Keep the untouched title here
   so matching reads the source rather than the label. */
wrapper.dataset.sourceFieldTitle = title
wrapper.dataset.personalizationStage = personalizationStage(field)
if (field.option_role) wrapper.dataset.optionRole = String(field.option_role)

if (type === 'instructions') {
  wrapper.classList.add('sj-personalization-instruction')
  if (displayTitle && !/^Personalization \d+$/.test(displayTitle)) {
    wrapper.append(createElement('p', 'sj-label', displayTitle))
  }
  values.forEach((value) => {
    const source = safeInstructionImage(value.key)
    if (source) {
      guideCharts.push({ src: source, title: displayTitle })
    } else if (value.key) {
      const plainText = String(value.key).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
      if (plainText) wrapper.append(createElement('p', '', plainText))
    }
  })
  return wrapper
}

const fieldId = `SilveristicPersonalization-${index}`
/* The order property key must be the label the shopper was shown. It used to call
   fulfillmentPropertyLabel again here, unguarded, while the label above only calls it behind
   verbosePropertyLabel — so a title short enough to be left alone on screen still went through
   the rewriter on its way to the order. "Preferred Name" reached the packing slip as
   "Preferred name": the shopper read one key and fulfilment received another.

   displayTitle is already the shortened value whenever the title was verbose, so verbose titles
   keep the concise key this shortener exists to produce; short titles now keep the exact
   wording, and label and key can no longer diverge. */
/*
  Two contract-level overrides sit in front of that rule, because a Listings contract knows things
  the shortener cannot infer from a title:

  `property_key` pins the key verbatim. The shortener exists to turn a merchant's paragraph-long
  question into a readable packing-slip label, which is right for a field nobody has matched on
  before — but wrong for one fulfilment already reads. "Upload your image" was being shortened to
  "Source image", quietly renaming the key an existing product posts today.

  `serialize: false` gives a field no key at all. Composite parts are real controls the shopper
  fills in, but their answers are composed into ONE property under the product's existing key; a
  control with a name would post its half a second time under an invented one. A nameless control
  still renders, still validates and still reads back — it simply is not submitted.
*/
const name = field.serialize === false
  ? ''
  : `properties[${field.property_key || displayTitle}]`
const pinnedPropertyKey = field.serialize !== false && Boolean(field.property_key)

/*
  A short base-stage list is written out, not collapsed into a dropdown.

  These are the app-owned choices a customer decides BEFORE personalizing — Length, Number of
  Stones. Hiding them behind "Choose Length" made the page ask a question whose answers you had to
  open a menu to see, while the native axes right above it laid every choice out. Same stage, same
  weight of decision, so the same control.

  Only base stage, and normally only when the list is short enough to read at a glance. Ring Size is
  the deliberate exception: the merchant's Admin list remains authoritative, but every size must be
  visible without opening a dropdown. Its compact numeric chips are easier to scan than a concealed
  native menu and still preserve the exact stored value (for example, "7.5 US").
*/
const BASE_OPEN_LIST_LIMIT = 12
const nonBlankChoiceCount = values.filter((value) => value?.key).length
const isRingSizeChoice = /^ring\s*size(?:\s*\([^)]*\))?$/i.test(displayTitle)
  || /^ring\s*size(?:\s*\([^)]*\))?$/i.test(title)
const opensAsList = type === 'default'
  /* The same signal the wrapper is stamped with, not the raw `field.stage`: on the hosted theme the
     schema field carries no stage of its own and the base classification is derived, so reading the
     raw property worked in the fixture and silently did nothing on the storefront. */
  && personalizationStage(field) === 'base'
  && nonBlankChoiceCount > 1
  && (isRingSizeChoice || nonBlankChoiceCount <= BASE_OPEN_LIST_LIMIT)

/*
  How a stored choice READS, without changing what it is.

  Two rules, both display-only — the value that reaches the cart and the workshop is untouched:

    · a length says 14" rather than "14 inches". Both spellings exist in the merchant's own data
      (79 products store "18 inches", 45 store 18"), so the page normalises what it shows and leaves
      each product's stored value alone;

    · when every choice in a field ends with the same word — "1 Turquoise" … "10 Turquoise" — that
      word is said once in the legend and the buttons carry just the number. Ten buttons repeating
      the same noun is ten times the reading for one piece of information.
*/
const SHORT_UNIT = /^(\d+(?:\.\d+)?)\s*(?:inches|inch|in)\.?$/i
const commonTrailingWord = (values) => {
  const words = values
    .map((value) => String(value?.key ?? '').trim())
    .filter(Boolean)
    .map((text) => text.split(/\s+/))
  if (words.length < 3 || words.some((parts) => parts.length < 2)) return ''
  const last = words[0][words[0].length - 1]
  if (!/^[A-Za-z]+$/.test(last)) return ''
  /* A unit is already handled by the short-form rule above, and folding it into the legend turned
     "Length" into "Length inches". Only a real subject noun — Turquoise, Charms — moves up. */
  if (/^(?:inches|inch|in|cm|mm)$/i.test(last)) return ''
  return words.every((parts) => parts[parts.length - 1].toLowerCase() === last.toLowerCase()) ? last : ''
}
const choiceDisplayLabel = (raw, trailing) => {
  const text = String(raw ?? '').trim()
  const unit = text.match(SHORT_UNIT)
  if (unit) return `${unit[1]}"`
  if (trailing) {
    const stripped = text.replace(new RegExp(`\\s*${trailing}\\s*$`, 'i'), '').trim()
    if (stripped) return stripped
  }
  return text
}

/*
  A contract may say a sentence under the control. Used where the ANSWER changes what the rest of
  the form asks — the name-disk switch decides whether the birth flowers appear at all, and that
  they are optional is not something two buttons can say on their own.
*/
const appendFieldHelp = () => {
  if (field.help) wrapper.append(createElement('p', 'sj-personalization-field__help', String(field.help)))
}

if (type === 'buttons' || opensAsList) {
  const fieldset = createElement('fieldset', 'sj-fieldset')
  const trailingWord = commonTrailingWord(values)
  /* The shared word moves into the legend so it is still said, once. A UNIT is bracketed there —
     "Ring size (US)" over buttons reading 5 … 13, which is what fits one line — while a subject
     noun reads as part of the question: "Number of Turquoise". Owner instruction, 2026-08-20. */
  const UNIT_WORD = /^(?:us|uk|eu|mm|cm)$/i
  const legendText = trailingWord && !new RegExp(trailingWord, 'i').test(displayTitle)
    ? (UNIT_WORD.test(trailingWord)
        ? `${displayTitle} (${trailingWord.toLocaleUpperCase()})`
        : `${displayTitle.replace(/\s+stones?$/i, '')} ${trailingWord}`)
    : displayTitle
  const legend = createElement('legend', 'sj-legend', legendText)
  const options = createElement('div', 'sj-options')
  const usesSwatches = /(?:color|colour|finish|metal)/i.test(title)
  if (usesSwatches) options.classList.add('sj-options--swatch')
  /* A size list wraps into the same compact grid the native size axis uses, so a contract-rendered
     ring size and a variant-rendered one are one control to look at. */
  if (/\bsize\b/i.test(title)) options.classList.add('sj-options--size')
  if (isRingSizeChoice) options.classList.add('sj-options--ring-size')
  values.forEach((value, valueIndex) => {
    const label = createElement('label', 'sj-option')
    const input = document.createElement('input')
    input.type = 'radio'
    input.name = name
    input.value = String(value.key || '')
    input.id = `${fieldId}-${valueIndex}`
    input.required = required
    input.dataset.priceAdjustment = String(choicePrice(value))
    if (!intentionalChoice && String(field.preselect_value || '') === input.value) input.checked = true
    label.htmlFor = input.id
    const optionLabel = createElement('span')
    const visibleValue = usesSwatches
      ? metalFinishDisplayLabel(input.value, materialLabel)
      : choiceDisplayLabel(input.value, trailingWord)
    /*
      The ORDER SUMMARY reads data-option-display-value, so it keeps the whole answer even when the
      button is shortened. A unit hoisted into the legend is a reading convenience for the page; a
      size that reaches a packing slip as "7" is not a size.
    */
    const unitHoisted = Boolean(trailingWord) && /^(?:us|uk|eu|mm|cm)$/i.test(trailingWord)
    input.dataset.optionDisplayValue = unitHoisted ? input.value : visibleValue
    /*
      The accessible name has to say the WHOLE answer, because the button only shows part of it —
      the shared word moved into the legend. " color" belongs to a metal finish and nothing else:
      appended to every shortened value it announced a ring size as "7 color". Screen-reader users
      hear the original value, which is the one the cart receives.
    */
    if (visibleValue !== input.value) {
      input.setAttribute('aria-label', usesSwatches ? `${visibleValue} color` : input.value)
    }
    if (usesSwatches) {
      const swatch = createElement('i', 'sj-option__swatch')
      const swatchKey = input.value.toLowerCase()
      swatch.style.background = swatchKey.includes('rose')
        ? '#ce9377'
        : swatchKey.includes('gold') || swatchKey.includes('yellow')
          ? '#cda44a'
          : '#c2c6cb'
      swatch.setAttribute('aria-hidden', 'true')
      optionLabel.append(swatch)
    }
    optionLabel.append(document.createTextNode(visibleValue))
    label.append(input, optionLabel)
    options.append(label)
  })
  fieldset.append(legend, options)
  /*
    A field that is not submitted has no control name, and radios with no name are not a group: both
    buttons stayed pressed and the answer was whichever the reader guessed. Grouping is enforced
    here instead of by inventing a name, because a named control would post a stray cart parameter.
  */
  if (!name) {
    fieldset.addEventListener('change', (event) => {
      const chosen = event.target
      if (!chosen.matches?.('input[type="radio"]')) return
      fieldset.querySelectorAll('input[type="radio"]').forEach((radio) => {
        if (radio !== chosen) radio.checked = false
      })
    })
  }
  wrapper.append(fieldset)
  appendFieldHelp()
} else if (type === 'checkboxes') {
  const fieldset = createElement('fieldset', 'sj-fieldset')
  fieldset.append(createElement('legend', 'sj-legend', title))
  values.forEach((value, valueIndex) => {
    const label = createElement('label', 'sj-checkbox')
    const input = document.createElement('input')
    input.type = 'checkbox'
    input.name = name
    input.value = String(value.key || '')
    input.id = `${fieldId}-${valueIndex}`
    input.dataset.priceAdjustment = String(choicePrice(value))
    label.htmlFor = input.id
    label.append(input, createElement('span', '', input.value))
    fieldset.append(label)
  })
  wrapper.append(fieldset)
  appendFieldHelp()
} else {
  const label = createElement('label', 'sj-label', displayTitle)
  label.htmlFor = fieldId
  wrapper.append(label)

  let input
  if (type === 'single_initial') {
    input = createElement('input', 'sj-input sj-input--compact-personalization')
    input.type = 'text'
    input.maxLength = 1
    input.pattern = '[A-Z]'
    input.autocomplete = 'off'
    input.autocapitalize = 'characters'
    input.spellcheck = false
    wrapper.dataset.structuredControl = 'single_initial'
  } else if (type === 'media_choice') {
    /*
      A visual chooser bound to ONE field.

      The select underneath stays the source of truth — it holds the saved value, it is what the
      form submits, and it is what validation reads — while the enhancer below replaces its visible
      form with a photographed grid. Rendering a real <select> rather than a bare hidden input means
      a product whose photographs have not been uploaded yet degrades to a working dropdown instead
      of to nothing at all.
    */
    input = createElement('select', 'sj-select')
    const placeholder = document.createElement('option')
    placeholder.value = ''
    placeholder.textContent = `Choose ${String(displayTitle || title).toLocaleLowerCase()}`
    input.append(placeholder)
    values.forEach((value) => {
      const option = document.createElement('option')
      option.value = String(value.key || '')
      option.textContent = option.value
      input.append(option)
    })
    wrapper.dataset.structuredControl = 'media_choice'
    if (field.token_type) wrapper.dataset.tokenType = String(field.token_type)
    if (field.trigger) wrapper.dataset.choiceTrigger = String(field.trigger)
    if (field.placement) wrapper.dataset.choicePlacement = String(field.placement)
  } else if (type === 'token_picker') {
    input = createElement('input', 'sj-visually-hidden')
    input.type = 'text'
    input.tabIndex = -1
    input.setAttribute('aria-hidden', 'true')
    wrapper.dataset.structuredControl = 'token_picker'
  } else if (type === 'textarea' && !compactEngraving) {
    input = createElement('textarea', 'sj-textarea')
    input.rows = 4
  } else if (compactEngraving) {
    input = createElement('input', 'sj-input sj-input--compact-personalization')
    input.type = 'text'
    input.autocomplete = 'off'
    input.spellcheck = false
    input.enterKeyHint = 'done'
  } else if (type === 'file') {
    input = createElement('input', 'sj-input')
    input.type = 'file'
    input.accept = 'image/jpeg,image/png,image/webp,image/heic,application/pdf'
    wrapper.append(createElement('p', 'sj-personalization-field__help', sjUi.upload_accept))
  } else if (type === 'default' || type === 'select' || type === 'dropdown') {
    input = createElement('select', 'sj-select')
    const placeholder = document.createElement('option')
    placeholder.value = ''
    placeholder.textContent = `Choose ${title}`
    input.append(placeholder)
    values.forEach((value) => {
      const option = document.createElement('option')
      option.value = String(value.key || '')
      option.textContent = choicePrice(value) > 0 ? `${option.value} (+${money(choicePrice(value) * 100)})` : option.value
      option.dataset.priceAdjustment = String(choicePrice(value))
      if (!intentionalChoice && String(field.preselect_value || '') === option.value) option.selected = true
      input.append(option)
    })
  } else {
    input = createElement('input', 'sj-input')
    input.type = field.input_type === 'email' ? 'email' : 'text'
  }

  input.id = fieldId
  input.name = name
  input.required = required
  /*
    A contract may say the answer is a capital letter. The interlocking-letters necklace asks for
    two, one per half of the pendant, and they are ENGRAVED as capitals — so a lowercase "m" typed
    into the box is not what the piece will read, and the customer has no way to know that from
    the page. The value is normalised as it is typed, and autocapitalize tells a phone keyboard to
    open in caps so the correction is rarely even visible.
  */
  if (field.uppercase) {
    input.autocapitalize = 'characters'
    input.autocomplete = 'off'
    input.spellcheck = false
    if (field.pattern) input.pattern = String(field.pattern)
    input.addEventListener('input', () => {
      const upper = input.value.toLocaleUpperCase()
      if (upper === input.value) return
      /* Preserve the caret: rewriting value collapses it to the end, which on a one-character box
         is invisible but on a longer one moves the cursor while the customer is still typing. */
      const at = input.selectionStart
      input.value = upper
      if (at !== null) input.setSelectionRange(at, at)
    })
  }
  if (type === 'textarea' && /preferred letter|preferred icon/i.test(title)) {
    input.placeholder = sjUi.token_example
  }
  /* A contract may write the example INTO the box. Where the limit is the whole point of the field
     — ten characters, or exactly one — saying it in the box is what the customer reads before
     typing, rather than discovering it when the input stops accepting keys. */
  if (field.placeholder) input.placeholder = String(field.placeholder)
  /*
    A field the piece can only make from digits — a sports number is stamped, not engraved, so a
    letter typed there is an order the workshop has to send back. Declared on the contract rather
    than guessed from the title, and enforced as the customer types instead of at the CTA.
  */
  if (field.input_mode === 'numeric' && input.tagName === 'INPUT') {
    input.inputMode = 'numeric'
    input.pattern = '[0-9]*'
    input.autocomplete = 'off'
    input.addEventListener('input', () => {
      const digits = input.value.replace(/[^0-9]/g, '')
      if (digits !== input.value) input.value = digits
    })
  }
  if (field.maxlength && Number(field.maxlength) > 0) {
    input.maxLength = Number(field.maxlength)
  } else if (input.tagName === 'TEXTAREA') {
    /*
      An unbounded paragraph box is the legacy generic renderer's signature, and a few merchant
      fields declare no limit at all — so they arrived on the page as exactly the control this work
      exists to remove, whatever contract was driving them.

      400 is the ceiling, not a guess: it is the largest limit the merchant sets anywhere in their
      own product data, so a field that declares nothing now behaves like their most generous one
      and no customer loses room they had. Anything with its own declared limit keeps it.
    */
    input.maxLength = 400
  }
  /* A field whose contract pins its key keeps it verbatim through the submit-time shortener —
     row 122's upload is the case: left to the shortener "Upload your image" became "Source image",
     renaming a property this product already receives. */
  if (pinnedPropertyKey) input.dataset.exactPropertyKey = ''
  const help = wrapper.querySelector('.sj-personalization-field__help')
  wrapper.insertBefore(input, help)
}

return wrapper
}

const updatePersonalizationConditions = (form) => {
const selections = formSelections(form)
const selectionsByName = formSelectionsByName(form)
const fieldValues = formPersonalizationValues(form)
form.querySelectorAll('[data-personalization-field]').forEach((wrapper) => {
  if (form._sjPositionConfigurator && !form._sjPositionConfigurator.usesGenericFields && wrapper.closest('[data-generic-personalizer]')) {
    wrapper.hidden = true
    wrapper.querySelectorAll('input, select, textarea').forEach((input) => {
      input.disabled = true
      input.required = false
    })
    return
  }
  const parseList = (value) => { try { return JSON.parse(value || '[]') } catch { return [] } }
  const field = {
    conditional_option: wrapper.dataset.conditionalOption,
    conditional_value: wrapper.dataset.conditionalValue,
    conditional_option_name: wrapper.dataset.conditionalOptionName || null,
    conditional_field_title: wrapper.dataset.conditionalFieldTitle || null,
    conditional_roles: parseList(wrapper.dataset.conditionalRoles),
    conditional_values: parseList(wrapper.dataset.conditionalValues)
  }
  const visible = conditionMatches(field, selections, selectionsByName, fieldValues)
  wrapper.hidden = !visible
  wrapper.querySelectorAll('input, select, textarea').forEach((input) => {
    if (!input.dataset.originalRequired) input.dataset.originalRequired = input.required ? 'true' : 'false'
    const progressiveNameLocked = input.dataset.fontNameInput !== undefined && wrapper.dataset.fontSelected !== 'true'
    const progressiveNameRequired = input.dataset.fontNameSource !== undefined && wrapper.dataset.fontSelected === 'true'
    input.disabled = !visible || progressiveNameLocked
    input.required = visible && (input.dataset.originalRequired === 'true' || progressiveNameRequired)
  })
})
/*
  Final sweep, after every pass has had its say. A control that is required but has no layout box
  cannot be filled in, and the browser refuses to submit the form without telling anyone why: the
  button reads "Add to cart", the customer presses it, and nothing happens. That is what a legacy
  paragraph box left behind by a picker did on the initial-birthflower bracelet.

  Deliberately last and deliberately geometric — it does not care WHY a control is out of view,
  only that a customer cannot answer it. Requiredness is restored the moment it is visible again,
  from the original the pass above records.
*/
requestAnimationFrame(() => {
  const activeBefore = document.activeElement
  form.querySelectorAll('[data-personalization-field] :is(input, select, textarea)').forEach((input) => {
    if (input.type === 'hidden' || input.disabled) return
    const unreachable = input.offsetParent === null && getComputedStyle(input).position !== 'fixed'
    if (unreachable && input.required) input.required = false
  })
  /* Never at the cost of focus: another pass may have just put the caret in a field this one is
     inspecting, and a form the customer is typing into must not lose it. */
  if (activeBefore && document.activeElement !== activeBefore && typeof activeBefore.focus === 'function') {
    activeBefore.focus({ preventScroll: true })
  }
})
syncConditionalPersonalizerVisibility(form)
}

const fieldValue = (wrapper) => {
const checked = [...wrapper.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked')].map((input) => input.value)
if (checked.length) return checked.join(', ')
const control = wrapper.querySelector('select, textarea, input:not([type="radio"]):not([type="checkbox"]):not([type="file"])')
if (control?.value) return control.value
const file = wrapper.querySelector('input[type="file"]')
return file?.files?.[0]?.name || ''
}

const fieldDisplayValue = (wrapper) => {
const checked = [...wrapper.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked')]
  .map((input) => input.dataset.optionDisplayValue || input.value)
if (checked.length) return checked.join(', ')
const control = wrapper.querySelector('select, textarea, input:not([type="radio"]):not([type="checkbox"]):not([type="file"])')
if (control?.value) return control.selectedOptions?.[0]?.dataset?.optionDisplayValue || control.dataset.optionDisplayValue || control.value
const file = wrapper.querySelector('input[type="file"]')
return file?.files?.[0]?.name || ''
}

const nativeOptionDisplayValue = (fieldset, fallback = '') => {
const control = fieldset.querySelector('input:checked, select')
const value = control?.value || fallback
const displayValue = control?.dataset?.optionDisplayValue || control?.selectedOptions?.[0]?.dataset?.optionDisplayValue || value
if (displayValue !== value) return displayValue
if (fieldset.dataset.optionDisplay !== 'count') return value
return String(value).match(/^\s*\d+/)?.[0]?.trim() || value
}

const selectedPriceAdjustment = (form) => {
let adjustment = 0
form.querySelectorAll('[data-personalization-field]:not([hidden])').forEach((wrapper) => {
  wrapper.querySelectorAll('input:checked').forEach((input) => {
    adjustment += Number(input.dataset.priceAdjustment || 0)
  })
  const selectedOption = wrapper.querySelector('select')?.selectedOptions[0]
  if (selectedOption) adjustment += Number(selectedOption.dataset.priceAdjustment || 0)
})
return adjustment
}

const productScope = () => document
const updateProductionSummary = (form) => {
if (form._sjPositionConfigurator) {
  form._sjPositionConfigurator.syncProperties()
  return
}
const list = productScope().querySelector('[data-production-summary-list]')
const summaryInput = form.querySelector('[data-production-summary-input]')
if (!list || !summaryInput) return
const rows = []
form.querySelectorAll('[data-option-index]').forEach((fieldset) => {
  const label = fieldset.querySelector('legend')?.childNodes[0]?.textContent?.trim() || 'Option'
  const value = nativeOptionDisplayValue(fieldset, 'Not selected')
  rows.push([label, value, value])
})
form.querySelectorAll('[data-personalization-field]:not([hidden])').forEach((wrapper) => {
  if (wrapper.classList.contains('sj-personalization-instruction')) return
  const label = wrapper.querySelector('.sj-label, .sj-legend')?.textContent?.trim() || 'Personalization'
  const rawValue = fieldValue(wrapper)
  const displayValue = fieldDisplayValue(wrapper)
  if (rawValue) rows.push([label, displayValue, rawValue])
})
list.replaceChildren()
const productTitle = document.querySelector('.sj-product__buybox h1')?.textContent?.trim()
if (productTitle) rows.unshift(['Product', productTitle, productTitle])
rows.forEach(([label, displayValue]) => {
  const row = document.createElement('div')
  row.append(createElement('dt', '', label), createElement('dd', '', displayValue))
  list.append(row)
})
summaryInput.value = rows.map(([label, displayValue, rawValue = displayValue]) => `${label}: ${rawValue}`).join(' | ')

const adjustment = selectedPriceAdjustment(form)
const status = form.querySelector('[data-personalization-status]')
const submit = form.querySelector('[data-product-submit]')
if (adjustment > 0) {
  form.dataset.unmodeledPrice = 'true'
  if (status) {
    status.dataset.state = 'error'
    status.textContent = `This priced choice adds ${money(adjustment * 100)}. It must be represented by a native Shopify variant before launch; checkout is blocked to prevent an incorrect price.`
  }
  if (submit) {
    submit.disabled = true
    submit.setAttribute('aria-disabled', 'true')
  }
} else {
  delete form.dataset.unmodeledPrice
  if (status?.dataset.state === 'error') {
    status.dataset.state = ''
    status.textContent = ''
  }
  updateProductForm(form)
}
}

const personalizationStage = (field) => {
if (field?.stage === 'base' || field?.stage === 'personalization') return field.stage
const type = String(field?.type || 'text').toLowerCase()
const title = propertyName(field, 0)
const isChoice = ['buttons', 'checkboxes', 'default', 'dropdown', 'select'].includes(type)
const isBaseChoice = /(?:^|\b)(?:color|colour|finish|finishing|material|metal|chain|length|size|number|quantity|count)(?:\b|$)/i.test(title)
return isChoice && isBaseChoice ? 'base' : 'personalization'
}

const v023Stones = [
['January', 'Garnet', '#7A2E3A'],
['February', 'Amethyst', '#6E5A9E'],
['March', 'Aquamarine', '#6FA3B4'],
['April', 'White Topaz', '#B9BEC4'],
['May', 'Emerald', '#2E6B4F'],
['June', 'Alexandrite', '#7E8FB0'],
['July', 'Ruby', '#8E2436'],
['August', 'Peridot', '#7D8F3E'],
['September', 'Sapphire', '#2C4A7E'],
['October', 'Opal', '#AEB9BE'],
['November', 'Citrine', '#C08A2E'],
['December', 'Turquoise', '#3E8F8A']
]

const escapeMarkup = (value) => String(value ?? '')
.replaceAll('&', '&amp;')
.replaceAll('<', '&lt;')
.replaceAll('>', '&gt;')
.replaceAll('"', '&quot;')
.replaceAll("'", '&#039;')

const normalizeInitial = (value) => String(value ?? '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 1)

const initializeContractConfigurator = (form, fields) => {
const contract = personalizationContract(form)
/*
  `text_sequence` is the odd one: its positions carry NO token at all, only a short engraving. A
  paw bracelet with four paws needs four names, and nothing is chosen from a vocabulary. It joins
  this list so the whole sequence machinery — count binding to the native axis, resize that keeps
  what was typed, per-row validation, the CTA that names the empty row, one composed property —
  applies unchanged; the only differences are that the tile is not drawn and that a row is complete
  when its text is filled rather than when a token is picked. See textOnly() below.
*/
const SEQUENCE_FLOWS = ['letter_symbol_sequence', 'mixed_token_sequence', 'birthstone_sequence',
  'birthflower_sequence', 'mixed_birthflower_sequence', 'charm_sequence', 'text_sequence']
if (!contract || !SEQUENCE_FLOWS.includes(contract.flow_type)) return false

const details = form.querySelector('[data-sj-personalizer]')
const generic = details?.querySelector('[data-generic-personalizer]')
const submit = form.querySelector('[data-product-submit]')
/*
  The "how many" a sequence sizes itself from is usually a real variant axis, because usually the
  number changes the price. When it does not — the birth-flower bracelet costs the same whether it
  carries one flower or three — the question has no business being a variant, and it is a base-stage
  contract field instead. Both are searched here by the name the contract states.

  Before this, only native axes were searched, so a product whose count was a contract field
  rendered a picker with one slot no matter what the shopper answered: they could ask for three
  flowers and order one.
*/
const countCandidates = [
  ...form.querySelectorAll('[data-option-index]'),
  /* Any contract field, wherever it has ended up. A base question starts in the base container but
     the configurator moves the ones it does not replace out beside itself, so searching only the
     base container found the count by luck of ordering and would have stopped finding it the moment
     that order changed. */
  ...form.querySelectorAll('[data-personalization-field] fieldset')
]
const wantedCountName = String(contract.count_option_name || '').trim().toLocaleLowerCase()
const countGroup = countCandidates.find((fieldset) => {
  const label = fieldset.dataset.nativeOptionLabel
    || fieldset.dataset.fieldTitle
    || fieldset.closest('[data-personalization-field]')?.dataset.fieldTitle
    || fieldset.querySelector('legend')?.childNodes[0]?.textContent?.trim()
    || ''
  return label.toLocaleLowerCase() === wantedCountName
})
/* Most sequence products size themselves from a native "how many" option. A few have no such
   option because the count is part of the design — the engraved bar carries exactly one stone —
   and for those the contract states the number outright. Everything below therefore treats
   countGroup as optional whenever fixedCount is set, and as required when it is not. */
const fixedCount = Number.isInteger(contract.fixed_position_count) && contract.fixed_position_count > 0
  ? contract.fixed_position_count
  : null
const sizedByRules = Array.isArray(contract.conditional_rules) && contract.conditional_rules.length > 0
/*
  A third way to be sized: the sequence grows as it is filled.

  Every product here used to size itself from a "how many" answer or from a number the contract
  states outright, so a contract with neither was refused and fell back to the inline personalizer —
  which renders a token field as a hidden input with nothing to drive it, so the block-name bracelet
  showed no way to enter a name at all. An open-ended sequence needs no count precisely because it
  never asks for one.
*/
const sizedByGrowth = Boolean(contract.open_ended)
if (!details || !generic || !submit || (!countGroup && !fixedCount && !sizedByRules && !sizedByGrowth)) return false

const personalFields = fields.filter((field) => (
  personalizationStage(field) === 'personalization'
  && String(field.type || '').toLowerCase() !== 'instructions'
))
const root = createElement('section', 'sj-token-configurator')
root.dataset.tokenConfigurator = ''
const picker = createElement('dialog', 'sj-token-picker')
picker.dataset.tokenPicker = ''
picker.setAttribute('aria-labelledby', 'SilveristicTokenPickerTitle')
generic.after(root)
details.append(picker)
/* The configurator speaks for the fields it replaces, so those get disabled — otherwise they
   would submit a second, conflicting value. A contract can name fields it does NOT replace
   (the engraved bar's message box, which is text the shopper types, not a token in the
   sequence); those keep working and keep submitting their own line-item property. */
const independentTitles = (contract.independent_field_titles || [])
  .map((entry) => String(entry).trim().toLocaleLowerCase())
  .filter(Boolean)
/* Matched on data-source-field-title, the merchant's untouched wording — the visible label goes
   through the shortener ("Please specify the word, date, or a short message…" renders as
   "Engraving"), so matching what is on screen would miss every field the shortener rewrote. */
const independentFields = independentTitles.length
  ? [...generic.querySelectorAll('[data-personalization-field]')].filter((field) => {
      const title = String(field.dataset.sourceFieldTitle || field.dataset.fieldTitle || '')
        .trim().toLocaleLowerCase()
      return independentTitles.some((wanted) => title.includes(wanted))
    })
  : []
generic.querySelectorAll('input, select, textarea, button').forEach((control) => {
  if (independentFields.some((field) => field.contains(control))) return
  /*
    Never the control that decides how many positions there are.

    Most sequence products take their count from a native option, which lives outside this container
    and was therefore never at risk. The monogram earrings ask for the count as a contract field —
    the number of initials does not change the price, so it is not a variant — and disabling it left
    the shopper looking at three greyed-out buttons with no way to start.
  */
  if (countGroup?.contains(control)) return
  control.disabled = true
})

/*
  Composite parts, in the order the contract declares them, matched to the wrappers that render
  them. Declared order is what the packing slip reads; DOM order follows layout and would reorder
  the answer whenever the design moved a control.
*/
const compositeParts = () => {
  if (String(contract.serializer?.kind || '') !== 'composite_property') return []
  return (contract.serializer?.parts || []).map((part) => {
    const wanted = String(part.field_title || '').trim().toLocaleLowerCase()
    const wrapper = independentFields.find((field) =>
      independentTitleOf(field).includes(wanted)) || null
    return { label: String(part.label || part.field_title || 'Detail'), wrapper }
  })
}

/* Composite parts carry no key of their own — see `serialize: false` in the field builder, which
   is where that is decided so it holds in every render mode rather than only inside this one. */
/* [data-generic-personalizer] is display:none in positions mode, so leaving these enabled inside
   it would keep them submitting while invisible. Moving them out of it — after the configurator,
   so the shopper picks the stone first and writes the message second — is what actually shows
   them. A move preserves each control's name and value, so the line-item property is unchanged. */
const independentTitleOf = (field) => String(
  field.dataset.sourceFieldTitle || field.dataset.fieldTitle || '').trim().toLocaleLowerCase()

/* Which independent fields the CURRENT variant asks for. With no conditional rules every
   independent field is always on, which is how the engraved bar behaves. With rules, a field the
   active rule does not name is hidden AND disabled: hidden alone would still submit it, and a
   value the customer cannot see reaching the workshop is worse than no value at all. */
const applyIndependentVisibility = () => {
  const rule = activeRule()
  const wanted = rule && rule.then && Array.isArray(rule.then.text_fields)
    ? rule.then.text_fields.map((entry) => String(entry).trim().toLocaleLowerCase())
    : null
  independentFields.forEach((field) => {
    /* A field that carries its OWN condition is governed by updatePersonalizationConditions, the
       one shared resolver. Touching it here as well made the two fight over the same wrapper —
       the rule hid it and the resolver showed it back on the same event — so the rule stands
       aside and lets the field's declared condition decide. */
    if (field.dataset.conditionalOptionName) return
    const title = independentTitleOf(field)
    const on = !wanted || wanted.some((entry) => title.includes(entry))
    field.hidden = !on
    field.querySelectorAll('input, select, textarea').forEach((control) => {
      control.disabled = !on
      if (!on) control.required = false
    })
  })
}

/*
  Moving a field out of the generic personalizer also moves it out of the flex row that makes
  `input_width: half` mean anything, so two half fields landed one under the other. The moved halves
  get a row of their own — same container class, so the one width rule still governs them — and a
  switch keeps its answer box beside it instead of a line below.
*/
const independentRow = independentFields.some((field) => field.classList.contains('sj-personalization-field--half'))
  ? createElement('div', 'sj-personalizer__fields')
  : null
if (independentRow) root.after(independentRow)

/*
  An advancing anchor, not a repeated root.after(). Every call to root.after() inserts directly
  after the configurator, so each field pushed the previous one down and the panel read back to
  front — the hexagon's back-side line landed above the birthstone that sits in the middle of its
  front. The order the contract declares is the order the shopper reads.
*/
let independentAnchor = independentRow || root
independentFields.forEach((field) => {
  field.dataset.tokenIndependentField = ''
  field.addEventListener('input', () => { syncProperties() })
  field.addEventListener('change', () => { syncProperties() })
  if (independentRow && field.classList.contains('sj-personalization-field--half')) independentRow.append(field)
  else {
    independentAnchor.after(field)
    independentAnchor = field
  }
  /* updatePersonalizationConditions hides and disables everything under the generic personalizer
     wholesale, and may already have run. Once the field lives outside it that branch no longer
     applies, but the state it left behind has to be cleared here or the field stays hidden. */
  field.hidden = false
  field.querySelectorAll('input, select, textarea').forEach((input) => { input.disabled = false })
})
/* This configurator replaces the per-field controls with ONE positional UI, so its root is a
   sibling of the generic personalizer, not a child of any [data-personalization-field]. The
   claim is therefore recorded explicitly: a containment test would report every profile-built
   token_picker as unclaimed and fail a perfectly valid profile closed. */
claimStructuredControls(form.querySelectorAll('[data-structured-control="token_picker"]'), 'token_configurator', root)

details.dataset.personalizerMode = 'tokens'
details.dataset.personalizationContract = contract.flow_type
details.removeAttribute('hidden')
details.open = true
form.dataset.inlinePersonalization = 'true'
form.dataset.personalizationStarted = 'true'
form.querySelector('[data-personalize-start]')?.setAttribute('hidden', '')
submit.removeAttribute('hidden')

const discardDialog = form.querySelector('[data-config-discard]')
const typeLabels = {
  charm: 'Charm',
  letter: 'Letter',
  serif_letter: 'Serif letter',
  cursive_letter: 'Cursive letter',
  symbol: 'Symbol',
  birthflower: 'Birth flower',
  birthstone: 'Birthstone',
  font: 'Font',
  number: 'Number',
  zodiac: 'Zodiac sign',
  heart: 'Heart',
  lowercase_letter: 'Lowercase letter',
  monogram: 'Monogram',
  large_initial_letter: 'Letter',
  large_initial_symbol: 'Symbol'
}
/* A token the piece ALWAYS carries, which the customer places but never chooses — the paw on a
   paw-letter bracelet. It occupies a real position (so the count axis "Paw + 2 letters" means two
   letters plus this, three cards) and reorders like any other, but opens no picker: there is
   nothing to pick. Declared by the contract, so a product without one behaves exactly as before.
   Its type only has to resolve inside `vocabulary` for the card to draw; it deliberately need NOT
   appear in `token_types`, which is what the picker offers. */
const fixedToken = contract.fixed_token?.value
  ? { type: contract.fixed_token.type || 'symbol', value: contract.fixed_token.value, fixed: true }
  : null

const state = {
  positions: [],
  errors: [],
  activeIndex: 0,
  pickerType: 'symbol',
  pickerCategory: '',
  reorderMode: false,
  fixedPlacedByCustomer: false,
  pendingCount: null
}

/* A count option's value is not always a bare number — "4 Charms", "Paw + 3 letters" — so pull
   the first digit run out of it rather than requiring the value to start with one. Strictly wider
   than a leading-digit parseInt: every value that already worked (leading digits) matches the
   same digits either way.

   A value with no digit at all is a real count meaning ZERO, not a parse failure: swept the whole
   catalogue and the only two such values are "Only paw" / "Only Paw" (paw-print-bracelet and
   sideways-paw-letter-necklace), both of which mean the piece carries its paw and no letters. No
   count axis anywhere spells a number out in words, so 0 is unambiguous. An EMPTY value is still
   not a count and stays NaN, so callers that skip on NaN keep skipping nothing-selected. */
const parseCountValue = (value) => {
  const text = String(value ?? '').trim()
  if (!text) return Number.NaN
  const digits = text.match(/\d+/)
  return digits ? Number.parseInt(digits[0], 10) : 0
}

/* Some axes name only the positions the customer fills and leave the preselected first token
   implicit: "Paw + 2 letters" is three cards, not two, because the paw occupies one of them.
   Declaring that on the contract keeps the merchant's own wording intact — no variant rename
   needed — while the sequence still opens with the right number of positions. Axes that already
   count the whole piece ("3 Initials" = paw + 2 letters) declare nothing and are unaffected. */
const countOffset = contract.count_excludes_preselect ? 1 : 0
const countFor = (value) => {
  const parsed = parseCountValue(value)
  return Number.isFinite(parsed) ? parsed + countOffset : Number.NaN
}

/*
  Some pieces make one countable thing out of TWO choices: an initial-birthflower charm is a flower
  AND a letter, so "3 Charms" is six positions in a fixed alternating order. The contract states how
  many positions one count unit takes and which type each of them is; everything downstream — the
  cards, the picker, validation, the serialized order — works on positions as it always has.
*/
/*
  Positions the piece always has, ahead of the counted ones. The name-disk necklace engraves ONE
  birth flower whatever the stone count, so slot 0 is a flower and the axis only sizes the stones.
*/
const leadingPositionTypes = () => (Array.isArray(contract.leading_position_types)
  ? contract.leading_position_types
  : [])

/*
  A piece can be counted by TWO axes at once: the birth-flower-and-birthstones bracelet has its own
  "Number of Flowers" and "Quantity of Birthstones", and both are real variant axes. Bound to one of
  them the other did nothing — the customer set a stone count and no stone appeared. Each segment
  names its axis and the type its positions hold; the sequence is their sum, in declared order.
*/
const countSegments = () => {
  const declared = Array.isArray(contract.count_segments) ? contract.count_segments : []
  return declared.map((segment) => {
    const wanted = String(segment?.option_name || '').trim().toLocaleLowerCase()
    const group = [...form.querySelectorAll('[data-option-index]')].find((fieldset) => {
      const label = fieldset.dataset.nativeOptionLabel
        || fieldset.querySelector('legend')?.childNodes[0]?.textContent?.trim() || ''
      return label.toLocaleLowerCase() === wanted
    })
    return { type: String(segment?.type || ''), group }
  }).filter((segment) => segment.type && segment.group)
}
const segmentCounts = () => countSegments().map((segment) => {
  const value = segment.group.querySelector('input:checked, select')?.value || ''
  const parsed = parseCountValue(value)
  return { type: segment.type, count: Number.isFinite(parsed) ? parsed : 0 }
})
const positionsPerCount = Math.max(1, Number(contract.positions_per_count) || 1)
const positionTypeCycle = Array.isArray(contract.position_type_cycle) && contract.position_type_cycle.length
  ? contract.position_type_cycle
  : null
/*
  One axis value can state the exact order of slots, not just how many. "3 Names - 2 Stone Rings"
  is three names with a stone between each pair — five slots reading name, stone, name, stone,
  name — which no count alone can express: bound to the stone count the piece offered two name
  boxes for three names, so the third name had nowhere to go.
*/
/*
  A personalization ANSWER can decide the shape of the sequence, not just which fields show.

  The name-disk necklace engraves either a name or birth flowers, never both, and the flowers are
  one per stone. So the switch that asks which decides how many slots each stone unit opens: one
  (the stone alone) or two (the stone and its flower). Absent from a contract, nothing changes.
*/
const positionSwitchTypes = () => {
  const rule = contract.position_field_switch
  if (!rule || !rule.field_title) return null
  const values = formPersonalizationValues(form)
  const answer = String(values[String(rule.field_title).trim().toLocaleLowerCase()] ?? '')
  const chosen = rule.values?.[answer]
  const types = chosen?.types
  return Array.isArray(types) && types.length ? types : null
}

const activeTypeSequence = () => {
  const map = contract.position_type_sequences
  if (!map || !countGroup) return null
  const value = countGroup.querySelector('input:checked, select')?.value
  if (value == null) return null
  const sequence = map[value]
  return Array.isArray(sequence) && sequence.length ? sequence : null
}
const typeForIndex = (index) => {
  const switched = positionSwitchTypes()
  if (switched) {
    /* Grouped, not interleaved: all the stones, then all the flowers. Interleaving retyped slots
       the customer had already filled every time the switch moved, so choosing flowers threw away
       a stone. Grouping keeps the stones where they are and appends the flowers after them. */
    const units = Math.max(1, Math.ceil(state.positions.length / switched.length) || 1)
    return switched[Math.min(switched.length - 1, Math.floor(index / units))]
  }
  const sequence = activeTypeSequence()
  if (sequence) return sequence[index] || sequence[sequence.length - 1]
  const segments = segmentCounts()
  if (segments.length) {
    let seen = 0
    for (const segment of segments) {
      if (index < seen + segment.count) return segment.type
      seen += segment.count
    }
    return segments[segments.length - 1].type
  }
  const leading = leadingPositionTypes()
  if (index < leading.length) return leading[index]
  const offset = index - leading.length
  if (positionTypeCycle) return positionTypeCycle[offset % positionTypeCycle.length]
  if (leading.length) return String(contract.counted_position_type || defaultType())
  return defaultType()
}

/*
  Does the contract DECIDE this slot's kind, or is typeForIndex only naming a default? Pinned runs
  constrain the chain; a free mixed run does not. Reading that default as a constraint chained
  letters and nothing else — it failed the moment a number or symbol was picked. Owner 2026-08-29.
*/
const typeIsPinnedForIndex = (index) => {
  if (positionSwitchTypes()) return true
  if (activeTypeSequence()) return true
  if (segmentCounts().length) return true
  if (index < leadingPositionTypes().length) return true
  return Boolean(positionTypeCycle)
}

const selectedCount = () => {
  /*
    An open-ended sequence sizes itself: however many the shopper has filled, plus one empty slot
    waiting. The block-name bracelet asks for a name, and a name has no natural count to pick from a
    list first — the owner's instruction is a plus after every choice, and the shopper stops when the
    word is finished. `open_ended.max` is the only ceiling, and there is no trailing plus once it is
    reached. Everything from the first slot on is optional in the contract, so the trailing empty one
    never blocks Add to cart.
  */
  if (contract.open_ended) {
    const ceiling = Number.isInteger(contract.open_ended.max) && contract.open_ended.max > 0
      ? contract.open_ended.max
      : 20
    const filled = state.positions.filter((position) => position.value).length
    return Math.max(1, Math.min(ceiling, filled + 1))
  }
  const switched = positionSwitchTypes()
  if (switched) {
    const value = countGroup?.querySelector('input:checked, select')?.value || ''
    const units = countFor(value)
    return Number.isFinite(units) ? units * switched.length : 0
  }
  const sequence = activeTypeSequence()
  if (sequence) return sequence.length
  const segments = segmentCounts()
  if (segments.length) return segments.reduce((total, segment) => total + segment.count, 0)
  const rule = activeRule()
  if (rule && rule.then && Number.isInteger(rule.then.position_count)) return rule.then.position_count
  /* An axis whose own label states the answer ("3 Names - 2 Stone Rings"). Matched on the raw
     option value, because that string is the merchant's key, not a number to be parsed out. */
  if (contract.count_value_map && countGroup) {
    const value = countGroup.querySelector('input:checked, select')?.value
    if (value != null && Object.prototype.hasOwnProperty.call(contract.count_value_map, value)) {
      return contract.count_value_map[value]
    }
  }
  if (fixedCount) return fixedCount
  const value = countGroup.querySelector('input:checked, select')?.value || ''
  const count = countFor(value)
  return Number.isFinite(count) ? count * positionsPerCount + leadingPositionTypes().length : 0
}

const setSelectedCount = (count) => {
  if (fixedCount) return
  const radio = [...countGroup.querySelectorAll('input')].find((input) => countFor(input.value) === count)
  if (radio) radio.checked = true
  const select = countGroup.querySelector('select')
  if (select) {
    const option = [...select.options].find((item) => countFor(item.value) === count)
    select.value = option?.value || ''
  }
  countGroup.dataset.touched = 'true'
}

/* The shopper counts cards, not letters, so an axis that names only the letters gets relabelled
   to the number of cards it actually produces: "Paw + 2 letters" reads 3, exactly like every
   other sequence product's plain-number axis. Only the LABEL changes — the input keeps the
   merchant's real option value, so variant matching, the cart and the order line are untouched.

   Done here rather than in the option markup because that markup exists twice (the theme's
   sj-product-option-group.liquid and local-preview's mirror), and this file is the one place both
   of them run. Relabelling in the two renderers instead would be a drift waiting to happen. */
const relabelCountAxis = () => {
  if (!countOffset || !countGroup) return
  let allNumeric = true
  countGroup.querySelectorAll('input').forEach((input) => {
    const total = countFor(input.value)
    if (!Number.isFinite(total)) { allNumeric = false; return }
    input.dataset.optionDisplayValue = String(total)
    const caption = input.closest('label')?.querySelector('span')
    if (caption) caption.textContent = String(total)
  })
  /* Bare numbers fit the compact square the labelled shape had to opt out of. */
  if (allNumeric) countGroup.dataset.optionCountShape = 'numeric'
}

const defaultType = () => contract.flow_type === 'birthstone_sequence'
  ? 'birthstone'
  : contract.flow_type === 'birthflower_sequence'
    ? 'birthflower'
    : contract.flow_type === 'charm_sequence'
      ? 'charm'
    : String(contract.token_types?.[0] || 'letter')
/*
  DECLARATIVE CONDITIONAL MODEL
  -----------------------------
  Seventeen products in listings235 change shape with a native option: a blank heart takes nothing
  while an engraved one takes a name, a one-sided pendant fixes its charm while a two-sided one
  also accepts text, a "3 Names - 2 Stone Rings" axis opens two stones and not three.

  All of it is DATA on the contract, evaluated here once, rather than a branch per handle. Two
  fields carry it:

    mode_option        the native option the rules watch, by name.
    conditional_rules  [{ when: [role, …], then: { position_count, token_types, text_fields,
                         preselect_value, fixed_text, requires_upload } }]

  Rules match on a normalized ROLE (blank / engraved / one_side / both_sides / front_only /
  front_and_back / single / multi), never on the merchant's literal string. Renaming "Blank Heart"
  to "Plain Heart" must not silently switch a product's personalization off, and role matching is
  what makes that true.

  count_value_map handles the axes whose label already states the answer — "3 Names - 2 Stone
  Rings" is a non-linear 1→1, 2→1, 3→2, 4→3, 5→4 map that no amount of digit-parsing gets right.
*/
/* modeRoleOf is shared — see its definition above conditionMatches. */


const modeGroup = contract.mode_option
  ? [...form.querySelectorAll('[data-option-index]')].find((fieldset) => {
      const label = fieldset.dataset.nativeOptionLabel
        || fieldset.querySelector('legend')?.childNodes[0]?.textContent?.trim() || ''
      return label.toLocaleLowerCase() === String(contract.mode_option).trim().toLocaleLowerCase()
    })
  : null

const currentModeRole = () => {
  if (!modeGroup) return null
  const control = modeGroup.querySelector('input:checked, select')
  return control ? modeRoleOf(control.value) : null
}

/* No rule matched means the merchant chose a value the document never described. Falling back to
   the unconditional contract would quietly offer everything; returning null instead lets the
   caller keep the base shape, which is the same thing the product did before this model existed. */
const activeRule = () => {
  const rules = contract.conditional_rules || []
  if (!rules.length) return null
  const role = currentModeRole()
  if (!role) return null
  return rules.find((rule) => (rule.when || []).includes(role)) || null
}

const availableTypes = (index = state.activeIndex) => {
  /* A cycled sequence pins each slot: the flower half of a charm must not offer letters, or the
     customer can build a charm with two letters and no flower. */
  /* A switch that decides the slots pins them just as a cycle does: with the flowers turned on,
     every slot offered BOTH tabs, so a stone slot would take a flower and a flower slot a stone —
     the two answers landed in each other's places and the order read back wrong. */
  const switchedPin = positionSwitchTypes() && Number.isInteger(index) && index >= 0
  if (switchedPin || (positionTypeCycle && Number.isInteger(index) && index >= 0)) {
    const pinned = typeForIndex(index)
    /* A pinned slot may still accept more than one KIND of the same thing: the initial on a charm
       can be a photographed capital or the lowercase the site sets in type. The pin is what stops a
       letter landing in the stone's slot; it was never meant to stop a letter being lowercase. */
    const alternatives = contract.position_type_alternatives?.[pinned]
    return Array.isArray(alternatives) && alternatives.length ? alternatives : [pinned]
  }
  const rule = activeRule()
  const types = (rule && rule.then && rule.then.token_types) || contract.token_types || []
  return types.length ? types : [defaultType()]
}
/*
  Named for the slot being asked about, not for the sequence in general. Without the index every
  empty slot read "Choose a letter or lowercase letter" — including the birthstone slots beside
  them, which name a choice that slot cannot take.
*/
const choicePrompt = (index = undefined) => {
  const nouns = availableTypes(index).map((type) => type === 'birthstone' ? 'birthstone' : typeLabels[type].toLocaleLowerCase())
  if (nouns.length === 1) return nouns[0] === 'birthstone' ? 'Choose a birth month' : `Choose a ${nouns[0]}`
  if (nouns.length === 2) return `Choose a ${nouns[0]} or ${nouns[1]}`
  return `Choose a ${nouns.slice(0, -1).join(', ')}, or ${nouns.at(-1)}`
}
/*
  Pull every row answer off the live inputs and onto its position before anything reshapes the
  sequence.

  A count change re-renders the option markup, and the sequence is rebuilt from `state`. If a name
  the customer typed is only in the DOM at that moment it is re-created in index order while the
  stones keep the order the customer dragged them into — the pair silently swaps partners. Capturing
  first makes state the single source at every reshape, which is what keeps a name attached to its
  own stone through a resize, a variant swap or a re-init.
*/
const captureRowAnswers = () => {
  if (!rowTextSpec()) return
  root?.querySelectorAll('[data-token-row-text]').forEach((input) => {
    const position = state.positions[Number(input.dataset.tokenRowText)]
    if (position) position.rowText = input.value
  })
}

const resizePositions = (count) => {
  captureRowAnswers()
  if (!fixedToken) {
    const next = state.positions.slice(0, count)
    while (next.length < count) {
      /* Only the very first card, and only while the sequence is still empty. A customer who
         changed or cleared it must not have it silently put back on the next count change. */
      const seed = next.length === 0 ? sequencePreselect() : null
      next.push(seed || { type: typeForIndex(next.length), value: '' })
    }
    state.positions = next
    state.errors = []
    return
  }
  /* With a fixed token, `count` is how many CHOSEN positions the variant carries; the fixed one
     sits alongside them. Wherever the customer has already dragged it stays put (clamped if the
     count shrank); otherwise it starts just left of centre, which is the middle card for an odd
     total — "Paw + 2 letters" opens as letter · paw · letter — and the leading card when there
     is only one letter to sit beside. */
  const chosen = state.positions.filter((position) => !position.fixed).slice(0, count)
  while (chosen.length < count) chosen.push({ type: defaultType(), value: '' })
  const total = count + 1
  const previous = state.positions.findIndex((position) => position.fixed)
  const target = state.fixedPlacedByCustomer && previous >= 0
    ? Math.min(previous, total - 1)
    : Math.floor((total - 1) / 2)
  chosen.splice(target, 0, { ...fixedToken })
  state.positions = chosen
  state.errors = []
}

const vocabularyFor = (type) => {
  /* A merchant profile supplies real choice objects for EVERY token type, including letters.
     Wrapping one of those objects again would produce { value: {…} } and render "[object
     Object]", so an object is passed through exactly as the other types already do. */
  if (type === 'letter') return (contract.vocabulary?.alphabet || []).map((value) => (
    typeof value === 'object' ? value : { value, label: value, glyph: value }
  ))
  if (type === 'number') return (contract.vocabulary?.numbers || []).map((value) => (
    typeof value === 'object' ? value : { value, label: value, glyph: value }
  ))
  if (type === 'charm') return contract.vocabulary?.charms || []
  if (type === 'serif_letter') return contract.vocabulary?.serif_letters || []
  if (type === 'cursive_letter') return contract.vocabulary?.cursive_letters || []
  if (type === 'symbol') return contract.vocabulary?.symbols || []
  if (type === 'birthflower') return contract.vocabulary?.birthflowers || []
  if (type === 'birthstone') return contract.vocabulary?.birthstones || []
  if (type === 'zodiac') return contract.vocabulary?.zodiac_signs || []
  if (type === 'heart') return contract.vocabulary?.enamel_hearts || []
  if (type === 'lowercase_letter') return contract.vocabulary?.lowercase_letters || []
  if (type === 'monogram') return contract.vocabulary?.monograms || []
  if (type === 'large_initial_letter') return contract.vocabulary?.large_initial_letters || []
  if (type === 'large_initial_symbol') return contract.vocabulary?.large_initial_symbols || []
  if (type === 'font') return contract.vocabulary?.fonts || []
  return []
}

/* A sequence whose first card is settled before the customer starts — the paw on a paw-initial
   necklace is always the leading charm, so the shopper confirms it rather than hunting for it in
   the picker. Read from the token_picker field's own default value, which Admin already stores
   (personalization_field.default_value) and the profile Liquid already emits as preselect_value,
   so nothing new has to be modelled. Unlike a fixed token this stays fully editable: it is a
   head start, not a lock. The declared token types decide which vocabulary owns the value, so a
   value that no active vocabulary offers is ignored rather than rendered as a dead card. */
const sequencePreselect = () => {
  const value = personalFields.find((field) => String(field.type || '').toLowerCase() === 'token_picker')?.preselect_value
  if (!value) return null
  /* Searched across every vocabulary the contract carries, not just the types the picker offers:
     the paw bracelet offers letters only, yet opens with a paw. That combination is deliberate —
     the piece always starts with the paw, and swapping it means choosing a letter instead. A
     value no vocabulary knows resolves to nothing rather than drawing a card with no picture. */
  const types = [...new Set([...availableTypes(), ...Object.keys(CONTRACT_VOCABULARY_KEY)])]
  const type = types.find((candidate) => vocabularyFor(candidate).some((item) => item.value === value))
  return type ? { type, value } : null
}

const tokenDefinition = (position) => vocabularyFor(position.type).find((item) => item.value === position.value)
const tokenLabel = (position) => {
  const definition = tokenDefinition(position)
  if (!definition) return ''
  return [definition.label, definition.detail].filter(Boolean).join(' — ')
}

const serializedToken = (position) => position.type === 'birthflower'
  ? tokenLabel(position)
  : position.value

/*
  Name what this product actually offers, not what its flow usually does.

  The headings below were written per FLOW, so a contract that narrows the sequence still announced
  the flow's full set: the baguette necklace offers capitals, lowercase and birthstones and read
  "letter, number, symbol, and birthstone" — two of those it does not have, and the lowercase it
  does have went unmentioned. Read from token_types so the sentence cannot drift from the picker.
*/
const offeredTypeNames = () => {
  const types = Array.isArray(contract.token_types) && contract.token_types.length
    ? contract.token_types
    : availableTypes()
  const names = [...new Set(types.map((type) => `${(typeLabels[type] || type).toLocaleLowerCase()}s`))]
  if (names.length <= 1) return names.join('')
  if (names.length === 2) return `${names[0]} and ${names[1]}`
  return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`
}

/*
  The merchant-owned PDP instruction is the copy for THIS exact surface, not an extra paragraph
  above it. Sequence mode keeps the Liquid node in the DOM as the no-JS/source-of-truth surface,
  hides that duplicate visually, and consumes its complete text here in place of the generated
  introduction. A blank metafield still receives the contract-aware fallback below.
*/
const merchantIntro = details.querySelector('[data-personalization-help]')?.textContent?.trim() || ''
const merchantTitle = details.dataset.personalizationTitle?.trim() || ''

/*
  A piece with ONE slot has no sequence to build and nothing to reorder, so the standard invitation
  described controls it does not show. It says what this page actually asks for instead.
*/
const soleSlotIntro = fixedCount === 1 || (Number.isInteger(contract.fixed_position_count) && contract.fixed_position_count === 1)
const fallbackTitle = soleSlotIntro
  ? `Choose your ${offeredTypeNames().replace(/s and /, ' or ').replace(/s$/, '')}`
  : contract.flow_type === 'birthstone_sequence'
  ? 'Choose each birthstone'
  : contract.flow_type === 'birthflower_sequence'
    ? 'Choose each birth flower'
    : contract.flow_type === 'charm_sequence'
      ? 'Choose every charm'
    : contract.flow_type === 'mixed_birthflower_sequence'
      ? `Build your ${offeredTypeNames()} sequence`
    : contract.flow_type === 'mixed_token_sequence'
      ? availableTypes().length === 1 && availableTypes()[0] === 'font'
        ? 'Choose your font'
        : `Build your ${offeredTypeNames()} sequence`
        /* A sequence that offers exactly ONE token type has no type to choose, so naming a second
           one (or inviting a "type" choice in the intro below) would describe a control the
           customer never sees. Every shipped product on this flow offers letter+symbol+number, so
           this reads identically for all of them; it only differs where a profile narrows the
           sequence to a single type. */
        : contract.position_layout
          ? 'Choose a letter for each side'
        : availableTypes().length === 1
          ? `Build your ${typeLabels[availableTypes()[0]].toLocaleLowerCase()} sequence`
          : 'Build your letter and symbol sequence'
const title = merchantTitle || fallbackTitle
/* A sequence whose positions are PLACES on the piece is not a sequence the shopper builds — the
   four faces of a hexagon are given, and only what goes in them is a choice. */
const placedPositions = Boolean(contract.position_layout)
const fallbackIntro = soleSlotIntro
  ? `Choose the ${offeredTypeNames().replace(/s and /, ' or ').replace(/s$/, '')} for this piece.`
  : contract.flow_type === 'birthstone_sequence'
  ? 'Choose one birth month for every position. The order below is the production order.'
  : contract.flow_type === 'birthflower_sequence'
    ? 'Choose every flower from the visual chart. The order below is the production order.'
    : contract.flow_type === 'charm_sequence'
      ? 'Choose a charm, serif letter, cursive letter, or number for every position. The order below is the production order.'
    : availableTypes().length === 1
      ? availableTypes()[0] === 'font'
        ? 'Select the font for this engraving.'
        /* Positions that are PLACES on the piece cannot be reordered — the top of a hexagon is the
           top of a hexagon — so the line stops offering it. */
        : `Open a position to choose its ${typeLabels[availableTypes()[0]].toLocaleLowerCase()}.${contract.position_layout ? ' Each one is engraved where it sits here.' : ' Reorder without re-entering anything.'}`
      : `Open a position to choose its type and value.${contract.position_layout ? ' Each one is engraved where it sits here.' : ' Reorder without re-entering anything.'}`
const intro = merchantIntro || fallbackIntro

const currentPrice = () => {
  const buybox = form.closest('.sj-product__buybox')
  const value = buybox?.querySelector('[data-product-price]')?.textContent?.trim() || ''
  const prefix = buybox?.querySelector('[data-product-price-prefix]')
  return [prefix && !prefix.hidden ? prefix.textContent.trim() : '', value].filter(Boolean).join(' ')
}

const syncSubmitLabel = () => {
  const label = submit.querySelector('[data-submit-label]')
  if (!label) return
  const unresolvedChoices = unresolvedBaseChoices(form)
  if (unresolvedChoices.length) {
    label.textContent = unresolvedChoicePrompt(form, unresolvedChoices)
    return
  }
  // The shared resolver owns this label; the controller only reports its state.
  renderPrimaryCta(form)
}

const summaryMarkup = () => {
  const complete = state.positions.filter((position, index) =>
    positionIsText(index) ? String(position.rowText || '').trim() : position.value).length
  const itemMarkup = state.positions.map((position, index) => {
    const definition = tokenDefinition(position)
    const label = tokenLabel(position)
    /* A sequence may name its positions. Four cufflink initials are Left 1, Left 2, Right 1 and
       Right 2 — "Position 3" would leave an order genuinely ambiguous about which cuff it means. */
    const positionName = positionLabelFor(index)
    const empty = !position.value
    const error = state.errors.find((item) => item.index === index)
    const photograph = empty || contract.plain_tokens ? null : tokenPhotograph(position.type, definition?.value)
    const accessibleLabel = escapeMarkup(label || position.value || choicePrompt(index))
    let preview = ''
    if (empty) {
      preview = '<span class="sj-token-summary__empty-mark" aria-hidden="true">+</span>'
    } else if (photograph) {
      preview = `<span class="sj-token-summary__visual sj-token-summary__visual--photo" style="--sj-token-photo:url('${escapeMarkup(photograph)}')" aria-hidden="true"></span>`
    } else {
      preview = `<span class="sj-token-summary__visual sj-token-summary__visual--glyph"${definition?.color ? ` style="--sj-token-color:${escapeMarkup(definition.color)}"` : ''} aria-hidden="true">${escapeMarkup(definition?.glyph || position.value)}</span>`
    }
    /*
      A flower tile shows a generic ✿ for all twelve months, so twelve chosen flowers looked
      identical in the summary and the only way to read the design back was to reopen each picker.
      The month and the flower it names go under the glyph, stacked and small so a row of three
      still fits. Scoped to flowers because every other token type is already self-identifying —
      a letter shows its letter, a birthstone its colour.
    */
    const caption = !empty && position.type === 'birthflower' && (definition?.label || definition?.detail)
      ? `<span class="sj-token-summary__caption" aria-hidden="true">`
        + `<span>${escapeMarkup(definition.label || position.value)}</span>`
        + (definition.detail ? `<span>${escapeMarkup(definition.detail)}</span>` : '')
        + `</span>`
      : ''
    const reorderAttributes = state.reorderMode
      ? ` draggable="true" data-token-draggable="true" aria-roledescription="draggable position"`
      : ''
    const describedBy = [error ? `SilveristicTokenError-${index}` : '', state.reorderMode ? 'SilveristicTokenReorderHelp' : ''].filter(Boolean).join(' ')
    /* The fixed token is placed, not picked, so it never offers "Change selection" — saying so
       would promise a picker that deliberately does not open. */
    const action = position.fixed
      ? '. Always included'
      : empty ? '.' : '. Change selection.'
    /* No vocabulary, so no tile and no picker to open — the row IS the control. Rendered inside
       the same position card so reorder, validation and the error id all keep working. */
    if (positionIsText(index)) {
      return `<div class="sj-token-summary__position sj-token-summary__position--text" role="listitem" data-token-position="${index}"${reorderAttributes}${error ? ' data-invalid="true"' : ''}>
        <span class="sj-token-summary__number" aria-hidden="true"${
          /* Same rule as the picture tiles: quiet corner index, full size while reordering or
             when this is the position the CTA is pointing at. */
          state.reorderMode || error ? '' : ' data-compact="true"'
        }>${escapeMarkup(namedPositions() ? positionName : String(index + 1))}</span>${rowTextMarkup(index)}${error ? `<span class="sj-visually-hidden" id="SilveristicTokenError-${index}">${escapeMarkup(error.message)}</span>` : ''}
      </div>`
    }
    /*
      One slot, more than one kind of thing to put in it: name the kinds instead of a "+".

      A single "+" asked the shopper to discover that a Large Initial can be a letter OR one of
      seven symbols by pressing it. The two doors are the choice, so they are what the page shows;
      pressing one opens the picker already on that tab. Once something is chosen the tile takes
      over — the piece itself, with a way to undo it.
    */
    /*
      Not in an open-ended sequence. There the plus is the whole affordance the owner asked for — one
      after every choice, and one at the start — and naming the kinds on the first slot alone would
      make the first step look different from every step after it. The kinds are still a click away:
      the picker opens with its Letters and Symbols tabs.
    */
    const soleSlot = !contract.open_ended && state.positions.length === 1 && !position.fixed
    const offered = soleSlot ? availableTypes(index) : []
    if (soleSlot && empty && offered.length > 1) {
      return `<div class="sj-token-summary__position sj-token-summary__position--doors" role="listitem" data-token-position="${index}"${error ? ' data-invalid="true"' : ''}>
        <div class="sj-token-summary__doors">${offered.map((type) => `
          <button class="sj-token-summary__door" type="button" data-token-picker-open="${index}" data-empty="true" data-picker-type="${escapeMarkup(type)}">${escapeMarkup(typeLabels[type] || type)}s</button>`).join('')}
        </div>${error ? `<span class="sj-visually-hidden" id="SilveristicTokenError-${index}">${escapeMarkup(error.message)}</span>` : ''}
      </div>`
    }
    const clearControl = soleSlot && !empty
      ? `<button class="sj-token-summary__clear" type="button" data-token-clear="${index}" aria-label="Clear ${escapeMarkup(label || position.value)} and choose again">Change</button>`
      : ''
    return `<div class="sj-token-summary__position" role="listitem" data-token-position="${index}"${reorderAttributes}${position.fixed ? ' data-token-fixed="true"' : ''}${error ? ' data-invalid="true"' : ''}>
      <button class="sj-token-summary__item" type="button" data-token-picker-open="${index}" data-picker-type="${position.type}" data-empty="${empty}"${empty ? '' : ` data-preview-type="${escapeMarkup(position.type)}"`} aria-label="${escapeMarkup(positionName)}: ${accessibleLabel}${action}${state.reorderMode ? ' Drag to reorder, or use the Left and Right arrow keys.' : ''}" aria-invalid="${Boolean(error)}"${describedBy ? ` aria-describedby="${describedBy}"` : ''}>
        ${positionGroups().length
          ? ''
          : `<strong class="sj-token-summary__number" aria-hidden="true"${
              /*
                The 28px ringed badge was a third of a 104px tile and pushed longer values —
                "CANCER" — out of the space they needed. It earns that weight only where the
                number is load-bearing: while reordering, and on a position the CTA is pointing
                at. Everywhere else it shrinks to a corner index, which still lets "Choose
                position 2" find its card, and screen readers keep the full "Position 2: …" from
                the button's own aria-label either way.
              */
              state.reorderMode || error ? '' : ' data-compact="true"'
            }>${escapeMarkup(namedPositions() ? positionName : String(index + 1))}</strong>`}${preview}${caption}
      </button>${clearControl}${rowTextMarkup(index)}${error ? `<span class="sj-visually-hidden" id="SilveristicTokenError-${index}">${escapeMarkup(error.message)}</span>` : ''}
    </div>`
  })
  const groups = positionGroups()
  const items = groups.length
    ? `<div class="sj-token-summary__groups"${positionSwitchTypes() ? ' data-group-mode="kind"' : ''}>${groups.map((group) => {
        const groupItems = itemMarkup.slice(group.start, group.start + group.count).join('')
        return `<section class="sj-token-summary__group" aria-labelledby="SilveristicTokenGroup-${group.start}">
          <h4 id="SilveristicTokenGroup-${group.start}">${escapeMarkup(group.label)}</h4>
          <div class="sj-token-summary__items" role="list">${groupItems}</div>
        </section>`
      }).join('')}</div>`
    /*
      A contract may say how its positions sit on the PIECE. The hexagon pendant engraves four
      initials around a centre stone — top, right, bottom, left — and a row of four tiles cannot say
      which is which; laid out as they are worn, the shopper reads their own design back at a glance.
    */
    /*
      The middle cell is a real slot, not a drawn circle. It used to be a decorative ::before, so the
      stone had to be asked for in a separate titled block underneath the pendant — four initials
      arranged as the piece, and then the stone somewhere else. It is rendered here and the picker is
      moved into it after every render, because this whole summary is replaced on each state change.
    */
    : `<div class="sj-token-summary__items" role="list"${contract.position_layout ? ` data-position-layout="${escapeMarkup(contract.position_layout)}"` : ''}>${itemMarkup.join('')}${contract.position_layout ? '<div class="sj-token-summary__centre" data-token-centre></div>' : ''}</div>`
  /*
    `chain_same_type` says the slots are one undifferentiated decision — three loose stones, not a
    first stone then a second. Where that is true and the slots also carry a typed answer, the two
    are separate parts of the piece and must not render welded together as "+name +name"; the CSS
    stacks them into a row of tiles over a row of names. Everywhere else the name IS engraved on
    that charm (a name per paw, per heart, per bar), so side by side is the honest arrangement and
    stays. Surfaced as an attribute because only the contract knows which of the two this is.
  */
  return `<section class="sj-token-summary" data-token-summary${contract.chain_same_type ? ' data-slots-interchangeable="true"' : ''} aria-label="${escapeMarkup(sjUi.design_summary)}">
    <div class="sj-token-summary__head"><div><h3>Your design</h3><span>${contract.open_ended
      /* An open-ended sequence has no target to be "of": the trailing slot is an invitation, not a
         requirement, and "3 of 4 complete" told a shopper who had finished a three-letter name that
         one was still missing. */
      ? `${complete} chosen`
      : `${complete} of ${state.positions.length} complete`}</span></div>${state.positions.length > 1 && !groups.length && !contract.position_layout ? `<button class="sj-token-summary__reorder" type="button" data-token-reorder aria-expanded="${state.reorderMode}" aria-pressed="${state.reorderMode}">${state.reorderMode ? 'Done' : 'Reorder'}</button>` : ''}</div>
    ${items}
    ${state.reorderMode ? `<p class="sj-token-summary__help" id="SilveristicTokenReorderHelp">${escapeMarkup(sjUi.reorder_help)}</p>` : ''}
  </section>`
}

const activeSerializationFields = () => {
  const selections = formSelections(form)
  const byName = formSelectionsByName(form)
  const fieldValues = formPersonalizationValues(form)
  return personalFields.filter((field) => conditionMatches(field, selections, byName, fieldValues))
}

/* Some migrated profiles store one production property per selected position rather than one
   joined sequence. Their field titles are the actual workshop keys ("First Letter", "Second
   Letter", …), and the native count choice decides which set is active. Keep that contract exact:
   never collapse it into an invented `Personalization` property, and never submit inactive fields
   for another count. The positional UI still remains one compact shared picker. */
const sequenceSerializationFields = () => activeSerializationFields().filter((field) => (
  String(field.type || '').toLowerCase() === 'token_picker'
))
/*
  What a position is called. Defaults to its number, which is right for a name or a monogram where
  order is the only thing that distinguishes the slots. A contract that declares `position_labels`
  overrides it for sequences where the slots mean different physical things.
*/
/*
  Some sequences pair each position with a short answer of its own: a heart necklace sets one stone
  PER NAME, so asking for the names in a separate box would leave the workshop matching two lists by
  eye. `row_text` gives every position a compact input beside its picker, and the composed property
  keeps them together in order — "1. Mary — APRIL · 2. Alex — JULY".

  The values live in state so they survive a re-render, and the input is nameless like every other
  composite part: the one property is written by the serializer.
*/
const textOnly = () => contract.flow_type === 'text_sequence'
/*
  `text_sequence` makes EVERY slot a typed answer. A slot can also be typed on its own, when a
  position sequence names it so — that is what lets names and stones alternate in one sequence.
  Without a declared sequence this is exactly textOnly(), so no existing contract changes.
*/
const textPositionTypes = () => (Array.isArray(contract.text_position_types)
  ? contract.text_position_types
  : ['text'])
const positionIsText = (index) => textOnly()
  || textPositionTypes().includes(state.positions[index]?.type || typeForIndex(index))
const rowTextSpecAll = () => contract.fields?.find((field) => field.type === 'token_picker')?.row_text || null
/*
  A row answer may belong to ONE kind of slot. The name-disk necklace engraves a name beside its
  single flower; its birthstones take no name, and giving every stone an empty required box would
  block the cart on answers the piece has nowhere to put.
*/
const rowTextAppliesTo = (index) => {
  const spec = rowTextSpecAll()
  if (!spec) return false
  const only = Array.isArray(spec.only_types) ? spec.only_types : null
  if (!only) return true
  return only.includes(state.positions[index]?.type || typeForIndex(index))
}
const rowTextSpec = (index = null) => {
  const spec = rowTextSpecAll()
  if (!spec) return null
  if (index === null) return spec
  return rowTextAppliesTo(index) ? spec : null
}
const rowTextMarkup = (index) => {
  const spec = rowTextSpec(index)
  if (!spec) return ''
  const value = state.positions[index]?.rowText || ''
  /* The box is as wide as what fits in it. `ch` is the width of a "0" in the current font, and the
     uppercase engraving letters run narrower than that, so the declared limit is enough room for
     all of it — and four nine-character paws then fit one line of the 500px buybox column. */
  const limit = Number(spec.maxlength) || 20
  return `<label class="sj-token-summary__row-text"><span class="sj-visually-hidden">${escapeMarkup(spec.title)} for ${escapeMarkup(positionLabelFor(index))}</span>`
    + `<input type="text" data-token-row-text="${index}" value="${escapeMarkup(value)}" maxlength="${limit}"`
    + ` style="--sj-row-text-width:${limit}ch" placeholder="${escapeMarkup(spec.title)}" autocomplete="off" spellcheck="false"></label>`
}

/*
  Whether the sequence's positions have names worth SHOWING on the tile itself.

  A GROUPED sequence does not: the group heading already says "Left cufflink", so repeating "Left 1"
  and "Left 2" inside the two slots beneath it is noise, and the numbers made the tiles read like a
  four-step sequence when they are two pairs. The name still reaches assistive technology through
  each tile's aria-label.
*/
const namedPositions = () =>
  Array.isArray(contract.fields?.find((field) => field.type === 'token_picker')?.position_labels)

const positionLabelFor = (index) => {
  const declared = contract.fields?.find((field) => field.type === 'token_picker')?.position_labels
  const label = Array.isArray(declared) ? declared[index] : null
  return label ? String(label) : `Position ${index + 1}`
}

/* Physical product groups are not one reorderable production sequence. Cufflink initials, for
   example, are two letters for the left cufflink and two for the right; presenting four anonymous
   slots in one rail makes it possible to create an order the workshop cannot interpret. */
const positionGroups = () => {
  /*
    When one countable thing spans several positions the cards must SAY so: a flower and a letter
    that go on the same charm read as two unrelated slots side by side otherwise. Groups are built
    from the count rather than declared, because how many there are is the customer's choice.
  */
  const perUnit = positionsPerCount
  const unitLabel = String(contract.position_group_label || '').trim()
  if (perUnit > 1 && unitLabel) {
    const units = Math.floor((state.positions.length - leadingPositionTypes().length) / perUnit)
    const offset = leadingPositionTypes().length
    return Array.from({ length: units }, (_, unit) => ({
      label: `${unitLabel} ${unit + 1}`,
      start: offset + unit * perUnit,
      count: perUnit
    }))
  }
  /*
    A switch that opens a second KIND of slot groups by kind, not by unit: the stones the piece is
    counted by, then the birth flowers that may sit beside them. Ungrouped they rendered as one
    undifferentiated row of "+" tiles, so the flowers read as more stones and the customer could not
    tell which half they were filling.
  */
  const switched = positionSwitchTypes()
  if (switched && switched.length > 1 && state.positions.length) {
    const units = Math.max(1, Math.floor(state.positions.length / switched.length))
    return switched.map((type, groupIndex) => ({
      label: `${typeLabels[type] || type}s`,
      start: groupIndex * units,
      count: units
    }))
  }
  const declared = contract.fields?.find((field) => field.type === 'token_picker')?.position_groups
  if (!Array.isArray(declared)) return []
  return declared.map((group) => ({
    label: String(group?.label || '').trim(),
    start: Number(group?.start),
    count: Number(group?.count)
  })).filter((group) => group.label && Number.isInteger(group.start) && group.start >= 0
    && Number.isInteger(group.count) && group.count > 0
    && group.start + group.count <= state.positions.length)
}

const sequenceSerializationPropertyName = (field) => String(field.title || field.label || '').trim()

/*
  One legacy key, several structured answers.

  These products already receive ONE line-item property whose title is the question the merchant
  wrote — "Preferred Font and Name", "Please specify the charm(s) in the order you would like".
  Fulfilment matches on that key today. The Listings work replaces the free-text box behind it with
  real controls (a font tile grid, a constrained name field, a birthstone list), but the key itself
  must not move: renaming it is the silent kind of breakage that surfaces as a wrong piece on a
  bench rather than as an error anyone sees.

  So each part renders as its own control and NONE of them posts its own property; the parts are
  composed here into a single labelled value under the original key. The shopper is asked once, the
  workshop reads one field, and the answer arrives structured instead of typed.
*/
const compositePropertyValue = () => {
  const parts = []
  /* A piece that is always engraved with the same words, which the customer may then extend. The
     fixed text is stated once, here, so choosing the extension adds to it instead of repeating it
     — "In my showgirl era · Back side: MAMA", never the phrase twice. */
  const fixedPrefix = String(contract.serializer?.fixed_prefix || '').trim()
  /* "1. Mary — APRIL", so a packing slip never has to pair two separate lists by eye. */
  const rowSpec = rowTextSpec()
  const sequence = state.positions
    .map((position, index) => {
      const token = tokenLabel(position) || serializedToken(position)
      if (!rowSpec) return token
      const answer = String(position.rowText || '').trim()
      /*
        A pair is serialized only when it is COMPLETE. An em dash for the missing half used to reach
        the order looking like a real answer — "2. — — JULY" tells the workshop nothing and reads as
        a name nobody typed. An incomplete row contributes nothing here and is blocked at the CTA by
        validationErrors, so it can never be the reason a property looks finished.
      */
      if (positionIsText(index)) return answer ? `${index + 1}. ${answer}` : ''
      if (!rowTextAppliesTo(index)) return token
      if (!token || !answer) return ''
      return `${index + 1}. ${answer} — ${token}`
    })
    .filter(Boolean)
  if (sequence.length) {
    const groups = positionGroups()
    const value = groups.length
      ? groups.map((group) => `${group.label}: ${sequence.slice(group.start, group.start + group.count).join(' · ')}`).join(' | ')
      : sequence.join(' · ')
    /*
      A contract may declare an EMPTY sequence label, which means the property key already says
      what the value is. The paw bracelet's key is "Preferred name", so prefixing the value with
      "Engraving for each paw:" only made the workshop read the same thing twice. Undeclared still
      falls back to "Selection"; only an explicit empty string drops the prefix.
    */
    const sequenceLabel = contract.serializer && 'sequence_label' in contract.serializer
      ? String(contract.serializer.sequence_label || '')
      : 'Selection'
    if (sequenceLabel) parts.push([sequenceLabel, value])
    else parts.push([null, value])
  }
  /* Source order, not DOM order: the merchant's question reads in a fixed order and the packing
     slip should too, however the controls end up laid out on screen. */
  compositeParts().forEach(({ label, wrapper }) => {
    if (!wrapper || wrapper.hidden) return
    const value = fieldValue(wrapper)
    if (value) parts.push([label, value])
  })
  const composed = parts.map(([label, value]) => (label ? `${label}: ${value}` : value)).join(' · ')
  if (!fixedPrefix) return composed
  return composed ? `${fixedPrefix} · ${composed}` : fixedPrefix
}

const sequencePropertyPairs = () => {
  const serializerKind = String(contract.serializer?.kind || '')
  if (serializerKind === 'composite_property') {
    const property = String(contract.serializer?.property_name || '').trim()
    const value = compositePropertyValue()
    return property && value ? [[property, value]] : []
  }

  if (serializerKind === 'single_property') {
    const property = String(contract.serializer?.property_name || '').trim()
    /*
      A single-property sequence may now pair each token with a short answer of its own — one name
      per birthstone. Serialized as a numbered pair so the workshop reads "1. ANNA — APRIL" instead
      of matching two lists by eye, exactly as the composite serializer does; without a row spec
      nothing changes and the value stays the plain token list it has always been.
    */
    const rowSpec = rowTextSpec()
    const value = state.positions
      .map((position, index) => {
        const token = tokenLabel(position) || serializedToken(position)
        const answer = String(position.rowText || '').trim()
        /* A typed slot has no token to pair with — it IS the answer. Without this the names in a
           (name, stone, name) sequence were dropped from the order and only the stones reached the
           workshop, which is worse than not offering the names at all. */
        if (positionIsText(index)) return answer ? `${index + 1}. ${answer}` : ''
        /* When typed and picked slots alternate, the picked ones carry their number too, or the
           line reads "1. Mary · February · 3. Alex" and 2 and 4 look like they went missing. Only
           a declared sequence does this; every other product's property is unchanged. */
        if (contract.position_type_sequences && token) return `${index + 1}. ${token}`
        if (!rowSpec || !rowTextAppliesTo(index)) return token
        if (!token || !answer) return ''
        return `${index + 1}. ${answer} — ${token}`
      })
      .filter(Boolean)
      .join(' · ')
    return property && value ? [[property, value]] : []
  }
  if (serializerKind !== 'conditional_fields') return []
  const activeFields = sequenceSerializationFields()
  if (activeFields.length !== state.positions.length) return []
  const names = activeFields.map(sequenceSerializationPropertyName)
  if (names.some((name) => !String(name || '').trim()) || new Set(names).size !== names.length) return []
  return activeFields.map((field, index) => [
    sequenceSerializationPropertyName(field),
    tokenLabel(state.positions[index]) || serializedToken(state.positions[index])
  ]).filter(([, value]) => Boolean(value))
}

const serializationReady = () => {
  /* A composite needs a key and at least one answered part. Requiring every part would block the
     cart on an optional detail; requiring none would post an empty property. */
  if (String(contract.serializer?.kind || '') === 'composite_property') {
    return Boolean(String(contract.serializer?.property_name || '').trim())
  }
  if (String(contract.serializer?.kind || '') === 'single_property') {
    return Boolean(String(contract.serializer?.property_name || '').trim())
  }
  if (String(contract.serializer?.kind || '') !== 'conditional_fields') return false
  const activeFields = sequenceSerializationFields()
  const names = activeFields.map(sequenceSerializationPropertyName)
  return activeFields.length === state.positions.length
    && names.every((name) => Boolean(String(name || '').trim()))
    && new Set(names).size === names.length
}

const syncProperties = () => {
  let container = form.querySelector('[data-contract-properties]')
  if (!container) {
    container = createElement('div')
    container.hidden = true
    container.dataset.contractProperties = ''
    form.append(container)
  }
  container.replaceChildren()

  /*
    Facts about the piece that the customer does not choose but the order should carry. The paw
    earrings are always 6 mm — it used to hide inside the Color value ("Gold / 6mm"), which made it
    look like a choice and pushed the finish out of its swatch. Stated here instead, so it reaches
    the order summary and the packing slip without pretending to be an option.
  */
  const appendProperty = (name, value) => {
    if (!name || !value) return
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = `properties[${name}]`
    /* The serializer's key comes from the contract, so it is exact by definition. */
    input.dataset.exactPropertyKey = ''
    input.value = value
    container.append(input)
  }

  Object.entries(contract.fixed_properties || {}).forEach(([name, value]) => appendProperty(name, value))

  /* Only the sequence goes in here. Any other personalization field is already a real, named
     input inside the form and posts itself as its own order property; adding one here as well
     would send it twice AND read as one more position in the sequence — the kind of ambiguity
     that reaches the bench as a wrong piece. */
  /* The property key is part of the product contract, not a UI convenience. Listings contracts
     deliberately retain the product's shipped production key; hard-coding "Personalization"
     here made every structured product look correct in the picker while posting the wrong key
     to the cart. Compatibility fixtures that genuinely use Personalization already declare it
     in their serializer, so reading the contract is both backwards-compatible and exact. */
  sequencePropertyPairs().forEach(([name, value]) => appendProperty(name, value))
  const productionRows = []
  form.querySelectorAll('[data-option-index]').forEach((fieldset) => {
    const label = fieldset.querySelector('legend')?.childNodes[0]?.textContent?.trim() || 'Option'
    const value = nativeOptionDisplayValue(fieldset)
    if (value) productionRows.push([label, value])
  })
  basePersonalizationFields(form).forEach((wrapper) => {
    const value = fieldValue(wrapper)
    if (value) productionRows.push([wrapper.dataset.fieldTitle || 'Product choice', value])
  })
  const groups = positionGroups()
  if (groups.length) {
    groups.forEach((group) => {
      const values = state.positions.slice(group.start, group.start + group.count)
        .map((position) => tokenLabel(position))
        .filter(Boolean)
      if (values.length) productionRows.push([group.label, values.join(' · ')])
    })
  } else {
    state.positions.forEach((position, index) => {
      if (!position.value) return
      /* The pair, not two lists. A summary that showed the stones in one place and the names in
         another left the person at the bench matching them by row number. */
      const answer = String(position.rowText || '').trim()
      productionRows.push([
        positionLabelFor(index),
        answer ? `${answer} — ${tokenLabel(position)}` : tokenLabel(position)
      ])
    })
  }
  /* An independent field posts its own property, but the production summary is built here from
     scratch — so without this the engraving reached the order while the shopper's own summary
     never showed it back to them. */
  independentFields.forEach((wrapper) => {
    if (wrapper.hidden) return
    const value = fieldValue(wrapper)
    if (value) productionRows.push([wrapper.dataset.fieldTitle || 'Personalization', value])
  })
  const productionSummary = form.querySelector('[data-production-summary-input]')
  if (productionSummary) productionSummary.value = productionRows.map(([label, value]) => `${label}: ${value}`).join(' | ')
}

const errorsMarkup = () => {
  if (!state.errors.length) return ''
  return `<section class="sj-token-configurator__errors" tabindex="-1" data-token-errors><h3>${state.errors.length} ${state.errors.length === 1 ? 'position needs' : 'positions need'} attention</h3>${state.errors.map((error) => `<button type="button" data-token-error="${error.index}">Position ${error.index + 1} — ${escapeMarkup(error.message)}</button>`).join('')}</section>`
}

/* Zero positions has two very different meanings: nothing picked on the count axis yet, or a
   count option that genuinely carries none ("Only paw"). Telling someone who already chose to
   "choose above" sends them back to a control they have finished with. */
const countChosen = () => {
  if (fixedCount) return true
  if (countGroup) {
    return Boolean(countGroup.querySelector('input:checked'))
      || Boolean(countGroup.querySelector('select')?.value)
  }
  /* A conditional product can have no dedicated count field at all: its mode rule supplies the
     position count (for example Plain Band -> 0, Stones with Engraving -> 2). The old code still
     dereferenced countGroup in that valid shape and aborted the entire runtime before change
     listeners were installed, leaving conditional fields permanently hidden. */
  return sizedByRules && Boolean(activeRule())
}
const emptyMarkup = () => countChosen()
  ? `<div class="sj-token-configurator__empty"><p>${escapeMarkup((countGroup && nativeOptionDisplayValue(countGroup)) || 'That option')} needs nothing else — there are no positions to fill.</p></div>`
  : `<div class="sj-token-configurator__empty"><p>Choose ${escapeMarkup(String(contract.count_option_name || 'the number of pieces').toLocaleLowerCase())} above. Your positions will appear here immediately.</p></div>`

const render = ({ focusIndex = null } = {}) => {
  /* Rescue the centred chooser before the redraw wipes it — see detachCentreChoice. */
  detachCentreChoice(form)
  root.innerHTML = `<div class="sj-token-configurator__head"><h2>${escapeMarkup(title)}</h2><p>${escapeMarkup(intro)}</p></div>${errorsMarkup()}${state.positions.length ? summaryMarkup() : emptyMarkup()}<p class="sj-visually-hidden" data-token-live aria-live="polite"></p>`
  placeCentreChoice(form)
  syncProperties()
  syncSubmitLabel()
  if (focusIndex !== null) requestAnimationFrame(() => root.querySelector(`[data-token-position="${focusIndex}"] [data-token-picker-open]`)?.focus())
}

const announce = (message) => {
  const live = root.querySelector('[data-token-live]')
  if (!live) return
  live.textContent = ''
  requestAnimationFrame(() => { live.textContent = message })
}

/*
  What the shopper has chosen so far, shown INSIDE the picker.

  The picker now stays open across a run of slots, which removed the reopening but also removed the
  only moment the sequence was visible: to check what was already picked you had to close the dialog
  and read the summary behind it. Owner, 2026-08-29: "Hangilerini seçtiğim belli olmuyor pop-uptan
  çıkıp ön izlemeye bakmadan."

  Positions rather than choices, deliberately. The same stone may be chosen twice — two children
  born in the same month — so a strip of choices would collapse a real answer into one chip and a
  "used" state on the tile would read as "unavailable". Listing positions shows a repeat as what it
  is: two filled slots carrying the same stone.

  Each chip is also a way back to that slot, so a mistake three positions ago is one click rather
  than a close, a re-open and a lost place.
*/
const pickerProgressMarkup = () => {
  if (state.positions.length < 2) return ''
  const chips = state.positions.map((position, index) => {
    const filled = Boolean(position.value)
    const definition = filled ? tokenDefinition(position) : null
    const photograph = filled && !contract.plain_tokens
      ? tokenPhotograph(position.type, position.value)
      : null
    const face = photograph
      ? `<span class="sj-token-picker__progress-photo" style="--sj-token-photo:url('${escapeMarkup(photograph)}')" aria-hidden="true"></span>`
      : filled
        ? `<i class="sj-token-picker__progress-glyph"${definition?.color ? ` style="background:${escapeMarkup(definition.color)};color:${escapeMarkup(definition.color)}"` : ''} aria-hidden="true">${escapeMarkup(definition?.glyph || '●')}</i>`
        : '<span class="sj-token-picker__progress-empty" aria-hidden="true">+</span>'
    const name = filled ? (definition?.label || position.value) : 'Not chosen yet'
    const current = index === state.activeIndex
    return `<button type="button" class="sj-token-picker__progress-chip" data-token-picker-goto="${index}"`
      + ` aria-current="${current ? 'true' : 'false'}" data-empty="${filled ? 'false' : 'true'}"`
      + ` aria-label="${escapeMarkup(positionLabelFor(index))}: ${escapeMarkup(name)}${current ? '. Choosing now' : '. Go to this position'}">`
      + `<span class="sj-token-picker__progress-number" aria-hidden="true">${index + 1}</span>${face}`
      + `${filled ? `<span class="sj-token-picker__progress-name" aria-hidden="true">${escapeMarkup(name)}</span>` : ''}</button>`
  }).join('')
  return `<div class="sj-token-picker__progress" aria-label="Your sequence so far">${chips}</div>`
}

const renderPicker = () => {
  const position = state.positions[state.activeIndex]
  if (!position) return
  const types = availableTypes()
  if (!types.includes(state.pickerType)) state.pickerType = types[0]
  const choices = vocabularyFor(state.pickerType)
  const filterable = state.pickerType === 'charm'
  /*
    A chart can belong to the WHOLE picker (the flower products, whose only token type is the
    flower) or to a SINGLE TAB of a multi-type picker — the charm bar offers zodiac signs beside
    charms and letters, and only the zodiac tab is a chart. `image_maps` keys a chart by token
    type; `picker.kind === 'image_map'` stays the whole-picker form it already was.
  */
  const typeMap = contract.picker?.image_maps?.[state.pickerType] || null
  const wholePickerMap = state.pickerType === 'birthflower'
    && contract.picker?.kind === 'image_map'
    && Boolean(contract.picker?.guide_image_url)
    ? {
        guide_image_url: contract.picker.guide_image_url,
        guide_image_width: contract.picker.guide_image_width,
        guide_image_height: contract.picker.guide_image_height,
        target_inset: contract.picker.target_inset,
        hint: 'Choose a month or flower directly from the chart.',
        alt: sjUi.birthflower_alt,
        note: 'The highlighted cell is the flower that will be saved for this position.'
      }
    : null
  const map = typeMap || wholePickerMap
  const imageMap = Boolean(map?.guide_image_url)
  const categories = [...new Set(choices.map((choice) => choice.category).filter(Boolean))]
  const filtered = choices.filter((choice) => (
    !state.pickerCategory || choice.category === state.pickerCategory
  ))
  const typeControls = types.length > 1
    ? `<div class="sj-token-picker__types" role="radiogroup" aria-label="Choice type for position ${state.activeIndex + 1}">${types.map((type) => `<button type="button" role="radio" data-token-picker-type="${type}" aria-checked="${state.pickerType === type}" tabindex="${state.pickerType === type ? '0' : '-1'}">${typeLabels[type]}s</button>`).join('')}</div>`
    : ''
  const categoryFilters = categories.length > 1
    ? `<div class="sj-token-picker__filters" aria-label="Choice categories">${categories.map((category) => `<button type="button" data-token-picker-category="${escapeMarkup(category)}" aria-pressed="${state.pickerCategory === category}">${escapeMarkup(category)}</button>`).join('')}</div>`
    : ''
  const tools = imageMap
    ? `<div class="sj-token-picker__tools"><p class="sj-token-picker__hint">${escapeMarkup(map.hint || 'Choose directly from the chart.')}</p></div>`
    : filterable && categoryFilters
      ? `<div class="sj-token-picker__tools sj-token-picker__tools--filters">${categoryFilters}</div>`
      : ''
  /*
    Two tiers, most specific first.

    The glyph tier is not a fallback for a failed lookup, it is the correct rendering for a
    choice this store has no photograph of. Substituting a different charm's picture would
    misrepresent the product.
  */
  /*
    Which OTHER slots already carry this choice. Shown as a quiet badge rather than a disabled tile:
    the same stone twice is a real order — two children born in the same month — so the tile stays
    fully selectable and the badge only says where it has been used already.
  */
  const usedAt = (value) => state.positions
    .map((entry, index) => (entry.type === state.pickerType && entry.value === value ? index + 1 : null))
    .filter((entry) => entry !== null)
  const choiceMarkup = (choice) => {
    const pressed = position.type === state.pickerType && position.value === choice.value
    const used = usedAt(choice.value)
    const usedBadge = used.length
      ? `<span class="sj-token-picker__used" aria-hidden="true">${used.join(' · ')}</span>`
      : ''
    /* Leads with its own full stop so an UNUSED choice keeps the exact accessible name it had —
       appending a bare "." turned "Choose A" into "Choose A." and broke the name every screen
       reader and qa/test-sideway-option-hierarchy already knew. */
    const usedNote = used.length
      ? `. Already at position ${used.join(' and ')}. Choosing it again is allowed.`
      : ''
    const base = `type="button" data-token-picker-choice data-picker-value="${escapeMarkup(choice.value)}" aria-pressed="${pressed}"${used.length ? ` data-used="true"` : ''}`
    /*
      A contract can ask for the plain list. The hexagon pendant engraves four small initials around
      a centre stone, and the photographed alphabet — each letter shot as a pendant of its own —
      shows the shopper a different piece four times over. `plain_tokens` keeps the letterforms and
      drops the photographs; every other product is untouched.
    */
    const photograph = contract.plain_tokens ? null : tokenPhotograph(state.pickerType, choice.value)
    if (photograph) {
      /* The accessible name is the button's own aria-label; the picture is decorative, so
         the visible label and detail stay exactly where a screen reader already found them. */
      const described = [choice.label, choice.detail].filter(Boolean).join(', ')
      return `<button class="sj-token-picker__choice sj-token-picker__choice--photo" ${base} aria-label="Choose ${escapeMarkup(described)}${escapeMarkup(usedNote)}"><span class="sj-token-picker__photo" style="--sj-token-photo:url('${escapeMarkup(photograph)}')" aria-hidden="true"></span><span>${escapeMarkup(choice.label)}</span>${choice.detail ? `<small>${escapeMarkup(choice.detail)}</small>` : ''}${usedBadge}</button>`
    }
    return `<button class="sj-token-picker__choice" ${base}${usedNote ? ` aria-label="Choose ${escapeMarkup([choice.label, choice.detail].filter(Boolean).join(', '))}${escapeMarkup(usedNote)}"` : ''}><i${choice.color ? ` style="background:${escapeMarkup(choice.color)};color:${escapeMarkup(choice.color)}"` : ''} aria-hidden="true">${escapeMarkup(choice.glyph || '●')}</i><span>${escapeMarkup(choice.label)}</span>${choice.detail ? `<small>${escapeMarkup(choice.detail)}</small>` : ''}${usedBadge}</button>`
  }
  const pickerContent = imageMap
    ? `<div class="sj-token-picker__image-map-scroll"><div class="sj-token-picker__image-map"><img src="${escapeMarkup(map.guide_image_url)}" width="${Number(map.guide_image_width) || 1792}" height="${Number(map.guide_image_height) || 1790}" alt="${escapeMarkup(map.alt || 'Reference chart')}" loading="eager" decoding="async"><div class="sj-token-picker__image-targets"${map.target_inset ? ` style="--sj-image-map-inset:${escapeMarkup(map.target_inset)}"` : ''} aria-label="${escapeMarkup(map.targets_label || 'Chart choices')}">${filtered.map((choice) => `<button type="button" data-token-picker-choice data-picker-value="${escapeMarkup(choice.value)}" aria-label="Choose ${escapeMarkup(choice.label)}${choice.detail ? `, ${escapeMarkup(choice.detail)}` : ''}" aria-pressed="${position.type === state.pickerType && position.value === choice.value}"><span class="sj-visually-hidden">${escapeMarkup(choice.label)}${choice.detail ? ` — ${escapeMarkup(choice.detail)}` : ''}</span></button>`).join('')}</div></div><p class="sj-token-picker__image-note">${escapeMarkup(map.note || 'The highlighted cell is what will be saved for this position.')}</p></div>`
    : `<div class="sj-token-picker__grid">${filtered.length ? filtered.map(choiceMarkup).join('') : `<p class="sj-token-picker__empty">${escapeMarkup(sjUi.no_matching_choices)}</p>`}</div>`
  picker.dataset.activePickerType = state.pickerType
  picker.innerHTML = `<div class="sj-token-picker__inner"><div class="sj-token-picker__head"><div class="sj-token-picker__head-main"><h2 id="SilveristicTokenPickerTitle">Choose for position ${state.activeIndex + 1}</h2>${typeControls}<p>${types.length > 1 ? 'Select a type, then choose one option.' : 'Select one option.'}</p></div>${pickerProgressMarkup()}<button class="sj-token-picker__close" type="button" data-dialog-close aria-label="Close picker">×</button></div>${tools}${pickerContent}</div>`
}

const openPicker = (index, type, trigger) => {
  state.activeIndex = index
  state.pickerType = type
  state.pickerCategory = ''
  renderPicker()
  openDialog(picker, trigger)
  requestAnimationFrame(() => {
    const typeControl = picker.querySelector(`[data-token-picker-type="${CSS.escape(state.pickerType)}"]`)
    const selected = picker.querySelector('[data-token-picker-choice][aria-pressed="true"]')
    ;(typeControl || selected || picker.querySelector('[data-token-picker-choice]'))?.focus()
  })
}

const validationErrors = () => {
  const rowSpec = rowTextSpec()
  /*
    Both halves of a row are required, and they are reported in the order a customer would fill
    them: choose the stone, then name it. Before this, only the token was inspected, so a blank name
    reached Add to cart and the property serialized a placeholder where the name should have been.

    `key` lets the input handler clear just this error as the customer types, and `focusRow` tells
    goNext to send them to the text input rather than to the picker they already answered.
  */
  /*
    Some pieces offer a second slot the customer may leave empty — "1 or 2 birthstones", a second
    initial on the other side. Everything from this index on is optional: it still renders, it is
    still serialized when filled, and it can no longer block Add to cart when it is not.
  */
  const optionalFrom = Number.isInteger(contract.optional_from_index) ? contract.optional_from_index : null
  const missing = state.positions.flatMap((position, index) => {
    if (optionalFrom !== null && index >= optionalFrom && !position.value
      && !String(position.rowText || '').trim()) return []
    /* Slots the piece offers but does not require — the birth flower beside each stone, which the
       customer may fill for one stone, all of them, or none. Declared by TYPE because which index
       they land on moves with the count. */
    const optionalTypes = Array.isArray(contract.optional_position_types) ? contract.optional_position_types : []
    if (optionalTypes.includes(position.type || typeForIndex(index)) && !position.value) return []
    if (!positionIsText(index) && !position.value) return [{ index, message: `${choicePrompt(index)} for this position.` }]
    if (!rowSpec || !rowTextAppliesTo(index)) return []
    if (String(position.rowText || '').trim()) return []
    return [{
      index,
      key: `row-${index}`,
      focusRow: true,
      message: `Enter ${String(rowSpec.title || 'name').toLocaleLowerCase()} ${index + 1}.`
    }]
  })
  if (missing.length || serializationReady()) return missing
  return [{ index: 0, message: 'This product\'s production-property mapping is incomplete.' }]
}

const goNext = () => {
  if (!state.positions.length) {
    /* Unreachable with a fixed count — the positions exist from the first render — but guarded
       anyway so a future contract with fixed_position_count can never throw here. */
    if (!countGroup) return
    countGroup.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
    countGroup.focus({ preventScroll: true })
    announce(`Choose ${contract.count_option_name} first.`)
    return
  }
  state.errors = validationErrors()
  render()
  if (state.errors.length) {
    /* A blank name is addressable: send the customer to the input itself rather than to the error
       list, which would tell them what is wrong and leave them to find it. */
    const rowError = state.errors.find((error) => error.focusRow)
    if (rowError) {
      requestAnimationFrame(() => {
        const input = root.querySelector(`[data-token-row-text="${rowError.index}"]`)
        input?.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
        input?.focus({ preventScroll: true })
      })
      announce(rowError.message)
      return
    }
    requestAnimationFrame(() => root.querySelector('[data-token-errors]')?.focus())
    announce(`${state.errors.length} ${state.errors.length === 1 ? 'position needs' : 'positions need'} attention.`)
  }
}

const start = () => {
  form.dataset.personalizationStarted = 'true'
  form.dataset.inlinePersonalization = 'true'
  details.removeAttribute('hidden')
  details.open = true
  form.querySelector('[data-personalize-start]')?.setAttribute('hidden', '')
  submit.removeAttribute('hidden')
  resizePositions(selectedCount())
  render()
}

const moveTokenPosition = (from, to) => {
  if (from === to || from < 0 || to < 0 || from >= state.positions.length || to >= state.positions.length) return false
  /* Whatever is in the inputs right now belongs to the positions as they stand, before the splice. */
  captureRowAnswers()
  const [position] = state.positions.splice(from, 1)
  state.positions.splice(to, 0, position)
  /* Any reorder means the customer has arranged the layout themselves — dragging a letter past
     the paw places the paw just as deliberately as dragging the paw does. From here on, changing
     the count must not shove the fixed token back to its default spot; before it, the default
     should keep following the count. */
  state.fixedPlacedByCustomer = true
  state.errors = []
  render({ focusIndex: to })
  announce(`Position ${from + 1} moved to position ${to + 1}.`)
  return true
}

const clearDragState = () => {
  root.querySelectorAll('[data-dragging], [data-drop-target]').forEach((position) => {
    position.removeAttribute('data-dragging')
    position.removeAttribute('data-drop-target')
  })
}

let pointerReorder = null
root.addEventListener('pointerdown', (event) => {
  if (!state.reorderMode || !event.isPrimary || !['touch', 'pen'].includes(event.pointerType)) return
  const position = event.target.closest('[data-token-position]')
  if (!position) return
  pointerReorder = {
    pointerId: event.pointerId,
    from: Number(position.dataset.tokenPosition),
    to: Number(position.dataset.tokenPosition),
    startX: event.clientX,
    startY: event.clientY,
    moved: false
  }
  position.setPointerCapture?.(event.pointerId)
})
root.addEventListener('pointermove', (event) => {
  if (!pointerReorder || event.pointerId !== pointerReorder.pointerId) return
  if (!pointerReorder.moved && Math.hypot(event.clientX - pointerReorder.startX, event.clientY - pointerReorder.startY) < 8) return
  pointerReorder.moved = true
  event.preventDefault()
  clearDragState()
  root.querySelector(`[data-token-position="${pointerReorder.from}"]`)?.setAttribute('data-dragging', 'true')
  const target = document.elementFromPoint(event.clientX, event.clientY)?.closest('[data-token-position]')
  if (!target || !root.contains(target)) return
  pointerReorder.to = Number(target.dataset.tokenPosition)
  target.setAttribute('data-drop-target', 'true')
})
const finishPointerReorder = (event, cancelled = false) => {
  if (!pointerReorder || event.pointerId !== pointerReorder.pointerId) return
  const drag = pointerReorder
  pointerReorder = null
  clearDragState()
  if (!cancelled && drag.moved) moveTokenPosition(drag.from, drag.to)
}
root.addEventListener('pointerup', (event) => finishPointerReorder(event))
root.addEventListener('pointercancel', (event) => finishPointerReorder(event, true))

let nativeDragIndex = null
root.addEventListener('dragstart', (event) => {
  const position = event.target.closest('[data-token-draggable]')
  if (!state.reorderMode || !position) return
  nativeDragIndex = Number(position.dataset.tokenPosition)
  position.setAttribute('data-dragging', 'true')
  event.dataTransfer.effectAllowed = 'move'
  event.dataTransfer.setData('text/plain', String(nativeDragIndex))
  announce(`Position ${nativeDragIndex + 1} picked up.`)
})
root.addEventListener('dragover', (event) => {
  const position = event.target.closest('[data-token-position]')
  if (nativeDragIndex === null || !position) return
  event.preventDefault()
  event.dataTransfer.dropEffect = 'move'
  root.querySelectorAll('[data-drop-target]').forEach((item) => item.removeAttribute('data-drop-target'))
  position.setAttribute('data-drop-target', 'true')
})
root.addEventListener('drop', (event) => {
  const position = event.target.closest('[data-token-position]')
  if (nativeDragIndex === null || !position) return
  event.preventDefault()
  const from = nativeDragIndex
  nativeDragIndex = null
  clearDragState()
  moveTokenPosition(from, Number(position.dataset.tokenPosition))
})
/*
  Row answers. Recorded on input WITHOUT re-rendering — redrawing the sequence on every keystroke
  would blur the field the customer is typing in — and pushed straight into the composed property.
*/
root.addEventListener('input', (event) => {
  const field = event.target.closest('[data-token-row-text]')
  if (!field) return
  const index = Number(field.dataset.tokenRowText)
  const position = state.positions[index]
  if (!position) return
  /*
    Stored ON the position, not in a map keyed by index. An index map looks equivalent and quietly
    detaches every name from its stone the moment the customer reorders or changes the count: the
    positions move and the names do not. Keeping the pair in one object makes both operations
    atomic for free — a splice carries the name with the stone.
  */
  position.rowText = field.value
  /* Clearing the error as the customer types is what makes "Enter name 2" stop shouting the moment
     they answer it, without re-rendering the field they are typing in. */
  if (field.value.trim()) state.errors = state.errors.filter((error) => error.key !== `row-${index}`)
  syncProperties()
  /* The CTA reads its next action from validationErrors, so it has to be recomputed as the customer
     types — otherwise "Enter name 2" stays on screen after they have entered it. */
  syncSubmitLabel()
})

root.addEventListener('dragend', () => {
  nativeDragIndex = null
  clearDragState()
})

root.addEventListener('keydown', (event) => {
  if (!state.reorderMode) return
  const item = event.target.closest('[data-token-picker-open]')
  if (!item || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return
  const index = Number(item.dataset.tokenPickerOpen)
  event.preventDefault()
  const target = index + (event.key === 'ArrowRight' ? 1 : -1)
  if (target >= 0 && target < state.positions.length) moveTokenPosition(index, target)
})

root.addEventListener('click', (event) => {
  const reorder = event.target.closest('[data-token-reorder]')
  if (reorder) {
    state.reorderMode = !state.reorderMode
    render()
    requestAnimationFrame(() => root.querySelector('[data-token-reorder]')?.focus())
    announce(state.reorderMode ? 'Drag reorder enabled.' : 'Drag reorder finished.')
    return
  }
  /* Undo a sole choice without opening the picker to do it. */
  const clear = event.target.closest('[data-token-clear]')
  if (clear) {
    const index = Number(clear.dataset.tokenClear)
    const position = state.positions[index]
    if (position && !position.fixed) {
      position.value = ''
      position.rowText = ''
      /*
        An open-ended sequence closes the gap. Clearing the second letter of a five-letter name
        should leave four letters and one waiting plus, not a hole in the middle followed by an
        eleventh slot; the letters are a word, and a word has no empty space in it.
      */
      if (contract.open_ended) {
        state.positions = state.positions.filter((slot) => slot.value)
        resizePositions(selectedCount())
      }
      state.errors = []
      render()
      announce('Choice cleared.')
      requestAnimationFrame(() => root.querySelector(`[data-token-position="${index}"] button`)?.focus())
    }
    return
  }
  const opener = event.target.closest('[data-token-picker-open]')
  if (opener) {
    if (state.reorderMode) return
    const index = Number(opener.dataset.tokenPickerOpen)
    /* The fixed token has nothing to choose. Opening an empty picker on it would be a dead end. */
    if (state.positions[index]?.fixed) {
      announce(`${tokenLabel(state.positions[index]) || 'This piece'} is always included. Use Reorder to move it.`)
      return
    }
    openPicker(index, opener.dataset.pickerType, opener)
    return
  }
  const error = event.target.closest('[data-token-error]')
  if (error) root.querySelector(`[data-token-position="${error.dataset.tokenError}"] [data-token-picker-open]`)?.focus()
})

picker.addEventListener('keydown', (event) => {
  const type = event.target.closest('[data-token-picker-type]')
  if (!type || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return
  const types = [...picker.querySelectorAll('[data-token-picker-type]')]
  const current = types.indexOf(type)
  const next = event.key === 'Home'
    ? 0
    : event.key === 'End'
      ? types.length - 1
      : (current + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + types.length) % types.length
  event.preventDefault()
  types[next]?.click()
})

picker.addEventListener('click', (event) => {
  const type = event.target.closest('[data-token-picker-type]')
  if (type) {
    state.pickerType = type.dataset.tokenPickerType
    state.pickerCategory = ''
    renderPicker()
    requestAnimationFrame(() => picker.querySelector(`[data-token-picker-type="${CSS.escape(state.pickerType)}"]`)?.focus())
    return
  }
  /*
    A chip in the progress strip is a way back to that slot. It re-points the picker rather than
    closing it, so correcting position 1 from position 4 costs one click instead of a close, a
    scroll and a re-open — and the type follows the slot, because a mixed sequence can hold a letter
    at one position and a stone at the next.
  */
  const goto = event.target.closest('[data-token-picker-goto]')
  if (goto) {
    const target = Number(goto.dataset.tokenPickerGoto)
    if (Number.isInteger(target) && state.positions[target]) {
      state.activeIndex = target
      const types = availableTypes()
      const wanted = state.positions[target].value ? state.positions[target].type : typeForIndex(target)
      if (types.includes(wanted)) state.pickerType = wanted
      state.pickerCategory = ''
      renderPicker()
      picker.querySelector('[data-token-picker-choice]')?.focus()
    }
    return
  }
  const category = event.target.closest('[data-token-picker-category]')
  if (category) {
    const clicked = category.dataset.tokenPickerCategory
    /* No "All" chip: the currently-pressed category is the only way back to the full list,
       so clicking it again clears the filter instead of doing nothing. */
    state.pickerCategory = state.pickerCategory === clicked ? '' : clicked
    renderPicker()
    picker.querySelector(`[data-token-picker-category="${CSS.escape(clicked)}"]`)?.focus()
    return
  }
  const choice = event.target.closest('[data-token-picker-choice]')
  if (!choice) return
  const index = state.activeIndex
  /*
    Spread the position rather than rebuilding it. Rebuilding dropped `rowText`, so on the multiple
    name heart necklace a customer who typed MIA and then chose her birthstone watched the name
    disappear — silently, because the picker closes over the field and the summary redraws from
    state. The row-answer comment above says the pair lives in one object precisely so a splice
    carries the name with the stone; assigning a fresh object here was the one place that broke it.
  */
  state.positions[index] = { ...state.positions[index], type: state.pickerType, value: choice.dataset.pickerValue }
  state.errors = state.errors.filter((error) => error.index !== index)
  const label = tokenLabel(state.positions[index])
  /*
    Several slots of the same kind with no order to them — three birthstones on a disk — are one
    decision, not three. Rather than closing and making the customer reopen the same list, the
    picker moves to the next empty slot of that type and stays put. It still closes as soon as
    there is nothing of that kind left to answer.
  */
  const nextSameType = contract.chain_same_type
    ? state.positions.findIndex((position, at) => {
      if (at <= index || position.value) return false
      /* Pinned slots must still match; unpinned ones take whatever is being chosen now. */
      return typeIsPinnedForIndex(at) ? typeForIndex(at) === state.pickerType : true
    })
    : -1
  if (nextSameType !== -1) {
    state.activeIndex = nextSameType
    render()
    renderPicker()
    announce(`Position ${index + 1}: ${label}. Now position ${nextSameType + 1}.`)
    return
  }
  closeDialog(picker)
  /* Open-ended: filling the last slot opens the next one, so a plus is always waiting until the
     ceiling. Resizing here rather than on a count control is the whole difference. */
  if (contract.open_ended) resizePositions(selectedCount())
  render({ focusIndex: index })
  announce(`Position ${index + 1}: ${label}.`)
})

/* A mode change can alter the card count, the offered token types and which text fields apply,
   so everything downstream is recomputed rather than patched: positions resize, the picker
   re-renders, CTA readiness and the cart properties follow from the new state. */
modeGroup?.addEventListener('change', () => {
  applyIndependentVisibility()
  resizePositions(selectedCount())
  state.errors = []
  render()
})

/*
  A switch that decides the SHAPE resizes the sequence too. The name-disk necklace offers either a
  name or a birth flower beside each stone, so answering that question changes how many slots the
  same stone count opens — and without this the flowers were declared and never appeared.
*/
if (contract.position_field_switch?.field_title) {
  const wanted = String(contract.position_field_switch.field_title).trim().toLocaleLowerCase()
  form.addEventListener('change', (event) => {
    const wrapper = event.target.closest?.('[data-personalization-field]')
    if (!wrapper) return
    if (String(wrapper.dataset.fieldTitle || '').trim().toLocaleLowerCase() !== wanted) return
    captureRowAnswers()
    resizePositions(selectedCount())
    /* Retype in place after the resize: a slot's kind follows its index, and the index of every
       slot after the stones has just changed meaning. A value that no longer belongs to its slot
       is cleared rather than left to serialize as the wrong kind of answer. */
    state.positions.forEach((position, index) => {
      const type = typeForIndex(index)
      if (position.type === type) return
      position.type = type
      position.value = ''
    })
    state.errors = []
    render()
  })
}

/* Every counting axis resizes the sequence, not just the one the contract calls primary. */
countSegments().forEach(({ group }) => {
  if (group === countGroup) return
  group.addEventListener('change', () => {
    captureRowAnswers()
    resizePositions(selectedCount())
    state.errors = []
    render()
  })
})

countGroup?.addEventListener('change', (event) => {
  /* selectedCount() is the one place that knows about count_value_map and the active rule.
     Recomputing from the raw value here re-introduced plain digit parsing and silently ignored
     the non-linear maps — "3 Names - 2 Stone Rings" opened one card instead of two. */
  const count = selectedCount()
  if (!Number.isFinite(count)) return
  /* The count axis governs the CHOSEN positions only. A fixed token is never discarded — it is
     repositioned — so it must be excluded from both sides of this comparison. Counting it made
     every reduction look like it would throw away a filled position, which raised the discard
     dialog over work the customer had never done and then left the count unapplied. */
  const chosen = state.positions.filter((position) => !position.fixed)
  const previous = chosen.length
  const discarded = count < previous ? chosen.slice(count).filter((position) => position.value) : []
  if (discarded.length && discardDialog) {
    event.stopPropagation()
    setSelectedCount(previous)
    state.pendingCount = count
    const list = discardDialog.querySelector('[data-config-discard-list]')
    if (list) list.innerHTML = state.positions.slice(count).map((position, index) => `<p>Position ${count + index + 1}: ${escapeMarkup(tokenLabel(position) || 'Not selected')}</p>`).join('')
    openDialog(discardDialog, event.target)
    return
  }
  resizePositions(count)
  render()
  announce(`${count} ${count === 1 ? 'position' : 'positions'} ready to personalize.`)
})

discardDialog?.querySelector('[data-config-discard-keep]')?.addEventListener('click', () => {
  state.pendingCount = null
  closeDialog(discardDialog)
})
discardDialog?.querySelector('[data-config-discard-confirm]')?.addEventListener('click', () => {
  const count = state.pendingCount
  state.pendingCount = null
  if (Number.isFinite(count)) {
    setSelectedCount(count)
    resizePositions(count)
    render()
    updateProductForm(form)
    updatePersonalizationConditions(form)
  }
  closeDialog(discardDialog)
})
discardDialog?.addEventListener('close', () => { state.pendingCount = null })

const controller = {
  usesGenericFields: false,
  start,
  goNext,
  syncProperties,
  isReady: () => state.positions.length > 0 && validationErrors().length === 0,
  getNextAction: () => {
    /* A controller that is not the visible flow has no outstanding requirement.
       This product also carries the staged shell, and without this the token
       controller claimed the step and overwrote the stage's own next label. */
    if (details.hasAttribute('hidden') || details.offsetParent === null) return null
    if (state.positions.length === 0) return null
    const subject = contract.flow_type === 'charm_sequence' ? 'charm'
      : contract.flow_type === 'birthstone_sequence' ? 'birthstone'
      : contract.flow_type === 'birthflower_sequence' ? 'birth flower'
      : 'position'
    /*
      A row answer is as required as the token beside it, so the CTA has to be able to name it.
      Reported AFTER the unanswered tokens, which is the order a customer fills them: every stone
      first, then the names. Without this step the button said "Add to cart" over a blank required
      name, and pressing it submitted a row the workshop cannot make.
    */
    const rowSpec = rowTextSpec()
    if (rowSpec) {
      const blankRow = state.positions.findIndex((position, at) =>
        rowTextAppliesTo(at) && (positionIsText(at) || position.value) && !String(position.rowText || '').trim())
      const tokensAllChosen = state.positions.every((position, at) => positionIsText(at) || position.value)
      if (tokensAllChosen && blankRow !== -1) {
        const human = blankRow + 1
        const noun = String(rowSpec.title || 'name').toLocaleLowerCase()
        const label = `Enter ${noun} ${human}`
        const inputFor = () => details.querySelector(`[data-token-row-text="${blankRow}"]`)
        return {
          kind: 'row_text', label,
          accessibleLabel: `${label} of ${state.positions.length}`,
          meta: { position: human, total: state.positions.length, flow: contract.flow_type },
          target: inputFor() || details,
          activate: () => {
            if (!details.open) details.open = true
            const input = inputFor()
            ;(input || details).scrollIntoView({
              block: 'center',
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            })
            input?.focus({ preventScroll: true })
          }
        }
      }
    }

    /* A text-only sequence has no token to choose, so this step would send the customer to a picker
       that does not exist — and it ran BEFORE the row step, so the CTA stayed on "Choose position 1"
       however many names were typed. */
    const optionalFromCta = Number.isInteger(contract.optional_from_index) ? contract.optional_from_index : null
    const optionalTypesCta = Array.isArray(contract.optional_position_types) ? contract.optional_position_types : []
    const index = state.positions.findIndex((position, at) => !positionIsText(at)
      && !optionalTypesCta.includes(position.type || typeForIndex(at))
      && !position.value && (optionalFromCta === null || at < optionalFromCta))
    if (index !== -1) {
      const human = index + 1
      const label = `Choose ${subject} ${human}`
      return {
        kind: 'token_position', label,
        accessibleLabel: `${label} of ${state.positions.length}`,
        meta: { position: human, total: state.positions.length, flow: contract.flow_type },
        target: details.querySelectorAll('[data-token-picker-open]')[index] || details,
        activate: () => {
          if (!details.open) details.open = true
          const opener = details.querySelectorAll('[data-token-picker-open]')[index]
          ;(opener || details).scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
          opener ? opener.click() : details.focus?.()
        }
      }
    }
    /* Reaching here means every position has a value, and validationErrors() only
       ever reports value-less positions — so there is nothing left to report. The
       previous branch targeted a [data-token-error-key] attribute that no renderer
       emits, against error objects that carry no key. Removed rather than dressed up. */
    return null
  },
  activateNextAction: (action) => action?.activate?.(),
  /* Called after a native variant swap re-renders the option markup. Conditional state is derived
     from that markup, so it has to be recomputed here too, not only on the change event. */
  reapplyConditionalState: () => {
    applyIndependentVisibility()
    resizePositions(selectedCount())
    render()
  },
  afterProductUpdate: () => {
    details.removeAttribute('hidden')
    details.open = true
    submit.removeAttribute('hidden')
    syncSubmitLabel()
    syncProperties()
  }
}
form._sjPositionConfigurator = controller
form._sjControllers = (form._sjControllers || []).filter((entry) => entry !== controller).concat(controller)
relabelCountAxis()
applyIndependentVisibility()
/* The independent fields have just moved out of the generic personalizer. Their conditions were
   last evaluated in the old location, so the shared resolver runs once more here — otherwise a
   field whose variant does not apply stays on screen until the shopper happens to change an
   option, which is precisely when nobody is looking. */
updatePersonalizationConditions(form)
resizePositions(selectedCount())
render()
controller.afterProductUpdate()
return true
}

const compatibilityFontNames = [
'Alex Brush',
'Brush Script MT',
'Commercial Script BT',
'Elaine Hanks Bold',
'FabletScript Bold',
'Harlow Solid Italic',
'Sofia',
'Old English Text MT',
'Hermonie Script',
'Love Hewitts'
]

const fontChartChoice = (value, label, disabled = false) => {
const match = String(value || '').match(/^Font\s+(10|[1-9])$/i)
if (!match) return null
return { value: String(value), label: String(label || value), number: Number(match[1]), disabled }
}

const fontChartMapMarkup = ({ imageUrl, width, height, choices, choiceAttribute }) => {
const byNumber = new Map(choices.filter(Boolean).map((choice) => [choice.number, choice]))
const targets = Array.from({ length: 10 }, (_, index) => {
  const number = index + 1
  const choice = byNumber.get(number)
  const label = choice?.label || compatibilityFontNames[index] || `Font ${number}`
  if (!choice) {
    /*
      A row this piece does not sell used to render as an inert <span>: the shopper saw ten font
      samples, seven of them did nothing when clicked, and nothing on screen said why. Silent dead
      space reads as a broken page, which is exactly how it was reported.

      It is a disabled button now — announced, dimmed, and unmistakably not selectable — so the
      chart still shows what the fonts look like while making clear which three are on offer here.
    */
    return `<button class="sj-font-picker__guide-target sj-font-picker__guide-target--unavailable" type="button" disabled data-font-unavailable aria-label="${escapeMarkup(label)} is not available for this piece"><span class="sj-visually-hidden">${escapeMarkup(label)} is not available for this piece</span></button>`
  }
  return `<button class="sj-font-picker__guide-target" type="button" ${choiceAttribute}="${escapeMarkup(choice.value)}" aria-label="Choose ${escapeMarkup(choice.value)}, ${escapeMarkup(label)}" aria-pressed="false"${choice.disabled ? ' disabled' : ''}><span class="sj-visually-hidden">Choose ${escapeMarkup(choice.value)}, ${escapeMarkup(label)}</span></button>`
}).join('')
/*
  The chart is one image of ten samples, so on a piece that sells three the shopper has to find the
  right rows among ten. An explicit list of exactly what IS available sits under it, so choosing
  never depends on hitting the correct band of a picture.
*/
const offered = choices.filter(Boolean)
const offeredMarkup = offered.length && offered.length < 10
  ? `<div class="sj-font-picker__offered" role="group" aria-label="Fonts available for this piece"><p class="sj-font-picker__offered-label">${sjUi.available_on_piece}</p><div class="sj-font-picker__offered-choices">${offered.map((choice) => `<button class="sj-font-picker__choice" type="button" ${choiceAttribute}="${escapeMarkup(choice.value)}" aria-label="Choose ${escapeMarkup(choice.value)}, ${escapeMarkup(choice.label)}" aria-pressed="false"${choice.disabled ? ' disabled' : ''}><strong>${escapeMarkup(choice.value)}</strong><span>${escapeMarkup(choice.label)}</span></button>`).join('')}</div></div>`
  : ''
return `<div class="sj-font-picker__guide-scroll" tabindex="0" aria-label="Scrollable font sample guide"><div class="sj-font-picker__guide-map"><img class="sj-font-picker__guide" src="${escapeMarkup(imageUrl)}" alt="Comparison chart of the name necklace fonts" width="${width}" height="${height}" loading="eager" decoding="async"><div class="sj-font-picker__guide-targets" aria-label="Choose a font from the sample chart">${targets}</div></div></div>${offeredMarkup}`
}

/*
  One photographed chooser, bound to ONE field.

  This was inline in initializeMediaChoicePicker and could only ever build a single picker: it ran
  only when the WHOLE contract was flow_type choice_select, then claimed the first <select> it found
  anywhere on the form. A product that asks two visual questions — the hexagon pendant asks for
  initials and a birthstone, the necklace-and-earrings set asks for three stones — could not be
  served at all. The body is a function now and every id it derives hangs off the field's own select,
  so several pickers coexist with their own dialogs, triggers and validated values.
*/
/* The visual-chooser family moved to snippets/silveristic-global-js-2.liquid — see the note
   there. Part one is at Shopify's 256 KB per-file cap; nothing about the call order changed,
   because every one of them is called from inside a function rather than at module scope. */




const initializeFontNamePicker = (form, generic, contract) => {
const guideImage = [...productScope().querySelectorAll('[data-personalization-guide-media] img')].find((image) => (
  /AvailableFontsforPersonalizedNameNecklaces/i.test(image.src || '')
))
const profileGuideUrl = (contract?.token_types || []).includes('font')
  ? String(contract?.picker?.guide_image_url || '') : ''
const nameWrapper = [...generic.querySelectorAll('[data-personalization-field]:not(.sj-personalization-instruction)')].find((wrapper) => {
  /* sourceFieldTitle first: it is the title as the profile states it, before the fulfilment
     label shortener rewrites it for display. The other two stay in the haystack so profiles
     that never went through the shortener keep matching exactly as before. */
  const language = `${wrapper.dataset.sourceFieldTitle || ''} ${wrapper.dataset.fieldTitle || ''} ${wrapper.querySelector('.sj-label')?.textContent || ''}`
  return /preferred.*(?:name|names|initial)/i.test(language) && Boolean(wrapper.querySelector('textarea, input[type="text"]'))
})
const nameSource = nameWrapper?.querySelector('textarea, input[type="text"]')
if ((!guideImage && !profileGuideUrl) || !nameWrapper || !nameSource) return false

/*
  The product's OWN font list decides what the picker offers.

  This fell back to all ten chart fonts when the contract carried no vocabulary.fonts, then looked
  for a select matching that ten exactly. The Custom Pet Lover Necklace sells three (Font 3, 7, 9),
  so nothing matched: its select stayed on the page wired to nothing while the picker offered all
  ten, and choosing one of the seven it does not sell left the button reading "Choose font" forever
  with no explanation. Reading the values off the field the product actually renders fixes both:
  the picker can only offer what can be bought, and the matched wrapper is the one that gets hidden.
*/
const looksLikeFontValue = (value) => /^Font\s+(?:10|[1-9])$/i.test(value) || /handwriting/i.test(value)
const fontFieldWrapper = [...generic.querySelectorAll('[data-personalization-field]:not(.sj-personalization-instruction)')].find((wrapper) => {
  const select = wrapper.querySelector('select')
  if (!select) return false
  const values = [...select.options].map((option) => option.value).filter(Boolean)
  return values.length > 0 && values.every(looksLikeFontValue)
})
const productFontValues = fontFieldWrapper
  ? [...fontFieldWrapper.querySelector('select').options].map((option) => option.value).filter(Boolean)
  : []
const chartNameFor = (value) => {
  const number = Number(String(value).match(/^Font\s+(10|[1-9])$/i)?.[1])
  return Number.isFinite(number) ? compatibilityFontNames[number - 1] : String(value)
}
const profileFonts = Array.isArray(contract?.vocabulary?.fonts) ? contract.vocabulary.fonts : []
const fontValues = productFontValues.length
  ? productFontValues
  : profileFonts.length
    ? profileFonts.map((choice) => String(typeof choice === 'object' ? choice.value : choice))
    : compatibilityFontNames.map((_, index) => `Font ${index + 1}`)
const fontNames = productFontValues.length
  ? productFontValues.map(chartNameFor)
  : profileFonts.length
    ? profileFonts.map((choice, index) => String(typeof choice === 'object' ? (choice.label || choice.value) : choice || fontValues[index]))
    : compatibilityFontNames
let fontWrapper = fontFieldWrapper || [...generic.querySelectorAll('[data-personalization-field]:not(.sj-personalization-instruction)')].find((wrapper) => {
  const select = wrapper.querySelector('select')
  const values = select ? [...select.options].map((option) => option.value).filter(Boolean) : []
  return values.length === fontValues.length && values.every((value, index) => value === fontValues[index])
})
const sourceRequired = nameSource.required
const sourceLabel = nameWrapper.querySelector('.sj-label')
let fontSource = fontWrapper?.querySelector('select') || null

/* Same reason as the match above: on "Preferred Font and Name - ..." the shortener drops the
   word "font", so reading only the display title concludes the source property does NOT cover
   the font and adds a second, redundant Font field to a profile that already collects it. */
const productionPropertyIncludesFont = /\bfont\b/i.test(
  `${nameWrapper.dataset.sourceFieldTitle || ''} ${nameWrapper.dataset.fieldTitle || ''} ${sourceLabel?.textContent || ''}`
)
if (!fontSource && !productionPropertyIncludesFont) {
  fontWrapper = createElement('div', 'sj-personalization-field sj-font-property-field')
  fontWrapper.dataset.personalizationField = ''
  fontWrapper.dataset.fieldTitle = 'Font'
  fontWrapper.dataset.required = 'true'

  const implicitFontLabel = createElement('label', 'sj-label sj-visually-hidden', 'Font')
  const implicitFontId = `${nameSource.id}-FontSource`
  implicitFontLabel.htmlFor = implicitFontId
  fontSource = document.createElement('input')
  fontSource.type = 'text'
  fontSource.id = implicitFontId
  fontSource.name = 'properties[Font]'
  fontSource.required = true
  fontSource.dataset.originalRequired = 'true'
  fontSource.className = 'sj-visually-hidden'
  fontWrapper.append(implicitFontLabel, fontSource)
  nameWrapper.before(fontWrapper)
}

/* The plural belongs to the profile's own wording ("Preferred NAMES or Initials"), which the
   shortener flattens to "Preferred name" — reading the display title alone would relabel a
   two-name product as singular. */
const nameLabel = /names|initials/i.test(
  `${nameWrapper.dataset.sourceFieldTitle || ''} ${nameWrapper.dataset.fieldTitle || ''}`
) ? 'Names or initials' : 'Name'
let selectedFont = fontSource?.value || ''

if (!fontSource) {
  const saved = String(nameSource.value || '').match(/^(Font (?:10|[1-9]))\s+[—-]\s+(.+)$/)
  if (saved) {
    selectedFont = saved[1]
    nameSource.value = saved[2]
  }
}

const localFontChart = tokenPhotograph('font', 'Font 1')
const highResolutionGuide = localFontChart
  || (profileGuideUrl || guideImage.src).replace(/_\d+x(?=\.[a-z0-9]+(?:\?|$))/i, '')

nameSource.classList.remove('sj-textarea', 'sj-input')
nameSource.classList.add('sj-visually-hidden')
nameSource.dataset.fontNameSource = ''
nameSource.tabIndex = -1
nameSource.setAttribute('aria-hidden', 'true')
if (sourceLabel) {
  sourceLabel.classList.add('sj-visually-hidden')
  sourceLabel.textContent = fontSource ? nameLabel : 'Font and name'
}
nameWrapper.dataset.fieldTitle = fontSource ? nameLabel : 'Font and name'

if (fontSource) {
  const fontLabel = fontWrapper.querySelector('.sj-label')
  fontSource.classList.remove('sj-select')
  fontSource.classList.add('sj-visually-hidden')
  fontSource.dataset.fontChoiceSource = ''
  fontSource.tabIndex = -1
  fontSource.setAttribute('aria-hidden', 'true')
  if (fontLabel) {
    fontLabel.classList.add('sj-visually-hidden')
    fontLabel.textContent = 'Font'
  }
  fontWrapper.dataset.fieldTitle = 'Font'
}

const ownerWrapper = fontWrapper || nameWrapper
const ownerSource = fontSource || nameSource
const triggerId = `${ownerSource.id}-FontTrigger`
const dialogId = `${ownerSource.id}-FontPicker`
const titleId = `${dialogId}-Title`
const helpId = `${ownerSource.id}-FontHelp`
const control = createElement('div', 'sj-font-picker-control')
control.dataset.fontPickerControl = ''
control.append(createElement('p', 'sj-label', 'Font'))
const trigger = createElement('button', 'sj-font-picker__trigger')
trigger.type = 'button'
trigger.id = triggerId
trigger.dataset.fontPickerOpen = ''
trigger.setAttribute('aria-haspopup', 'dialog')
trigger.setAttribute('aria-controls', dialogId)
trigger.setAttribute('aria-expanded', 'false')
trigger.setAttribute('aria-describedby', helpId)
const triggerCopy = createElement('span', 'sj-font-picker__trigger-copy')
const triggerValue = createElement('span', 'sj-font-picker__trigger-value', sjUi.choose_font)
/* The product's own count, not the chart's. */
const triggerHint = createElement('span', 'sj-font-picker__trigger-hint',
  `Compare ${fontValues.length} style${fontValues.length === 1 ? '' : 's'}`)
triggerCopy.append(triggerValue, triggerHint)
const triggerIcon = createElement('span', 'sj-font-picker__trigger-icon', '⌄')
triggerIcon.setAttribute('aria-hidden', 'true')
trigger.append(triggerCopy, triggerIcon)
const fontHelp = createElement('p', 'sj-personalization-field__help', sjUi.font_price)
fontHelp.id = helpId
control.append(trigger, fontHelp)
ownerSource.insertAdjacentElement('afterend', control)

const dialog = createElement('dialog', 'sj-font-picker')
dialog.id = dialogId
dialog.dataset.fontPicker = ''
dialog.setAttribute('aria-labelledby', titleId)
const guideWidth = localFontChart ? 1200 : Number(contract?.picker?.guide_image_width) || 1920
const guideHeight = localFontChart ? 900 : Number(contract?.picker?.guide_image_height) || 1080
const chartChoices = fontValues.map((value, index) => fontChartChoice(value, fontNames[index]))
const extraChoices = fontValues.map((value, index) => ({ value, name: fontNames[index] })).filter(({ value }) => !fontChartChoice(value, value))
const chartMarkup = fontChartMapMarkup({ imageUrl: highResolutionGuide, width: guideWidth, height: guideHeight, choices: chartChoices, choiceAttribute: 'data-font-choice' })
const extrasMarkup = extraChoices.length ? `<div class="sj-font-picker__choices" aria-label="Additional font choices">${extraChoices.map(({ value, name }) => `<button class="sj-font-picker__choice" type="button" data-font-choice="${escapeMarkup(value)}" aria-label="Choose ${escapeMarkup(value)}, ${escapeMarkup(name)}" aria-pressed="false"><strong>${escapeMarkup(value)}</strong><span>${escapeMarkup(name)}</span></button>`).join('')}</div>` : ''
dialog.innerHTML = `<div class="sj-font-picker__inner"><div class="sj-font-picker__head"><div><h2 id="${titleId}">${sjUi.choose_font}</h2><p>${sjUi.font_tap}</p></div><button class="sj-font-picker__close" type="button" data-dialog-close aria-label="Close font picker">×</button></div>${chartMarkup}<p class="sj-font-picker__mobile-hint">${sjUi.font_swipe}</p>${extrasMarkup}<p class="sj-font-picker__note">${sjUi.font_included}</p></div>`
control.append(dialog)

const nameStep = createElement('div', 'sj-font-name-step')
nameStep.dataset.fontNameStep = ''
nameStep.hidden = !selectedFont
/* Fields that declared they belong to this step, hidden and revealed with it. */
const followers = [...form.querySelectorAll('[data-personalization-field][data-reveal-with-font]')]
/* A dedicated state rather than `hidden`: the independent-visibility pass owns `hidden` and was
   re-showing this field immediately after the gate closed it. Two owners of one flag is how the
   second name came back on its own; CSS hides it from this attribute instead. */
const revealFollowers = (visible) => followers.forEach((field) => {
  field.dataset.awaitingFont = visible ? 'false' : 'true'
})
revealFollowers(Boolean(selectedFont))
const visibleId = `${nameSource.id}-Visible`
const visibleLabel = createElement('label', 'sj-label', nameLabel)
visibleLabel.htmlFor = visibleId
const visibleInput = createElement('input', 'sj-input')
visibleInput.type = 'text'
visibleInput.id = visibleId
visibleInput.dataset.fontNameInput = ''
visibleInput.dataset.originalRequired = 'false'
visibleInput.disabled = !selectedFont
visibleInput.autocomplete = 'off'
visibleInput.setAttribute('aria-required', String(sourceRequired))
if (nameSource.maxLength > 0) visibleInput.maxLength = nameSource.maxLength
visibleInput.value = fontSource ? nameSource.value : String(nameSource.value || '').replace(/^(Font (?:10|[1-9]))\s+[—-]\s+/, '')
visibleInput.placeholder = nameLabel === 'Name' ? 'Enter the name exactly as it should be made' : 'Enter names or initials in production order'
const nameHelp = createElement('p', 'sj-personalization-field__help', sjUi.case_help)
nameHelp.id = `${visibleId}-Help`
visibleInput.setAttribute('aria-describedby', nameHelp.id)
nameStep.append(visibleLabel, visibleInput, nameHelp)
nameWrapper.append(nameStep)

const syncSourceValue = () => {
  const name = visibleInput.value
  nameWrapper.dataset.fontSelected = selectedFont ? 'true' : 'false'
  nameSource.required = sourceRequired || Boolean(selectedFont)
  nameSource.value = fontSource
    ? name
    : selectedFont && name
      ? `${selectedFont} — ${name}`
      : ''
}

const syncPicker = () => {
  const fontIndex = Number.parseInt(selectedFont.replace(/\D/g, ''), 10)
  const fontName = Number.isFinite(fontIndex) ? fontNames[fontIndex - 1] : ''
  triggerValue.textContent = selectedFont || sjUi.choose_font
  triggerHint.textContent = selectedFont ? `${fontName} · Change font` : 'Compare 10 styles'
  trigger.setAttribute('aria-label', selectedFont ? `${selectedFont}, ${fontName}. Change font` : sjUi.choose_font)
  trigger.removeAttribute('aria-invalid')
  fontHelp.dataset.state = ''
  fontHelp.textContent = sjUi.font_price
  nameStep.hidden = !selectedFont
  revealFollowers(Boolean(selectedFont))
  visibleInput.disabled = !selectedFont
  dialog.querySelectorAll('[data-font-choice]').forEach((choice) => {
    choice.setAttribute('aria-pressed', String(choice.dataset.fontChoice === selectedFont))
  })
  syncSourceValue()
}

const showFontError = () => {
  trigger.setAttribute('aria-invalid', 'true')
  fontHelp.dataset.state = 'error'
  fontHelp.textContent = sjUi.font_required
  requestAnimationFrame(() => trigger.focus())
}

const showNameError = () => {
  nameStep.hidden = false
  revealFollowers(true)
  visibleInput.disabled = false
  nameHelp.dataset.state = 'error'
  nameHelp.textContent = `Enter the ${nameLabel.toLocaleLowerCase()} to continue.`
  requestAnimationFrame(() => visibleInput.focus())
}

const chooseFont = (font) => {
  selectedFont = font
  if (fontSource) {
    fontSource.value = font
    fontSource.dispatchEvent(new Event('input', { bubbles: true }))
    fontSource.dispatchEvent(new Event('change', { bubbles: true }))
  }
  syncPicker()
  nameSource.dispatchEvent(new Event('input', { bubbles: true }))
  closeDialog(dialog)
  requestAnimationFrame(() => visibleInput.focus())
}

trigger.addEventListener('click', () => {
  trigger.setAttribute('aria-expanded', 'true')
  openDialog(dialog, trigger)
  requestAnimationFrame(() => {
    const selected = dialog.querySelector('[data-font-choice][aria-pressed="true"]')
    ;(selected || dialog.querySelector('[data-font-choice]'))?.focus()
  })
})

dialog.addEventListener('click', (event) => {
  const choice = event.target.closest('[data-font-choice]')
  if (choice) chooseFont(choice.dataset.fontChoice)
})

dialog.addEventListener('keydown', (event) => {
  if (event.metaKey || event.ctrlKey || event.altKey || !/^[0-9]$/.test(event.key)) return
  const index = event.key === '0' ? 10 : Number(event.key)
  event.preventDefault()
  chooseFont(`Font ${index}`)
})

dialog.addEventListener('close', () => {
  trigger.setAttribute('aria-expanded', 'false')
})

fontSource?.addEventListener('invalid', (event) => {
  event.preventDefault()
  showFontError()
})

nameSource.addEventListener('invalid', (event) => {
  event.preventDefault()
  if (!selectedFont) showFontError()
  else showNameError()
})

visibleInput.addEventListener('input', () => {
  nameHelp.dataset.state = ''
  nameHelp.textContent = sjUi.case_help
  syncSourceValue()
})

syncPicker()
return true
}

/*
  One visual A-Z picker, bound to one hidden field.

  This was inline in initializeInlinePersonalizer and could only ever build ONE picker: it took the
  first personalization field on the form, hardcoded its label to "Initial", and ran only when the
  whole contract's flow_type was single_initial. The Interlocking Letters Necklace needs two
  independent letters inside a composite free-text profile, and the owner's rule is that neither may
  be typed, so the body is a function now and every id it derives — dialog, trigger, help text —
  hangs off the field's own input id. Two pickers on one form therefore get two dialogs, two labelled
  triggers and two separately validated hidden values, with no shared state between them.
*/
const enhanceSingleInitialField = (form, wrapper, current, options = {}) => {
  if (!wrapper || !current) return null
  const fieldLabel = String(options.label || 'Initial')
  const dialogTitle = String(options.dialogTitle || `Choose a letter for ${fieldLabel.toLowerCase()}`)
  const chooseCopy = String(options.chooseCopy || 'Choose a letter')
  /*
    `plain_tokens` reaches this picker too, passed in rather than read from the contract: this
    function is module level and `contract` only exists inside the per-form initializer, so reading
    it here threw a ReferenceError that aborted the whole enhancement and left the field with no
    trigger at all.

    The flag already existed for the token picker — the hexagon pendant sets it, because the
    photographed alphabet shoots every letter as a pendant of its own and showing four of them
    around one hexagon sells the shopper a different piece four times. Owner, 2026-08-29, on the
    interlocking letters necklace: "Bu üründe harf seçimleri görsel olarak gözükmesin. Normal Harf
    olarak yazsın sadece."
  */
  const plainTokens = Boolean(options.plainTokens)
  const letterPhotograph = (letter) => (plainTokens ? null : tokenPhotograph('letter', letter))
  const provided = options.alphabet
  const alphabet = (Array.isArray(provided) ? provided : [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'])
    /* Admin-owned choice sets carry { value, label, ... } objects. Normalizing the whole
       object turns every entry into the first letter of "OBJECT" and collapses A–Z to a
       single O button. Read the stable saved value, while retaining string compatibility. */
    .map((letter) => normalizeInitial(typeof letter === 'object' ? letter?.value : letter))
    .filter((letter, index, letters) => letter && letters.indexOf(letter) === index)
  const input = document.createElement('input')
  input.className = 'sj-visually-hidden'
  input.type = 'text'
  input.id = current.id
  input.name = current.name
  /*
    Carry the ORIGINAL requiredness across the swap, not whatever it happens to be right now.

    updatePersonalizationConditions clears `required` on any control it considers not-yet-visible and
    records the real value in dataset.originalRequired. If that pass runs before this one — it does,
    when the personalizer starts collapsed — then copying the live flag copies a `false` that the
    next pass then treats as the original, and the field is never required again. Both interlocking
    initials are mandatory and neither was enforced.
  */
  const originallyRequired = current.dataset.originalRequired
    ? current.dataset.originalRequired === 'true'
    : current.required
  input.required = originallyRequired
  input.dataset.originalRequired = originallyRequired ? 'true' : 'false'
  input.maxLength = 1
  input.pattern = '[A-Z]'
  input.autocomplete = 'off'
  input.autocapitalize = 'characters'
  input.spellcheck = false
  input.tabIndex = -1
  input.dataset.singleInitialValue = ''
  input.setAttribute('aria-hidden', 'true')
  current.replaceWith(input)

  const label = wrapper.querySelector('.sj-label')
  const triggerId = `${input.id}-Trigger`
  const dialogId = `${input.id}-Picker`
  const titleId = `${dialogId}-Title`
  const helpId = `${input.id}-Help`
  if (label) {
    label.textContent = fieldLabel
    label.htmlFor = triggerId
  }
  /* Only the visible label. dataset.sourceFieldTitle is left untouched: the composite serializer
     matches its parts on the field's ORIGINAL title, so renaming that here would silently stop the
     two letters from reaching the cart property. */
  wrapper.dataset.fieldTitle = fieldLabel

  const control = createElement('div', 'sj-initial-picker-control')
  const trigger = createElement('button', 'sj-initial-picker__trigger')
  trigger.type = 'button'
  trigger.id = triggerId
  trigger.dataset.singleInitialOpen = ''
  trigger.setAttribute('aria-haspopup', 'dialog')
  trigger.setAttribute('aria-controls', dialogId)
  trigger.setAttribute('aria-expanded', 'false')
  trigger.setAttribute('aria-describedby', helpId)
  const triggerPhoto = createElement('span', 'sj-initial-picker__trigger-photo')
  triggerPhoto.setAttribute('aria-hidden', 'true')
  triggerPhoto.hidden = true
  const triggerCopy = createElement('span', 'sj-initial-picker__trigger-copy')
  const triggerValue = createElement('span', 'sj-initial-picker__trigger-value', chooseCopy)
  const triggerHint = createElement('span', 'sj-initial-picker__trigger-hint', 'A–Z')
  triggerCopy.append(triggerValue, triggerHint)
  const triggerIcon = createElement('span', 'sj-initial-picker__trigger-icon', '⌄')
  triggerIcon.setAttribute('aria-hidden', 'true')
  trigger.append(triggerPhoto, triggerCopy, triggerIcon)

  const dialog = createElement('dialog', 'sj-initial-picker')
  dialog.id = dialogId
  dialog.dataset.singleInitialPicker = ''
  dialog.setAttribute('aria-labelledby', titleId)
  dialog.innerHTML = `<div class="sj-initial-picker__inner"><div class="sj-initial-picker__head"><div><h2 id="${titleId}">${escapeMarkup(dialogTitle)}</h2><p>${sjUi.one_letter}</p></div><button class="sj-initial-picker__close" type="button" data-dialog-close aria-label="Close ${escapeMarkup(fieldLabel.toLowerCase())} picker">×</button></div><div class="sj-initial-picker__grid" aria-label="Available letters for ${escapeMarkup(fieldLabel.toLowerCase())}">${alphabet.map((letter) => {
    const photograph = letterPhotograph(letter)
    return `<button class="sj-initial-picker__choice${photograph ? ' sj-initial-picker__choice--photo' : ''}" type="button" data-single-initial-choice="${letter}" aria-label="Choose ${letter} for ${escapeMarkup(fieldLabel.toLowerCase())}" aria-pressed="false">${photograph ? `<span class="sj-initial-picker__photo" style="--sj-token-photo:url('${escapeMarkup(photograph)}')" aria-hidden="true"></span>` : ''}<span class="sj-initial-picker__letter">${letter}</span></button>`
  }).join('')}</div></div>`

  const help = createElement('p', 'sj-personalization-field__help', sjUi.one_letter_period)
  help.id = helpId
  control.append(trigger, dialog)
  input.insertAdjacentElement('afterend', control)
  wrapper.append(help)
  claimStructuredControls([wrapper], 'single_initial_picker', control)

  const syncInitialPicker = () => {
    const value = normalizeInitial(input.value)
    input.value = value
    triggerValue.textContent = value || chooseCopy
    triggerHint.textContent = value ? 'Change letter' : 'A–Z'
    const photograph = value ? letterPhotograph(value) : null
    triggerPhoto.hidden = !photograph
    if (photograph) triggerPhoto.style.setProperty('--sj-token-photo', `url("${photograph}")`)
    else triggerPhoto.style.removeProperty('--sj-token-photo')
    trigger.setAttribute('aria-label', value ? `${fieldLabel}: ${value} selected. Change letter` : `${chooseCopy} for ${fieldLabel.toLowerCase()}`)
    trigger.removeAttribute('aria-invalid')
    help.dataset.state = ''
    help.textContent = sjUi.one_letter_period
    dialog.querySelectorAll('[data-single-initial-choice]').forEach((choice) => {
      choice.setAttribute('aria-pressed', String(choice.dataset.singleInitialChoice === value))
    })
  }

  const chooseInitial = (letter) => {
    input.value = normalizeInitial(letter)
    syncInitialPicker()
    input.dispatchEvent(new Event('input', { bubbles: true }))
    input.dispatchEvent(new Event('change', { bubbles: true }))
    closeDialog(dialog)
  }

  const showInitialError = () => {
    trigger.setAttribute('aria-invalid', 'true')
    help.dataset.state = 'error'
    help.textContent = sjUi.initial_required
  }

  trigger.addEventListener('click', () => {
    trigger.setAttribute('aria-expanded', 'true')
    openDialog(dialog, trigger)
    requestAnimationFrame(() => {
      const selected = dialog.querySelector('[data-single-initial-choice][aria-pressed="true"]')
      ;(selected || dialog.querySelector('[data-single-initial-choice]'))?.focus()
    })
  })

  dialog.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-single-initial-choice]')
    if (choice) chooseInitial(choice.dataset.singleInitialChoice)
  })

  dialog.addEventListener('keydown', (event) => {
    if (event.metaKey || event.ctrlKey || event.altKey) return
    if (!/^[A-Z]$/i.test(event.key)) return
    const letter = event.key.toUpperCase()
    if (!alphabet.includes(letter)) return
    event.preventDefault()
    chooseInitial(letter)
  })

  dialog.addEventListener('close', () => {
    trigger.setAttribute('aria-expanded', 'false')
  })

  input.addEventListener('invalid', (event) => {
    event.preventDefault()
    showInitialError()
    /*
      The browser fires `invalid` on every failing control, in document order, so focusing on each
      one walks the customer to the LAST unanswered picker — with two initials that meant being sent
      to the second while the first was still empty above it. Only the first one takes focus; the
      others still mark themselves and explain what is missing.
    */
    if (document.activeElement?.matches?.('[data-single-initial-open][aria-invalid="true"]')) return
    trigger.focus()
    requestAnimationFrame(() => trigger.focus())
  })

  input.addEventListener('input', () => {
    syncInitialPicker()
    updateProductionSummary(form)
  })
  syncInitialPicker()
  return { input, trigger, dialog }
}

const initializeInlinePersonalizer = (form, contract) => {
const details = form.querySelector('[data-sj-personalizer]')
const generic = details?.querySelector('[data-generic-personalizer]')
const submit = form.querySelector('[data-product-submit]')
if (!details || !generic || !submit) return false

initializeMediaChoicePicker(form, generic, contract)
initializeMediaChoiceFields(form, contract)
initializeFontNamePicker(form, generic, contract)

/*
  Every single_initial field on the form gets its own picker.

  flow_type single_initial is the one-letter product archetype and still enhances the form's single
  field. A composite profile — Interlocking Letters, two initials serialized into one `Initial` cart
  property — declares each letter as its own field instead, so those are found by the control the
  field builder stamped on the wrapper rather than by the contract's overall flow.
*/
const singleInitialAlphabet = Array.isArray(contract?.vocabulary?.alphabet) ? contract.vocabulary.alphabet : null
if (contract?.flow_type === 'single_initial') {
  const wrapper = generic.querySelector('[data-personalization-field]:not(.sj-personalization-instruction)')
  enhanceSingleInitialField(form, wrapper, wrapper?.querySelector('textarea, input[type="text"]'),
    { label: 'Initial', dialogTitle: 'Choose a letter', alphabet: singleInitialAlphabet,
      plainTokens: Boolean(contract?.plain_tokens) })
} else {
  const initialFields = [...generic.querySelectorAll('[data-personalization-field][data-structured-control="single_initial"]')]
  for (const wrapper of initialFields) {
    /* The field's own declared title is the label — "First initial", "Second initial" — so the two
       triggers are told apart by sight and by screen reader without a positional guess. */
    const declared = wrapper.dataset.fieldTitle || wrapper.querySelector('.sj-label')?.textContent?.trim() || 'Initial'
    enhanceSingleInitialField(form, wrapper, wrapper.querySelector('textarea, input[type="text"]'),
      { label: declared, dialogTitle: `Choose a letter for ${declared.toLowerCase()}`, alphabet: singleInitialAlphabet,
        plainTokens: Boolean(contract?.plain_tokens) })
  }
}

const upload = generic.querySelector('input[type="file"]')
const sendLater = [...generic.querySelectorAll('input[type="checkbox"]')].find((input) => /send/i.test(input.value || input.closest('label')?.textContent || ''))
if (upload && sendLater) {
  const instruction = createElement('p', 'sj-personalization-field__help', sjUi.upload_choice)
  generic.querySelector('[data-personalization-fields]')?.prepend(instruction)
  const syncUploadChoice = (source) => {
    if (source === sendLater && sendLater.checked) upload.value = ''
    if (source === upload && upload.files?.length) sendLater.checked = false
    upload.required = !sendLater.checked
    upload.dataset.originalRequired = upload.required ? 'true' : 'false'
    updateProductionSummary(form)
  }
  upload.required = !sendLater.checked
  upload.dataset.originalRequired = upload.required ? 'true' : 'false'
  upload.addEventListener('change', () => syncUploadChoice(upload))
  sendLater.addEventListener('change', () => syncUploadChoice(sendLater))
}

details.dataset.personalizerMode = 'inline'
details.removeAttribute('hidden')
details.open = true
form.dataset.inlinePersonalization = 'true'
form.dataset.personalizationStarted = 'true'
form.querySelector('[data-personalize-start]')?.setAttribute('hidden', '')
submit.removeAttribute('hidden')
return true
}

const initializePositionConfigurator = (form, fields) => {
const details = form.querySelector('[data-sj-personalizer]')
const merchantTitle = details?.dataset.personalizationTitle?.trim() || ''
const declaredFamily = String(details?.dataset.personalizationFamily || '').toLowerCase()
const declaredContract = String(details?.dataset.personalizationContract || '').toLowerCase()
const countGroup = [...form.querySelectorAll('[data-option-index]')].find((fieldset) => {
  const label = fieldset.querySelector('legend')?.childNodes[0]?.textContent?.trim() || ''
  return /number\s+of\s+(?:initials?|letters?|birthstones?|stones?)/i.test(label)
})
const schemaLanguage = fields.map((field) => `${field.title || ''} ${field.label || ''}`).join(' ')
const positionInputLanguage = fields
  .filter((field) => personalizationStage(field) === 'personalization' && String(field.type || 'text').toLowerCase() !== 'instructions')
  .map((field) => `${field.title || ''} ${field.label || ''}`)
  .join(' ')
const hasStoneToken = /(?:birthstone|stone)/i.test(positionInputLanguage)
const hasAnotherTokenKind = /(?:letter|initial|icon|symbol|birthflower|flower|cross|charm)/i.test(positionInputLanguage)
const isMixedTokenContract = hasStoneToken && hasAnotherTokenKind
if (isMixedTokenContract && declaredContract !== 'paired-letter-stone') return false
const positionFamily = declaredFamily === 'stones' || (declaredFamily !== 'letters' && !/(?:letter|initial)/i.test(schemaLanguage)) ? 'stones' : 'letters'
const isPositionFlow = Boolean(
  countGroup
  && hasStoneToken
  && ['letters', 'stones', ''].includes(declaredFamily)
)
if (!isPositionFlow) return false

const root = details?.querySelector('[data-v023-configurator]')
const stageNode = root?.querySelector('[data-config-stage]')
const progressNode = root?.querySelector('[data-config-progress]')
const errorsNode = root?.querySelector('[data-config-errors]')
const titleNode = root?.querySelector('[data-config-title]')
const countNode = root?.querySelector('[data-config-count]')
const back = root?.querySelector('[data-config-back]')
const next = root?.querySelector('[data-config-next]')
const actions = root?.querySelector('[data-config-actions]')
const priceNode = root?.querySelector('[data-config-price]')
const liveNode = root?.querySelector('[data-config-live]')
const submit = form.querySelector('[data-product-submit]')
const dialog = form.querySelector('[data-config-discard]')
if (!details || !root || !stageNode || !progressNode || !submit) return false

const generic = details.querySelector('[data-generic-personalizer]')
/* Same exemption as the contract configurator above: the control that sets the count keeps working. */
generic?.querySelectorAll('input, select, textarea, button').forEach((control) => {
  if (countGroup?.contains(control)) return
  control.disabled = true
})
details.dataset.personalizerMode = 'positions'
details.dataset.personalizationFamily = positionFamily
root.removeAttribute('hidden')

const submitHome = submit.parentNode
const submitNextSibling = submit.nextSibling
const stages = ['Meaning', 'Representation', 'Gift & delivery', 'Review']
const state = {
  started: false,
  stage: 0,
  positions: [],
  gift: false,
  packaging: 'Keepsake box',
  giftNote: '',
  country: 'United States',
  needBy: '',
  errors: [],
  pendingCount: null
}

const selectedCount = () => {
  const value = countGroup.querySelector('input:checked, select')?.value || ''
  const parsed = Number.parseInt(value, 10)
  return Number.isFinite(parsed) ? parsed : 0
}

const setSelectedCount = (count) => {
  const radio = [...countGroup.querySelectorAll('input')].find((input) => Number.parseInt(input.value, 10) === count)
  if (radio) radio.checked = true
  const select = countGroup.querySelector('select')
  if (select) select.value = String(count)
  countGroup.dataset.touched = 'true'
}

const announce = (message) => {
  if (!liveNode) return
  liveNode.textContent = ''
  requestAnimationFrame(() => { liveNode.textContent = message })
}

const currentPrice = () => {
  const buybox = form.closest('.sj-product__buybox')
  const price = buybox?.querySelector('[data-product-price]')?.textContent?.trim() || ''
  const prefix = buybox?.querySelector('[data-product-price-prefix]')
  return [prefix && !prefix.hidden ? prefix.textContent.trim() : '', price].filter(Boolean).join(' ')
}

const selectedOption = (matcher) => {
  const fieldset = [...form.querySelectorAll('[data-option-index]')].find((item) => {
    const label = item.querySelector('legend')?.childNodes[0]?.textContent?.trim() || ''
    return matcher.test(label)
  })
  const control = fieldset?.querySelector('input:checked, select')
  const nativeValue = control?.value || ''
  if (nativeValue) return control?.dataset?.optionDisplayValue || control?.selectedOptions?.[0]?.dataset?.optionDisplayValue || nativeValue
  const virtual = basePersonalizationFields(form).find((item) => matcher.test(item.dataset.fieldTitle || item.querySelector('.sj-label, .sj-legend')?.textContent || ''))
  return virtual ? fieldValue(virtual) : ''
}

const stone = (month) => v023Stones.find((item) => item[0] === month)
const stoneLabel = (month) => {
  const match = stone(month)
  return match ? `${match[0]} — ${match[1]}` : ''
}

const summaryRows = () => {
  const rows = [
    ['Product', details.dataset.productTitle || 'Personalized jewelry'],
    ['Material', details.dataset.materialLabel || ''],
    ['Metal color/finish', selectedOption(/(?:metal\s+color|colour|finish)/i)],
    ['Length', selectedOption(/length/i).replace(/"/g, ' in')],
    [positionFamily === 'stones' ? 'Number of birthstones' : 'Number of initials', String(state.positions.length)]
  ]
  state.positions.forEach((position, index) => {
    if (positionFamily === 'letters') rows.push([`Initial ${index + 1}`, position.letter])
    rows.push([`Stone ${index + 1}`, stoneLabel(position.stone)])
  })
  rows.push(['Gift', state.gift ? 'Yes' : 'No'])
  if (state.gift) {
    rows.push(['Gift packaging', state.packaging])
    if (state.giftNote) rows.push(['Gift note', state.giftNote])
  }
  rows.push(['Destination', state.country])
  if (state.needBy) rows.push(['Need-by date', state.needBy])
  return rows.filter(([, value]) => value !== '')
}

const summaryMarkup = (review = false) => `<div class="sj-v023-summary-rows">${summaryRows().map(([label, value]) => `
  <div class="sj-v023-summary-row"><span>${escapeMarkup(label)}</span><span>${escapeMarkup(value)}</span></div>`).join('')}
</div>`

const syncProperties = () => {
  let container = form.querySelector('[data-position-properties]')
  if (!container) {
    container = document.createElement('div')
    container.hidden = true
    container.dataset.positionProperties = ''
    form.append(container)
  }
  container.replaceChildren()
  const personalization = state.positions.map((position, index) => {
    const parts = []
    if (positionFamily === 'letters' && position.letter) parts.push(`Initial ${index + 1}: ${position.letter}`)
    if (position.stone) parts.push(`Birthstone ${index + 1}: ${stoneLabel(position.stone)}`)
    return parts.join(', ')
  }).filter(Boolean).join(' · ')
  const orderRows = [
    ['Personalization', personalization],
    ['Gift', state.gift ? 'Yes' : ''],
    ['Gift packaging', state.gift ? state.packaging : ''],
    ['Gift note', state.gift ? state.giftNote : ''],
    ['Destination', state.country],
    ['Need-by date', state.needBy]
  ].filter(([, value]) => value)
  orderRows.forEach(([label, value]) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = `properties[${label}]`
    input.value = value
    container.append(input)
  })
  const productionSummary = form.querySelector('[data-production-summary-input]')
  if (productionSummary) productionSummary.value = summaryRows().map(([label, value]) => `${label}: ${value}`).join(' | ')
}

const restoreSubmit = () => {
  if (submit.parentNode !== submitHome) submitHome.insertBefore(submit, submitNextSibling)
  submit.setAttribute('hidden', '')
  submit.removeAttribute('data-config-primary')
}

const renderProgress = () => {
  progressNode.innerHTML = stages.map((stage, index) => {
    if (index < state.stage) return `<li><button type="button" data-config-stage-go="${index}">${index + 1} · ${escapeMarkup(stage)} ✓</button></li>`
    if (index === state.stage) return `<li><span aria-current="step">${index + 1} · ${escapeMarkup(stage)}</span></li>`
    return `<li><span aria-disabled="true">${index + 1} · ${escapeMarkup(stage)}</span></li>`
  }).join('')
}

const monthOptions = (selected) => `<option value="">${sjUi.choose_month}</option>${v023Stones.map(([month, gem]) => `
  <option value="${month}"${selected === month ? ' selected' : ''}>${month} — ${gem}</option>`).join('')}`

const errorFor = (key) => state.errors.find((error) => error.key === key)
const renderMeaning = () => {
  const rows = state.positions.map((position, index) => {
    const letterError = errorFor(`letter-${index}`)
    const stoneError = errorFor(`stone-${index}`)
    const stoneData = stone(position.stone)
    return `<div class="sj-v023-position" data-position-index="${index}">
      <span class="sj-v023-position__number" aria-hidden="true">${index + 1}</span>
      <div class="sj-v023-position__fields">
        ${positionFamily === 'letters' ? `<div>
          <label for="SilveristicInitial-${index}">Initial ${index + 1} <span>${sjUi.one_letter_suffix}</span></label>
          <input class="sj-v023-position__initial" id="SilveristicInitial-${index}" type="text" data-position-letter="${index}" value="${escapeMarkup(normalizeInitial(position.letter))}" maxlength="1" pattern="[A-Z]" autocapitalize="characters" autocomplete="off" spellcheck="false" aria-invalid="${letterError ? 'true' : 'false'}"${letterError ? ` aria-describedby="SilveristicInitialError-${index}"` : ''}>
          ${letterError ? `<p class="sj-v023-position__error" id="SilveristicInitialError-${index}">${escapeMarkup(letterError.message)}</p>` : ''}
        </div>` : ''}
        <div>
          <label for="SilveristicStone-${index}">Stone ${index + 1} <span>— birth month</span></label>
          <div class="sj-v023-position__stone-line">
            <select class="sj-v023-position__stone" id="SilveristicStone-${index}" data-position-stone="${index}" aria-invalid="${stoneError ? 'true' : 'false'}"${stoneError ? ` aria-describedby="SilveristicStoneError-${index}"` : ''}>${monthOptions(position.stone)}</select>
            ${stoneData ? `<span class="sj-v023-position__stone-dot" style="background:${stoneData[2]}" aria-hidden="true"></span>` : ''}
          </div>
          ${stoneError ? `<p class="sj-v023-position__error" id="SilveristicStoneError-${index}">${escapeMarkup(stoneError.message)}</p>` : ''}
        </div>
      </div>
      <div class="sj-v023-position__moves">
        <button type="button" data-position-move="${index}" data-direction="-1" aria-label="Move position ${index + 1} up" aria-disabled="${index === 0}">↑</button>
        <button type="button" data-position-move="${index}" data-direction="1" aria-label="Move position ${index + 1} down" aria-disabled="${index === state.positions.length - 1}">↓</button>
      </div>
    </div>`
  }).join('')
  return `<div data-config-stage-grid><div class="sj-v023-position-list">${rows}
    <p class="sj-v023-position-help">Move ↑ ↓ is always available — order is meaning here. ${positionFamily === 'letters' ? 'Only one A–Z letter is accepted for each position.' : 'Choose one birth month for each position; nothing is reordered for you.'}</p>
  </div></div>`
}

const renderRepresentation = () => `<div data-config-stage-grid>
  <div class="sj-v023-representation">
    <div class="sj-v023-representation__line">${state.positions.map((position, index) => {
      const stoneData = stone(position.stone)
      return `<span class="sj-v023-representation__item"><span class="sj-v023-representation__connector" aria-hidden="true"></span><span class="sj-v023-representation__glyph">${escapeMarkup(positionFamily === 'letters' ? (position.letter || '·') : String(index + 1))}</span>${stoneData ? `<span class="sj-v023-representation__stone" style="background:${stoneData[2]}" aria-hidden="true"></span>` : ''}</span>`
    }).join('')}</div>
    <p>${sjUi.layout_guide}</p>
  </div>
  <div class="sj-v023-design-summary"><p>${sjUi.design_summary}</p>${summaryMarkup()}</div>
</div>`

const renderGift = () => `<div class="sj-v023-gift-stage" data-config-stage-grid>
  <label class="sj-v023-gift-toggle"><input type="checkbox" data-config-gift${state.gift ? ' checked' : ''}>${sjUi.gift_toggle}</label>
  ${state.gift ? `<div class="sj-v023-gift-options">
    <fieldset><legend>Presentation</legend><div class="sj-v023-gift-options__choices">${['Keepsake box', 'Simple recycled sleeve'].map((packaging) => `<button type="button" data-config-packaging="${packaging}" aria-pressed="${state.packaging === packaging}">${packaging} — included</button>`).join('')}</div></fieldset>
    <div><label for="SilveristicGiftNote">${escapeMarkup(sjUi.written_note)} <span>${escapeMarkup(sjUi.optional_printed)}</span></label><textarea id="SilveristicGiftNote" rows="3" data-config-gift-note>${escapeMarkup(state.giftNote)}</textarea><p class="sj-v023-gift-note-count">${state.giftNote.length} of 120 characters</p></div>
  </div>` : ''}
  <div><label for="SilveristicDestination">${sjUi.destination}</label><select id="SilveristicDestination" data-config-country>${['United States', 'Canada', 'United Kingdom', 'Australia', 'Elsewhere'].map((country) => `<option${state.country === country ? ' selected' : ''}>${country}</option>`).join('')}</select><small>${sjUi.delivery_use}</small></div>
  <div><label for="SilveristicNeedBy">Need-by date <span>(optional)</span></label><input id="SilveristicNeedBy" type="date" data-config-need-by value="${escapeMarkup(state.needBy)}"><small>${sjUi.delivery_date}</small></div>
</div>`

const renderReview = () => `<div data-config-stage-grid>
  <p class="sj-v023-review-intro">${sjUi.review_intro}</p>
  <div class="sj-v023-review-summary">${summaryMarkup(true)}<div class="sj-v023-review-edits"><button type="button" data-config-edit="base">Edit base</button><button type="button" data-config-edit="meaning">Edit meaning</button><button type="button" data-config-edit="gift">${sjUi.edit_gift_delivery}</button></div></div>
  <p class="sj-v023-review-policy">${sjUi.personalized_policy}</p>
</div>`

const renderErrors = () => {
  if (!state.errors.length) {
    errorsNode.hidden = true
    errorsNode.replaceChildren()
    return
  }
  const title = `${state.errors.length} ${state.errors.length === 1 ? 'detail needs' : 'details need'} attention`
  errorsNode.innerHTML = `<h3>${title}</h3>${state.errors.map((error) => `<p><button type="button" data-config-error-target="${escapeMarkup(error.key)}">${escapeMarkup(error.label)}</button> — ${escapeMarkup(error.message)}</p>`).join('')}<p class="sj-v023-error-note">${sjUi.field_error_note}</p>`
  errorsNode.hidden = false
}

const render = ({ focusHeading = false } = {}) => {
  restoreSubmit()
  titleNode.textContent = state.stage === 0 && merchantTitle ? merchantTitle : stages[state.stage]
  countNode.textContent = `Step ${state.stage + 1} of ${stages.length} · base choices stay editable above`
  renderProgress()
  renderErrors()
  stageNode.innerHTML = state.stage === 0
    ? renderMeaning()
    : state.stage === 1
      ? renderRepresentation()
      : state.stage === 2
        ? renderGift()
        : renderReview()
  back.hidden = state.stage === 0
  next.hidden = state.stage === stages.length - 1
  next.textContent = state.stage === 0
    ? 'Continue to representation'
    : state.stage === 1
      ? 'Continue to gift & delivery'
      : 'Review design'
  priceNode.textContent = currentPrice()
  if (state.stage === stages.length - 1) {
    const grid = stageNode.querySelector('[data-config-stage-grid]')
    submit.dataset.configPrimary = ''
    submit.removeAttribute('hidden')
    grid?.append(submit)
  }
  syncProperties()
  root.dispatchEvent(new CustomEvent('silveristic:configurator-change', { bubbles: true }))
  if (focusHeading) requestAnimationFrame(() => titleNode.focus({ preventScroll: true }))
}

const validateMeaning = () => {
  const errors = []
  state.positions.forEach((position, index) => {
    if (positionFamily === 'letters' && !position.letter) errors.push({ key: `letter-${index}`, label: `Initial ${index + 1}`, message: `Enter one letter A–Z for position ${index + 1}.` })
    else if (positionFamily === 'letters' && !/^[A-Z]$/.test(position.letter)) errors.push({ key: `letter-${index}`, label: `Initial ${index + 1}`, message: `“${position.letter}” isn’t a single A–Z letter.` })
    if (!position.stone) errors.push({ key: `stone-${index}`, label: `Stone ${index + 1}`, message: `Choose a birth month for position ${index + 1}.` })
  })
  return errors
}

const validateCurrent = () => {
  if (state.stage === 0) return validateMeaning()
  if (state.stage === 2 && state.gift && state.giftNote.length > 120) {
    return [{ key: 'gift-note', label: 'Gift note', message: `The note is ${state.giftNote.length} of 120 characters — shorten it.` }]
  }
  return []
}

const goToStage = (stage) => {
  state.errors = []
  state.stage = Math.max(0, Math.min(stage, stages.length - 1))
  render({ focusHeading: true })
  announce(`Step ${state.stage + 1} of ${stages.length}: ${stages[state.stage]}.`)
}

const goNext = () => {
  state.errors = validateCurrent()
  if (state.errors.length) {
    render()
    announce(`${state.errors.length} ${state.errors.length === 1 ? 'detail needs' : 'details need'} attention.`)
    requestAnimationFrame(() => errorsNode.focus())
    return
  }
  goToStage(state.stage + 1)
}

const resizePositions = (count) => {
  const nextPositions = state.positions.slice(0, count)
  while (nextPositions.length < count) nextPositions.push({ letter: '', stone: '' })
  state.positions = nextPositions
  state.errors = []
  if (state.started) state.stage = 0
  syncProperties()
  if (state.started) render({ focusHeading: true })
  announce(`Now ${count} positions. Entered values are preserved in order.`)
}

const showDiscard = (count, trigger) => {
  state.pendingCount = count
  const discarded = state.positions.slice(count).filter((position) => position.letter || position.stone)
  dialog.querySelector('[data-config-discard-title]').textContent = `Reduce to ${count} positions?`
  const list = dialog.querySelector('[data-config-discard-list]')
  list.innerHTML = discarded.map((position) => `<p>${escapeMarkup(position.letter || '—')}${position.stone ? ` · ${escapeMarkup(position.stone)}` : ''}</p>`).join('')
  openDialog(dialog, trigger)
  requestAnimationFrame(() => dialog.querySelector('[data-config-discard-keep]')?.focus())
}

const handleCountChange = (input) => {
  if (!countGroup.contains(input)) return
  const requested = Number.parseInt(input.value, 10)
  if (!Number.isFinite(requested)) return
  const current = state.positions.length
  if (state.started && requested < current && state.positions.slice(requested).some((position) => position.letter || position.stone)) {
    setSelectedCount(current)
    showDiscard(requested, input)
    return
  }
  resizePositions(requested)
}

const start = () => {
  const count = selectedCount()
  if (!count) return
  if (!state.positions.length) resizePositions(count)
  state.started = true
  state.stage = 0
  state.errors = []
  form.dataset.personalizationStarted = 'true'
  details.removeAttribute('hidden')
  details.open = true
  form.querySelector('[data-personalize-start]')?.setAttribute('hidden', '')
  updateProductForm(form)
  render({ focusHeading: true })
  details.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
  announce('Personalizing. Step 1 of 4: Meaning.')
}

root.addEventListener('click', (event) => {
  const move = event.target.closest('[data-position-move]')
  if (move) {
    const index = Number(move.dataset.positionMove)
    const destination = index + Number(move.dataset.direction)
    if (destination < 0 || destination >= state.positions.length) return
    const positions = state.positions.slice()
    ;[positions[index], positions[destination]] = [positions[destination], positions[index]]
    state.positions = positions
    state.errors = []
    render()
    announce(`Moved to position ${destination + 1} of ${positions.length}.`)
    return
  }
  const completed = event.target.closest('[data-config-stage-go]')
  if (completed) { goToStage(Number(completed.dataset.configStageGo)); return }
  if (event.target.closest('[data-config-next]')) { goNext(); return }
  if (event.target.closest('[data-config-back]')) { goToStage(state.stage - 1); return }
  const packaging = event.target.closest('[data-config-packaging]')
  if (packaging) { state.packaging = packaging.dataset.configPackaging; render(); return }
  const edit = event.target.closest('[data-config-edit]')
  if (edit) {
    if (edit.dataset.configEdit === 'gift') goToStage(2)
    else {
      goToStage(0)
      if (edit.dataset.configEdit === 'base') countGroup.scrollIntoView({ block: 'center', behavior: 'smooth' })
    }
    return
  }
  const errorTarget = event.target.closest('[data-config-error-target]')
  if (errorTarget) {
    const key = errorTarget.dataset.configErrorTarget
    const index = Number(key.split('-').at(-1))
    if (key.startsWith('letter-')) root.querySelector(`[data-position-letter="${index}"]`)?.focus()
    if (key.startsWith('stone-')) root.querySelector(`[data-position-stone="${index}"]`)?.focus()
    if (key === 'gift-note') root.querySelector('[data-config-gift-note]')?.focus()
  }
})

root.addEventListener('input', (event) => {
  if (event.target.matches('[data-position-letter]')) {
    const index = Number(event.target.dataset.positionLetter)
    const letter = normalizeInitial(event.target.value)
    if (event.target.value !== letter) event.target.value = letter
    state.positions[index] = { ...state.positions[index], letter }
    syncProperties()
  }
  if (event.target.matches('[data-config-gift-note]')) {
    state.giftNote = event.target.value
    root.querySelector('.sj-v023-gift-note-count').textContent = `${state.giftNote.length} of 120 characters`
    syncProperties()
  }
})

root.addEventListener('change', (event) => {
  if (event.target.matches('[data-position-stone]')) {
    const index = Number(event.target.dataset.positionStone)
    state.positions[index] = { ...state.positions[index], stone: event.target.value }
    state.errors = state.errors.filter((error) => error.key !== `stone-${index}`)
    render()
  }
  if (event.target.matches('[data-config-gift]')) {
    state.gift = event.target.checked
    render()
  }
  if (event.target.matches('[data-config-country]')) state.country = event.target.value
  if (event.target.matches('[data-config-need-by]')) state.needBy = event.target.value
  syncProperties()
})

form.addEventListener('change', (event) => handleCountChange(event.target))
dialog?.querySelector('[data-config-discard-keep]')?.addEventListener('click', () => {
  state.pendingCount = null
  closeDialog(dialog)
})
dialog?.querySelector('[data-config-discard-confirm]')?.addEventListener('click', () => {
  const count = state.pendingCount
  state.pendingCount = null
  if (count) {
    setSelectedCount(count)
    resizePositions(count)
    updateProductForm(form)
  }
  closeDialog(dialog)
})
dialog?.addEventListener('close', () => { state.pendingCount = null })

const controller = {
  usesGenericFields: false,
  start,
  goNext,
  syncProperties,
  isReady: () => state.started && state.stage === stages.length - 1 && validateMeaning().length === 0,
  getNextAction: () => {
    if (root?.offsetParent === null) return null
    if (!state.started) return null
    const errors = validateCurrent()
    if (errors.length) {
      /* Focus the real control, using the same key -> field mapping this
         configurator's own error-summary handler already uses. */
      return errorAction(errors[0], 'stage_field', (error) => {
        const key = String(error.key || '')
        const index = Number(key.split('-').at(-1))
        if (key.startsWith('letter-')) return root.querySelector(`[data-position-letter="${index}"]`)
        if (key.startsWith('stone-')) return root.querySelector(`[data-position-stone="${index}"]`)
        if (key === 'gift-note') return root.querySelector('[data-config-gift-note]')
        return root.querySelector('[data-config-stage]')
      })
    }
    if (state.stage < stages.length - 1) {
      return stageAdvanceAction({ stages, stage: state.stage, nextButton: next, goNext })
    }
    return null
  },
  activateNextAction: (action) => action?.activate?.(),
  afterProductUpdate: () => {
    if (priceNode) priceNode.textContent = currentPrice()
    if (!state.started || state.stage !== stages.length - 1) submit.setAttribute('hidden', '')
    else {
      submit.removeAttribute('hidden')
    }
    renderPrimaryCta(form)
  }
}
form._sjPositionConfigurator = controller
form._sjControllers = (form._sjControllers || []).filter((entry) => entry !== controller).concat(controller)
resizePositions(selectedCount())
controller.afterProductUpdate()
return true
}


/*
  initializeLinearConfigurator and everything after it moved here from part one on 2026-08-21.

  Part one had reached the 256 KB ceiling exactly, so the next real change — limiting the font
  picker to the fonts a product actually sells — could not be written without the build refusing
  to emit. Nothing about this code changed; the concatenation order into assets/sj-global.js is
  byte-for-byte what it was, because a tail of part one became the head of part two.
*/

const initializeLinearConfigurator = (form) => {
const details = form.querySelector('[data-sj-personalizer]')
const merchantTitle = details?.dataset.personalizationTitle?.trim() || ''
const family = String(details?.dataset.personalizationFamily || '').toLowerCase()
if (!['engrave', 'hand', 'pet'].includes(family)) return false

const root = details?.querySelector('[data-v023-configurator]')
const generic = details?.querySelector('[data-generic-personalizer]')
const stageNode = root?.querySelector('[data-config-stage]')
const progressNode = root?.querySelector('[data-config-progress]')
const errorsNode = root?.querySelector('[data-config-errors]')
const titleNode = root?.querySelector('[data-config-title]')
const countNode = root?.querySelector('[data-config-count]')
const back = root?.querySelector('[data-config-back]')
const next = root?.querySelector('[data-config-next]')
const priceNode = root?.querySelector('[data-config-price]')
const liveNode = root?.querySelector('[data-config-live]')
const submit = form.querySelector('[data-product-submit]')
if (!details || !root || !generic || !stageNode || !progressNode || !errorsNode || !submit) return false

const stages = family === 'engrave'
  ? ['Engraving', 'Gift & delivery', 'Review']
  : family === 'hand'
    ? ['Upload or send later', 'Representation', 'Gift & delivery', 'Review']
    : ['Meaning', 'Gift & delivery', 'Review']
const stageLabels = Object.freeze({
  Engraving: sjUi.stage_engraving,
  'Gift & delivery': sjUi.stage_gift_delivery,
  Review: sjUi.stage_review,
  'Upload or send later': sjUi.stage_upload_send,
  Representation: sjUi.stage_representation,
  Meaning: sjUi.stage_meaning
})
const stageLabel = (stage) => stageLabels[stage] || stage
const state = {
  started: false,
  stage: 0,
  gift: false,
  packaging: 'Keepsake box',
  giftNote: '',
  country: 'United States',
  needBy: '',
  errors: []
}
const submitHome = submit.parentNode
const submitNextSibling = submit.nextSibling
const parking = document.createElement('div')
parking.hidden = true
parking.dataset.genericPersonalizerParking = ''
root.append(parking)
generic.querySelector('[data-production-summary]')?.setAttribute('hidden', '')
details.dataset.personalizerMode = 'linear'
root.removeAttribute('hidden')

const announce = (message) => {
  if (!liveNode) return
  liveNode.textContent = ''
  requestAnimationFrame(() => { liveNode.textContent = message })
}
const currentPrice = () => {
  const buybox = form.closest('.sj-product__buybox')
  const price = buybox?.querySelector('[data-product-price]')?.textContent?.trim() || ''
  const prefix = buybox?.querySelector('[data-product-price-prefix]')
  return [prefix && !prefix.hidden ? prefix.textContent.trim() : '', price].filter(Boolean).join(' ')
}
const visibleGenericFields = () => [...generic.querySelectorAll('[data-personalization-field]:not([hidden])')]
  .filter((wrapper) => !wrapper.classList.contains('sj-personalization-instruction'))
const summaryRows = () => {
  const familyLabel = { engrave: sjUi.stage_engraving, hand: sjUi.method_handwriting, pet: sjUi.method_pet_memorial }[family]
  const rows = [
    [sjUi.product, details.dataset.productTitle || ''],
    [sjUi.personalization_method, familyLabel],
    ['Material', details.dataset.materialLabel || '']
  ]
  form.querySelectorAll('[data-option-index]').forEach((fieldset) => {
    const label = fieldset.querySelector('legend')?.childNodes[0]?.textContent?.trim() || sjUi.option
    const value = nativeOptionDisplayValue(fieldset)
    if (value) rows.push([label, value.replace(/"/g, ' in')])
  })
  basePersonalizationFields(form).forEach((wrapper) => {
    const value = fieldValue(wrapper)
    if (value) rows.push([wrapper.dataset.fieldTitle || sjUi.base_choice, value])
  })
  visibleGenericFields().forEach((wrapper) => {
    const value = fieldValue(wrapper)
    if (value) rows.push([wrapper.dataset.fieldTitle || sjUi.personalization, value])
  })
  rows.push(['Gift', state.gift ? sjUi.yes : sjUi.no])
  if (state.gift) {
    rows.push(['Gift packaging', state.packaging === 'Keepsake box' ? sjUi.packaging_keepsake : sjUi.packaging_recycled])
    if (state.giftNote) rows.push([sjUi.written_note, state.giftNote])
  }
  rows.push([sjUi.destination, ({
    'United States': sjUi.country_us,
    Canada: sjUi.country_canada,
    'United Kingdom': sjUi.country_uk,
    Australia: sjUi.country_australia,
    Elsewhere: sjUi.country_elsewhere
  })[state.country] || state.country])
  if (state.needBy) rows.push([sjUi.need_by, state.needBy])
  return rows.filter(([, value]) => value !== '')
}
const summaryMarkup = () => `<div class="sj-v023-summary-rows">${summaryRows().map(([label, value]) => `<div class="sj-v023-summary-row"><span>${escapeMarkup(label)}</span><span>${escapeMarkup(value)}</span></div>`).join('')}</div>`
const syncProperties = () => {
  let container = form.querySelector('[data-linear-properties]')
  if (!container) {
    container = document.createElement('div')
    container.hidden = true
    container.dataset.linearProperties = ''
    form.append(container)
  }
  container.replaceChildren()
  ;[['Gift', state.gift ? 'Yes' : 'No'], ['Gift packaging', state.gift ? state.packaging : ''], ['Gift note', state.gift ? state.giftNote : '']].forEach(([label, value]) => {
    if (!value) return
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = `properties[${label}]`
    input.value = value
    container.append(input)
  })
  const productionSummary = form.querySelector('[data-production-summary-input]')
  if (productionSummary) productionSummary.value = summaryRows().map(([label, value]) => `${label}: ${value}`).join(' | ')

  const adjustment = selectedPriceAdjustment(form)
  const status = form.querySelector('[data-personalization-status]')
  if (adjustment > 0) {
    form.dataset.unmodeledPrice = 'true'
    if (status) {
      status.dataset.state = 'error'
      status.textContent = sjUiText('priced_choice_warning', { __PRICE__: money(adjustment * 100) })
    }
    submit.disabled = true
    submit.setAttribute('aria-disabled', 'true')
  } else {
    delete form.dataset.unmodeledPrice
    if (status?.dataset.state === 'error') {
      status.dataset.state = ''
      status.textContent = ''
    }
  }
}
const validatePersonalization = () => {
  const errors = []
  visibleGenericFields().forEach((wrapper, index) => {
    if (wrapper.dataset.required !== 'true' || fieldValue(wrapper)) return
    errors.push({ key: `field-${index}`, label: wrapper.dataset.fieldTitle || sjUi.personalization, message: sjUi.complete_detail })
  })
  if (family === 'hand') {
    const hasFile = Boolean(generic.querySelector('input[type="file"]')?.files?.length)
    const sendsLater = Boolean(generic.querySelector('input[type="checkbox"]:checked') || generic.querySelector('input[type="radio"]:checked')?.value?.match(/send/i))
    if (!hasFile && !sendsLater) errors.push({ key: 'source-image', label: sjUi.source_image, message: sjUi.source_image_required })
  }
  return errors
}
const validateCurrent = () => {
  if (state.stage === 0) return validatePersonalization()
  const giftIndex = stages.indexOf('Gift & delivery')
  if (state.stage === giftIndex && state.gift && state.giftNote.length > 120) return [{ key: 'gift-note', label: sjUi.written_note, message: sjUiText('gift_note_too_long', { __COUNT__: state.giftNote.length }) }]
  return []
}
const renderProgress = () => {
  progressNode.innerHTML = stages.map((stage, index) => {
    if (index < state.stage) return `<li><button type="button" data-config-stage-go="${index}">${index + 1} · ${escapeMarkup(stageLabel(stage))} ✓</button></li>`
    if (index === state.stage) return `<li><span aria-current="step">${index + 1} · ${escapeMarkup(stageLabel(stage))}</span></li>`
    return `<li><span aria-disabled="true">${index + 1} · ${escapeMarkup(stageLabel(stage))}</span></li>`
  }).join('')
}
const renderErrors = () => {
  if (!state.errors.length) {
    errorsNode.hidden = true
    errorsNode.replaceChildren()
    return
  }
  const heading = sjUiText(state.errors.length === 1 ? 'detail_attention' : 'details_attention', { __COUNT__: state.errors.length })
  errorsNode.innerHTML = `<h3>${escapeMarkup(heading)}</h3>${state.errors.map((error) => `<p><button type="button" data-linear-error="${escapeMarkup(error.key)}">${escapeMarkup(error.label)}</button> — ${escapeMarkup(error.message)}</p>`).join('')}<p class="sj-v023-error-note">${escapeMarkup(sjUi.nothing_substituted)}</p>`
  errorsNode.hidden = false
}
const giftMarkup = () => `<div class="sj-v023-gift-stage" data-config-stage-grid>
  <label class="sj-v023-gift-toggle"><input type="checkbox" data-config-gift${state.gift ? ' checked' : ''}>${escapeMarkup(sjUi.gift_toggle)}</label>
  ${state.gift ? `<div class="sj-v023-gift-options"><fieldset><legend>${escapeMarkup(sjUi.presentation)}</legend><div class="sj-v023-gift-options__choices">${[['Keepsake box', sjUi.packaging_keepsake], ['Simple recycled sleeve', sjUi.packaging_recycled]].map(([value, label]) => `<button type="button" data-config-packaging="${value}" aria-pressed="${state.packaging === value}">${escapeMarkup(label)} — ${escapeMarkup(sjUi.included)}</button>`).join('')}</div></fieldset><div><label for="SilveristicGiftNote">${escapeMarkup(sjUi.written_note)} <span>${escapeMarkup(sjUi.optional_printed)}</span></label><textarea id="SilveristicGiftNote" rows="3" data-config-gift-note>${escapeMarkup(state.giftNote)}</textarea><p class="sj-v023-gift-note-count">${escapeMarkup(sjUiText('gift_note_count', { __COUNT__: state.giftNote.length }))}</p></div></div>` : ''}
  <div><label for="SilveristicDestination">${escapeMarkup(sjUi.destination)}</label><select id="SilveristicDestination" data-config-country>${[['United States', sjUi.country_us], ['Canada', sjUi.country_canada], ['United Kingdom', sjUi.country_uk], ['Australia', sjUi.country_australia], ['Elsewhere', sjUi.country_elsewhere]].map(([value, label]) => `<option value="${value}"${state.country === value ? ' selected' : ''}>${escapeMarkup(label)}</option>`).join('')}</select><small>${escapeMarkup(sjUi.delivery_use)}</small></div>
  <div><label for="SilveristicNeedBy">${escapeMarkup(sjUi.need_by)} <span>(optional)</span></label><input id="SilveristicNeedBy" type="date" data-config-need-by value="${escapeMarkup(state.needBy)}"><small>${escapeMarkup(sjUi.delivery_date)}</small></div>
</div>`
const representationMarkup = () => `<div data-config-stage-grid><div class="sj-v023-representation"><p>${escapeMarkup(sjUi.source_image_guide)}</p></div><div class="sj-v023-design-summary"><p>${escapeMarkup(sjUi.design_summary)}</p>${summaryMarkup()}</div></div>`
const reviewMarkup = () => `<div data-config-stage-grid><p class="sj-v023-review-intro">${escapeMarkup(sjUi.review_intro)}</p><div class="sj-v023-review-summary">${summaryMarkup()}<div class="sj-v023-review-edits"><button type="button" data-config-edit="meaning">${escapeMarkup(family === 'hand' ? sjUi.edit_source_image : family === 'engrave' ? sjUi.edit_engraving : sjUi.edit_meaning)}</button><button type="button" data-config-edit="gift">${escapeMarkup(sjUi.edit_gift_delivery)}</button></div></div><p class="sj-v023-review-policy">${escapeMarkup(sjUi.personalized_policy)}</p></div>`
const restoreSubmit = () => {
  if (submit.parentNode !== submitHome) submitHome.insertBefore(submit, submitNextSibling)
  submit.setAttribute('hidden', '')
  submit.removeAttribute('data-config-primary')
}
const render = ({ focusHeading = false } = {}) => {
  restoreSubmit()
  if (generic.parentNode === stageNode) parking.append(generic)
  titleNode.textContent = state.stage === 0 && merchantTitle ? merchantTitle : stageLabel(stages[state.stage])
  countNode.textContent = sjUiText('step_count', { __CURRENT__: state.stage + 1, __TOTAL__: stages.length })
  renderProgress()
  renderErrors()
  const currentStage = stages[state.stage]
  if (state.stage === 0) {
    stageNode.replaceChildren(generic)
  } else {
    stageNode.innerHTML = currentStage === 'Representation' ? representationMarkup() : currentStage === 'Gift & delivery' ? giftMarkup() : reviewMarkup()
  }
  back.hidden = state.stage === 0
  next.hidden = state.stage === stages.length - 1
  next.textContent = state.stage < stages.length - 1 ? (stages[state.stage + 1] === 'Review' ? sjUi.review_design : sjUiText('continue_to', { __STAGE__: stageLabel(stages[state.stage + 1]).toLocaleLowerCase() })) : ''
  priceNode.textContent = currentPrice()
  if (state.stage === stages.length - 1) {
    const grid = stageNode.querySelector('[data-config-stage-grid]')
    submit.dataset.configPrimary = ''
    submit.removeAttribute('hidden')
    grid?.append(submit)
  }
  syncProperties()
  root.dispatchEvent(new CustomEvent('silveristic:configurator-change', { bubbles: true }))
  if (focusHeading) requestAnimationFrame(() => titleNode.focus({ preventScroll: true }))
}
const goToStage = (stage) => {
  state.errors = []
  state.stage = Math.max(0, Math.min(stage, stages.length - 1))
  render({ focusHeading: true })
  updateProductForm(form)
  announce(sjUiText('step_announcement', { __CURRENT__: state.stage + 1, __TOTAL__: stages.length, __STAGE__: stageLabel(stages[state.stage]) }))
}
const goNext = () => {
  state.errors = validateCurrent()
  if (state.errors.length) {
    render()
    announce(sjUiText(state.errors.length === 1 ? 'detail_attention' : 'details_attention', { __COUNT__: state.errors.length }))
    requestAnimationFrame(() => errorsNode.focus())
    return
  }
  goToStage(state.stage + 1)
}
const start = () => {
  state.started = true
  state.stage = 0
  state.errors = []
  form.dataset.personalizationStarted = 'true'
  details.removeAttribute('hidden')
  details.open = true
  form.querySelector('[data-personalize-start]')?.setAttribute('hidden', '')
  render({ focusHeading: true })
  updateProductForm(form)
  details.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
  announce(sjUiText('personalizing_step', { __TOTAL__: stages.length, __STAGE__: stageLabel(stages[0]) }))
}

root.addEventListener('click', (event) => {
  const completed = event.target.closest('[data-config-stage-go]')
  if (completed) { goToStage(Number(completed.dataset.configStageGo)); return }
  if (event.target.closest('[data-config-next]')) { goNext(); return }
  if (event.target.closest('[data-config-back]')) { goToStage(state.stage - 1); return }
  const packaging = event.target.closest('[data-config-packaging]')
  if (packaging) { state.packaging = packaging.dataset.configPackaging; render(); return }
  const edit = event.target.closest('[data-config-edit]')
  if (edit) { goToStage(edit.dataset.configEdit === 'gift' ? stages.indexOf('Gift & delivery') : 0); return }
  const error = event.target.closest('[data-linear-error]')
  if (error) {
    const key = error.dataset.linearError
    if (key === 'source-image') generic.querySelector('input[type="file"]')?.focus()
    else visibleGenericFields()[Number(key.split('-').at(-1))]?.querySelector('input, select, textarea')?.focus()
  }
})
root.addEventListener('input', (event) => {
  if (event.target.matches('[data-config-gift-note]')) {
    state.giftNote = event.target.value
    root.querySelector('.sj-v023-gift-note-count').textContent = sjUiText('gift_note_count', { __COUNT__: state.giftNote.length })
  }
  syncProperties()
})
root.addEventListener('change', (event) => {
  if (event.target.matches('[data-config-gift]')) { state.gift = event.target.checked; render(); return }
  if (event.target.matches('[data-config-country]')) state.country = event.target.value
  if (event.target.matches('[data-config-need-by]')) state.needBy = event.target.value
  state.errors = []
  syncProperties()
})

const controller = {
  usesGenericFields: true,
  start,
  goNext,
  syncProperties,
  isReady: () => state.started && state.stage === stages.length - 1 && validatePersonalization().length === 0,
  getNextAction: () => {
    if (root?.offsetParent === null) return null
    if (!state.started) return null
    const errors = validateCurrent()
    if (errors.length) {
      /* field-<n> indexes visibleGenericFields(), NOT the wrapper's data-field-index —
         they diverge as soon as any field is hidden — so resolve through the same
         list the validator counted. */
      return errorAction(errors[0], 'stage_field', (error) => {
        const key = String(error.key || '')
        if (key.startsWith('field-')) {
          const wrapper = visibleGenericFields()[Number(key.split('-').at(-1))]
          return wrapper?.querySelector('input:not([disabled]), select, textarea') || wrapper || null
        }
        if (key === 'source-image') return generic?.querySelector('input[type="file"]') || null
        return root.querySelector('[data-config-stage]')
      })
    }
    if (state.stage < stages.length - 1) {
      return stageAdvanceAction({ stages, stage: state.stage, nextButton: next, goNext })
    }
    return null
  },
  activateNextAction: (action) => action?.activate?.(),
  afterProductUpdate: () => {
    if (priceNode) priceNode.textContent = currentPrice()
    if (!state.started || state.stage !== stages.length - 1) submit.setAttribute('hidden', '')
    else {
      submit.removeAttribute('hidden')
    }
    renderPrimaryCta(form)
  }
}
form._sjPositionConfigurator = controller
form._sjControllers = (form._sjControllers || []).filter((entry) => entry !== controller).concat(controller)
controller.afterProductUpdate()
return true
}
/* Continued from snippets/silveristic-global-js.liquid — moved here only because
   Shopify caps a single theme file at 256 KB. Order is the contract; see the JS_SNIPPETS
   list in custom-data/build-global-assets.mjs. */

/*
  Composite serialization for products with no sequence.

  A composite contract composes its parts into ONE property under the product's existing key. When
  the product also has a token sequence the contract configurator owns that job (`syncProperties`),
  but most composites are a font tile grid and a name box with no positions at all — those never
  start the configurator, so nothing was writing the property and the parts, being deliberately
  nameless, posted nothing either. The page looked complete and the cart arrived empty.

  This writer is installed only when no configurator claimed the form, so the two can never both
  write into [data-contract-properties].
*/
const installCompositeProperty = (form, contract) => {
  const key = String(contract?.serializer?.property_name || '').trim()
  if (!key) return
  const fixedPrefix = String(contract.serializer?.fixed_prefix || '').trim()
  const parts = contract.serializer?.parts || []

  let container = form.querySelector('[data-contract-properties]')
  if (!container) {
    container = createElement('div')
    container.hidden = true
    container.dataset.contractProperties = ''
    form.append(container)
  }

  /* Read the control the shopper actually sees. Matching on the wrapper's title rather than on a
     name is the whole point — these controls have no names, by design. */
  const valueOf = (wanted) => {
    const wrapper = [...form.querySelectorAll('[data-personalization-field]')].find((field) => {
      if (field.hidden || field.offsetParent === null) return false
      const title = String(field.dataset.sourceFieldTitle || field.dataset.fieldTitle || '').trim()
      return title.toLocaleLowerCase() === String(wanted || '').trim().toLocaleLowerCase()
    })
    if (!wrapper) return ''
    const select = wrapper.querySelector('select')
    if (select) return String(select.value || '').trim()
    const checked = wrapper.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked')
    if (checked) return String(checked.value || '').trim()
    const text = wrapper.querySelector('input, textarea')
    return text ? String(text.value || '').trim() : ''
  }

  const sync = () => {
    const segments = parts
      .map((part) => [String(part.label || part.field_title), valueOf(part.field_title)])
      .filter(([, value]) => value)
      .map(([label, value]) => `${label}: ${value}`)
    const composed = fixedPrefix
      ? [fixedPrefix, ...segments].join(' · ')
      : segments.join(' · ')
    container.replaceChildren()
    if (!composed) return
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = `properties[${key}]`
    /* Contract-owned: exempt from the submit-time label shortener. */
    input.dataset.exactPropertyKey = ''
    input.value = composed
    container.append(input)
  }

  form.addEventListener('input', sync)
  form.addEventListener('change', sync)
  sync()
}

/*
  The visual-chooser family, moved here from part one when that file reached Shopify's 256 KB
  per-file cap. Order is the contract — see the JS_SNIPPETS list in
  custom-data/build-global-assets.mjs — and it is safe: part one calls these from inside
  initializeInlinePersonalizer and from the token configurator's render(), both of which run long
  after the whole module has evaluated, so nothing reads them in the temporal dead zone.
*/
/*
  Move a centred chooser into the design it belongs to.

  The token configurator rebuilds its whole summary on every state change, so the picker cannot
  simply be appended once — it is re-parented after each render. The <select> underneath stays where
  the field builder put it, still hidden and still what the form submits; only the visible control
  travels. Called from render() and again once the enhancer has had a chance to build it, because
  the configurator initialises first and there is nothing to move on the first pass.
*/
/*
  Return a centred chooser to the field that owns it, before the design is redrawn.

  The centre slot lives inside the configurator's root, and every render replaces that root's whole
  innerHTML — so a control parked there is DESTROYED, not merely detached. The hexagon pendant lost
  its birthstone button the moment the first letter was chosen: the node was gone, placeCentreChoice
  had nothing left to move, and the shopper could no longer choose a stone at all. Parking it back on
  its own field first keeps it alive across the redraw; the field is outside the root and is never
  rewritten.
*/
const detachCentreChoice = (form) => {
  const control = form?.querySelector('[data-token-centre] [data-media-choice-control]')
  const home = form?.querySelector('[data-personalization-field][data-choice-placement="center"]')
  if (!control || !home || control.parentElement === home) return
  home.append(control)
}

const placeCentreChoice = (form) => {
  const slot = form?.querySelector('[data-token-centre]')
  const control = form?.querySelector('[data-personalization-field][data-choice-placement="center"] [data-media-choice-control]')
    || form?.querySelector('[data-media-choice-control][data-centred]')
  if (!slot || !control || control.parentElement === slot) return
  control.dataset.centred = ''
  slot.append(control)
}

const enhanceMediaChoiceField = (form, wrapper, source, tokenType, vocabulary) => {
  if (!wrapper || !source || source.dataset.mediaChoiceSource !== undefined) return false
  const allowed = new Set([...source.options].map((option) => option.value).filter(Boolean))
  const choices = vocabulary
    .map((choice) => typeof choice === 'object'
      ? { value: String(choice.value || ''), label: String(choice.label || choice.value || ''), detail: String(choice.detail || '') }
      : { value: String(choice), label: String(choice), detail: '' })
    .filter((choice) => choice.value && allowed.has(choice.value))
  if (!choices.length || !choices.some((choice) => tokenPhotograph(tokenType, choice.value))) return false

  wrapper.dataset.structuredControl = 'media_choice_select'
  /*
    Restore requiredness from the field's own record.

    updatePersonalizationConditions clears `required` on a control it considers not-yet-visible and
    then treats whatever it finds as the original, so a mandatory choice that was hidden at the wrong
    moment becomes optional for good. The builder stamps the contract's answer on the wrapper, which
    no pass rewrites, so that is what the picker trusts. Without this the necklace-and-earrings set
    could be added to the cart with none of its three stones chosen.
  */
  const mustChoose = wrapper.dataset.required === 'true'
  source.required = mustChoose
  source.dataset.originalRequired = mustChoose ? 'true' : 'false'
  source.dataset.mediaChoiceSource = ''
  source.classList.remove('sj-select')
  source.classList.add('sj-visually-hidden')
  source.tabIndex = -1
  source.setAttribute('aria-hidden', 'true')

  const label = wrapper.querySelector('.sj-label')
  const triggerId = `${source.id}-MediaTrigger`
  const dialogId = `${source.id}-MediaPicker`
  const titleId = `${dialogId}-Title`
  const helpId = `${source.id}-MediaHelp`
  if (label) {
    label.htmlFor = triggerId
    label.classList.add('sj-visually-hidden')
  }

  const control = createElement('div', 'sj-media-choice-control')
  control.dataset.mediaChoiceControl = ''
  /*
    A control placed INSIDE the design — the stone that sits in the middle of the hexagon's four
    initials — is labelled by the design around it. Repeating "Birthstone" over it, and a line of
    help under it, turned one slot into a second titled section below the piece, which is not what
    the pendant looks like. The button keeps its accessible name, so nothing is lost to a reader.
  */
  const centred = wrapper.dataset.choicePlacement === 'center'
  /*
    A lone slot in a group named after it does not repeat the word.

    The necklace's stone sits in a group captioned NECKLACE, and the picker then printed NECKLACE
    again directly under the caption; the pair beside it reads EARRINGS / EARRING 1 / EARRING 2,
    where the second line does say something new. The caption wins because it is what pairs the two
    halves of the set; the button keeps its own accessible name either way.
  */
  const group = wrapper.closest('[data-personalization-group]')
  const groupName = String(group?.dataset.personalizationGroup || '').trim().toLocaleLowerCase()
  const ownTitle = String(wrapper.dataset.fieldTitle || '').trim().toLocaleLowerCase()
  const fieldName = String(wrapper.dataset.fieldTitle || sjUi.option).trim().toLocaleLowerCase()
  const echoesItsGroup = Boolean(group)
    && groupName === ownTitle
    && group.querySelectorAll('[data-personalization-field]').length === 1
  if (!centred && !echoesItsGroup) {
    control.append(createElement('p', 'sj-label', wrapper.dataset.fieldTitle || sjUi.option))
  }
  const trigger = createElement('button', 'sj-media-choice__trigger')
  trigger.type = 'button'
  trigger.id = triggerId
  trigger.dataset.mediaChoiceOpen = ''
  trigger.setAttribute('aria-haspopup', 'dialog')
  trigger.setAttribute('aria-controls', dialogId)
  trigger.setAttribute('aria-expanded', 'false')
  trigger.setAttribute('aria-describedby', helpId)
  const triggerPhoto = createElement('span', 'sj-media-choice__trigger-photo')
  triggerPhoto.setAttribute('aria-hidden', 'true')
  triggerPhoto.hidden = true
  const triggerCopy = createElement('span', 'sj-media-choice__trigger-copy')
  const triggerValue = createElement('span', 'sj-media-choice__trigger-value', sjUiText('choose_dynamic', { __VALUE__: fieldName }))
  const triggerHint = createElement('span', 'sj-media-choice__trigger-hint', sjUiText('visual_choices', { __COUNT__: choices.length }))
  triggerCopy.append(triggerValue, triggerHint)
  const triggerIcon = createElement('span', 'sj-media-choice__trigger-icon', '⌄')
  triggerIcon.setAttribute('aria-hidden', 'true')
  /*
    A field may ask for the bare plus instead of the labelled row: one centred "+" the shopper taps,
    with the explanation carried by the copy above rather than by a caption inside the control. The
    accessible name still says what the button chooses, so the plus is decoration and never the only
    thing announcing what it does.
  */
  const plusTrigger = wrapper.dataset.choiceTrigger === 'plus'
  if (plusTrigger) {
    trigger.classList.add('sj-media-choice__trigger--plus')
    control.classList.add('sj-media-choice-control--plus')
    const mark = createElement('span', 'sj-media-choice__plus', '+')
    mark.setAttribute('aria-hidden', 'true')
    trigger.append(triggerPhoto, mark)
  } else {
    trigger.append(triggerPhoto, triggerCopy, triggerIcon)
  }

  const dialog = createElement('dialog', 'sj-media-choice-picker')
  dialog.id = dialogId
  dialog.dataset.mediaChoicePicker = ''
  dialog.setAttribute('aria-labelledby', titleId)
  const choiceMarkup = choices.map((choice) => {
    const photograph = tokenPhotograph(tokenType, choice.value)
    const parts = choice.label.split(/\s+-\s+/)
    const primary = parts.shift() || choice.label
    const secondary = choice.detail || parts.join(' - ')
    return `<button class="sj-media-choice-picker__choice${photograph ? ' sj-media-choice-picker__choice--photo' : ''}" type="button" data-media-choice-value="${escapeMarkup(choice.value)}" aria-label="${escapeMarkup(sjUiText('choose_dynamic', { __VALUE__: choice.label }))}" aria-pressed="false">${photograph ? `<span class="sj-media-choice-picker__photo" style="--sj-token-photo:url('${escapeMarkup(photograph)}')" aria-hidden="true"></span>` : ''}<span class="sj-media-choice-picker__copy"><strong>${escapeMarkup(primary)}</strong>${secondary ? `<span>${escapeMarkup(secondary)}</span>` : ''}</span></button>`
  }).join('')
  dialog.innerHTML = `<div class="sj-media-choice-picker__inner"><div class="sj-media-choice-picker__head"><div><h2 id="${titleId}">${escapeMarkup(sjUiText('choose_dynamic', { __VALUE__: fieldName }))}</h2><p>${escapeMarkup(sjUi.select_exact_piece)}</p></div><button class="sj-media-choice-picker__close" type="button" data-dialog-close aria-label="${escapeMarkup(sjUi.visual_picker_close)}">×</button></div><div class="sj-media-choice-picker__grid" aria-label="${escapeMarkup(sjUiText('visual_picker_available', { __TYPE__: tokenType }))}">${choiceMarkup}</div></div>`

  const help = createElement('p', 'sj-personalization-field__help', sjUi.choose_option_help)
  help.id = helpId
  /*
    A bare plus carries no help line of its own. The sentence is longer than the button by an order
    of magnitude, so it — not the control — decided the slot's width, and three plus slots that
    should have shared one row each reserved 410px. The owner's rule for this shape is the same on
    every product that uses it: the plus, and the explanation in the copy above.
  */
  if (centred || plusTrigger) { help.hidden = true; trigger.removeAttribute('aria-describedby') }
  control.append(trigger, dialog, help)
  source.insertAdjacentElement('afterend', control)
  claimStructuredControls([wrapper], 'media_choice_picker', control)

  const sync = () => {
    const selected = choices.find((choice) => choice.value === source.value) || null
    const photograph = selected ? tokenPhotograph(tokenType, selected.value) : null
    triggerValue.textContent = selected?.label || sjUiText('choose_dynamic', { __VALUE__: fieldName })
    triggerHint.textContent = selected ? sjUi.change_selection : sjUiText('visual_choices', { __COUNT__: choices.length })
    trigger.setAttribute('aria-label', selected ? sjUiText('selected_change', { __VALUE__: selected.label }) : sjUiText('choose_dynamic', { __VALUE__: wrapper.dataset.fieldTitle || sjUi.option }))
    trigger.removeAttribute('aria-invalid')
    help.dataset.state = ''
    help.textContent = sjUi.choose_option_help
    triggerPhoto.hidden = !photograph
    if (photograph) triggerPhoto.style.setProperty('--sj-token-photo', `url("${photograph}")`)
    else triggerPhoto.style.removeProperty('--sj-token-photo')
    dialog.querySelectorAll('[data-media-choice-value]').forEach((choice) => {
      choice.setAttribute('aria-pressed', String(choice.dataset.mediaChoiceValue === source.value))
    })
  }
  const choose = (value) => {
    if (!allowed.has(value)) return
    source.value = value
    sync()
    source.dispatchEvent(new Event('input', { bubbles: true }))
    source.dispatchEvent(new Event('change', { bubbles: true }))
    closeDialog(dialog)
  }

  trigger.addEventListener('click', () => {
    trigger.setAttribute('aria-expanded', 'true')
    openDialog(dialog, trigger)
    requestAnimationFrame(() => {
      const selected = dialog.querySelector('[data-media-choice-value][aria-pressed="true"]')
      ;(selected || dialog.querySelector('[data-media-choice-value]'))?.focus()
    })
  })
  dialog.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-media-choice-value]')
    if (choice) choose(choice.dataset.mediaChoiceValue)
  })
  dialog.addEventListener('close', () => trigger.setAttribute('aria-expanded', 'false'))
  source.addEventListener('invalid', (event) => {
    event.preventDefault()
    trigger.setAttribute('aria-invalid', 'true')
    help.dataset.state = 'error'
    help.textContent = sjUiText('choose_to_continue', { __VALUE__: fieldName })
    trigger.focus()
  })
  source.addEventListener('change', sync)
  sync()
  return true
}

const initializeMediaChoicePicker = (form, generic, contract) => {
if (contract?.flow_type !== 'choice_select') return false
/*
  A contract that declares a font guide belongs to the reviewed font-and-name picker below, which
  shows the merchant's full sample sheet and then asks for the name in the same flow. This picker
  runs first and claims the first select it finds, so once Listings gave the font rows a real font
  vocabulary it started taking them — the shopper got a tile grid, the CTA's "Choose font" opened
  the wrong control, and the two-step name entry never appeared.
*/
if (contract?.picker?.kind === 'font_guide') return false
const tokenType = String(contract.token_types?.[0] || '')
const vocabularyKey = contractVocabularyKeys[tokenType]
const vocabulary = vocabularyKey ? contract.vocabulary?.[vocabularyKey] : null
if (!tokenType || !Array.isArray(vocabulary) || !vocabulary.length) return false

const wrapper = [...generic.querySelectorAll('[data-personalization-field]:not(.sj-personalization-instruction)')]
  .find((candidate) => candidate.querySelector('select'))
const source = wrapper?.querySelector('select')
if (!wrapper || !source || source.dataset.mediaChoiceSource !== undefined) return false

  return enhanceMediaChoiceField(form, wrapper, source, tokenType, vocabulary)
}

/*
  The per-field path.

  A contract field typed `media_choice` names its own vocabulary, so it does not depend on the
  contract's overall flow and several can sit on one form. The contract-wide function above is kept
  for the products that already rely on it — a whole-contract choice_select with no field-level
  declaration — and the two never touch the same control, because the first thing the enhancer does
  is refuse a select another picker has already claimed.
*/
const initializeMediaChoiceFields = (form, contract) => {
  /*
    Scoped to the FORM, not to the generic personalizer.

    A configurator moves the fields it owns out of [data-generic-personalizer] into its own flow, and
    it takes its siblings with them: the hexagon pendant's birthstone ends up outside the generic
    container even though nothing claimed it. Searching from the container found no field to enhance
    and the dropdown survived. The marker is on the field itself, so searching the whole form is both
    correct and narrower than it looks — only fields the builder typed `media_choice` match, and the
    enhancer refuses any select another picker has already claimed.
  */
  const wrappers = [...form.querySelectorAll('[data-personalization-field][data-structured-control="media_choice"]')]
  let built = 0
  for (const wrapper of wrappers) {
    const source = wrapper.querySelector('select')
    if (!source) continue
    const tokenType = String(wrapper.dataset.tokenType || contract?.token_types?.[0] || '')
    const vocabularyKey = contractVocabularyKeys[tokenType]
    const declared = vocabularyKey ? contract?.vocabulary?.[vocabularyKey] : null
    /*
      Fall back to the field's OWN options when the contract carries no vocabulary for this token
      type. A contract hydrated from listings235 publishes one vocabulary for the whole product —
      the hexagon pendant's is `letter`, for its four initials — while the birthstone beside it
      carries its twelve choices on the field. Reading the field means a second visual question does
      not depend on the first one's vocabulary.
    */
    const vocabulary = Array.isArray(declared) && declared.length
      ? declared
      : [...source.options].map((option) => option.value).filter(Boolean)
    if (!tokenType || !vocabulary.length) continue
    if (enhanceMediaChoiceField(form, wrapper, source, tokenType, vocabulary)) built += 1
  }
  return built > 0
}

/*
  A DATE PICKER — a calendar the shopper opens, not a box they type into.

  The infinity necklace is engraved "10.05.2024" between two names, and the contract used to ask for
  the names AND the date in one 30-character box. The first attempt at splitting it gave the date
  three typed segments; the owner's answer was that a typed field is not a date picker, and they are
  right — this is the calendar.

  What keeps it small, which was the other half of the brief: the FIELD is a single button showing
  the chosen date, so the form gains one control-height row and nothing more. The calendar lives in
  a dialog and exists only while it is open.

  What keeps it usable for THIS question: an engraving date is an anniversary or a birthday, often
  years back, so a month-at-a-time calendar alone would mean dozens of clicks. Tapping the title
  opens a month-and-year jump, which is two taps to any date in the range instead of twenty-four.

  It stays an ENHANCEMENT. The contract declares an ordinary `text` field with `format: "date"`, so
  without JavaScript the shopper still gets a labelled text box with a DD.MM.YYYY placeholder. The
  source input is kept, visually hidden, and stays the FIRST control in its wrapper — fieldValue()
  and formPersonalizationValues() both read the first match, so anything inserted before it would be
  serialized in its place.
*/
const DATE_MIN_YEAR = 1940
const DATE_MAX_YEAR = new Date().getFullYear() + 5
const DATE_MONTHS = Object.freeze(['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'])
/* Monday first: the storefront's own locale and every European engraving convention read that way. */
const DATE_WEEKDAYS = Object.freeze(['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'])

const pad2 = (value) => String(value).padStart(2, '0')
const daysInMonth = (year, month) => new Date(year, month + 1, 0).getDate()
/* JS weeks start on Sunday; shift so Monday is column 0. */
const firstWeekday = (year, month) => (new Date(year, month, 1).getDay() + 6) % 7

const enhanceDateField = (wrapper, field) => {
  if (!wrapper || wrapper.dataset.dateField === 'on') return false
  const source = wrapper.querySelector('input.sj-input, input[type="text"]')
  if (!source) return false
  wrapper.dataset.dateField = 'on'
  source.classList.add('sj-visually-hidden')
  source.setAttribute('tabindex', '-1')
  source.setAttribute('aria-hidden', 'true')

  const label = wrapper.dataset.fieldTitle || 'Date'
  const parsed = String(source.value || '').match(/^(\d{2})\.(\d{2})\.(\d{4})$/)
  let selected = parsed
    ? { year: Number(parsed[3]), month: Number(parsed[2]) - 1, day: Number(parsed[1]) }
    : null
  const today = new Date()
  let viewYear = selected ? selected.year : today.getFullYear()
  let viewMonth = selected ? selected.month : today.getMonth()

  const trigger = createElement('button', 'sj-datefield')
  trigger.type = 'button'
  trigger.setAttribute('aria-haspopup', 'dialog')
  trigger.setAttribute('aria-expanded', 'false')
  const valueText = createElement('span', 'sj-datefield__value')
  /* An outline mark rather than the calendar emoji: the emoji renders in full colour and reads as a
     sticker beside this typography, and it is the one element on the control we do not draw. */
  const glyph = createElement('span', 'sj-datefield__glyph')
  glyph.setAttribute('aria-hidden', 'true')
  glyph.innerHTML = '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor"'
    + ' stroke-width="1.3" stroke-linecap="round"><rect x="1.6" y="3" width="12.8" height="11.4" rx="2"/>'
    + '<path d="M1.6 6.6h12.8M5.2 1.6v2.6M10.8 1.6v2.6"/></svg>'
  trigger.append(valueText, glyph)

  const dialog = createElement('dialog', 'sj-datepicker')
  dialog.dataset.datePicker = ''
  const inner = createElement('div', 'sj-datepicker__inner')
  const head = createElement('div', 'sj-datepicker__head')
  const previous = createElement('button', 'sj-datepicker__step', '‹')
  previous.type = 'button'
  previous.setAttribute('aria-label', 'Previous month')
  const title = createElement('button', 'sj-datepicker__title')
  title.type = 'button'
  title.setAttribute('aria-expanded', 'false')
  const next = createElement('button', 'sj-datepicker__step', '›')
  next.type = 'button'
  next.setAttribute('aria-label', 'Next month')
  const close = createElement('button', 'sj-datepicker__close', '×')
  close.type = 'button'
  close.dataset.dialogClose = ''
  close.setAttribute('aria-label', 'Close')
  head.append(previous, title, next, close)

  const weekdays = createElement('div', 'sj-datepicker__weekdays')
  DATE_WEEKDAYS.forEach((day) => weekdays.append(createElement('span', '', day)))
  const grid = createElement('div', 'sj-datepicker__grid')
  grid.setAttribute('role', 'grid')
  grid.setAttribute('aria-label', label)
  const jump = createElement('div', 'sj-datepicker__jump')
  jump.hidden = true
  inner.append(head, weekdays, grid, jump)
  dialog.append(inner)

  const publish = () => {
    const value = selected ? `${pad2(selected.day)}.${pad2(selected.month + 1)}.${selected.year}` : ''
    valueText.textContent = value || (field?.placeholder || 'DD.MM.YYYY')
    valueText.classList.toggle('sj-datefield__value--empty', !value)
    trigger.setAttribute('aria-label', value ? `${label}: ${value}. Change date` : `Choose ${label.toLowerCase()}`)
    if (source.value === value) return
    source.value = value
    source.dispatchEvent(new Event('input', { bubbles: true }))
    source.dispatchEvent(new Event('change', { bubbles: true }))
  }

  const renderGrid = () => {
    title.textContent = `${DATE_MONTHS[viewMonth]} ${viewYear}`
    previous.disabled = viewYear === DATE_MIN_YEAR && viewMonth === 0
    next.disabled = viewYear === DATE_MAX_YEAR && viewMonth === 11
    grid.textContent = ''
    for (let blank = 0; blank < firstWeekday(viewYear, viewMonth); blank += 1) {
      grid.append(createElement('span', 'sj-datepicker__blank'))
    }
    const total = daysInMonth(viewYear, viewMonth)
    for (let day = 1; day <= total; day += 1) {
      const cell = createElement('button', 'sj-datepicker__day', String(day))
      cell.type = 'button'
      cell.dataset.dateDay = String(day)
      const isSelected = Boolean(selected) && selected.year === viewYear
        && selected.month === viewMonth && selected.day === day
      if (isSelected) cell.classList.add('sj-datepicker__day--selected')
      cell.setAttribute('aria-pressed', isSelected ? 'true' : 'false')
      /* Roving tabindex: one stop for the whole grid, arrows move within it. */
      cell.tabIndex = isSelected || (!selected && day === 1) ? 0 : -1
      grid.append(cell)
    }
  }

  const renderJump = () => {
    jump.textContent = ''
    const months = createElement('div', 'sj-datepicker__jump-months')
    DATE_MONTHS.forEach((name, index) => {
      const button = createElement('button', 'sj-datepicker__jump-month', name.slice(0, 3))
      button.type = 'button'
      button.dataset.jumpMonth = String(index)
      if (index === viewMonth) button.classList.add('is-current')
      months.append(button)
    })
    const years = createElement('div', 'sj-datepicker__jump-years')
    for (let year = DATE_MAX_YEAR; year >= DATE_MIN_YEAR; year -= 1) {
      const button = createElement('button', 'sj-datepicker__jump-year', String(year))
      button.type = 'button'
      button.dataset.jumpYear = String(year)
      if (year === viewYear) button.classList.add('is-current')
      years.append(button)
    }
    jump.append(months, years)
    requestAnimationFrame(() => years.querySelector('.is-current')?.scrollIntoView({ block: 'center' }))
  }

  const setJump = (open) => {
    jump.hidden = !open
    grid.hidden = open
    weekdays.hidden = open
    title.setAttribute('aria-expanded', open ? 'true' : 'false')
    if (open) renderJump()
  }

  const shiftMonth = (delta) => {
    const moved = new Date(viewYear, viewMonth + delta, 1)
    if (moved.getFullYear() < DATE_MIN_YEAR || moved.getFullYear() > DATE_MAX_YEAR) return
    viewYear = moved.getFullYear()
    viewMonth = moved.getMonth()
    renderGrid()
  }

  previous.addEventListener('click', () => shiftMonth(-1))
  next.addEventListener('click', () => shiftMonth(1))
  title.addEventListener('click', () => setJump(jump.hidden))

  jump.addEventListener('click', (event) => {
    const month = event.target.closest('[data-jump-month]')
    const year = event.target.closest('[data-jump-year]')
    if (month) viewMonth = Number(month.dataset.jumpMonth)
    if (year) viewYear = Number(year.dataset.jumpYear)
    if (!month && !year) return
    renderGrid()
    /*
      The MONTH is the last step, so picking one returns to the grid; picking a year keeps the panel
      open so the month can follow. Waiting for both in one click — which is what this did first —
      meant the panel never closed and the days stayed hidden behind it.
    */
    if (month) setJump(false)
    else renderJump()
  })

  grid.addEventListener('click', (event) => {
    const cell = event.target.closest('[data-date-day]')
    if (!cell) return
    selected = { year: viewYear, month: viewMonth, day: Number(cell.dataset.dateDay) }
    publish()
    closeDialog(dialog)
  })

  /* Arrows walk the month the way a calendar reads; the grid keeps one tab stop. */
  grid.addEventListener('keydown', (event) => {
    const step = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[event.key]
    if (!step) return
    const cell = event.target.closest('[data-date-day]')
    if (!cell) return
    event.preventDefault()
    const target = Number(cell.dataset.dateDay) + step
    const landing = grid.querySelector(`[data-date-day="${target}"]`)
    if (landing) {
      cell.tabIndex = -1
      landing.tabIndex = 0
      landing.focus()
      return
    }
    /* Off the end of the month: move the view and keep walking. */
    shiftMonth(step > 0 ? 1 : -1)
    const wrapped = step > 0
      ? grid.querySelector('[data-date-day="1"]')
      : grid.querySelector('[data-date-day]:last-of-type')
    if (wrapped) {
      grid.querySelectorAll('[data-date-day]').forEach((day) => { day.tabIndex = -1 })
      wrapped.tabIndex = 0
      wrapped.focus()
    }
  })

  trigger.addEventListener('click', () => {
    if (selected) {
      viewYear = selected.year
      viewMonth = selected.month
    }
    setJump(false)
    renderGrid()
    openDialog(dialog, trigger)
    requestAnimationFrame(() => grid.querySelector('[tabindex="0"]')?.focus())
  })

  publish()
  renderGrid()
  source.insertAdjacentElement('afterend', trigger)
  trigger.insertAdjacentElement('afterend', dialog)
  /*
    buildField renders `help` for the controls it knows about, and it never saw this one, so a help
    line declared on the contract was silently dropped. Rendered here rather than removed from the
    contract: "engraved exactly as you enter it" is the reassurance a customer wants before putting
    a date onto metal, and a contract key that does nothing is worse than either.
  */
  const help = field?.help ? String(field.help) : ''
  if (help && !wrapper.querySelector('.sj-personalization-field__help')) {
    dialog.insertAdjacentElement('afterend', createElement('p', 'sj-personalization-field__help', help))
  }
  return true
}

/*
  Runs for every configurator, because a date is a plain typed answer whichever one owns the form.
  Matched by contract INDEX rather than by title: part one rewrites display titles through the
  fulfilment shortener, and its own comment warns that behaviour must not key off them.
*/
/*
  A pair the contract wants kept on one row.

  The shared half-width floor is 12rem, chosen so a name box stays comfortable, and two of them plus
  the gap need ~400px — more than a phone's personalizer column, so they wrap. That is the right
  default and it is not being changed for everyone. The single_initial pair already had the same
  problem and was given its own floor; this is the same remedy for fields that declare they belong
  side by side, and like that one it is declared by the CONTRACT rather than by handle.

  Owner, 2026-08-30: "Name'leri tek satıra sığdır yan yana."
*/
const applyTightPairs = (form, fields) => {
  ;(Array.isArray(fields) ? fields : []).forEach((field, index) => {
    if (field?.input_width !== 'half' || field?.pair_tight !== true) return
    form.querySelector(`[data-personalization-field][data-field-index="${index}"]`)
      ?.classList.add('sj-personalization-field--half-tight')
  })
}

const initializeDateFields = (form, fields) => {
  let built = 0
  ;(Array.isArray(fields) ? fields : []).forEach((field, index) => {
    if (String(field?.format || '').toLowerCase() !== 'date') return
    const wrapper = form.querySelector(`[data-personalization-field][data-field-index="${index}"]`)
    if (enhanceDateField(wrapper, field)) built += 1
  })
  return built > 0
}

const groupPersonalizationFields = (container) => {
  if (!container) return
  const wrappers = [...container.querySelectorAll(':scope > [data-personalization-field][data-field-group]')]
  let index = 0
  while (index < wrappers.length) {
    const name = wrappers[index].dataset.fieldGroup
    const run = []
    while (index < wrappers.length && wrappers[index].dataset.fieldGroup === name) run.push(wrappers[index++])
    /*
      A run of one still gets its caption. The necklace's stone sits beside the earrings' pair and
      the two captions are what say which is which; captioning only the pair left the third slot
      floating unlabelled at a different height, reading as an afterthought rather than as the other
      half of the set.
    */
    if (!run.length) continue
    const group = createElement('fieldset', 'sj-personalization-group')
    group.dataset.personalizationGroup = name
    const legend = createElement('legend', 'sj-personalization-group__legend', name)
    /*
      The slots get their own row inside the group.

      With the legend as a flex sibling of the slots, the browser sizes the group as though caption
      and slots shared a line — the caption's width was added to the row even though it renders
      above — so the Earrings group reserved ~240px for 160px of buttons and the necklace beside it
      wrapped away on every screen narrower than a desktop.
    */
    const slots = createElement('div', 'sj-personalization-group__slots')
    group.append(legend, slots)
    run[0].before(group)
    run.forEach((wrapper) => {
      slots.append(wrapper)
      /*
        A lone slot whose field is named after its group says the same word twice — the necklace's
        stone was captioned NECKLACE and then labelled NECKLACE again directly underneath. The
        caption is the one that survives, because it is what pairs it with EARRINGS beside it; the
        control keeps its accessible name either way.
      */
      const own = wrapper.querySelector('.sj-label')
      const sameWord = String(wrapper.dataset.fieldTitle || '').trim().toLocaleLowerCase() === name.trim().toLocaleLowerCase()
      if (own && run.length === 1 && sameWord) own.classList.add('sj-visually-hidden')
    })
  }
}

/*
  Some compatibility profiles contain only fields that apply to one native variant value. The
  shared condition resolver already hides those fields, but the inline personalizer used to leave
  its heading and help copy behind as an empty promise. Keep that panel in the same state as its
  fields. This is deliberately limited to inline profiles whose real fields are ALL conditional;
  token, staged, mixed conditional/unconditional and ordinary inline contracts are untouched.
*/
const syncConditionalPersonalizerVisibility = (form) => {
  const details = form.querySelector('[data-sj-personalizer]')
  if (!details || details.dataset.personalizerMode !== 'inline') return
  const fields = [...details.querySelectorAll(
    '[data-generic-personalizer] [data-personalization-field]:not(.sj-personalization-instruction)'
  )]
  if (!fields.length) return
  const isConditional = (field) => [
    'conditionalOption', 'conditionalValue', 'conditionalOptionName',
    'conditionalFieldTitle', 'conditionalRoles', 'conditionalValues'
  ].some((key) => field.dataset[key] != null && field.dataset[key] !== '' && field.dataset[key] !== '[]')
  if (!fields.every(isConditional)) return
  const hasApplicableField = fields.some((field) => !field.hidden)
  details.toggleAttribute('hidden', !hasApplicableField)
  if (hasApplicableField) details.open = true
}

const initializePersonalization = (form) => {
const schemaNode = form.querySelector('[data-personalization-schema]')
const schema = parsePersonalizationSchema(schemaNode)
const container = form.querySelector('[data-personalization-fields]')
if (!schema || !container) return
let fields = Array.isArray(schema.fields) ? schema.fields : Array.isArray(schema.virtual_options) ? schema.virtual_options : []
if (Array.isArray(schema.groups)) {
  fields = schema.groups.flatMap((group) => {
    const groupSchema = group?.schema
    if (Array.isArray(groupSchema)) return groupSchema
    if (Array.isArray(groupSchema?.fields)) return groupSchema.fields
    if (Array.isArray(groupSchema?.virtual_options)) return groupSchema.virtual_options
    return []
  })
}
const baseContainer = form.querySelector('[data-personalization-base-fields]')
const baseWrap = form.querySelector('[data-personalization-base-wrap]')
const productHandle = form.dataset.productHandle || ''
const materialLabel = form.querySelector('[data-sj-personalizer]')?.dataset.materialLabel || ''
const personalFields = []
fields.forEach((field, index) => {
  const element = buildField(field, index, productHandle, materialLabel)
  if (personalizationStage(field) === 'base' && baseContainer) {
    baseContainer.append(element)
  } else {
    container.append(element)
    personalFields.push(field)
  }
})
/*
  Consecutive fields that name the same `group` are wrapped together and captioned once.

  The necklace-and-earrings set asks for three stones: two that belong to the pair of earrings and
  one for the necklace. Three separately titled fields describe that as three unrelated questions;
  the shopper is buying one set and reads it as "the earrings, and the necklace". A fieldset with a
  legend is the honest markup for it — a screen reader announces the group before each slot, which is
  exactly the relationship the caption draws.
*/
groupPersonalizationFields(container)
if (baseContainer?.children.length) baseWrap?.removeAttribute('hidden')
/* Must run BEFORE the initializers below: the font picker locates its chart by URL, and
   it now reads the reference area instead of the in-form instruction fields. */
publishGuideCharts(form)
const hasPersonalInput = personalFields.some((field) => String(field.type || 'text').toLowerCase() !== 'instructions')
const contract = personalizationContract(form)
const hasContractConfigurator = initializeContractConfigurator(form, fields)
const declaredContract = form.querySelector('[data-sj-personalizer]')?.dataset.personalizationContract || ''
const hasPositionConfigurator = hasContractConfigurator || declaredContract !== 'paired-letter-stone'
  ? false
  : initializePositionConfigurator(form, fields)
const hasInlinePersonalizer = hasPersonalInput && !hasContractConfigurator && !hasPositionConfigurator
  ? initializeInlinePersonalizer(form, contract)
  : false
/*
  A field-level visual chooser binds to ITS OWN field, so it must run whichever configurator owns the
  form. The hexagon pendant is the case that made this necessary: a token configurator claims the
  form for the four initials, and the birthstone beside them stayed a plain dropdown because the
  per-field enhancer only ran inside initializeInlinePersonalizer, which that product never reaches.
  Enhancing here — after every configurator has taken what it wanted, before the unclaimed-control
  check below — leaves the owning configurator untouched and upgrades only fields nothing claimed.
*/
if (!hasInlinePersonalizer) {
  initializeMediaChoiceFields(form, contract)
  /* The configurator has already rendered once by now, so its centre slot is empty until this. */
  placeCentreChoice(form)
}
/* Outside that guard on purpose: a date is a typed answer no configurator claims. */
applyTightPairs(form, fields)
initializeDateFields(form, fields)
/*
  Read the routing contract directly rather than through personalizationContract(), which returns
  null for anything with an empty vocabulary. That gate is right for pickers — a token picker with
  no tokens is broken — but a composite of a font list and a name box has no token vocabulary at
  all and is perfectly well formed, so going through the helper silently skipped exactly the
  contracts this writer exists for.

  Installed only when no configurator claimed the form; where one did, syncProperties owns the key.
*/
if (!hasContractConfigurator) {
  const routing = parsePersonalizationSchema(
    form.querySelector('[data-personalization-contract-schema]'))
  if (String(routing?.serializer?.kind || '') === 'composite_property') {
    installCompositeProperty(form, routing)
  }
}
if (!hasPersonalInput && !hasContractConfigurator && !hasPositionConfigurator && !hasInlinePersonalizer) {
  form.dataset.baseOnly = 'true'
  form.querySelector('[data-personalize-start]')?.setAttribute('hidden', '')
  form.querySelector('[data-sj-personalizer]')?.setAttribute('hidden', '')
  form.querySelector('[data-product-submit]')?.removeAttribute('hidden')
  if (!fields.length) productScope().querySelector('[data-production-summary]')?.setAttribute('hidden', '')
}
/* A structured control that no configurator claimed would be a bare text box wearing a
   structured label. Fail the form closed instead of shipping it. */
const unclaimed = unclaimedStructuredControls(form)
if (unclaimed.length && schemaNode.dataset.schemaSource === 'structured-profile') {
  form.dataset.profileBlocked = 'true'
  form.dataset.profileBlockedReason = `unclaimed structured control: ${unclaimed.map((w) => w.dataset.structuredControl).join(', ')}`
}
form.dataset.personalizationSource = schemaNode.dataset.schemaSource || 'unknown'
const resolutionNode = form.querySelector('[data-personalization-contract-schema]')
const resolutionContract = parsePersonalizationSchema(resolutionNode)
form.dataset.personalizationResolutionSource = resolutionNode?.dataset.resolutionSource
  || resolutionContract?.source
  || 'none'
updatePersonalizationConditions(form)
updateProductionSummary(form)
}

/*
  Also in part two, for the same reason as the fan-out below it: part one is at Shopify's 256 KB
  per-file cap. It is called from initializeProductForms, which is in this file.
*/
/*
  Owner instruction, 2026-08-21, asked twice: the Love Knot couples bracelet must not show a
  Quantity selection.

  Quantity is a REAL Shopify variant axis on that product — Single $49.50, 2 Pieces $78.10 — so it
  is hidden here, in the theme, rather than deleted from the product. No variant, price, SKU,
  inventory or status is touched, and the change is undone by emptying the map below.

  The axis is hidden rather than removed from the DOM on purpose: the variant resolver reads a
  value from every option group, and a group that simply vanishes leaves the form unable to pick a
  variant at all. It stays in the document, pinned to the value named here, and is taken out of the
  accessibility tree and the tab order so nothing announces or focuses a choice the shopper no
  longer has.

  WHAT THIS COSTS, plainly: with the axis pinned, this page can only sell the pinned variant, so
  2 Pieces is no longer reachable from the product page. That is what removing the choice means —
  the pair was what the second price bought.
*/
const SJ_PINNED_OPTIONS = {
  'love-knot-bracelet-for-couples': { Quantity: 'Single' }
}

const pinSuppressedOptions = (form) => {
  const pins = SJ_PINNED_OPTIONS[String(form.dataset.productHandle || '')]
  if (!pins) return
  for (const [optionName, value] of Object.entries(pins)) {
    const fieldset = [...form.querySelectorAll('fieldset[data-option-index]')].find((group) => (
      String(group.dataset.optionLabel || group.dataset.nativeOptionLabel || '').trim().toLocaleLowerCase()
        === optionName.trim().toLocaleLowerCase()
    ))
    if (!fieldset || fieldset.dataset.sjOptionPinned === 'true') continue
    const inputs = [...fieldset.querySelectorAll('input[type="radio"]')]
    const wanted = inputs.find((input) => input.value === value) || inputs.find((input) => !input.disabled)
    if (!wanted) continue
    if (!wanted.checked) {
      wanted.checked = true
      wanted.dispatchEvent(new Event('change', { bubbles: true }))
    }
    fieldset.dataset.sjOptionPinned = 'true'
    fieldset.hidden = true
    fieldset.setAttribute('aria-hidden', 'true')
    inputs.forEach((input) => { input.tabIndex = -1 })
  }
}


const initializeNativeFontPickers = (form) => {
const chart = tokenPhotograph('font', 'Font 1')
if (!chart) return
form.querySelectorAll('[data-option-role="font_choice"]').forEach((fieldset) => {
  if (fieldset.dataset.nativeFontPickerInitialized === 'true') return
  const source = fieldset.querySelector('.sj-options')
  const inputs = [...fieldset.querySelectorAll('input[type="radio"]')]
  if (!source || !inputs.length) return
  const chartCovered = inputs
    .filter((input) => input.value !== 'Your Handwriting')
    .every((input) => /^Font\s+(?:10|[1-9])$/i.test(input.value))
  if (!chartCovered) return
  fieldset.dataset.nativeFontPickerInitialized = 'true'
  source.hidden = true
  inputs.forEach((input) => { input.tabIndex = -1 })

  const optionIndex = fieldset.dataset.optionIndex || 'font'
  const productKey = `${String(form.dataset.productHandle || 'product')}-${form.getAttribute('id') || 'form'}`
    .replace(/[^a-z0-9_-]+/gi, '-')
  const dialogId = `SilveristicNativeFontPicker-${productKey}-${optionIndex}`
  const titleId = `${dialogId}-Title`
  const control = createElement('div', 'sj-font-picker-control sj-native-font-picker-control')
  control.dataset.nativeFontPickerControl = ''
  const trigger = createElement('button', 'sj-font-picker__trigger')
  trigger.type = 'button'
  trigger.dataset.nativeFontPickerOpen = ''
  trigger.setAttribute('aria-haspopup', 'dialog')
  trigger.setAttribute('aria-controls', dialogId)
  trigger.setAttribute('aria-expanded', 'false')
  const triggerCopy = createElement('span', 'sj-font-picker__trigger-copy')
  const triggerValue = createElement('span', 'sj-font-picker__trigger-value')
  const triggerHint = createElement('span', 'sj-font-picker__trigger-hint', sjUi.compare_full_chart)
  triggerCopy.append(triggerValue, triggerHint)
  const triggerIcon = createElement('span', 'sj-font-picker__trigger-icon', '⌄')
  triggerIcon.setAttribute('aria-hidden', 'true')
  trigger.append(triggerCopy, triggerIcon)
  control.append(trigger)
  source.insertAdjacentElement('afterend', control)

  const dialog = createElement('dialog', 'sj-font-picker sj-native-font-picker')
  dialog.id = dialogId
  dialog.dataset.nativeFontPicker = ''
  dialog.setAttribute('aria-labelledby', titleId)
  const chartChoices = inputs.map((input) => {
    const number = Number(String(input.value).match(/^Font\s+(10|[1-9])$/i)?.[1])
    const name = Number.isFinite(number) ? compatibilityFontNames[number - 1] : sjUi.customer_style
    return fontChartChoice(input.value, name, input.disabled)
  })
  const extraChoices = inputs.filter((input) => !fontChartChoice(input.value, input.value)).map((input) => {
    return `<button class="sj-font-picker__choice" type="button" data-native-font-choice="${escapeMarkup(input.value)}" aria-label="${escapeMarkup(sjUiText('choose_dynamic', { __VALUE__: input.value }))}" aria-pressed="false"${input.disabled ? ' disabled' : ''}><strong>${escapeMarkup(input.value)}</strong><span>${escapeMarkup(sjUi.customer_style)}</span></button>`
  }).join('')
  const chartMarkup = fontChartMapMarkup({ imageUrl: chart, width: 1200, height: 900, choices: chartChoices, choiceAttribute: 'data-native-font-choice' })
  const extrasMarkup = extraChoices ? `<div class="sj-font-picker__choices" aria-label="${escapeMarkup(sjUi.additional_font_choices)}">${extraChoices}</div>` : ''
  dialog.innerHTML = `<div class="sj-font-picker__inner"><div class="sj-font-picker__head"><div><h2 id="${titleId}">${escapeMarkup(sjUi.choose_font)}</h2><p>${escapeMarkup(sjUi.font_tap)}</p></div><button class="sj-font-picker__close" type="button" data-dialog-close aria-label="${escapeMarkup(sjUi.close_font_picker)}">×</button></div>${chartMarkup}<p class="sj-font-picker__mobile-hint">${escapeMarkup(sjUi.font_swipe)}</p>${extrasMarkup}<p class="sj-font-picker__note">${escapeMarkup(sjUi.visual_variant_note)}</p></div>`
  document.body.append(dialog)
  form._sjDetachedDialogs = (form._sjDetachedDialogs || []).concat(dialog)

  const sync = () => {
    const selected = inputs.find((input) => input.checked) || inputs[0]
    triggerValue.textContent = selected?.value || sjUi.choose_font
    trigger.setAttribute('aria-label', selected?.value ? sjUiText('selected_change', { __VALUE__: selected.value }) : sjUi.choose_font)
    dialog.querySelectorAll('[data-native-font-choice]').forEach((choice) => {
      choice.setAttribute('aria-pressed', String(choice.dataset.nativeFontChoice === selected?.value))
    })
  }
  trigger.addEventListener('click', () => {
    trigger.setAttribute('aria-expanded', 'true')
    openDialog(dialog, trigger)
    requestAnimationFrame(() => {
      const selected = dialog.querySelector('[data-native-font-choice][aria-pressed="true"]')
      ;(selected || dialog.querySelector('[data-native-font-choice]:not([disabled])'))?.focus()
    })
  })
  dialog.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-native-font-choice]')
    if (!choice || choice.disabled) return
    const input = inputs.find((candidate) => candidate.value === choice.dataset.nativeFontChoice)
    if (!input) return
    input.checked = true
    sync()
    input.dispatchEvent(new Event('change', { bubbles: true }))
    closeDialog(dialog)
  })
  dialog.addEventListener('close', () => trigger.setAttribute('aria-expanded', 'false'))
  fieldset.addEventListener('change', sync)
  sync()
})
}

/*
  Lives in part two because part one reached Shopify's 256 KB per-file cap. The two files are
  ONE module, concatenated in order into assets/sj-global.js, so everything this uses from part
  one — createElement, openDialog, tokenPhotograph, updateProductForm — is already defined.
*/
/*
  ONE product page, SEVERAL line items.

  The stacking ring is bought as a set: the shopper says how many rings, then chooses that many
  birthstone designs. Every design is already a real Shopify variant with its own inventory, so the
  honest way to sell three of them is three line items — not one line item carrying two extra months
  in a text property, and not a "3 Rings" option that would have to carry a price the variant
  matrix does not know about. Three real lines means the price is the sum of three real prices, the
  stock of each month actually moves, and the workshop reads the order without decoding anything.

  What this replaces on the page: an open grid of twelve photographs that could only ever be ONE
  choice, because Style is a variant axis. The grid is hidden — its radios stay as the authoritative
  variant input for the first ring, so price, availability and gallery media keep following the
  selection — and a button opens the same photographs as a dialog the shopper stays inside until
  every ring is chosen. Owner instruction, 2026-08-20.

  Declared per product by the contract's `fan_out` block, never by handle.
*/
const initializeFanOutSelection = (form) => {
if (form._sjFanOut) return true
/* Read the routing node directly, not through personalizationContract(): that helper returns null
   for a contract with no token vocabulary, and a fan-out product deliberately has none — its
   choices are real variants, not tokens. */
const contract = parsePersonalizationSchema(form.querySelector('[data-personalization-contract-schema]'))
const fan = contract?.fan_out
if (!fan || !fan.axis) return false

const axis = String(fan.axis)
const fieldset = [...form.querySelectorAll('[data-option-index]')]
  .find((group) => String(group.dataset.nativeOptionLabel || '').trim() === axis)
const options = fieldset?.querySelector('.sj-options')
const inputs = fieldset ? [...fieldset.querySelectorAll('input[type="radio"]')] : []
/* No axis, no fan-out. Failing quiet here would leave a product with a button and nothing behind
   it; failing closed leaves the ordinary variant grid, which still sells the piece. */
if (!fieldset || !options || inputs.length < 2) return false

const max = Math.min(Number(fan.max) || 5, inputs.length)
const countTitle = String(fan.count_title || 'How many')
const unit = String(fan.unit || 'item')
const unitPlural = String(fan.unit_plural || `${unit}s`)
const photoType = String(fan.photo_type || '')

const labelFor = (value) => {
  const raw = String(value)
  const tail = String(fan.strip_suffix || '')
  return tail && raw.endsWith(tail) ? raw.slice(0, -tail.length).trim() : raw
}
const photoFor = (value) => (photoType ? tokenPhotograph(photoType, value) : null)

options.hidden = true
inputs.forEach((input) => { input.tabIndex = -1 })
/* The heading described a grid of twelve designs. It now sits above a button that opens them and a
   strip of the ones chosen, so it says that instead. data-option-label is untouched — the runtime
   and the QA suites match on it. */
const axisLegend = fieldset.querySelector('legend')
if (axisLegend && fan.axis_legend) axisLegend.textContent = String(fan.axis_legend)

const state = { count: null, picks: [] }
const productKey = `${String(form.dataset.productHandle || 'product')}`.replace(/[^a-z0-9_-]+/gi, '-')
const dialogId = `SilveristicFanOut-${productKey}`
const titleId = `${dialogId}-Title`

/* ---- how many ---- */
const countFieldset = createElement('fieldset', 'sj-fieldset sj-fanout__count')
countFieldset.dataset.fanoutCount = ''
countFieldset.append(createElement('legend', 'sj-legend', countTitle))
const countRow = createElement('div', 'sj-options sj-options--size')
for (let n = 1; n <= max; n += 1) {
  const label = createElement('label', 'sj-option')
  const input = document.createElement('input')
  input.type = 'radio'
  input.name = `sj-fanout-count-${productKey}`
  input.value = String(n)
  /* Deliberately NOT a properties[] input: the number is implied by how many lines reach the cart,
     and posting it as well would put a second, unpriced copy of the same fact on the order. */
  label.append(input, createElement('span', '', String(n)))
  countRow.append(label)
}
countFieldset.append(countRow)
countFieldset.append(createElement('p', 'sj-option-note',
  `Each ${unit} is chosen separately and arrives as its own piece.`))
/*
  Order of the questions, and why this one moves.

  A base-stage question — the ring size — renders after every native axis, which put it below the
  choosing. On a set that reads wrong: the size is a fact about the wearer, decided once, while the
  designs are the part being composed. Owner instruction, 2026-08-20: size comes straight after the
  metal colour. Moved only on fan-out products, so nothing else changes shape.
*/
const baseWrap = form.querySelector('[data-personalization-base-wrap]')
if (baseWrap && baseWrap.querySelector('fieldset, input, select')) fieldset.before(baseWrap)
fieldset.before(countFieldset)

/* ---- the trigger and the preview of what was chosen ---- */
const control = createElement('div', 'sj-fanout')
const trigger = createElement('button', 'sj-button sj-button--secondary sj-fanout__trigger')
trigger.type = 'button'
trigger.dataset.fanoutOpen = ''
trigger.setAttribute('aria-haspopup', 'dialog')
trigger.setAttribute('aria-controls', dialogId)
trigger.disabled = true
const preview = createElement('div', 'sj-fanout__preview')
preview.dataset.fanoutPreview = ''
control.append(trigger, preview)
options.after(control)

/* ---- the dialog the shopper stays inside ---- */
const dialog = createElement('dialog', 'sj-token-picker sj-fanout__dialog')
dialog.id = dialogId
dialog.dataset.fanoutDialog = ''
dialog.setAttribute('aria-labelledby', titleId)
const head = createElement('div', 'sj-token-picker__head')
const heading = createElement('h2', 'sj-token-picker__title', String(fan.heading || countTitle))
heading.id = titleId
const progress = createElement('p', 'sj-token-picker__hint')
progress.dataset.fanoutProgress = ''
progress.setAttribute('role', 'status')
const close = createElement('button', 'sj-token-picker__close', '×')
close.type = 'button'
close.dataset.fanoutClose = ''
close.setAttribute('aria-label', 'Close')
head.append(heading, progress, close)
const grid = createElement('div', 'sj-token-picker__grid')
inputs.forEach((input) => {
  const choice = createElement('button', 'sj-token-picker__choice')
  choice.type = 'button'
  choice.dataset.fanoutChoice = input.value
  if (input.disabled) choice.disabled = true
  const photograph = photoFor(input.value)
  if (photograph) {
    choice.classList.add('sj-token-picker__choice--photo')
    const photo = createElement('span', 'sj-token-picker__photo')
    photo.style.setProperty('--sj-token-photo', `url('${photograph}')`)
    photo.setAttribute('aria-hidden', 'true')
    choice.append(photo)
  }
  choice.append(createElement('span', '', labelFor(input.value)))
  const tally = createElement('small', 'sj-fanout__tally')
  tally.dataset.fanoutTally = ''
  choice.append(tally)
  grid.append(choice)
})
const done = createElement('button', 'sj-button sj-fanout__done')
done.type = 'button'
done.dataset.fanoutClose = ''
const chosenInside = createElement('div', 'sj-fanout__preview sj-fanout__preview--inside')
chosenInside.dataset.fanoutPreview = ''
const actions = createElement('div', 'sj-fanout__actions')
actions.append(done)
/* The chosen strip is repeated inside the dialog so a shopper can undo a tap without closing it —
   "without ever leaving the pop-up" has to include changing your mind. */
dialog.append(head, grid, chosenInside, actions)
form.append(dialog)

const chosenSummary = () => state.picks.map(labelFor).join(' · ')

const paint = () => {
  const remaining = state.count === null ? null : state.count - state.picks.length
  trigger.disabled = state.count === null
  /* The shared hierarchical CTA owns every incomplete step. This local control returns only after
     completion, when it has a distinct purpose: editing an already complete ring set. */
  trigger.hidden = state.count === null || remaining > 0
  trigger.textContent = state.count === null
    ? `Choose how many ${unitPlural} first`
    : state.picks.length === 0
      ? `Choose your ${state.count === 1 ? unit : unitPlural}`
      : remaining > 0
        ? `Choose ${remaining} more`
        : `Change your ${state.count === 1 ? unit : unitPlural}`
  trigger.setAttribute('aria-expanded', dialog.open ? 'true' : 'false')

  /* Only what was actually chosen is shown — the twelve-photograph wall is what the shopper asked
     to stop seeing. */
  const chip = (value, index) => {
    const item = createElement('span', 'sj-fanout__chip')
    const photograph = photoFor(value)
    if (photograph) {
      const photo = createElement('i', 'sj-fanout__chip-photo')
      photo.style.setProperty('--sj-token-photo', `url('${photograph}')`)
      photo.setAttribute('aria-hidden', 'true')
      item.append(photo)
    }
    item.append(createElement('span', '', labelFor(value)))
    const remove = createElement('button', 'sj-fanout__chip-remove', '×')
    remove.type = 'button'
    remove.dataset.fanoutRemove = String(index)
    remove.setAttribute('aria-label', `Remove ${labelFor(value)}`)
    item.append(remove)
    return item
  }
  for (const strip of [preview, chosenInside]) {
    strip.replaceChildren(...state.picks.map(chip))
    strip.hidden = state.picks.length === 0
  }

  progress.textContent = state.count === null
    ? ''
    : `${state.picks.length} of ${state.count} chosen`
  done.textContent = remaining !== null && remaining > 0 ? `Choose ${remaining} more` : 'Done'
  done.disabled = remaining !== null && remaining > 0

  grid.querySelectorAll('[data-fanout-choice]').forEach((choice) => {
    const value = choice.dataset.fanoutChoice
    const times = state.picks.filter((pick) => pick === value).length
    choice.setAttribute('aria-pressed', times > 0 ? 'true' : 'false')
    choice.classList.toggle('is-chosen', times > 0)
    const tally = choice.querySelector('[data-fanout-tally]')
    if (tally) tally.textContent = times > 1 ? `×${times}` : ''
    /* Full is full: once the last piece is chosen nothing more can be added, so no design invites a
       tap that would do nothing. Removing one on the strip re-opens them all. */
    choice.disabled = remaining === 0
  })

  /* The first chosen design stays the real variant, so price, availability, the gallery and the
     variant in the URL all keep following something the shopper actually picked. */
  const primary = state.picks[0]
  if (primary) {
    const input = inputs.find((entry) => entry.value === primary)
    if (input && !input.checked) {
      input.checked = true
      input.dispatchEvent(new Event('change', { bubbles: true }))
      return
    }
  }
  updateProductForm(form)
  /* Fan-out choices are buttons, not native input events. Re-resolve the shared CTA immediately so
     the last chosen ring changes "Choose your rings" into Add to cart in the same tick. */
  renderPrimaryCta(form)
  document.dispatchEvent(new CustomEvent('silveristic:configurator-change', { detail: { form } }))
}

countRow.addEventListener('change', (event) => {
  const input = event.target.closest('input[type="radio"]')
  if (!input) return
  state.count = Number(input.value)
  /* Trimming from the end keeps the choices already made rather than starting the shopper over. */
  if (state.picks.length > state.count) state.picks.length = state.count
  paint()
  if (state.picks.length < state.count) openDialog(dialog, trigger)
})

trigger.addEventListener('click', () => { if (state.count !== null) openDialog(dialog, trigger) })
dialog.addEventListener('close', () => { trigger.setAttribute('aria-expanded', 'false'); paint() })

dialog.addEventListener('click', (event) => {
  if (event.target.closest('[data-fanout-close]')) { closeDialog(dialog); return }
  const choice = event.target.closest('[data-fanout-choice]')
  if (!choice || choice.disabled) return
  const value = choice.dataset.fanoutChoice
  /* A tap ADDS, it never removes: two January rings is a real order, and a design that unselected
     itself on a second tap made that impossible to ask for. Removing is done on the chosen strip,
     which is inside the dialog too so nobody has to leave it to change their mind. */
  if (state.picks.length < state.count) state.picks.push(value)
  paint()
  /* Closing on the last choice is the whole point of "without leaving the pop-up": the shopper is
     finished, so the page says so instead of waiting to be dismissed. */
  if (state.picks.length === state.count) window.setTimeout(() => closeDialog(dialog), 220)
})

const removeHandler = (event) => {
  const remove = event.target.closest('[data-fanout-remove]')
  if (!remove) return
  event.stopPropagation()
  state.picks.splice(Number(remove.dataset.fanoutRemove), 1)
  paint()
}
preview.addEventListener('click', removeHandler)
chosenInside.addEventListener('click', removeHandler)

form._sjFanOut = {
  element: countFieldset,
  trigger,
  axis,
  unit,
  unitPlural,
  get count() { return state.count },
  get picks() { return state.picks.slice() },
  activate: () => {
    if (state.count !== null) {
      openDialog(dialog, trigger)
      return
    }
    countFieldset.scrollIntoView({ block: 'center',
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
    countRow.querySelector('input:not([disabled])')?.focus({ preventScroll: true })
  },
  complete: () => state.count !== null && state.picks.length === state.count,
  missingLabel: () => (state.count === null
    ? `how many ${unitPlural}`
    : `your ${state.count === 1 ? unit : unitPlural}`),
  summary: chosenSummary,
  /* One line per chosen design, collapsed by quantity when the same design is chosen twice. */
  lineItems: (variants) => {
    const selections = [...form.querySelectorAll('[data-option-index]')].reduce((result, group) => {
      const selected = group.querySelector('input:checked, select')
      result[Number(group.dataset.optionIndex)] = selected?.value || ''
      return result
    }, [])
    const axisIndex = Number(fieldset.dataset.optionIndex)
    const counts = new Map()
    state.picks.forEach((value) => counts.set(value, (counts.get(value) || 0) + 1))
    const items = []
    for (const [value, quantity] of counts) {
      const wanted = selections.slice()
      wanted[axisIndex] = value
      const variant = variants.find((entry) => entry.options.every((option, index) => option === wanted[index]))
      if (!variant) return null
      items.push({ id: variant.id, quantity })
    }
    return items
  }
}

paint()
return true
}

const initializeProductForms = (root = document) => {
root.querySelectorAll('[data-sj-product-form]').forEach((form) => {
  if (form.dataset.sjInitialized === 'true') return
  form.dataset.sjInitialized = 'true'
  standardizeNativeOptionOrder(form)
  initializeNativeFontPickers(form)
  /* Before anything reads the option state: the variant resolver, the CTA and the summary all
     have to see the pinned value, not an unanswered axis. */
  pinSuppressedOptions(form)
  initializePersonalization(form)
  standardizeNativeOptionOrder(form)
  /* AFTER the final reorder, not before it. standardizeNativeOptionOrder rearranges the native
     groups, and a "how many" inserted ahead of that ended up above Metal color instead of beside
     the choice it counts. Running last also means the fan-out sees the DOM the shopper will. */
  initializeFanOutSelection(form)
  updateProductForm(form)
  updateProductionSummary(form)
})
}

/*
  The gallery follows the chosen variant.

  A style axis whose values are twelve different stones is a choice about what the piece LOOKS like,
  and the photograph of it is already in the gallery — it simply never moved when the choice did.
  Variants without a picture of their own leave the gallery where it is rather than jumping to an
  unrelated frame.
*/
const showVariantMedia = (form) => {
  const gallery = document.querySelector('[data-product-gallery]')
  if (!gallery) return
  const id = form.querySelector('input[name="id"]')?.value
  const node = document.querySelector('[data-sj-variants]')
  if (!id || !node) return
  let variants
  try { variants = JSON.parse(node.textContent) } catch { return }
  const variant = variants.find((entry) => String(entry.id) === String(id))
  const mediaId = variant?.featured_media?.id
  if (!mediaId) return
  const medias = [...gallery.querySelectorAll('[data-gallery-media]')]
  const index = medias.findIndex((media) => String(media.dataset.galleryMedia) === String(mediaId))
  if (index >= 0) galleryState(gallery, index)
}

initializeProductForms()


document.addEventListener('change', (event) => {
const form = event.target.closest('[data-sj-product-form]')
if (form) {
  updateProductForm(form, event.target)
  showVariantMedia(form)
  updatePersonalizationConditions(form)
  updateProductionSummary(form)
}
if (event.target.matches('[data-localization-select]')) event.target.form?.submit()
if (event.target.matches('[data-submit-on-change]')) event.target.form?.submit()
})

document.addEventListener('input', (event) => {
const form = event.target.closest('[data-sj-product-form]')
if (form) {
  updateProductForm(form, event.target)
  updateProductionSummary(form)
}
})

document.addEventListener('click', (event) => {
const blockedSubmit = event.target.closest('[data-product-submit][data-choice-missing]')
if (blockedSubmit) {
  const blockedForm = blockedSubmit.closest('[data-sj-product-form]')
  if (focusUnresolvedChoice(blockedForm)) {
    event.preventDefault()
    return
  }
}
const start = event.target.closest('[data-personalize-start]')
if (!start) return
const form = start.closest('[data-sj-product-form]')
if (start.hasAttribute('data-choice-missing')) {
  focusUnresolvedChoice(form)
  return
}
if (form?._sjPositionConfigurator) {
  form._sjPositionConfigurator.start()
  syncPdpSticky()
  return
}
const details = form?.querySelector('[data-sj-personalizer]')
if (!details) return
form.dataset.personalizationStarted = 'true'
details.removeAttribute('hidden')
details.open = true
start.setAttribute('hidden', '')
form.querySelector('[data-product-submit]')?.removeAttribute('hidden')
updateProductForm(form)
syncPdpSticky()
details.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
requestAnimationFrame(() => details.querySelector('input, select, textarea, button, [tabindex]')?.focus())
})

// Forward holder: the zoom trigger sync is defined further down, but the gallery
// state machine above it must be able to call it on every index change.
let syncZoomTriggerFor = () => {}

const syncGalleryThumbRail = (gallery) => {
const rail = gallery.querySelector('.sj-product-gallery__thumbs')
const shell = rail?.closest('[data-gallery-thumb-rail]')
if (!rail || !shell) return
const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth)
const hasOverflow = maxScroll > 2
shell.dataset.thumbOverflow = String(hasOverflow)
shell.dataset.thumbStart = String(!hasOverflow || rail.scrollLeft <= 2)
shell.dataset.thumbEnd = String(!hasOverflow || rail.scrollLeft >= maxScroll - 2)
gallery.querySelector('[data-gallery-thumb-hint]')?.toggleAttribute('hidden', !hasOverflow)
}

const galleryState = (gallery, index, announce = true) => {
const medias = [...gallery.querySelectorAll('[data-gallery-media]')]
if (!medias.length) return
const next = (index + medias.length) % medias.length
const previous = Number(gallery.dataset.galleryIndex || 0)
medias.forEach((media, mediaIndex) => {
  media.removeAttribute('hidden')
  media.setAttribute('aria-current', mediaIndex === next ? 'true' : 'false')
  media.toggleAttribute('inert', mediaIndex !== next)
})
gallery.querySelectorAll('[data-gallery-thumb]').forEach((t, i) => t.setAttribute('aria-current', i === next ? 'true' : 'false'))
const count = gallery.querySelector('[data-gallery-count]')
if (count) count.textContent = (next + 1) + ' / ' + medias.length
const status = gallery.querySelector('[data-gallery-status]')
const thumb = gallery.querySelectorAll('[data-gallery-thumb]')[next]
if (announce && status && previous !== next) status.textContent = thumb?.dataset.announcement || ''
const thumbRail = thumb?.closest('.sj-product-gallery__thumbs')
if (thumbRail && previous !== next && thumbRail.scrollWidth > thumbRail.clientWidth) {
  const centered = thumb.offsetLeft - ((thumbRail.clientWidth - thumb.offsetWidth) / 2)
  const target = Math.max(0, Math.min(centered, thumbRail.scrollWidth - thumbRail.clientWidth))
  thumbRail.scrollTo({
    left: target,
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
  })
}
gallery.dataset.galleryIndex = String(next)
syncZoomTriggerFor(gallery)
return next
}

const galleryShow = (gallery, index, announce = true) => {
const next = galleryState(gallery, index, announce)
if (next === undefined) return
const stage = gallery.querySelector('[data-gallery-stage]')
const media = gallery.querySelectorAll('[data-gallery-media]')[next]
if (!stage || !media) return
gallery._sjGalleryTarget = next
stage.scrollTo({
  left: media.offsetLeft,
  behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
})
}

const galleryNearestIndex = (stage, medias) => medias.reduce((best, media, mediaIndex) => {
const distance = Math.abs(media.offsetLeft - stage.scrollLeft)
return distance < best.distance ? { index: mediaIndex, distance } : best
}, { index: 0, distance: Number.POSITIVE_INFINITY }).index

const initializeProductGalleries = (root = document) => {
root.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  if (gallery.dataset.sjGalleryInitialized === 'true') return
  gallery.dataset.sjGalleryInitialized = 'true'
  const stage = gallery.querySelector('[data-gallery-stage]')
  const frame = gallery.querySelector('.sj-product-gallery__frame')
  const pointer = gallery.querySelector('[data-gallery-pointer]')
  const medias = [...gallery.querySelectorAll('[data-gallery-media]')]
  if (!stage || !medias.length) return
  const thumbRail = gallery.querySelector('.sj-product-gallery__thumbs')
  let thumbScrollFrame = 0
  const queueThumbRailSync = () => {
    if (thumbScrollFrame) return
    thumbScrollFrame = requestAnimationFrame(() => {
      thumbScrollFrame = 0
      syncGalleryThumbRail(gallery)
    })
  }
  thumbRail?.addEventListener('scroll', queueThumbRailSync, { passive: true })
  queueThumbRailSync()
  medias.forEach((media) => media.querySelectorAll('img').forEach((image) => { image.draggable = false }))
  const initial = Math.max(0, Math.min(Number(gallery.dataset.galleryIndex || 0), medias.length - 1))
  galleryState(gallery, initial, false)
  stage.style.scrollBehavior = 'auto'
  stage.scrollLeft = medias[initial].offsetLeft
  requestAnimationFrame(() => stage.style.removeProperty('scroll-behavior'))

  let scrollFrame = 0
  const syncFromScroll = () => {
    scrollFrame = 0
    if (gallery._sjGalleryTarget !== undefined) {
      const target = medias[gallery._sjGalleryTarget]
      if (target && Math.abs(target.offsetLeft - stage.scrollLeft) < 2) gallery._sjGalleryTarget = undefined
      else return
    }
    galleryState(gallery, galleryNearestIndex(stage, medias), !stage.classList.contains('is-dragging'))
  }

  /*
    A video slide is not a "click to advance" surface. Clicking the picture of a bracelet to see
    the next picture is right; clicking a PLAYING video to skip past it is not what anyone means,
    and it left the small control-bar button as the only way to start or stop it. So on a video
    slide the click plays or pauses instead, and the advance arrow stays hidden — the thumbnails,
    the arrow keys and a swipe still move the gallery.
  */
  const activeVideo = () => {
    const active = medias[Number(gallery.dataset.galleryIndex || 0)] || medias[0]
    return active?.querySelector('video') || null
  }
  /* The browser's own control bar owns the bottom strip. Toggling there too would fight the
     button the customer just pressed. */
  const CONTROL_BAR = 52
  const overVideoSurface = (clientX, clientY) => {
    const video = activeVideo()
    if (!video) return null
    const rect = video.getBoundingClientRect()
    if (clientX < rect.left || clientX > rect.right || clientY < rect.top || clientY > rect.bottom) return null
    if (clientY > rect.bottom - CONTROL_BAR) return null
    return video
  }

  const hidePointer = () => {
    pointer?.removeAttribute('data-visible')
    stage.removeAttribute('data-gallery-cursor')
  }

  const pointerDirection = (clientX) => {
    const current = Number(gallery.dataset.galleryIndex || 0)
    const active = medias[current] || medias[0]
    const rect = active.getBoundingClientRect()
    return clientX < rect.left + (rect.width / 2) ? -1 : 1
  }

  const showPointer = (event) => {
    if (!pointer || !frame || medias.length < 2 || event.pointerType !== 'mouse' || stage.classList.contains('is-dragging')) return
    if (overVideoSurface(event.clientX, event.clientY)) {
      hidePointer()
      stage.dataset.galleryVideoCursor = 'true'
      return
    }
    delete stage.dataset.galleryVideoCursor
    const stageRect = stage.getBoundingClientRect()
    if (event.clientX < stageRect.left || event.clientX > stageRect.right || event.clientY < stageRect.top || event.clientY > stageRect.bottom) {
      hidePointer()
      return
    }
    const frameRect = frame.getBoundingClientRect()
    const direction = pointerDirection(event.clientX)
    /* A chevron, not a full arrow: the glyph follows the cursor across every image, so the
       lighter mark reads as a hint rather than a control competing with the photograph. */
    pointer.textContent = direction < 0 ? '\u2039' : '\u203A'
    pointer.dataset.direction = direction < 0 ? 'previous' : 'next'
    pointer.style.left = Math.max(28, Math.min(frameRect.width - 28, event.clientX - frameRect.left)) + 'px'
    pointer.style.top = Math.max(28, Math.min(stageRect.height - 28, event.clientY - frameRect.top)) + 'px'
    pointer.dataset.visible = 'true'
    stage.dataset.galleryCursor = 'true'
  }

  let drag = null
  const finishMouseInteraction = (event, cancelled = false) => {
    if (!drag || event.pointerId !== drag.pointerId) return
    const wasMoved = drag.moved
    const direction = pointerDirection(event.clientX)
    drag = null
    stage.classList.remove('is-dragging')
    stage.style.removeProperty('scroll-behavior')
    if (stage.hasPointerCapture?.(event.pointerId)) stage.releasePointerCapture(event.pointerId)
    if (cancelled) {
      galleryShow(gallery, galleryNearestIndex(stage, medias), false)
    } else if (wasMoved) {
      galleryShow(gallery, galleryNearestIndex(stage, medias))
    } else {
      const video = cancelled ? null : overVideoSurface(event.clientX, event.clientY)
      if (video) {
        if (video.paused) video.play().catch(() => {})
        else video.pause()
      } else {
        galleryShow(gallery, Number(gallery.dataset.galleryIndex || 0) + direction)
      }
    }
    hidePointer()
  }

  stage.addEventListener('scroll', () => {
    if (!scrollFrame) scrollFrame = requestAnimationFrame(syncFromScroll)
  }, { passive: true })
  stage.addEventListener('scrollend', () => {
    gallery._sjGalleryTarget = undefined
    syncFromScroll()
  })
  stage.addEventListener('keydown', (event) => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return
    event.preventDefault()
    const current = Number(gallery.dataset.galleryIndex || 0)
    if (event.key === 'Home') galleryShow(gallery, 0)
    else if (event.key === 'End') galleryShow(gallery, medias.length - 1)
    else galleryShow(gallery, current + (event.key === 'ArrowRight' ? 1 : -1))
  })
  stage.addEventListener('dragstart', (event) => event.preventDefault())
  stage.addEventListener('pointerenter', showPointer)
  stage.addEventListener('pointermove', (event) => {
    if (!drag || event.pointerId !== drag.pointerId) {
      showPointer(event)
      return
    }
    const delta = drag.startX - event.clientX
    if (!drag.moved && Math.abs(delta) >= 5) {
      drag.moved = true
      gallery._sjGalleryTarget = undefined
      stage.classList.add('is-dragging')
      stage.style.scrollBehavior = 'auto'
      hidePointer()
    }
    if (!drag.moved) return
    event.preventDefault()
    stage.scrollLeft = drag.startScrollLeft + delta
  })
  stage.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0 || medias.length < 2) return
    event.preventDefault()
    drag = {
      pointerId: event.pointerId,
      startX: event.clientX,
      startScrollLeft: stage.scrollLeft,
      moved: false
    }
    stage.setPointerCapture?.(event.pointerId)
  })
  stage.addEventListener('pointerup', (event) => finishMouseInteraction(event))
  stage.addEventListener('pointercancel', (event) => finishMouseInteraction(event, true))
  stage.addEventListener('lostpointercapture', (event) => {
    if (drag && event.pointerId === drag.pointerId) finishMouseInteraction(event, true)
  })
  stage.addEventListener('pointerleave', () => {
    if (!drag) hidePointer()
  })
})
}

let galleryThumbResizeFrame = 0
window.addEventListener('resize', () => {
if (galleryThumbResizeFrame) return
galleryThumbResizeFrame = requestAnimationFrame(() => {
  galleryThumbResizeFrame = 0
  document.querySelectorAll('[data-product-gallery]').forEach(syncGalleryThumbRail)
})
}, { passive: true })

initializeProductGalleries()

document.addEventListener('click', (event) => {
const step = event.target.closest('[data-gallery-prev], [data-gallery-next]')
if (!step) return
const gallery = step.closest('[data-product-gallery]')
if (!gallery) return
const current = Number(gallery.dataset.galleryIndex || 0)
galleryShow(gallery, current + (step.matches('[data-gallery-next]') ? 1 : -1))
})

document.addEventListener('click', (event) => {
const thumb = event.target.closest('[data-gallery-thumb]')
if (!thumb) return
const gallery = thumb.closest('[data-product-gallery]')
if (!gallery) return
const index = [...gallery.querySelectorAll('[data-gallery-thumb]')].indexOf(thumb)
if (index >= 0) galleryShow(gallery, index)
})

// Media zoom. Direct thumbnail, arrow and keyboard selection all use the
// original gallery index so closing the lightbox preserves the chosen view.
const mobileZoomQuery = matchMedia('(max-width: 39.99rem)')
const primeMediaZoom = (dialog, galleryIndex) => {
if (!dialog || mobileZoomQuery.matches) return
const figures = [...dialog.querySelectorAll('[data-media-zoom-figure]')]
const position = figures.findIndex((figure) => Number(figure.dataset.mediaZoomFigure) === galleryIndex)
if (position < 0) return
const nearby = [position, (position + 1) % figures.length, (position - 1 + figures.length) % figures.length]
;[...new Set(nearby)].forEach((figurePosition, priority) => {
  const image = figures[figurePosition]?.querySelector('img')
  if (!image) return
  image.loading = 'eager'
  image.fetchPriority = priority === 0 ? 'high' : 'auto'
  image.decode?.().catch(() => {})
})
}

const mediaZoomShow = (dialog, index, announce = true) => {
const figures = [...dialog.querySelectorAll('[data-media-zoom-figure]')]
if (!figures.length) return false
const match = figures.find((figure) => Number(figure.dataset.mediaZoomFigure) === index) || figures[0]
const previous = Number(dialog.dataset.mediaZoomIndex ?? -1)
const galleryIndex = Number(match.dataset.mediaZoomFigure)
primeMediaZoom(dialog, galleryIndex)
figures.forEach((figure) => {
  const active = figure === match
  figure.toggleAttribute('hidden', !active)
  figure.setAttribute('aria-current', String(active))
  figure.toggleAttribute('inert', !active)
})
const position = figures.indexOf(match) + 1
const count = dialog.querySelector('[data-media-zoom-count]')
if (count) count.textContent = position + ' / ' + figures.length
const thumbs = [...dialog.querySelectorAll('[data-media-zoom-thumb]')]
const activeThumb = thumbs.find((thumb) => Number(thumb.dataset.mediaZoomThumb) === galleryIndex)
thumbs.forEach((thumb) => thumb.setAttribute('aria-current', String(thumb === activeThumb)))
const status = dialog.querySelector('[data-media-zoom-status]')
if (announce && status && previous !== galleryIndex) {
  status.textContent = activeThumb?.dataset.announcement || (position + ' / ' + figures.length)
}
const viewport = dialog.querySelector('[data-media-zoom-viewport]')
if (viewport) {
  viewport.removeAttribute('data-swipe-active')
  viewport.style.setProperty('--sj-zoom-swipe-x', '0px')
  viewport.scrollTo({ top: 0, left: 0, behavior: 'auto' })
}
dialog.dataset.mediaZoomIndex = String(galleryIndex)

const gallery = dialog.closest('[data-product-root]')?.querySelector('[data-product-gallery]')
if (gallery && Number(gallery.dataset.galleryIndex || 0) !== galleryIndex) {
  galleryShow(gallery, galleryIndex, false)
}

const thumbRail = activeThumb?.closest('[data-media-zoom-thumbs]')
if (thumbRail && thumbRail.scrollWidth > thumbRail.clientWidth) {
  const centered = activeThumb.offsetLeft - ((thumbRail.clientWidth - activeThumb.offsetWidth) / 2)
  const target = Math.max(0, Math.min(centered, thumbRail.scrollWidth - thumbRail.clientWidth))
  thumbRail.scrollTo({
    left: target,
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
  })
}
return true
}

const mediaZoomStep = (dialog, amount) => {
const figures = [...dialog.querySelectorAll('[data-media-zoom-figure]')]
if (!figures.length) return
const currentIndex = Number(dialog.dataset.mediaZoomIndex ?? figures[0].dataset.mediaZoomFigure)
const currentPosition = Math.max(0, figures.findIndex((figure) => Number(figure.dataset.mediaZoomFigure) === currentIndex))
const nextPosition = (currentPosition + amount + figures.length) % figures.length
mediaZoomShow(dialog, Number(figures[nextPosition].dataset.mediaZoomFigure))
}

// Keep the trigger honest: media types without a zoom figure (video, model)
// must not advertise a control that cannot open.
const syncMediaZoomTrigger = (gallery) => {
const trigger = gallery.querySelector('[data-media-zoom-open]')
if (!trigger) return
if (mobileZoomQuery.matches) {
  trigger.hidden = true
  return
}
const dialog = document.getElementById(trigger.dataset.mediaZoomOpen)
if (!dialog) { trigger.hidden = true; return }
const index = Number(gallery.dataset.galleryIndex || 0)
const hasFigure = [...dialog.querySelectorAll('[data-media-zoom-figure]')]
  .some((figure) => Number(figure.dataset.mediaZoomFigure) === index)
trigger.hidden = !hasFigure
if (hasFigure) primeMediaZoom(dialog, index)
}

syncZoomTriggerFor = syncMediaZoomTrigger
document.querySelectorAll('[data-product-gallery]').forEach(syncMediaZoomTrigger)
const syncZoomForViewport = () => {
document.querySelectorAll('[data-product-gallery]').forEach(syncMediaZoomTrigger)
if (!mobileZoomQuery.matches) return
document.querySelectorAll('[data-media-zoom][open]').forEach((dialog) => dialog.close())
}
mobileZoomQuery.addEventListener?.('change', syncZoomForViewport)

document.addEventListener('click', (event) => {
const thumb = event.target.closest('[data-media-zoom-thumb]')
if (thumb) {
  const dialog = thumb.closest('[data-media-zoom]')
  if (dialog) mediaZoomShow(dialog, Number(thumb.dataset.mediaZoomThumb))
  return
}
const step = event.target.closest('[data-media-zoom-step]')
if (!step) return
const dialog = step.closest('[data-media-zoom]')
if (dialog) mediaZoomStep(dialog, Number(step.dataset.mediaZoomStep || 0))
})

document.addEventListener('keydown', (event) => {
const dialog = event.target.closest?.('[data-media-zoom][open]')
if (!dialog || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return
event.preventDefault()
const figures = [...dialog.querySelectorAll('[data-media-zoom-figure]')]
if (!figures.length) return
if (event.key === 'Home' || event.key === 'End') {
  const figure = event.key === 'Home' ? figures[0] : figures[figures.length - 1]
  mediaZoomShow(dialog, Number(figure.dataset.mediaZoomFigure))
} else {
  mediaZoomStep(dialog, event.key === 'ArrowRight' ? 1 : -1)
}
})

document.addEventListener('click', (event) => {
const trigger = event.target.closest('[data-media-zoom-open]')
if (!trigger) return
event.preventDefault()
if (mobileZoomQuery.matches) return
const dialog = document.getElementById(trigger.dataset.mediaZoomOpen)
const gallery = trigger.closest('[data-product-gallery]')
if (!dialog || !gallery) return
if (!dialog.querySelector('[data-media-zoom-figure]')) return
openDialog(dialog, trigger)
mediaZoomShow(dialog, Number(gallery.dataset.galleryIndex || 0))
})

const cartRecommendationState = { key: null, controller: null }

const cartPropertyLabel = (key) => {
const normalized = String(key || '').toLowerCase()
if (normalized.includes('please write your preferred') || normalized.includes('letters or icons') || normalized.includes('enter the letter')) return 'Personalization'
return key
}

const setCartLineQuantity = async (key, quantity) => {
const response = await fetch('/cart/change.js', {
  method: 'POST',
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) })
})
const result = await response.json()
if (!response.ok) throw new Error(result.description || result.message || 'The cart could not be updated.')
return renderCart()
}

const appendCartRecommendation = (grid, product) => {
const card = document.createElement('article')
card.className = 'sj-cart-recommendation'
if (product.id) card.dataset.productId = String(product.id)
const media = document.createElement('a')
media.className = 'sj-cart-recommendation__media'
media.href = product.url
media.setAttribute('aria-label', `View ${product.title}`)
if (product.image) {
  const image = document.createElement('img')
  image.src = product.image
  image.alt = product.title
  image.width = 320
  image.height = 320
  image.loading = 'lazy'
  media.append(image)
}
const content = document.createElement('div')
content.className = 'sj-cart-recommendation__content'
const heading = document.createElement('h4')
heading.className = 'sj-cart-recommendation__title'
const link = document.createElement('a')
link.href = product.url
link.textContent = product.title
heading.append(link)
const price = document.createElement('p')
price.className = 'sj-cart-recommendation__price'
price.textContent = product.price
const add = document.createElement(product.available === false ? 'button' : 'a')
add.className = 'sj-cart-recommendation__add'
add.setAttribute('data-cart-recommendation-cta', '')
add.textContent = product.available === false ? 'Sold out' : 'Choose options'
if (product.available === false) {
  add.type = 'button'
  add.disabled = true
  add.setAttribute('aria-label', `${product.title} is sold out`)
} else {
  add.href = product.url
  add.setAttribute('aria-label', `Choose options for ${product.title}`)
}
content.append(heading, price, add)
card.append(media, content)
grid.append(card)
}

const appendCuratedCartRecommendations = (grid, excludedIds = new Set(), excludedUrls = new Set(), limit = 3) => {
const template = document.querySelector('[data-cart-fallback-recommendations]')
const candidates = [...(template?.content?.querySelectorAll('[data-cart-curated-product]') || [])]
  .filter((card) => !excludedIds.has(String(card.dataset.productId)))
  .filter((card) => !excludedUrls.has(card.querySelector('a')?.getAttribute('href')))
  .slice(0, limit)
candidates.forEach((card) => grid.append(card.cloneNode(true)))
return candidates.length
}

const appendPageCartRecommendations = (grid, excludedUrls = new Set(), limit = 3) => {
const cards = [...document.querySelectorAll('.sj-product-recommendations-section .sj-pair-card')]
let added = 0
cards.forEach((card) => {
  if (added >= limit) return
  const link = card.querySelector('.sj-pair-card__media, .sj-pair-card__title a')
  const url = link?.getAttribute('href')
  if (!url || excludedUrls.has(url)) return
  appendCartRecommendation(grid, {
    title: card.querySelector('.sj-pair-card__title')?.textContent?.trim() || 'Recommended piece',
    url,
    price: card.querySelector('.sj-pair-card__price')?.textContent?.trim() || '',
    image: card.querySelector('img')?.currentSrc || card.querySelector('img')?.src || ''
  })
  excludedUrls.add(url)
  added += 1
})
return added
}

const renderCartRecommendations = async (cartItems = []) => {
const section = document.querySelector('[data-cart-recommendations]')
const grid = section?.querySelector('[data-cart-recommendation-grid]')
const status = section?.querySelector('[data-cart-recommendation-status]')
const productId = cartItems[0]?.product_id
const recommendationKey = cartItems.map((item) => String(item.product_id)).sort().join(':')
if (!section || !grid || !status || !productId) {
  section?.setAttribute('hidden', '')
  return
}
if (cartRecommendationState.key === recommendationKey && grid.childElementCount) {
  section.removeAttribute('hidden')
  return
}
cartRecommendationState.controller?.abort()
const controller = new AbortController()
cartRecommendationState.controller = controller
status.textContent = sjUi.loading_recommendations
grid.replaceChildren()
section.setAttribute('hidden', '')
try {
  const response = await fetch(`/recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=3&intent=complementary`, {
    headers: { Accept: 'application/json' },
    signal: controller.signal
  })
  const payload = await response.json()
  if (!response.ok) throw new Error(payload.description || payload.message)
  const excludedIds = new Set(cartItems.map((item) => String(item.product_id)))
  const excludedUrls = new Set(cartItems.map((item) => String(item.url || '').split('?')[0]))
  const products = (Array.isArray(payload.products) ? payload.products : [])
    .filter((product) => !excludedIds.has(String(product.id)))
    .slice(0, 3)
  products.forEach((product) => appendCartRecommendation(grid, {
    id: product.id,
    title: product.title,
    url: product.url,
    available: product.available,
    price: money(product.price),
    image: typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.url
  }))
  products.forEach((product) => {
    excludedIds.add(String(product.id))
    excludedUrls.add(product.url)
  })
  if (grid.childElementCount < 3) appendPageCartRecommendations(grid, excludedUrls, 3 - grid.childElementCount)
  if (grid.childElementCount < 3) appendCuratedCartRecommendations(grid, excludedIds, excludedUrls, 3 - grid.childElementCount)
  cartRecommendationState.key = recommendationKey
  status.textContent = ''
  section.toggleAttribute('hidden', !grid.childElementCount)
} catch (error) {
  if (error.name === 'AbortError') return
  const excludedIds = new Set(cartItems.map((item) => String(item.product_id)))
  const excludedUrls = new Set(cartItems.map((item) => String(item.url || '').split('?')[0]))
  appendPageCartRecommendations(grid, excludedUrls, 3)
  if (grid.childElementCount < 3) appendCuratedCartRecommendations(grid, excludedIds, excludedUrls, 3 - grid.childElementCount)
  status.textContent = grid.childElementCount ? '' : 'Recommendations are unavailable right now.'
  section.toggleAttribute('hidden', !grid.childElementCount)
}
}

const renderCart = async () => {
const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
const cart = await response.json()
if (!response.ok) throw new Error(cart.description || cart.message || 'The cart could not be loaded.')
document.querySelectorAll('[data-cart-count]').forEach((node) => {
  node.textContent = cart.item_count
})
const body = document.querySelector('[data-cart-lines]')
const subtotal = document.querySelector('[data-cart-subtotal]')
const count = document.querySelector('[data-cart-drawer-count]')
const footer = document.querySelector('[data-cart-footer]')
const emptyState = document.querySelector('[data-cart-empty]')
const noteWrap = document.querySelector('[data-cart-note-wrap]')
const note = document.querySelector('[data-cart-note]')
if (!body) return cart
body.replaceChildren()
body.toggleAttribute('hidden', !cart.items.length)
emptyState?.toggleAttribute('hidden', Boolean(cart.items.length))
if (count) count.textContent = `· ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`
footer?.toggleAttribute('hidden', !cart.items.length)
noteWrap?.toggleAttribute('hidden', !cart.items.length)
if (note && note !== document.activeElement) note.value = cart.note || ''
cart.items.forEach((item) => {
  const article = document.createElement('article')
  article.className = 'sj-cart-line'
  const media = document.createElement('a')
  media.className = 'sj-cart-line__image'
  media.href = item.url || '#'
  media.setAttribute('aria-label', `View ${item.product_title}`)
  if (item.image) {
    const image = document.createElement('img')
    image.src = item.image
    image.alt = item.product_title
    image.width = 176
    image.height = 220
    media.append(image)
  }
  const content = document.createElement('div')
  content.className = 'sj-cart-line__content'
  const title = document.createElement('h3')
  title.className = 'sj-card__title'
  title.textContent = item.product_title
  const summaryParts = []
  if (item.variant_title && item.variant_title !== 'Default Title') summaryParts.push(item.variant_title)
  const price = document.createElement('p')
  price.className = 'sj-card__price'
  price.textContent = money(item.final_line_price)
  const properties = Object.entries(item.properties || {}).filter(([key, value]) => value && !key.startsWith('_'))
  if (properties.length) {
    const values = properties.map(([, value]) => String(value)).filter(Boolean)
    if (values.length) summaryParts.push(values.join(' · '))
  }
  const summary = document.createElement('p')
  summary.className = 'sj-cart-line__summary'
  summary.textContent = summaryParts.join(' · ')
  content.append(title)
  if (summaryParts.length) content.append(summary)
  const footer = document.createElement('div')
  footer.className = 'sj-cart-line__footer'
  footer.append(price)
  const actions = document.createElement('div')
  actions.className = 'sj-cart-line__actions'
  const quantity = document.createElement('div')
  quantity.className = 'sj-cart-line__quantity'
  quantity.setAttribute('aria-label', `Quantity for ${item.product_title}`)
  const reduce = document.createElement('button')
  reduce.type = 'button'
  reduce.textContent = '−'
  reduce.dataset.cartQuantity = String(Math.max(0, item.quantity - 1))
  reduce.dataset.cartLineKey = item.key
  reduce.setAttribute('aria-label', `Reduce ${item.product_title} quantity by one`)
  const value = document.createElement('span')
  value.textContent = item.quantity
  const increase = document.createElement('button')
  increase.type = 'button'
  increase.textContent = '+'
  increase.dataset.cartQuantity = String(item.quantity + 1)
  increase.dataset.cartLineKey = item.key
  increase.setAttribute('aria-label', `Increase ${item.product_title} quantity by one`)
  quantity.append(reduce, value, increase)
  const remove = document.createElement('button')
  remove.type = 'button'
  remove.className = 'sj-cart-line__remove'
  remove.textContent = 'Remove'
  remove.dataset.cartQuantity = '0'
  remove.dataset.cartLineKey = item.key
  actions.append(quantity, remove)
  footer.append(actions)
  content.append(footer)
  article.append(media, content)
  body.append(article)
})
if (subtotal) subtotal.textContent = money(cart.total_price)
if (cart.items.length) void renderCartRecommendations(cart.items)
else {
  document.querySelector('[data-cart-recommendations]')?.setAttribute('hidden', '')
  cartRecommendationState.key = null
}
return cart
}

document.addEventListener('click', async (event) => {
const quantity = event.target.closest('[data-cart-line-key][data-cart-quantity]')
if (!quantity) return
event.preventDefault()
quantity.setAttribute('aria-busy', 'true')
try {
  await setCartLineQuantity(quantity.dataset.cartLineKey, quantity.dataset.cartQuantity)
} finally {
  quantity.removeAttribute('aria-busy')
}
})

document.addEventListener('change', async (event) => {
const note = event.target.closest('[data-cart-note]')
if (!note) return
const response = await fetch('/cart/update.js', {
  method: 'POST',
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  body: JSON.stringify({ note: note.value })
})
if (!response.ok) note.setCustomValidity('The note could not be saved. Please try again.')
else note.setCustomValidity('')
})

/* AMP Slide Cart delegates every product-form click through
 [action$="/cart/add"]. Its current storefront build treats the literal string
 aria-disabled="false" as truthy and cancels the click; if that attribute is absent it
 posts only id + quantity and drops every personalization property. Our product forms
 already own an exact FormData AJAX contract, so give their JS-enhanced action the
 Shopify AJAX suffix. This keeps the no-JS Liquid action intact in the server HTML,
 removes the app's incompatible delegated selector at runtime, and preserves every
 versioned production property. */
const claimAjaxCartForm = (form) => {
if (!form?.matches?.('[data-sj-product-form][data-ajax-cart]')) return
const action = String(form.getAttribute('action') || '').trim()
if (!action) return
if (!form.dataset.nativeCartAction) form.dataset.nativeCartAction = action
if (/\/cart\/add\/?$/.test(action)) form.setAttribute('action', `${action.replace(/\/$/, '')}.js`)
form.dataset.sjAjaxOwner = 'silveristic'
}

const claimAjaxCartForms = (root = document) => {
if (root?.matches?.('[data-sj-product-form][data-ajax-cart]')) claimAjaxCartForm(root)
root?.querySelectorAll?.('[data-sj-product-form][data-ajax-cart]').forEach(claimAjaxCartForm)
}

const sanitizeOrderProperties = (form) => {
const nativeSelections = new Map()
form.querySelectorAll('[data-option-index]').forEach((fieldset) => {
  const label = fieldset.querySelector('legend')?.childNodes[0]?.textContent?.replace(/\s+/g, ' ').trim()
  const value = fieldset.querySelector('input:checked')?.value || fieldset.querySelector('select')?.value || ''
  if (label && value) nativeSelections.set(label.toLocaleLowerCase(), String(value).trim().toLocaleLowerCase())
})
const serialized = new Map()
form.querySelectorAll('[name^="properties["]').forEach((input) => {
  if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return
  const match = String(input.name || '').match(/^properties\[(.*)\]$/)
  if (!match) return
  const key = match[1].replace(/\s+/g, ' ').trim()
  if (/^_(?:Silveristic|Production summary)/i.test(key)) {
    input.removeAttribute('name')
    return
  }
  /*
    The shortener turns a merchant's paragraph-long question into a readable packing-slip label,
    which is right for a field nobody has matched on before — and wrong for one fulfilment already
    reads. A contract that names its own key means "this is the key the workshop matches on", so
    that key travels verbatim; everything else still gets shortened exactly as before.

    Without this exemption the Listings work looked correct all the way to the cart and then
    renamed the very keys it exists to preserve: "Preferred Font and Name - …" arrived as
    "Personalization", and "Heart engraving (v1)" as "Engraving".
  */
  const exact = input.dataset.exactPropertyKey !== undefined
  const next = exact ? key : fulfillmentPropertyLabel(key, input.type)
  const value = String(input.value || '').trim()
  const nativeValue = nativeSelections.get(next.toLocaleLowerCase())
  if (nativeValue && nativeValue === value.toLocaleLowerCase()) {
    input.removeAttribute('name')
    return
  }
  input.name = `properties[${next}]`
  if (!value || input.type === 'file') return
  const existing = serialized.get(input.name)
  if (!existing) {
    serialized.set(input.name, input)
    return
  }
  const values = String(existing.value || '').split(' · ').map((item) => item.trim()).filter(Boolean)
  if (!values.includes(value)) existing.value = [...values, value].join(' · ')
  input.removeAttribute('name')
})
}

claimAjaxCartForms()

document.addEventListener('submit', async (event) => {
const form = event.target.closest('[data-sj-product-form][data-ajax-cart]')
if (!form) return
claimAjaxCartForm(form)
if (focusUnresolvedChoice(form)) {
  event.preventDefault()
  return
}
if (form._sjPositionConfigurator && !form._sjPositionConfigurator.isReady()) {
  event.preventDefault()
  form._sjPositionConfigurator.goNext()
  return
}
updatePersonalizationConditions(form)
updateProductionSummary(form)
sanitizeOrderProperties(form)
if (!form.reportValidity()) {
  event.preventDefault()
  const invalid = form.querySelector(':invalid')
  const details = invalid?.closest('[data-sj-personalizer]')
  if (details) details.open = true
  const invalidTarget = invalid?.dataset.singleInitialValue !== undefined
    ? invalid.closest('[data-personalization-field]')?.querySelector('[data-single-initial-open]')
    : invalid?.dataset.fontChoiceSource !== undefined || (invalid?.dataset.fontNameSource !== undefined && invalid.closest('[data-personalization-field]')?.dataset.fontSelected !== 'true')
      ? form.querySelector('[data-font-picker-open]')
      : invalid?.dataset.fontNameSource !== undefined
        ? invalid.closest('[data-personalization-field]')?.querySelector('[data-font-name-input]')
        : invalid
  invalidTarget?.focus()
  return
}
if (form.dataset.unmodeledPrice === 'true') {
  event.preventDefault()
  form.querySelector('[data-personalization-status]')?.scrollIntoView({ block: 'center' })
  return
}
const hasFile = [...form.querySelectorAll('input[type="file"]')].some((input) => input.files?.length)
if (hasFile) {
  const nativeAction = form.dataset.nativeCartAction || '/cart/add'
  const separator = nativeAction.includes('?') ? '&' : '?'
  form.setAttribute('action', `${nativeAction}${separator}_sj_native_upload=1`)
  form.removeAttribute('data-ajax-cart')
  return
}
event.preventDefault()
const submit = form.querySelector('[data-product-submit]')
const status = form.querySelector('[data-product-status]')
submit?.setAttribute('aria-busy', 'true')
if (submit) submit.disabled = true
if (status) {
  status.dataset.state = 'loading'
  status.textContent = status.dataset.loading
}
try {
  /*
    A fan-out product posts one line item per chosen piece. /cart/add.js takes an `items` array, so
    the set arrives as three real lines at three real prices with three real stock movements —
    rather than as one line carrying the other two months in a text property nothing charges for.
    The shared line-item properties (the ring size) ride on every line, because the set is worn
    together and the workshop needs the size on each piece it makes.
  */
  const fanOut = form._sjFanOut
  let response
  if (fanOut?.complete()) {
    const variants = JSON.parse(form.querySelector('[data-sj-variants]')?.textContent || '[]')
    const lines = fanOut.lineItems(variants)
    if (!lines) throw new Error('One of the pieces you chose is not available right now.')
    const shared = {}
    new FormData(form).forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/)
      if (match && String(value).trim() !== '') shared[match[1]] = value
    })
    response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: lines.map((line) => ({ ...line, properties: shared })) })
    })
  } else {
    response = await fetch(form.action || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
  }
  const result = await response.json()
  if (!response.ok) throw new Error(result.description || result.message)
  document.dispatchEvent(new CustomEvent('cart:updated', { detail: result }))
  await renderCart()
  openDialog(document.getElementById('SilveristicCartDrawer'), submit)
  if (status) {
    status.dataset.state = 'success'
    status.textContent = status.dataset.success
  }
} catch (error) {
  if (status) {
    status.dataset.state = 'error'
    status.textContent = error.message || status.dataset.error
  }
} finally {
  submit?.setAttribute('aria-busy', 'false')
  updateProductForm(form)
}
})

document.addEventListener('click', async (event) => {
const cartTrigger = event.target.closest('[data-cart-open]')
if (!cartTrigger) return
event.preventDefault()
await renderCart()
openDialog(document.getElementById('SilveristicCartDrawer'), cartTrigger)
})

document.addEventListener('click', async (event) => {
const trigger = event.target.closest('[data-collection-load-more]')
if (!trigger) return

const localItems = [...document.querySelectorAll('[data-local-load-more-item][hidden]')]
if (localItems.length) {
  event.preventDefault()
  localItems.forEach((item) => item.removeAttribute('hidden'))
  trigger.closest('.sj-v023-load-more')?.setAttribute('hidden', '')
  document.querySelector('.sj-v023-results-end')?.removeAttribute('hidden')
  return
}

if (!(trigger instanceof HTMLAnchorElement) || !trigger.href) return
event.preventDefault()
if (trigger.getAttribute('aria-busy') === 'true') return
trigger.setAttribute('aria-busy', 'true')
try {
  const response = await fetch(trigger.href, { headers: { Accept: 'text/html' } })
  if (!response.ok) throw new Error('Could not load more pieces.')
  const html = await response.text()
  const parsed = new DOMParser().parseFromString(html, 'text/html')
  const currentGrid = document.getElementById('SilveristicProductGrid')
  const nextGrid = parsed.getElementById('SilveristicProductGrid')
  if (!currentGrid || !nextGrid) throw new Error('The next product page is unavailable.')
  currentGrid.append(...nextGrid.children)

  const nextTrigger = parsed.querySelector('[data-collection-load-more]')
  if (nextTrigger instanceof HTMLAnchorElement && nextTrigger.href) {
    trigger.href = nextTrigger.href
    trigger.textContent = nextTrigger.textContent
    trigger.removeAttribute('aria-busy')
  } else {
    trigger.closest('.sj-v023-load-more')?.setAttribute('hidden', '')
    const end = parsed.querySelector('.sj-v023-results-end')
    const currentEnd = document.querySelector('.sj-v023-results-end')
    if (currentEnd && end) currentEnd.textContent = end.textContent
    currentEnd?.removeAttribute('hidden')
  }
} catch (error) {
  trigger.removeAttribute('aria-busy')
  trigger.setAttribute('data-load-error', 'true')
  trigger.textContent = error.message || 'Try loading more pieces again.'
}
})

const stickySourceForForm = (form) => {
if (!form) return null
const candidates = [
  form.querySelector('[data-personalize-start]:not([hidden])'),
  form.querySelector('[data-config-primary]:not([hidden])'),
  form.querySelector('[data-product-submit]:not([hidden])')
].filter(Boolean)
return candidates.find((candidate) => {
  const style = getComputedStyle(candidate)
  const rect = candidate.getBoundingClientRect()
  return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0
}) || null
}

const updatePdpStickyVisibility = () => {
const bar = document.querySelector('[data-pdp-sticky]')
if (!bar) return
const form = document.querySelector('[data-sj-product-form]')
const source = stickySourceForForm(form)
const sourceRect = source?.getBoundingClientRect()
const shouldShow = matchMedia('(max-width: 47.99rem)').matches &&
  Boolean(sourceRect) && sourceRect.bottom <= 0
bar.dataset.stickyVisible = shouldShow ? 'true' : 'false'
bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true')
bar.inert = !shouldShow
}

let stickyVisibilityFrame = 0
const schedulePdpStickyVisibility = () => {
if (stickyVisibilityFrame) return
stickyVisibilityFrame = requestAnimationFrame(() => {
  stickyVisibilityFrame = 0
  updatePdpStickyVisibility()
})
}

const syncPdpSticky = () => {
const bar = document.querySelector('[data-pdp-sticky]')
if (!bar) return
const form = document.querySelector('[data-sj-product-form]')
const price = form?.closest('.sj-product__buybox')?.querySelector('[data-product-price]')
if (form) renderPrimaryCta(form)
const stickyPrice = bar.querySelector('[data-sticky-price]')
if (stickyPrice && price) {
  const prefix = form?.closest('.sj-product__buybox')?.querySelector('[data-product-price-prefix]')
  stickyPrice.textContent = [prefix && !prefix.hidden ? prefix.textContent.trim() : '', price.textContent.trim()].filter(Boolean).join(' ')
}
schedulePdpStickyVisibility()
}

document.addEventListener('click', (event) => {
if (!event.target.closest('[data-sticky-cta]')) return
const form = document.querySelector('[data-sj-product-form]')
const target = form?.querySelector('[data-personalize-start]:not([hidden])')
  || form?.querySelector('[data-config-primary]:not([hidden])')
  || form?.querySelector('[data-product-submit]')
if (!target) return
if (!target.disabled) {
  target.click()
  return
}
if (!focusUnresolvedChoice(form)) target.focus({ preventScroll: true })
})

document.addEventListener('change', syncPdpSticky)
document.addEventListener('input', syncPdpSticky)
document.addEventListener('silveristic:configurator-change', syncPdpSticky)
addEventListener('scroll', schedulePdpStickyVisibility, { passive: true })
addEventListener('resize', schedulePdpStickyVisibility)
addEventListener('orientationchange', schedulePdpStickyVisibility)
addEventListener('pageshow', schedulePdpStickyVisibility)
visualViewport?.addEventListener('resize', schedulePdpStickyVisibility)
visualViewport?.addEventListener('scroll', schedulePdpStickyVisibility)
syncPdpSticky()

/*
  The Gift Finder runtime used to live here: a nine-step wizard plus renderGiftFinderResults(), an
  `every()` sieve over seven hand-authored cards that returned ZERO products on 68% of all answer
  paths. It now lives in assets/sj-gift-finder.js and assets/sj-gift-finder-rank.js, loaded as a
  module by sections/sj-gift-finder.liquid, so the matching model exists in exactly one file that
  the theme, the local preview and the QA suite all import unchanged.
*/

const initializeRecommendations = (root = document) => {
root.querySelectorAll('[data-product-recommendations][data-url]').forEach(async (element) => {
  if (element.dataset.sjInitialized === 'true') return
  element.dataset.sjInitialized = 'true'
  try {
    const response = await fetch(element.dataset.url)
    if (!response.ok) return
    const html = await response.text()
    const parsed = new DOMParser().parseFromString(html, 'text/html')
    const replacement = parsed.querySelector('[data-product-recommendations]')
    if (replacement?.innerHTML.trim()) {
      replacement.dataset.sjInitialized = 'true'
      element.replaceWith(replacement)
    }
  } catch {
    element.setAttribute('hidden', '')
  }
})
}

initializeRecommendations()

/* Every customer-facing "Ask a jeweler" link opens the store's Shopify Inbox
   launcher when it is available. The original href remains a real contact-page
   fallback: navigation is cancelled only after a usable chat activator is found. */
const ASK_JEWELER_LABEL = /ask a jewell?er/i

const openShopifyInboxChat = () => {
const chatHost = document.querySelector('shopify-chat')
const activator = chatHost?.shadowRoot?.querySelector('button.activator')
if (!(activator instanceof HTMLButtonElement) || activator.disabled) return false
activator.click()
return true
}

document.addEventListener('click', (event) => {
if (!(event.target instanceof Element)) return
const trigger = event.target.closest('a, button, [role="button"]')
if (!trigger) return
const explicitlyOpensChat = trigger.matches('[data-sj-open-chat]')
const labelOpensChat = ASK_JEWELER_LABEL.test(trigger.textContent || '')
if (!explicitlyOpensChat && !labelOpensChat) return
if (!openShopifyInboxChat()) return
event.preventDefault()
})

/* Chat launcher vs sticky purchase bar.

 A third-party chat launcher (Shopify Inbox on this store) is a fixed,
 bottom-anchored element the theme does not own, and it was landing on top of
 the sticky Add-to-cart button on mobile. The chat app's own settings are
 per-theme, but they only expose a corner and a coarse vertical preset — they
 cannot be conditional on whether the current page has a sticky buy bar, so
 raising the launcher natively would also raise it on every page that has no
 collision at all.

 The launcher is therefore identified by GEOMETRY, never by class, id or text:
 a small element that is position:fixed, anchored near the viewport floor, not
 ours, and actually intersecting the bar. That stays correct if Inbox changes
 its markup or the store swaps chat providers, and it only ever moves the
 same-origin wrapper — nothing inside the cross-origin iframe is touched. */
const initializeChatCollisionGuard = () => {
const bar = document.querySelector('[data-pdp-sticky]')
if (!bar) return

const GAP = 12
const CLOSED_MAX_HEIGHT = 140
const CLOSED_MAX_WIDTH_RATIO = 0.85
const FLOOR_SLACK = 200
/* A cookie banner can be ~43% of the viewport, so 45% would have read as
   "chat is open" and hidden the purchase bar. A real chat panel is far taller. */
const PANEL_HEIGHT_RATIO = 0.6
const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'LINK', 'TEMPLATE', 'NOSCRIPT', 'META'])
const LIGHT_DEPTH = 2
const SHADOW_DEPTH = 5

const lifts = new Map()
const watched = new WeakSet()
/* Resting geometry is captured ONCE per element per viewport, at first sight,
   before any lift exists. Deriving it from the live box instead made the guard
   read its own half-finished movement — the launcher carries `transition: all`,
   so each pass measured a box still in flight and added the shortfall again,
   compounding a 66px lift into 123px. */
const resting = new WeakMap()
let viewportKey = innerWidth + 'x' + innerHeight
/* Launchers commonly carry `transition: all`. Measuring while one is in flight
   reads a half-finished box, so viewport changes suspend measurement until the
   movement has settled. */
const SETTLE_MS = 320
let settling = false
let settleTimer = 0
const resizeObserver = new ResizeObserver(() => schedule())
const mutationObserver = new MutationObserver(() => schedule())
let queued = 0
let yielded = false
let focusToRestore = null

/* A launcher can carry a running CSS animation on its transform channel — the
   real one here runs `nudge-bounce` — and a CSS animation outranks a plain
   inline declaration, so `element.style.translate = ...` computed back to 0 and
   the element never moved. Re-anchor with `bottom` where the element has one,
   which leaves the vendor's own animation intact and transitions smoothly; fall
   back to translate for launchers positioned some other way. Either way the
   declaration is !important so an animation cannot outrank it. */
const apply = (element, lift) => {
  const existing = lifts.get(element)
  if (existing && Math.abs(existing.px - lift) < 5) return
  const style = getComputedStyle(element)
  let mode = existing?.mode
  let base = existing?.base
  if (!mode) {
    const bottom = parseFloat(style.bottom)
    const anchored = style.position !== 'static' && Number.isFinite(bottom)
    mode = anchored ? 'bottom' : 'translate'
    base = anchored ? bottom : 0
  }
  const property = mode === 'bottom' ? 'bottom' : 'translate'
  /* A launcher may set this property inline itself. Remember its exact
     declaration so releasing restores it instead of deleting the vendor's own
     positioning and leaving the launcher stranded. */
  const original = existing?.original ?? {
    value: element.style.getPropertyValue(property),
    priority: element.style.getPropertyPriority(property)
  }
  if (mode === 'bottom') element.style.setProperty('bottom', (base + lift) + 'px', 'important')
  else element.style.setProperty('translate', '0 ' + -lift + 'px', 'important')
  element.setAttribute('data-sj-chat-lifted', String(lift))
  lifts.set(element, { px: lift, mode, base, original })
}

const release = (element) => {
  const existing = lifts.get(element)
  if (!existing) return
  const property = existing.mode === 'bottom' ? 'bottom' : 'translate'
  if (existing.original?.value) element.style.setProperty(property, existing.original.value, existing.original.priority)
  else element.style.removeProperty(property)
  element.removeAttribute('data-sj-chat-lifted')
  lifts.delete(element)
}

const yieldBar = () => {
  if (yielded) return
  yielded = true
  if (bar.contains(document.activeElement)) {
    focusToRestore = document.activeElement
    focusToRestore.blur()
  }
  bar.classList.add('sj-mobile-sticky--yielded')
}

const restoreBar = () => {
  if (!yielded) return
  yielded = false
  bar.classList.remove('sj-mobile-sticky--yielded')
  if (focusToRestore && document.contains(focusToRestore)) focusToRestore.focus()
  focusToRestore = null
}

/* Walk light DOM and OPEN shadow roots together. The launcher is frequently
   not a plain body child: Shopify Inbox mounts a full-viewport, transparent,
   pointer-events:none host element and puts the real button inside its shadow
   root. Classifying that host by its own box would call it an open panel and
   permanently hide the purchase bar, so only nodes that actually take pointer
   input are classified, and the OUTERMOST qualifying node wins so the wrapper
   moves rather than the icon inside it. */
const scan = (root, depth, maxDepth, barRect, state, withinFixed) => {
  for (const element of root.children) {
    if (SKIP_TAGS.has(element.tagName)) continue
    if (element === bar || element.contains(bar)) continue

    const style = getComputedStyle(element)
    if (style.display === 'none' || style.visibility === 'hidden') { release(element); continue }
    observe(element)

    /* Only elements that actually float over the page can collide with a fixed
       bar. Without this gate ordinary tall page content overlaps the bar's strip
       and reads as an open chat panel. Descendants of a fixed host count as
       floating too, which is how the shadow-root launcher qualifies. */
    const floating = withinFixed || style.position === 'fixed'

    /* Measure at rest: add back any lift already applied so the correction can
       never feed back into its own input and oscillate. */
    const rect = element.getBoundingClientRect()
    const paints = rect.width > 0 && rect.height > 0
    let rest = resting.get(element)
    if (paints && (!rest || rest.key !== viewportKey)) {
      rest = { bottom: rect.bottom + (lifts.get(element)?.px || 0), key: viewportKey }
      resting.set(element, rest)
    }
    const restingBottom = rest ? rest.bottom : rect.bottom
    const restingTop = restingBottom - rect.height
    const overlapsBar = paints &&
      restingBottom > barRect.top && restingTop < barRect.bottom &&
      rect.right > barRect.left && rect.left < barRect.right

    if (floating && overlapsBar && style.pointerEvents !== 'none') {
      if (rect.height > innerHeight * PANEL_HEIGHT_RATIO) {
        state.panel = true
        release(element)
        continue
      }
      /* The launcher is the node the vendor ANCHORS to the corner, so it must be
         positioned. Its static descendants are just content: lifting one of those
         floats the label out of its own pill and leaves the pill on the button.
         Requiring a positioned node makes the choice structural rather than
         dependent on whatever geometry a pass happens to catch mid-transition.
         An element already under a lift stays the chosen one while it lives. */
      const isClosedLauncher = style.position !== 'static' &&
        rect.height <= CLOSED_MAX_HEIGHT &&
        rect.width <= innerWidth * CLOSED_MAX_WIDTH_RATIO &&
        innerHeight - restingBottom <= FLOOR_SLACK
      if (lifts.has(element) || isClosedLauncher) {
        state.found.push({ element, restingBottom })
        continue
      }
    }

    release(element)
    if (element.shadowRoot) scan(element.shadowRoot, 0, SHADOW_DEPTH, barRect, state, floating)
    if (depth < maxDepth) scan(element, depth + 1, maxDepth, barRect, state, floating)
  }
  return state
}

const observe = (element) => {
  if (watched.has(element)) return
  watched.add(element)
  resizeObserver.observe(element)
  if (element.shadowRoot) {
    mutationObserver.observe(element.shadowRoot,
      { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] })
  }
}

const measure = () => {
  queued = 0
  if (settling) return
  /* Detect the viewport change here rather than trusting the resize event to
     arrive. Cached resting positions belong to the viewport they were taken in;
     carrying one across a size change makes the launcher look like it sits far
     below the fold and it stops being recognised at all. */
  if (viewportKey !== innerWidth + 'x' + innerHeight) { reset(); return }
  const barStyle = getComputedStyle(bar)
  const barLive = barStyle.position === 'fixed' && barStyle.display !== 'none'
  if (!barLive) {
    for (const element of [...lifts.keys()]) release(element)
    restoreBar()
    return
  }

  const barRect = bar.getBoundingClientRect()
  const state = scan(document.body, 0, LIGHT_DEPTH, barRect, { panel: false, found: [] }, false)

  for (const { element, restingBottom } of state.found) {
    const lift = Math.min(Math.ceil(restingBottom - barRect.top + GAP), Math.round(innerHeight / 2))
    if (lift <= 0) { release(element); continue }
    apply(element, lift)
  }

  if (state.panel) yieldBar()
  else restoreBar()
}

const schedule = () => {
  if (queued) return
  queued = requestAnimationFrame(measure)
}

/* A viewport change invalidates every cached resting position. Drop the lifts,
   then re-measure once the launcher's own transition has settled. */
const reset = () => {
  viewportKey = innerWidth + 'x' + innerHeight
  for (const element of [...lifts.keys()]) release(element)
  settling = true
  if (queued) { cancelAnimationFrame(queued); queued = 0 }
  clearTimeout(settleTimer)
  settleTimer = setTimeout(() => { settling = false; schedule() }, SETTLE_MS)
}

resizeObserver.observe(bar)
mutationObserver.observe(document.body, { childList: true, subtree: true })
addEventListener('visibilitychange', schedule)
addEventListener('resize', reset)
addEventListener('orientationchange', reset)
visualViewport?.addEventListener('resize', schedule)
schedule()
window.SilveristicChatGuard = { measure, schedule, lifts }
}

initializeChatCollisionGuard()

/* Collection description disclosure.

 The full rich text is already in the document — server-rendered once. This only
 adds the collapsed presentation, and only when the text actually overflows the
 configured height at the current viewport, so a short description never grows a
 pointless button and a no-JS reader never loses content. */
const initializeCollectionDescription = () => {
const root = document.querySelector('[data-collection-description]')
if (!root) return
const body = root.querySelector('[data-collection-description-body]')
if (!body) return

const collapsedHeight = Number(root.dataset.collapsedHeight) || 320
root.style.setProperty('--sj-collection-description-height', collapsedHeight + 'px')

const labels = {
  more: root.dataset.labelMore || 'Read more',
  less: root.dataset.labelLess || 'Read less',
  moreA11y: root.dataset.a11yMore || root.dataset.labelMore || 'Read more',
  lessA11y: root.dataset.a11yLess || root.dataset.labelLess || 'Read less'
}

const toggle = createElement('button', 'sj-button sj-button--secondary sj-collection-description__toggle')
toggle.type = 'button'
toggle.hidden = true
toggle.setAttribute('aria-controls', body.id)
root.append(toggle)

let expanded = false
const paint = () => {
  root.dataset.expanded = expanded ? 'true' : 'false'
  toggle.textContent = expanded ? labels.less : labels.more
  toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false')
  toggle.setAttribute('aria-label', expanded ? labels.lessA11y : labels.moreA11y)
}

/* Measure against the UNCOLLAPSED height, then decide. Re-measured on resize and
   once fonts settle, because a description that fits at 1440 can overflow at 360. */
const evaluate = () => {
  const wasCollapsible = root.dataset.collapsible === 'true'
  root.dataset.collapsible = 'false'
  const overflows = body.scrollHeight > collapsedHeight + 8
  if (!overflows) {
    toggle.hidden = true
    root.removeAttribute('data-expanded')
    expanded = false
    return
  }
  toggle.hidden = false
  if (!wasCollapsible) expanded = false
  root.dataset.collapsible = 'true'
  paint()
}

toggle.addEventListener('click', () => {
  expanded = !expanded
  paint()
  /* Keep the button under the reader's finger when collapsing rather than letting
     the page jump; focus stays on the control either way. */
  if (!expanded) {
    const top = root.getBoundingClientRect().top
    if (top < 0) root.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
  }
  toggle.focus()
})

evaluate()
addEventListener('resize', evaluate)
document.fonts?.ready?.then(evaluate).catch(() => {})
}

initializeCollectionDescription()

/* Theme Editor lifecycle.

 Only section:load was handled. That is enough for a first render, but in the editor a
 merchant also removes, selects and reorders sections, and each of those leaves work to
 do: a removed section leaves its controllers registered against detached nodes, and a
 reordered section arrives with its initialise-once guard already set on surviving DOM.
 Every initialiser here is idempotent — initializeProductForms returns early on
 data-sj-initialized — so re-running is safe and never double-binds. */

/*
  The nine-step Gift Finder, restored on 2026-08-21 by owner instruction ("komple eski haline dön").

  This is the runtime that shipped before 2026-08-19, lifted verbatim from the 2026-08-03 theme
  snapshot: nine questions asked in order, a progress counter, Back and Skip, an answer-chip
  summary, and a reset. It replaces the chip-and-live-shortlist finder that stood in its place.

  Placed above initializeSectionScope because that is what calls it — a definition after its use
  throws on load, which is exactly how the first attempt at this failed.
*/
const finderRenderers = new WeakMap()

const initializeGiftFinders = (root = document) => {
  root.querySelectorAll('[data-gift-finder]').forEach((finder) => {
    if (finderRenderers.has(finder)) return
    const steps = [...finder.querySelectorAll('[data-finder-step]')]
    const progressCurrent = finder.querySelector('[data-finder-progress-current]')
    const progressTotal = finder.querySelector('[data-finder-progress-total]')
    const progressLabel = finder.querySelector('[data-finder-progress-label]')
    const back = finder.querySelector('[data-finder-back]')
    const next = finder.querySelector('[data-finder-next]')
    const skip = finder.querySelector('[data-finder-skip]')
    const submit = finder.querySelector('[data-finder-submit]')
    const skipAll = finder.querySelector('[data-finder-skip-all]')
    const conditionMatchesStep = (step) => {
      const conditionName = step.dataset.finderConditionName
      if (!conditionName) return true
      const selected = finder.querySelector(`[name="${CSS.escape(conditionName)}"]:checked`)?.value || ''
      if (step.dataset.finderConditionValue) return selected === step.dataset.finderConditionValue
      if (step.dataset.finderConditionNot) return selected !== step.dataset.finderConditionNot
      return true
    }
    const render = (requestedIndex = 0, shouldFocus = false) => {
      const activeSteps = steps.filter(conditionMatchesStep)
      steps.filter((step) => !activeSteps.includes(step)).forEach((step) => {
        step.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => { input.checked = false })
      })
      const index = Math.max(0, Math.min(requestedIndex, activeSteps.length - 1))
      const activeStep = activeSteps[index]
      finder.dataset.finderStepIndex = String(index)
      steps.forEach((step) => { step.hidden = step !== activeStep })
      if (progressCurrent) progressCurrent.textContent = String(index + 1)
      if (progressTotal) progressTotal.textContent = String(activeSteps.length)
      if (progressLabel) progressLabel.textContent = activeStep?.dataset.stepLabel || ''
      if (back) back.disabled = index === 0
      const isLast = index === activeSteps.length - 1
      if (next) next.hidden = isLast
      if (skip) skip.hidden = isLast
      if (submit) submit.hidden = !isLast
      if (skipAll) skipAll.hidden = isLast
      if (shouldFocus) activeStep?.querySelector('input, select')?.focus({ preventScroll: true })
    }
    render.goToInput = (name) => {
      const activeSteps = steps.filter(conditionMatchesStep)
      const index = activeSteps.findIndex((step) => step.querySelector(`[name="${CSS.escape(name)}"]`))
      if (index >= 0) render(index, true)
    }
    finderRenderers.set(finder, render)
    render(Number(finder.dataset.finderStepIndex || 0))
  })
}

initializeGiftFinders()

document.addEventListener('change', (event) => {
  const choice = event.target.closest('[data-gift-finder] [data-finder-step] input[type="radio"]')
  if (!choice) return
  const finder = choice.closest('[data-gift-finder]')
  const render = finderRenderers.get(finder)
  if (!render) return
  const current = Number(finder.dataset.finderStepIndex || 0)
  requestAnimationFrame(() => render(current + 1, true))
})

document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-finder-next], [data-finder-back], [data-finder-skip]')
  if (!control) return
  const finder = control.closest('[data-gift-finder]')
  const render = finderRenderers.get(finder)
  if (!finder || !render) return
  const current = Number(finder.dataset.finderStepIndex || 0)
  if (control.matches('[data-finder-back]')) {
    render(current - 1, true)
    return
  }
  if (control.matches('[data-finder-skip]')) {
    const visibleStep = [...finder.querySelectorAll('[data-finder-step]')].find((step) => !step.hidden)
    visibleStep?.querySelectorAll('input, select, textarea').forEach((input) => {
      if (input.matches('[type="radio"], [type="checkbox"]')) input.checked = false
      else if (input.tagName === 'SELECT') input.selectedIndex = 0
      else input.value = ''
    })
  }
  render(current + 1, true)
})

const finderAnswers = (finder) => {
  const answers = [...finder.querySelectorAll('[data-finder-step]')].flatMap((step) => {
    const selected = step.querySelector('input[type="radio"]:checked')
    if (!selected) return []
    const value = selected.closest('label')?.querySelector('span')?.textContent?.trim() || selected.value
    const question = (step.dataset.stepLabel || step.querySelector('legend')?.textContent || selected.name).replace(/\?$/, '')
    return [{ name: selected.name, question, value }]
  })
  const date = finder.querySelector('input[type="date"]')
  if (date?.value) {
    const step = date.closest('[data-finder-step]')
    const country = finder.querySelector('select[name="country"]')?.value || ''
    answers.push({
      name: date.name,
      question: (step?.dataset.stepLabel || 'Delivery').replace(/\?$/, ''),
      value: [country, date.value].filter(Boolean).join(' · ')
    })
  }
  return answers
}

const renderFinderAnswerControls = (finder) => {
  const controls = document.querySelector('[data-finder-result-controls]')
  const chips = controls?.querySelector('[data-finder-answer-chips]')
  if (!controls || !chips) return
  const answers = finderAnswers(finder)
  controls.hidden = answers.length === 0
  chips.innerHTML = answers.map((answer) => {
    const label = `${answer.question} — ${answer.value}`
    return `<span class="sj-finder-answer-chip">
      <button type="button" data-finder-edit="${escapeMarkup(answer.name)}">${escapeMarkup(label)} · edit</button>
      <button type="button" data-finder-clear="${escapeMarkup(answer.name)}" aria-label="Remove answer: ${escapeMarkup(label)}">×</button>
    </span>`
  }).join('')
}

/*
  The shortlist comes from the published catalogue, ranked — not from cards typed into the template.

  The wizard used to filter seven hand-authored cards with an `every()` test across seven axes. The
  arithmetic of that is unforgiving: 16,880 of the 21,600 fully answered paths returned nothing, so
  78% of the ways a shopper could answer ended on "Nothing matches every answer at once". The
  questions and their look are unchanged; what changed is that 232 giftable pieces answer them.

  Exact matches come first. When there are fewer than six of them the rest of the window is filled
  from the relaxation ladder under a divider that says so, and every relaxed card carries the reason
  it is there — a substitution the shopper cannot see is worse than a short list.
*/
/* The mapping itself lives in assets/sj-gift-finder-rank.js, exported as answersFromWizard, so the
   runtime and qa/test-gift-finder.mjs cannot drift apart on what an answer means. */
const giftFinderAnswers = (finder, model) => {
  const raw = {}
  for (const [key, value] of new FormData(finder).entries()) raw[key] = value
  return model.answersFromWizard(raw)
}

const giftFinderState = new WeakMap()
const loadGiftFinderData = (finder) => {
  if (giftFinderState.has(finder)) return giftFinderState.get(finder)
  const indexUrl = finder.dataset.gfIndex
  const rankUrl = finder.dataset.gfRank || new URL('./sj-gift-finder-rank.js', import.meta.url).href
  const ready = Promise.all([
    fetch(indexUrl).then((response) => response.json()),
    import(rankUrl)
  ]).then(([index, model]) => ({ index, model }))
  giftFinderState.set(finder, ready)
  return ready
}

const giftFinderCard = (item, model, answers) => {
  const row = item.row
  const article = document.createElement('article')
  /* The same card classes the server-rendered curated cards used, so the restored look is kept. */
  article.className = 'sj-card sj-card--v023'
  article.dataset.giftCard = row.h
  article.dataset.giftExact = item.exact ? 'true' : 'false'
  const reason = model.reasonFor(row, answers)
  const relaxed = model.relaxationLabel(item, answers)
  /* The model owns the money string so the card and the "a little over" label can never disagree,
     and so a per-variant piece reads "From $X" instead of quoting its cheapest variant as the price. */
  const price = model.priceLabel(row)
  article.innerHTML = `
    <a class="sj-card__media" href="${row.u}" aria-label="View ${escapeMarkup(row.t)}">
      ${row.badge ? `<span class="sj-card__badges"><span class="sj-badge sj-badge--overlay">${escapeMarkup(row.badge)}</span></span>` : ''}
      ${row.img ? `<img src="${escapeMarkup(row.img)}&width=600" alt="" width="600" height="600" loading="lazy" decoding="async">` : ''}
    </a>
    <div class="sj-card__body">
      <p class="sj-card__title"><a href="${row.u}">${escapeMarkup(row.t)}</a></p>
      <p class="sj-card__price">${price}</p>
      ${reason ? `<p class="sj-finder-match-reason" data-finder-match-reason>${escapeMarkup(reason)}</p>` : ''}
      ${relaxed ? `<p class="sj-finder-match-reason sj-finder-match-reason--relaxed" data-finder-relaxed>${escapeMarkup(relaxed)}</p>` : ''}
    </div>`
  return article
}

/*
  What the shopper is actually looking at.

  This line used to read "[count] matching pieces" with the exact-match count dropped into it, while
  the grid below showed six cards whatever that count was. A shopper who had three exact matches was
  told "3 matching pieces" over six cards, and one with none was told "0 matching pieces" over six —
  the count described one thing and the grid another. All three cases are now stated in full.
*/
const giftFinderCountLabel = (shortlist) => {
  const shown = shortlist.items.length
  const exact = shortlist.exactCount
  const piece = (n) => `${n} exact match${n === 1 ? '' : 'es'}`
  if (exact >= shown) return `Showing ${shown} of ${exact} exact match${exact === 1 ? '' : 'es'}`
  return `${piece(exact)} · ${shown - exact} closest shown`
}

const renderGiftFinderResults = (finder, shouldScroll = true) => {
  const results = document.querySelector('[data-gift-results]')
  const grid = document.querySelector('[data-gift-grid]')
  const count = document.querySelector('[data-gift-count]')
  const empty = document.querySelector('[data-gift-empty]')
  renderFinderAnswerControls(finder)
  if (results) {
    finder.hidden = true
    results.hidden = false
    if (shouldScroll) {
      results.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
      results.querySelector('h2')?.focus?.()
    }
  }
  if (!grid) return
  loadGiftFinderData(finder).then(({ index, model }) => {
    const answers = giftFinderAnswers(finder, model)
    const shortlist = model.shortlist(index, answers, { window: 6 })
    grid.replaceChildren()
    shortlist.items.forEach((item, position) => {
      if (shortlist.dividerAfter !== null && position === shortlist.dividerAfter) {
        const divider = document.createElement('p')
        divider.className = 'sj-finder-closest-divider'
        divider.dataset.giftDivider = ''
        divider.textContent = sjUi.closest_matches
        grid.append(divider)
      }
      grid.append(giftFinderCard(item, model, answers))
    })
    if (count) count.textContent = giftFinderCountLabel(shortlist)
    /* The panel below is a LOAD FAILURE, not a no-match state, so a successful render always hides
       it — including the honest case where nothing matched exactly and all six are closest matches. */
    if (empty) empty.hidden = true
  }).catch(() => {
    /* Drop the cached rejection: the promise is memoised per finder, so without this every retry
       would re-await the same failed load and the panel could never clear. */
    giftFinderState.delete(finder)
    if (grid) grid.replaceChildren()
    if (count) count.textContent = ''
    if (empty) empty.hidden = false
  })
}

document.addEventListener('submit', (event) => {
  const finder = event.target.closest('[data-gift-finder]')
  if (!finder) return
  event.preventDefault()
  renderGiftFinderResults(finder)
})

const resetGiftFinder = (finder) => {
  if (!finder) return
  finder.hidden = false
  finderRenderers.get(finder)?.(0)
  const results = document.querySelector('[data-gift-results]')
  if (results) results.hidden = true
  /*
    Empty the shortlist rather than un-hiding it.

    Both lines here are left from the era when seven cards were typed into the template and filtering
    meant hiding some of them: reset un-hid all seven and wrote a count into a `[count]` placeholder
    on the element. The grid is rebuilt from the catalogue on every render now, and that placeholder
    was removed when the count line was made to state exact-versus-closest honestly — so this threw
    `Cannot read properties of undefined` the moment a shopper pressed Start over, and left the
    previous shortlist standing underneath the wizard.
  */
  document.querySelector('[data-gift-grid]')?.replaceChildren()
  const empty = document.querySelector('[data-gift-empty]')
  if (empty) empty.hidden = true
  const count = document.querySelector('[data-gift-count]')
  /* Nothing has been answered yet, so there is no shortlist to describe. */
  if (count) count.textContent = ''
  const controls = document.querySelector('[data-finder-result-controls]')
  if (controls) controls.hidden = true
  controls?.querySelector('[data-finder-answer-chips]')?.replaceChildren()
}

document.addEventListener('reset', (event) => {
  if (!event.target.matches('[data-gift-finder]')) return
  requestAnimationFrame(() => resetGiftFinder(event.target))
})

document.addEventListener('click', (event) => {
  const edit = event.target.closest('[data-finder-edit]')
  const clear = event.target.closest('[data-finder-clear]')
  if (!edit && !clear) return
  const finder = document.querySelector('[data-gift-finder]')
  if (!finder) return
  if (edit) {
    document.querySelector('[data-gift-results]')?.setAttribute('hidden', '')
    finder.hidden = false
    finderRenderers.get(finder)?.goToInput?.(edit.dataset.finderEdit)
    finder.scrollIntoView({ block: 'start' })
    return
  }
  const name = clear.dataset.finderClear
  const control = finder.querySelector(`[name="${CSS.escape(name)}"]:checked`)
    || finder.querySelector(`[name="${CSS.escape(name)}"]`)
  if (control?.matches('[type="radio"], [type="checkbox"]')) control.checked = false
  else if (control) control.value = ''
  renderGiftFinderResults(finder, false)
})

/*
  Retry after a failed load. The catch above has already dropped the memoised rejection, so this
  simply re-runs the render — with the shopper's answers still in the form, which is why the panel
  promises they are saved.
*/
document.addEventListener('click', (event) => {
  const retry = event.target.closest('[data-gift-retry]')
  if (!retry) return
  const finder = document.querySelector('[data-gift-finder]')
  if (!finder) return
  giftFinderState.delete(finder)
  const empty = document.querySelector('[data-gift-empty]')
  if (empty) empty.hidden = true
  renderGiftFinderResults(finder, false)
})

document.addEventListener('click', (event) => {
  const reset = event.target.closest('[data-gift-reset]')
  if (!reset) return
  const finder = document.querySelector('[data-gift-finder]')
  finder?.reset()
  resetGiftFinder(finder)
  finder?.scrollIntoView({ block: 'start' })
})


const initializeSectionScope = (scope) => {
if (!scope || scope.nodeType !== 1) return
claimAjaxCartForms(scope)
initializeProductForms(scope)
initializeProductGalleries(scope)
initializeRecommendations(scope)
initializeGiftFinders(scope)
/* The Gift Finder is a module asset now, and it boots itself per [data-gift-finder] on load. A
   theme-editor section reload replaces the node, and the module's own guard re-runs against it —
   nothing to call from here. Calling a function this file no longer defines threw on every editor
   lifecycle event and took the rest of initializeSectionScope down with it. */
}

/* Drop per-form state for forms that are leaving the document, so a re-added section
 starts clean instead of inheriting a controller bound to detached nodes. */
const releaseSectionScope = (scope) => {
if (!scope || scope.nodeType !== 1) return
scope.querySelectorAll('[data-sj-product-form]').forEach((form) => {
  ;(form._sjDetachedDialogs || []).forEach((dialog) => dialog.remove())
  form._sjDetachedDialogs = []
  form.querySelectorAll('[data-native-font-picker-control]').forEach((control) => control.remove())
  form.querySelectorAll('[data-option-role="font_choice"]').forEach((fieldset) => {
    delete fieldset.dataset.nativeFontPickerInitialized
    const source = fieldset.querySelector('.sj-options')
    if (source) source.hidden = false
    fieldset.querySelectorAll('input[type="radio"]').forEach((input) => { input.removeAttribute('tabindex') })
  })
  form._sjControllers = []
  form._sjPositionConfigurator = null
  form._sjCtaAction = null
  delete form.dataset.sjInitialized
})
}

document.addEventListener('shopify:section:load', (event) => initializeSectionScope(event.target))
document.addEventListener('shopify:section:unload', (event) => releaseSectionScope(event.target))
document.addEventListener('shopify:section:reorder', (event) => initializeSectionScope(event.target))
document.addEventListener('shopify:section:select', (event) => initializeSectionScope(event.target))

/* Selecting a block inside the personalizer must reveal it, or the merchant selects a block
 in the sidebar and the canvas shows a blank gap where the collapsed <details> is. */
document.addEventListener('shopify:block:select', (event) => {
const personalizer = event.target?.closest?.('[data-sj-personalizer]')
  || event.target?.querySelector?.('[data-sj-personalizer]')
if (personalizer) { personalizer.removeAttribute('hidden'); personalizer.open = true }
initializeSectionScope(event.target?.closest?.('.shopify-section') || event.target)
})
}
